// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;utf8,<svg fill=\"none\" stroke=\"%23C9A84C\" stroke-width=\"2\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M19 9l-7 7-7-7\"></path></svg>", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --bg-dark: #0A0A0A;
    --bg-light: #FFFFFF;
    --text-dark: #F2EEE6;
    --text-light: #0A0A0E;
    --accent-gold: #C9A84C;
}

body:not(.light_theme) {
    --bg-color: var(--bg-dark) !important;
    background-color: #0a0a0a;
    --text-color: var(--text-dark);
    --stats-border: rgba(255, 255, 255, 0.06);
    --stats-bg: rgba(10, 10, 10, 0.75);
    --stats-cell-border: rgba(255, 255, 255, 0.04);
}

body:not(.light_theme) .tc-desc {
    color: #fff;
}

/* ─── HERO ─── */
#hero {
    min-height: 100vh;
    display: flex;
    align-items: center;
    padding: 68px 5% 0;
    position: relative;
    overflow: hidden;
}

.hero-perspective-bg {
    position: absolute;
    inset: 0;
    pointer-events: none;
    z-index: 1;
    overflow: hidden;
}

.hero-grid-floor {
    position: absolute;
    bottom: -15%;
    left: -20%;
    width: 140%;
    height: 60vh;
    background-image:
        linear-gradient(rgba(255, 255, 255, 0.45) 1px, transparent 1px),
        linear-gradient(90deg, rgba(255, 255, 255, 0.45) 1px, transparent 1px);
    background-size: 60px 60px;
    transform-origin: bottom center;
    transform: perspective(600px) rotateX(75deg);
    /* Premium double-directional mask: dissolves grid before the bottom edge to preserve depth */
    mask-image: linear-gradient(to top, transparent 0%, rgba(0, 0, 0, 0.8) 12%, rgba(0, 0, 0, 1) 30%, transparent 95%);
    -webkit-mask-image: linear-gradient(to top, transparent 0%, rgba(0, 0, 0, 0.8) 12%, rgba(0, 0, 0, 1) 30%, transparent 95%);
}

body.light_theme .hero-grid-floor {
    background-image:
        linear-gradient(rgba(0, 0, 0, 0.35) 1px, transparent 1px),
        linear-gradient(90deg, rgba(0, 0, 0, 0.35) 1px, transparent 1px);
}

/* Horizon Ambient Glow centered at bottom right to blend clipped Globe edge */
.hero-horizon-glow {
    position: absolute;
    bottom: 0;
    left: 60%;
    width: clamp(600px, 45vw, 1000px);
    height: clamp(200px, 15vw, 350px);
    margin-left: calc(-1 * clamp(600px, 45vw, 1000px) / 2);
    background: radial-gradient(ellipse at center, rgba(201, 168, 76, 0.22) 0%, rgba(201, 168, 76, 0.05) 45%, transparent 70%);
    filter: blur(40px);
    pointer-events: none;
    z-index: 2;
    animation: horizonPulse 8s ease-in-out infinite;
}

body.light_theme .hero-horizon-glow {
    background: radial-gradient(ellipse at center, rgba(201, 168, 76, 0.15) 0%, rgba(201, 168, 76, 0.03) 45%, transparent 70%);
}

@keyframes horizonPulse {

    0%,
    100% {
        opacity: 0.85;
        transform: scale(1);
    }

    50% {
        opacity: 1;
        transform: scale(1.05);
    }
}

.hero-globe {
    position: absolute;
    top: 15%;
    /* Elevated to sit directly behind the mobile mockups */
    left: 60%;
    /* Centered visuals on the grid floor */
    width: clamp(800px, 60vw, 1200px);
    height: clamp(467px, 35vw, 700px);
    /* 1.71 aspect ratio matching the high-fidelity SVG */
    margin-left: calc(-1 * clamp(800px, 60vw, 1200px) / 2);
    transform: perspective(1200px) rotateX(64deg) rotateZ(-8deg);
    /* Tilted slightly more up to ensure geographic clarity */
    transform-style: preserve-3d;
    pointer-events: none;
    opacity: 0.85;
    transition: all 0.5s cubic-bezier(0.25, 1, 0.5, 1);
}

.hero-globe .map-layer {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    transform-style: preserve-3d;
    transition: transform 0.6s cubic-bezier(0.25, 1, 0.5, 1), opacity 0.6s ease;
}

.hero-globe svg {
    width: 100%;
    height: 100%;
    overflow: visible;
}

.hero-globe svg path,
.hero-globe svg circle {
    pointer-events: auto;
    /* Enable mouse hover/clicks on path elements */
}

/* 3D Stacking and Parallax Offsets */
.hero-globe .shadow-layer {
    transform: translateZ(-28px);
    opacity: 0.45;
    filter: blur(6px);
}

.hero-globe .base-layer {
    transform: translateZ(4px);
}

.hero-globe .surface-layer {
    transform: translateZ(16px);
}

.hero-globe .network-layer {
    transform: translateZ(30px);
}

/* Hover Parallax Mechanics */
.hero-globe:hover .shadow-layer {
    transform: translateZ(-40px);
    opacity: 0.25;
    filter: blur(8px);
}

.hero-globe:hover .base-layer {
    transform: translateZ(8px);
}

.hero-globe:hover .surface-layer {
    transform: translateZ(28px);
}

.hero-globe:hover .network-layer {
    transform: translateZ(48px);
}

/* Country/Continent Path Styling */
.hero-globe .shadow-layer .map-continents path {
    fill: rgba(0, 0, 0, 0.75);
    stroke: none;
}

body.light_theme .hero-globe .shadow-layer .map-continents path {
    fill: rgba(0, 0, 0, 0.12);
    filter: blur(4px);
}

.hero-globe .base-layer .map-continents path {
    fill: rgba(201, 168, 76, 0.12);
    stroke: rgba(201, 168, 76, 0.35);
    stroke-width: 0.8px;
}

body.light_theme .hero-globe .base-layer .map-continents path {
    fill: rgba(201, 168, 76, 0.04);
    stroke: rgba(201, 168, 76, 0.18);
}

.hero-globe .surface-layer .map-continents path {
    fill: rgba(255, 255, 255, 0.08);
    stroke: rgba(255, 255, 255, 0.24);
    stroke-width: 0.5px;
    transition: fill 0.3s ease, stroke 0.3s ease, filter 0.3s ease;
}

body.light_theme .hero-globe .surface-layer .map-continents path {
    fill: rgba(0, 0, 0, 0.03);
    stroke: rgba(0, 0, 0, 0.12);
}

.hero-globe .surface-layer .map-continents path:hover {
    fill: rgba(201, 168, 76, 0.35);
    stroke: rgba(201, 168, 76, 0.8);
    filter: drop-shadow(0 0 8px rgba(201, 168, 76, 0.5));
    cursor: crosshair;
}

.hero-globe .globe-ring {
    fill: none;
    stroke: rgba(255, 255, 255, 0.18);
    stroke-width: 0.8px;
}

body.light_theme .hero-globe .globe-ring {
    stroke: rgba(0, 0, 0, 0.15);
}

.hero-globe .globe-node {
    fill: #C9A84C;
    filter: drop-shadow(0 0 6px #C9A84C);
}

@keyframes pulseNode {

    0%,
    100% {
        transform: scale(1);
        opacity: 0.4;
    }

    50% {
        transform: scale(1.4);
        opacity: 0.8;
    }
}

.orb {
    position: absolute;
    border-radius: 50%;
    pointer-events: none;
    filter: blur(110px);
}

.orb1 {
    width: 55vw;
    height: 55vw;
    max-width: 680px;
    max-height: 680px;
    top: -20%;
    left: -12%;
    background: radial-gradient(circle, rgba(201, 168, 76, 0.1), transparent 65%);
    animation: drift 16s ease-in-out infinite;
}

.orb2 {
    display: none;
    width: 35vw;
    height: 35vw;
    max-width: 450px;
    max-height: 450px;
    bottom: -15%;
    left: 22%;
    background: radial-gradient(circle, rgba(201, 168, 76, 0.04), transparent 65%);
    animation: drift 12s ease-in-out infinite reverse;
}

body.light_theme .orb2 {
    display: block;
}

@keyframes drift {

    0%,
    100% {
        transform: translate(0, 0);
    }

    50% {
        transform: translate(-20px, -28px);
    }
}

.hero-inner {
    width: 100%;
    display: grid;
    grid-template-columns: 1fr 1fr;
    max-width: 1260px;
    margin: 0 auto;
    align-items: center;
    gap: 4%;
    position: relative;
    /* Stacking context is now deferred to individual children */
    min-height: calc(100vh - 68px);
    padding: 60px 0 80px;
}

/* ─── LEFT COPY ─── */
.copy {
    display: flex;
    flex-direction: column;
    gap: 0;
    position: relative;
    z-index: 5;
    /* Floats above background shapes (z-index 2) */
}

.brand {
    margin-bottom: clamp(18px, 2.2vw, 32px);
}

.brand-name {
    font-size: clamp(20px, 2.6vw, 36px);
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    line-height: 1;
    background: linear-gradient(130deg, #F5E5B0 0%, #C9A84C 50%, #8B6B2A 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
}

.brand-exchange {
    font-size: clamp(8px, 0.85vw, 11px);
    letter-spacing: 0.28em;
    color: #B5AE9E;
    text-transform: uppercase;
    margin-top: 5px;
    font-weight: 500;
}

.brand-rule {
    height: 1px;
    width: clamp(90px, 11vw, 160px);
    margin-top: 10px;
    background: linear-gradient(90deg, rgba(201, 168, 76, 0.55), transparent);
}

.taglines {
    display: flex;
    align-items: center;
    column-gap: clamp(8px, 1.2vw, 5px);
    row-gap: 4px;
    margin: 0 0 clamp(16px, 2vw, 26px) 0;
}

.agcex.copy {
    width: 630px;
    max-width: 100%;
}

.tl {
    display: inline-block;
    font-size: clamp(32px, 4.5vw, 66px);
    font-weight: 700;
    line-height: 1.15;
    color: #F2EEE6;
    letter-spacing: -0.02em;
    margin: 0;
}

.scroolcounter_hd {
    display: inline-flex;
    align-items: center;
    height: 1.25em;
    overflow: hidden;
    vertical-align: middle;
    position: relative;
    padding: 0 4px;
}

.scroolcounter_item {
    display: inline-block;
    height: 1.25em;
    line-height: 1.25;
    white-space: nowrap;
    padding-right: 6px;
    will-change: transform, opacity;
}

.scroolcounter_item.anim-in {
    animation: heroWordSlideIn 0.35s cubic-bezier(0.16, 1, 0.3, 1) forwards;
}

.scroolcounter_item.anim-out {
    animation: heroWordSlideOut 0.35s cubic-bezier(0.7, 0, 0.84, 0) forwards;
}

@keyframes heroWordSlideIn {
    0% {
        transform: translateY(100%);
        opacity: 0;
    }

    100% {
        transform: translateY(0);
        opacity: 1;
    }
}

@keyframes heroWordSlideOut {
    0% {
        transform: translateY(0);
        opacity: 1;
    }

    100% {
        transform: translateY(-100%);
        opacity: 0;
    }
}

.tl.gold {
    background: linear-gradient(130deg, #F5E5B0, #C9A84C 60%, #8B6B2A);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
}

.sub {
    font-size: clamp(13px, 1.05vw, 16px);
    color: #d1d1d1;
    line-height: 1.85;
    max-width: clamp(260px, 36vw, 460px);
    margin-bottom: clamp(22px, 2.8vw, 38px);
    font-weight: 300;
}

body.light_theme .sub {
    color: #666;
}

.sub em {
    color: #C9A84C;
    font-style: normal;
    font-weight: 500;
}

/* EMAIL CTA */
.email-cta {
    display: flex;
    gap: 8px;
    max-width: clamp(280px, 36vw, 460px);
    margin-bottom: clamp(14px, 1.6vw, 22px);
}

.email-input {
    flex: 1 1;
    min-width: 0;
    background: rgba(255, 255, 255, 0.05);
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 50px;
    padding: clamp(11px, 1.1vw, 15px) clamp(16px, 1.5vw, 22px);
    font-size: clamp(12px, 0.95vw, 14px);
    color: #F2EEE6;
    font-family: 'DM Sans', sans-serif;
    outline: none;
    transition: border-color 0.3s;
}

.email-input::placeholder {
    color: #444;
}

.email-input:focus {
    border-color: rgba(201, 168, 76, 0.4);
}

.email-btn {
    flex-shrink: 0;
    background: linear-gradient(135deg, #E8C97A, #C9A84C);
    color: #0A0A0A;
    padding: clamp(11px, 1.1vw, 15px) clamp(18px, 2vw, 28px);
    border-radius: 50px;
    font-size: clamp(12px, 0.95vw, 14px);
    font-weight: 700;
    letter-spacing: 0.04em;
    text-decoration: none;
    transition: all 0.3s;
    white-space: nowrap;
    border: none;
    cursor: pointer;
    box-shadow: 0 4px 20px rgba(201, 168, 76, 0.28);
}

.email-btn:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 30px rgba(201, 168, 76, 0.45);
}

/* Hero Action & Trust Section */
.hero-actions-sec {
    display: flex;
    gap: 16px;
    margin-bottom: 30px;
}

.action-row {
    display: flex;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;
}

.s-label {
    font-size: 11px;
    color: #888;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    white-space: nowrap;
}

.s-icons-pro {
    display: flex;
    gap: 10px;
}

.s-ico-btn {
    width: 36px;
    height: 36px;
    border-radius: 10px;
    border: 1px solid rgba(255, 255, 255, 0.08);
    background: rgba(255, 255, 255, 0.03);
    display: flex;
    align-items: center;
    justify-content: center;
    color: #BBB;
    transition: all 0.3s;
    text-decoration: none;
}

.s-ico-btn:hover {
    background: rgba(201, 168, 76, 0.1);
    border-color: rgba(201, 168, 76, 0.4);
    color: #C9A84C;
    transform: translateY(-2px);
}

.s-divider-pro {
    width: 1px;
    height: 20px;
    background: rgba(255, 255, 255, 0.1);
    margin: 0 4px;
}

.qr-btn {
    width: 36px;
    height: 36px;
}

.trust-grid {
    display: flex;
    align-items: center;
    gap: 12px;
    flex-wrap: wrap;
}

.t-pill {
    width: 33%;
    font-size: 11px;
    color: #AAA;
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 6px 12px;
    background: rgba(255, 255, 255, 0.02);
    border: 1px solid rgba(255, 255, 255, 0.05);
    border-radius: 20px;
}

/* ─── RIGHT PHONES (overlapping stack) ─── */
.phones {
    position: relative;
    height: clamp(500px, 68vh, 800px);
    display: flex;
    align-items: center;
    justify-content: center;
    perspective: 1200px;
    /* Crucial for 3D depth perspective */
    transform-style: preserve-3d;
    z-index: 10;
}

.pg {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 140%;
    height: 120%;
    border-radius: 50%;
    background: radial-gradient(ellipse at center,
            rgba(201, 168, 76, 0.58) 0%,
            rgba(201, 168, 76, 0.32) 35%,
            rgba(232, 201, 122, 0.08) 60%,
            transparent 80%);
    pointer-events: none;
    filter: blur(80px);
    animation: gp 7s ease-in-out infinite;
    z-index: 1;
}

@keyframes gp {

    0%,
    100% {
        opacity: 0.8;
        transform: translate(-50%, -50%) scale(1);
    }

    50% {
        opacity: 1;
        transform: translate(-50%, -50%) scale(1.1);
    }
}

/* ── Centre phone — biggest, front ── */
.ph-c {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: clamp(175px, 19vw, 270px);
    height: clamp(357px, 38.8vw, 550px);
    z-index: 999;
    animation: bob0 5s ease-in-out infinite;
    transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
    transform-style: preserve-3d;
}

.ph-c:hover {
    z-index: 12;
    transform: translate(-50%, -50%) scale(1.08) !important;
    animation-play-state: paused;
    /* Pause bobbing while cursor is hovered */
}

.ph-c .s26-shell {
    transform: translate3d(0, 0, 0);
    transition: transform 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
}

.phones:hover .ph-c .s26-shell {
    transform: translateZ(45px) rotateY(calc(var(--mx, 0) * 3deg)) rotateX(calc(var(--my, 0) * -3deg));
    transition: transform 0.15s cubic-bezier(0.25, 0.8, 0.25, 1);
}

/* ── Left phone — behind left ── */
.ph-l {
    position: absolute;
    left: clamp(0px, 2%, 40px);
    top: 50%;
    transform: translateY(-42%) rotate(-8deg);
    width: clamp(140px, 15vw, 210px);
    height: clamp(280px, 30vw, 420px);
    z-index: 3;
    animation: bobL 6s ease-in-out infinite;
    animation-delay: 0.8s;
    transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
    transform-style: preserve-3d;
}

.ph-l:hover {
    z-index: 12;
    transform: translateY(-42%) rotate(-4deg) translateX(clamp(-50px, -4vw, -20px)) scale(1.05) !important;
    animation-play-state: paused;
}

.ph-l .s26-shell {
    transform: translate3d(0, 0, 0);
    transition: transform 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
}

.phones:hover .ph-l .s26-shell {
    transform: translateZ(20px) rotateY(calc(var(--mx, 0) * 2.5deg)) rotateX(calc(var(--my, 0) * -2.5deg));
    transition: transform 0.15s cubic-bezier(0.25, 0.8, 0.25, 1);
}

/* ── Right phone — behind right ── */
.ph-r {
    position: absolute;
    right: clamp(0px, 2%, 40px);
    top: 50%;
    transform: translateY(-44%) rotate(8deg);
    width: clamp(140px, 15vw, 210px);
    height: clamp(280px, 30vw, 420px);
    z-index: 3;
    animation: bobR 5.5s ease-in-out infinite;
    animation-delay: 1.4s;
    transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
    transform-style: preserve-3d;
}

.ph-r:hover {
    z-index: 12;
    transform: translateY(-44%) rotate(4deg) translateX(clamp(20px, 4vw, 50px)) scale(1.05) !important;
    animation-play-state: paused;
}

.ph-r .s26-shell {
    transform: translate3d(0, 0, 0);
    transition: transform 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
}

.phones:hover .ph-r .s26-shell {
    transform: translateZ(20px) rotateY(calc(var(--mx, 0) * 2.5deg)) rotateX(calc(var(--my, 0) * -2.5deg));
    transition: transform 0.15s cubic-bezier(0.25, 0.8, 0.25, 1);
}

/* ─── Unified Ultra-High Fidelity Samsung Galaxy S26 Ultra Mockup System ─── */
.s26-shell {
    width: 100%;
    height: 100%;
    border-radius: clamp(8px, 0.9vw, 15px);
    /* Sharp, boxy signature Galaxy Ultra corners */
    padding: clamp(3px, 0.35vw, 5px);
    box-sizing: border-box;
    position: relative;
    transition: all 0.4s ease;
    z-index: 2;
}

/* Specular charcoal black titanium armor chassis for dark theme */
body:not(.light_theme) .s26-shell,
body .s26-shell {
    background: linear-gradient(135deg, #2D2D35 0%, #1A1A20 25%, #0F0F12 50%, #1A1A20 75%, #2D2D35 100%);
    box-shadow: 0 50px 110px rgba(0, 0, 0, 0.95),
        0 0 0 1px rgba(255, 255, 255, 0.06),
        inset 0 1px 1px rgba(255, 255, 255, 0.12);
}

/* Specular silver/gray titanium armor chassis for light theme */
body.light_theme .s26-shell {
    background: linear-gradient(135deg, #FFFFFF 0%, #D8D8DC 25%, #9E9EA3 50%, #D8D8DC 75%, #FFFFFF 100%);
    box-shadow: 0 45px 95px rgba(0, 0, 0, 0.12),
        0 0 0 1px rgba(0, 0, 0, 0.06),
        inset 0 1px 1.5px rgba(255, 255, 255, 0.7),
        0 0 30px rgba(0, 0, 0, 0.02);
}

/* Specular physical buttons on S26 Ultra */
.s26-btn {
    position: absolute;
    right: -2.5px;
    width: 2.5px;
    z-index: 1;
    transition: all 0.4s ease;
    border-radius: 0 2px 2px 0;
}

.s26-btn-vol-up {
    top: 20%;
    height: 8%;
}

.s26-btn-vol-down {
    top: 29%;
    height: 8%;
}

.s26-btn-power {
    top: 42%;
    height: 12%;
}

/* Specular button colors matching active theme frame */
body:not(.light_theme) .s26-btn,
body .s26-btn {
    background: linear-gradient(180deg, #3D3D48 0%, #151519 100%);
    box-shadow: inset -0.5px 0.5px 0.5px rgba(255, 255, 255, 0.1);
}

body.light_theme .s26-btn {
    background: linear-gradient(180deg, #FFFFFF 0%, #A1A1A6 100%);
    box-shadow: inset -0.5px 0.5px 0.5px rgba(255, 255, 255, 0.4);
}

/* Dynamic screen ambient glow projection (projects screen colors onto backwall) */
.ambient-glow {
    position: absolute;
    top: 5%;
    left: 5%;
    right: 5%;
    bottom: 5%;
    filter: blur(45px);
    z-index: 1;
    pointer-events: none;
    opacity: 0;
    transition: opacity 0.6s ease;
}

/* Enable glows only in dark theme for realistic premium contrast */
body:not(.light_theme) .ambient-glow {
    opacity: 1;
}

.ph-l .ambient-glow {
    background: radial-gradient(circle, rgba(16, 185, 129, 0.18) 0%, rgba(239, 68, 68, 0.08) 60%, transparent 100%);
}

.ph-c .ambient-glow {
    background: radial-gradient(circle, rgba(201, 168, 76, 0.15) 0%, rgba(59, 130, 246, 0.12) 60%, transparent 100%);
}

.ph-r .ambient-glow {
    background: radial-gradient(circle, rgba(59, 130, 246, 0.2) 0%, rgba(139, 92, 246, 0.08) 60%, transparent 100%);
}

.s26-screen {
    width: 100%;
    height: 100%;
    background: #FFFFFF;
    border-radius: clamp(6px, 0.75vw, 12px);
    /* Perfectly matching boxy inner screen ratio */
    overflow: hidden;
    position: relative;
    border: clamp(2.5px, 0.3vw, 4.5px) solid #09090B;
    /* Minimalist ultra-thin uniform S26 bezels */
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
}

/* Infinity-O Front Camera Punch-hole */
.punch-hole {
    position: absolute;
    top: clamp(6px, 0.7vw, 10px);
    left: 50%;
    transform: translateX(-50%);
    width: clamp(8px, 0.9vw, 12px);
    height: clamp(8px, 0.9vw, 12px);
    background: #09090B;
    border-radius: 50%;
    z-index: 15;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: inset 0 0.5px 1px rgba(255, 255, 255, 0.2);
}

.punch-lens {
    width: clamp(3px, 0.3vw, 5px);
    height: clamp(3px, 0.3vw, 5px);
    border-radius: 50%;
    background: #141419;
    border: 0.5px solid #22222B;
}

/* Specular vertical glass curve reflection */
.s26-screen::before {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    left: 12%;
    width: 14%;
    background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.06) 50%, rgba(255, 255, 255, 0) 100%);
    transform: skewX(-15deg);
    z-index: 12;
    pointer-events: none;
}

/* Specular holographic glass shine sweep (moves dynamically with cursor) */
.s26-screen::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(calc(135deg + var(--mx, 0) * 15deg),
            rgba(255, 255, 255, calc(0.18 + var(--my, 0) * 0.05)) 0%,
            rgba(255, 255, 255, 0.04) calc(30% + var(--mx, 0) * 5%),
            rgba(255, 255, 255, 0) calc(31% + var(--mx, 0) * 5%),
            rgba(255, 255, 255, 0) 100%);
    pointer-events: none;
    z-index: 13;
    border-radius: inherit;
    transition: background 0.15s ease;
}

/* Razor-sharp vector navigation gesture bar */
.s26-nav-bar {
    position: absolute;
    bottom: clamp(4px, 0.45vw, 6px);
    left: 50%;
    transform: translateX(-50%);
    width: clamp(45px, 5vw, 75px);
    height: clamp(2px, 0.25vw, 3.5px);
    border-radius: 2px;
    z-index: 14;
    pointer-events: none;
    transition: background 0.4s ease;
}

body:not(.light_theme) .s26-nav-bar,
body .s26-nav-bar {
    background: rgb(255 255 255 / 20%);
}

body.light_theme .s26-nav-bar {
    background: rgba(0, 0, 0, 0.65);
}

/* Screen content helpers */
.scr {
    padding: 8% 7% 18%;
    height: 100%;
}

.scr-status {
    display: flex;
    justify-content: space-between;
    font-size: clamp(6px, 0.58vw, 9px);
    color: #444;
    font-weight: 600;
    margin-bottom: 4%;
}

.scr-hdr {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 4%;
}

.scr-logo {
    font-size: clamp(9px, 0.9vw, 13px);
    font-weight: 700;
    letter-spacing: 0.08em;
    color: #C9A84C;
    display: flex;
    align-items: center;
}

.scr-bell {
    width: clamp(14px, 1.5vw, 20px);
    height: clamp(14px, 1.5vw, 20px);
    border-radius: 50%;
    background: rgba(201, 168, 76, 0.1);
    border: 1px solid rgba(201, 168, 76, 0.2);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: clamp(6px, 0.6vw, 9px);
    color: #C9A84C;
}

.bal-card {
    background: linear-gradient(135deg, rgba(201, 168, 76, 0.12), rgba(201, 168, 76, 0.04));
    border: 1px solid rgba(201, 168, 76, 0.18);
    border-radius: clamp(8px, 1vw, 14px);
    padding: clamp(7px, 0.9vw, 13px);
    margin-bottom: 4%;
}

.bal-lbl {
    font-size: clamp(5px, 0.5vw, 8px);
    color: #555;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    margin-bottom: 2%;
}

.bal-amt {
    font-size: clamp(14px, 1.6vw, 24px);
    font-weight: 700;
    color: #F2EEE6;
    font-family: 'Cormorant Garamond', serif;
    line-height: 1;
}

.bal-chg {
    font-size: clamp(6px, 0.58vw, 9px);
    color: #4ADE80;
    margin-top: 3%;
}

.q-btns {
    display: grid;
    grid-template-columns: 1fr;
    max-width: 800px;
    gap: 4%;
    margin-bottom: 4%;
}

.q-buy {
    background: rgba(74, 222, 128, 0.1);
    border: 1px solid rgba(74, 222, 128, 0.18);
    border-radius: clamp(5px, 0.6vw, 9px);
    padding: 5%;
    text-align: center;
    font-size: clamp(6px, 0.6vw, 9px);
    color: #4ADE80;
    font-weight: 600;
}

.q-sell {
    background: rgba(248, 113, 113, 0.08);
    border: 1px solid rgba(248, 113, 113, 0.18);
    border-radius: clamp(5px, 0.6vw, 9px);
    padding: 5%;
    text-align: center;
    font-size: clamp(6px, 0.6vw, 9px);
    color: #F87171;
    font-weight: 600;
}

.mkt-lbl {
    font-size: clamp(5px, 0.48vw, 7px);
    color: #333;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    margin-bottom: 3%;
}

.c-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 3% 0;
    border-bottom: 1px solid rgba(255, 255, 255, 0.03);
}

.c-row:last-of-type {
    border-bottom: none;
}

.c-left {
    display: flex;
    align-items: center;
    gap: 5%;
}

.c-ico {
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 700;
    flex-shrink: 0;
    width: clamp(14px, 1.5vw, 22px);
    height: clamp(14px, 1.5vw, 22px);
    font-size: clamp(6px, 0.58vw, 9px);
}

.c-nm {
    font-size: clamp(6px, 0.62vw, 10px);
    color: #F2EEE6;
}

.c-tk {
    font-size: clamp(5px, 0.48vw, 8px);
    color: #444;
}

.spark {
    display: flex;
    align-items: flex-end;
    gap: 2px;
    height: clamp(10px, 1.1vw, 16px);
}

.sp {
    width: clamp(2px, 0.24vw, 4px);
    border-radius: 1px;
}

.c-right {
    text-align: right;
}

.c-px {
    font-size: clamp(6px, 0.62vw, 10px);
    color: #F2EEE6;
}

.c-ch {
    font-size: clamp(5px, 0.52vw, 8px);
    margin-top: 1px;
}

.scr-nav {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    justify-content: space-around;
    padding: 3% 2% 5%;
    border-top: 1px solid rgba(255, 255, 255, 0.05);
    background: rgba(0, 0, 0, 0.6);
}

.scr-nav span {
    font-size: clamp(5px, 0.52vw, 8px);
}

/* Android screen content - High Fidelity Trading Terminal */
.and-c {
    padding: 12% 7% 0;
    display: flex;
    flex-direction: column;
    gap: 3%;
    height: calc(100% - 25px);
}

.trd-head {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.trd-pair {
    display: flex;
    align-items: center;
    gap: 4px;
}

.trd-coin {
    font-size: clamp(8px, 0.8vw, 11px);
    font-weight: 700;
    color: #F2EEE6;
}

.trd-tag {
    font-size: clamp(4px, 0.4vw, 6px);
    background: rgba(201, 168, 76, 0.15);
    border: 1px solid rgba(201, 168, 76, 0.3);
    color: #C9A84C;
    padding: 1px 4px;
    border-radius: 3px;
    font-weight: 600;
}

.trd-change {
    font-size: clamp(6px, 0.6vw, 9px);
    color: #4ADE80;
    font-weight: 600;
}

.trd-price-row {
    display: flex;
    align-items: baseline;
    gap: 6px;
    margin-bottom: 1%;
}

.trd-big-px {
    font-size: clamp(14px, 1.6vw, 24px);
    font-weight: 700;
    color: #4ADE80;
    font-family: 'Cormorant Garamond', serif;
    line-height: 1;
}

.trd-sub-px {
    font-size: clamp(6px, 0.55vw, 8px);
    color: #666;
}

.trd-tf {
    display: flex;
    justify-content: space-between;
    background: rgba(0, 0, 0, 0.4);
    border-radius: 4px;
    padding: 2px 4px;
    margin-bottom: 2%;
}

.trd-tf span {
    font-size: clamp(5px, 0.5vw, 8px);
    color: #777;
    padding: 2px 6px;
    border-radius: 3px;
    font-weight: 500;
}

.trd-tf span.active {
    background: rgba(201, 168, 76, 0.2);
    color: #C9A84C;
    font-weight: 700;
}

.trd-chart-box {
    background: rgba(255, 255, 255, 0.02);
    border: 1px solid rgba(255, 255, 255, 0.05);
    border-radius: 6px;
    padding: 4%;
    position: relative;
    margin-bottom: 2%;
    flex-shrink: 0;
}

.trd-ma {
    font-size: clamp(4px, 0.45vw, 7px);
    color: #888;
    margin-bottom: 4px;
    display: flex;
    gap: 8px;
}

.trd-candles-rich {
    position: relative;
    width: 100%;
    aspect-ratio: 2.2 / 1;
}

.trd-svg-graph {
    width: 100%;
    height: 100%;
    overflow: visible;
}

.trd-vol {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    height: 15%;
    margin-top: 4px;
    border-top: 1px solid rgba(255, 255, 255, 0.04);
    padding-top: 2px;
}

.v-bar {
    width: 8%;
    border-radius: 1px;
    opacity: 0.8;
}

.cup {
    background: #4ADE80;
}

.cdn {
    background: #F87171;
}

.v-bar.cup {
    background: #4ADE80;
}

.v-bar.cdn {
    background: #F87171;
}

.trd-ob-box {
    background: rgba(0, 0, 0, 0.3);
    border-radius: 6px;
    padding: 3% 4%;
    display: flex;
    flex-direction: column;
    gap: 3px;
    flex-grow: 1;
    min-height: 0;
    overflow: hidden;
}

.ob-hdr {
    display: flex;
    justify-content: space-between;
    font-size: clamp(5px, 0.5vw, 7px);
    color: #888;
    font-weight: 600;
    padding-bottom: 2px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.05);
}

.ob-list {
    display: flex;
    flex-direction: column;
    gap: 2px;
    overflow: hidden;
}

.ob-row {
    display: flex;
    justify-content: space-between;
    position: relative;
    font-size: clamp(6px, 0.58vw, 8px);
    font-family: 'DM Sans', sans-serif;
    font-weight: 500;
    z-index: 1;
    padding: 1px 2px;
}

.ob-depth {
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    z-index: -1;
    opacity: 0.15;
    border-radius: 2px;
}

.ob-depth.cup {
    background: #4ADE80;
}

.ob-depth.cdn {
    background: #F87171;
}

.ask {
    color: #F87171;
}

.bid {
    color: #4ADE80;
}

.ob-qty {
    color: #BBB;
}

.ob-spread {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 2px 4px;
    background: rgba(201, 168, 76, 0.08);
    border: 1px solid rgba(201, 168, 76, 0.2);
    border-radius: 3px;
    margin: 1px 0;
    font-size: clamp(6px, 0.6vw, 9px);
    font-weight: 700;
    color: #4ADE80;
}

.spread-ind {
    font-size: clamp(5px, 0.5vw, 7px);
    color: #4ADE80;
}

.trd-actions {
    display: grid;
    grid-template-columns: 1fr;
    max-width: 800px;
    gap: 6px;
    margin-top: auto;
    margin-bottom: 8px;
}

.btn-buy-long {
    background: linear-gradient(135deg, #4ADE80, #22C55E);
    color: #0A0A0A;
    font-size: clamp(6px, 0.6vw, 9px);
    font-weight: 700;
    text-align: center;
    padding: 6px;
    border-radius: 4px;
    box-shadow: 0 2px 8px rgba(74, 222, 128, 0.25);
}

.btn-sell-short {
    background: linear-gradient(135deg, #F87171, #EF4444);
    color: #0A0A0A;
    font-size: clamp(6px, 0.6vw, 9px);
    font-weight: 700;
    text-align: center;
    padding: 6px;
    border-radius: 4px;
    box-shadow: 0 2px 8px rgba(248, 113, 113, 0.25);
}

.and-nav {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    justify-content: space-around;
    padding: 3% 2% 5%;
    border-top: 1px solid rgba(255, 255, 255, 0.04);
    background: rgba(0, 0, 0, 0.5);
}

.and-nav span {
    font-size: clamp(5px, 0.48vw, 7px);
}

/* Wallet screen (right phone) */
.wal-c {
    padding: 13% 8% 0;
}

.wal-hdr {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 6%;
}

.wal-title {
    font-size: clamp(8px, 0.8vw, 11px);
    font-weight: 700;
    color: #F2EEE6;
}

.wal-sub {
    font-size: clamp(5px, 0.5vw, 7px);
    color: #555;
    margin-top: 1%;
}

.wal-total {
    margin-bottom: 5%;
}

.wal-lbl {
    font-size: clamp(5px, 0.48vw, 7px);
    color: #555;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    margin-bottom: 1%;
}

.wal-amt {
    font-size: clamp(14px, 1.5vw, 22px);
    font-weight: 700;
    color: #F2EEE6;
    font-family: 'Cormorant Garamond', serif;
    line-height: 1;
}

.wal-chg {
    font-size: clamp(6px, 0.58vw, 8px);
    color: #4ADE80;
    margin-top: 1%;
}

.act-row {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 4%;
    margin-bottom: 6%;
}

.act-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4%;
}

.act-ico {
    width: clamp(18px, 1.9vw, 28px);
    height: clamp(18px, 1.9vw, 28px);
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.06);
    border: 1px solid rgba(255, 255, 255, 0.08);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: clamp(7px, 0.7vw, 10px);
    color: #888;
}

.act-lbl {
    font-size: clamp(4px, 0.44vw, 6px);
    color: #444;
    text-align: center;
}

.asset-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 3% 0;
    border-bottom: 1px solid rgba(255, 255, 255, 0.03);
}

.asset-row:last-of-type {
    border-bottom: none;
}

/* Floating badges-glassmorphism theme adjustments */
.badge {
    position: absolute;
    z-index: 15;
    /* Floats above all phone mockup scales & hovers (z-index 12) */
    border-radius: clamp(10px, 1.1vw, 16px);
    padding: clamp(8px, 0.85vw, 13px) clamp(10px, 1vw, 16px);
    backdrop-filter: blur(5px);
    -webkit-backdrop-filter: blur(5px);
    transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);
    transform-style: preserve-3d;
    transform: translateZ(85px);
    /* Elevated 3D stereoscopic depth spacing */
    pointer-events: auto;
}

.badge:hover {
    transform: translateZ(125px) scale(1.08) translateY(-4px) !important;
    box-shadow: 0 35px 75px rgba(0, 0, 0, 0.85), 0 0 25px rgba(201, 168, 76, 0.15) !important;
    z-index: 16;
}

body:not(.light_theme) .badge,
body .badge {
    background: rgba(10, 10, 18, 0.88);
    border: 1px solid rgba(255, 255, 255, 0.08);
    box-shadow: 0 20px 50px rgba(0, 0, 0, 0.7), 0 0 15px rgba(201, 168, 76, 0.05);
    color: #F2EEE6;
}

body:not(.light_theme) .badge.gold,
body .badge.gold {
    border-color: rgba(201, 168, 76, 0.3);
}

body.light_theme .badge {
    background: rgb(255 255 255 / 20%);
    border: 1px solid rgba(0, 0, 0, 0.08);
    box-shadow: 0 15px 40px rgba(0, 0, 0, 0.08), 0 0 10px rgba(0, 0, 0, 0.01);
    color: #1A1A1A;
}

body.light_theme .badge.gold {
    border-color: rgba(201, 168, 76, 0.35);
    background: rgba(253, 251, 242, 0.92);
}

body.light_theme .badge .b-val {
    color: #1A1A1A;
}

body.light_theme .badge .b-sub {
    color: #666 !important;
}

/* positions */
.b-btc {
    bottom: 7%;
    left: 1%;
    animation: bbl 5s ease-in-out infinite;
}

.b-pnl {
    top: 6%;
    right: 0%;
    animation: bbl 6s ease-in-out infinite;
    animation-delay: 1.5s;
}

.b-sec {
    bottom: 28%;
    right: 0%;
    animation: bbl 4.5s ease-in-out infinite;
    animation-delay: 0.7s;
}

@keyframes bbl {

    0%,
    100% {
        transform: translateZ(85px) translateY(0);
    }

    50% {
        transform: translateZ(85px) translateY(-9px);
    }
}

.b-label {
    font-size: clamp(7px, 0.62vw, 10px);
    color: #444;
    letter-spacing: 0.09em;
    text-transform: uppercase;
    margin-bottom: 4px;
}

.b-val {
    font-size: clamp(14px, 1.35vw, 20px);
    font-weight: 700;
    color: #F2EEE6;
    font-family: 'Cormorant Garamond', serif;
    line-height: 1.1;
}

.b-sub {
    font-size: clamp(8px, 0.68vw, 11px);
    margin-top: 3px;
}

.b-row {
    display: flex;
    align-items: center;
    gap: clamp(6px, 0.65vw, 10px);
}

.b-ico {
    width: clamp(22px, 2.1vw, 30px);
    height: clamp(22px, 2.1vw, 30px);
    border-radius: 50%;
    background: rgba(22, 163, 74, 0.12);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: clamp(10px, 0.95vw, 14px);
}

.b-t {
    font-size: clamp(9px, 0.78vw, 12px);
    font-weight: 600;
    color: #C9A84C;
}

.b-s {
    font-size: clamp(7px, 0.62vw, 10px);
    color: #444;
    margin-top: 2px;
}

.live-dot {
    display: inline-block;
    width: 5px;
    height: 5px;
    border-radius: 50%;
    background: #4ADE80;
    box-shadow: 0 0 6px rgba(74, 222, 128, 0.7);
    margin-right: 5px;
    vertical-align: middle;
    animation: lp 2s infinite;
}

@keyframes lp {

    0%,
    100% {
        box-shadow: 0 0 0 0 rgba(74, 222, 128, 0.7);
    }

    50% {
        box-shadow: 0 0 0 5px rgba(74, 222, 128, 0);
    }
}

/* ─── STATS BAR ─── */
.stats {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    max-width: 1200px;
    margin: -40px auto 40px;
    /* Pulls it up so it floats on top of the hero's grid floor */
    background: var(--stats-bg);
    backdrop-filter: blur(5px);
    -webkit-backdrop-filter: blur(5px);
    border: 1px solid var(--stats-border);
    border-radius: 16px;
    position: relative;
    z-index: 25;
    box-shadow: 0 30px 70px rgba(0, 0, 0, 0.35);
    transition: transform 0.3s ease, box-shadow 0.3s ease;
}

body.light_theme .stats {
    box-shadow: 0 15px 40px rgba(0, 0, 0, 0.05);
}

.stats:hover {
    transform: translateY(-2px);
    box-shadow: 0 35px 80px rgba(0, 0, 0, 0.45);
}

body.light_theme .stats:hover {
    box-shadow: 0 20px 50px rgba(0, 0, 0, 0.08);
}

.s-cell {
    padding: clamp(16px, 2vw, 28px) clamp(12px, 1.5vw, 20px);
    text-align: center;
    border-right: 1px solid var(--stats-cell-border);
    transition: background-color 0.3s ease;
}

.s-cell:first-child {
    border-top-left-radius: 15px;
    border-bottom-left-radius: 15px;
}

.s-cell:last-child {
    border-right: none;
    border-top-right-radius: 15px;
    border-bottom-right-radius: 15px;
}

.s-cell:hover {
    background-color: rgba(201, 168, 76, 0.04);
}

@media (max-width: 768px) {
    .stats {
        grid-template-columns: repeat(2, 1fr);
        margin: -20px 4% 30px;
    }

    .s-cell:nth-child(2) {
        border-right: none;
    }

    .s-cell:nth-child(2n) {
        border-right: none;
    }

    .s-cell:nth-child(2n+1) {
        border-right: 1px solid var(--stats-cell-border);
    }

    .s-cell:nth-child(1),
    .s-cell:nth-child(2) {
        border-bottom: 1px solid var(--stats-cell-border);
    }

    .s-cell:first-child {
        border-top-left-radius: 15px;
        border-bottom-left-radius: 0;
    }

    .s-cell:nth-child(2) {
        border-top-right-radius: 15px;
        border-bottom-right-radius: 0;
    }

    .s-cell:nth-child(3) {
        border-bottom-left-radius: 15px;
        border-top-left-radius: 0;
    }

    .s-cell:last-child {
        border-bottom-right-radius: 15px;
        border-top-right-radius: 0;
        border-bottom-left-radius: 0;
    }
}

.s-num {
    font-size: clamp(16px, 1.8vw, 26px);
    font-weight: 700;
    color: #C9A84C;
    font-family: 'Cormorant Garamond', serif;
    line-height: 1;
}

.s-lbl {
    font-size: clamp(8px, 0.68vw, 10px);
    color: #888;
    margin-top: 4px;
    letter-spacing: 0.07em;
    text-transform: uppercase;
}

/* ─── NEXT SECTIONS (Markets & Security) ─── */
.sec-pad {
    padding: 100px 5% 40px;
    border-bottom: none !important;
    position: relative;
    z-index: 10;
    max-width: 1590px;
    margin: 0 auto;
}

.sec-hdr {
    text-align: center;
    max-width: 700px;
    margin: 0 auto 50px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
}

.sec-tag {
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.2em;
    color: #C9A84C;
    text-transform: uppercase;
    background: rgba(201, 168, 76, 0.12);
    border: 1px solid rgba(201, 168, 76, 0.25);
    padding: 6px 16px;
    border-radius: 50px;
}

.sec-title {
    font-size: clamp(28px, 3.5vw, 46px);
    font-weight: 700;
    letter-spacing: -0.02em;
    color: #F2EEE6;
    line-height: 1.15;
}

.sec-sub {
    font-size: clamp(14px, 1.1vw, 17px);
    color: #888;
    line-height: 1.6;
}

/* Markets section */
.mkt-container {
    background: rgba(18, 18, 24, 0.6);
    border: 1px solid rgba(255, 255, 255, 0.06);
    border-radius: 24px;
    padding: 32px 40px;
    box-shadow: 0 30px 80px rgba(0, 0, 0, 0.8);
    backdrop-filter: blur(5px);
    -webkit-backdrop-filter: blur(5px);
}

.mkt-tabs {
    display: flex;
    gap: 12px;
    margin-bottom: 30px;
    overflow-x: auto;
    padding-bottom: 8px;
    scrollbar-width: none;
}

.mkt-tabs::-webkit-scrollbar {
    display: none;
}

.mkt-tab {
    background: rgba(255, 255, 255, 0.03);
    border: 1px solid rgba(255, 255, 255, 0.08);
    color: #888;
    padding: 10px 22px;
    border-radius: 40px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s;
    white-space: nowrap;
}

.mkt-tab:hover {
    color: #F2EEE6;
    background: rgba(255, 255, 255, 0.07);
}

.mkt-tab.active {
    background: linear-gradient(135deg, rgba(201, 168, 76, 0.25), rgba(201, 168, 76, 0.08));
    border-color: rgba(201, 168, 76, 0.4);
    color: #C9A84C;
    font-weight: 700;
}

.table-wrap {
    overflow-x: auto;
}

.mkt-table {
    width: 100%;
    border-collapse: separate;
    border-spacing: 0 12px;
    text-align: left;
}

.mkt-table th {
    font-size: 12px;
    font-weight: 600;
    color: #666;
    text-transform: uppercase;
    letter-spacing: 0.1em;
    padding: 0 20px 8px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.05);
}

.mkt-table tbody tr {
    background: rgba(255, 255, 255, 0.015);
    transition: transform 0.2s, background 0.2s;
}

.mkt-table tbody tr:hover {
    background: rgba(255, 255, 255, 0.04);
    transform: translateY(-2px);
}

.mkt-table td {
    padding: 18px 20px;
    vertical-align: middle;
    border-top: 1px solid rgba(255, 255, 255, 0.03);
    border-bottom: 1px solid rgba(255, 255, 255, 0.03);
}

.mkt-table td:first-child {
    border-left: 1px solid rgba(255, 255, 255, 0.03);
    border-top-left-radius: 14px;
    border-bottom-left-radius: 14px;
}

.mkt-table td:last-child {
    border-right: 1px solid rgba(255, 255, 255, 0.03);
    border-top-right-radius: 14px;
    border-bottom-right-radius: 14px;
}

.highlight-row {
    background: linear-gradient(90deg, rgba(201, 168, 76, 0.08), rgba(201, 168, 76, 0.02)) !important;
    border: 1px solid rgba(201, 168, 76, 0.3) !important;
}

.highlight-row td {
    border-color: rgba(201, 168, 76, 0.25) !important;
}

.t-asset {
    display: flex;
    align-items: center;
    gap: 14px;
}

.t-ico {
    width: 38px;
    height: 38px;
    border-radius: 10px;
    border: 1px solid rgba(255, 255, 255, 0.1);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    font-weight: 700;
}

.t-name {
    font-size: 16px;
    font-weight: 700;
    color: #F2EEE6;
}

.t-tk {
    font-size: 12px;
    color: #777;
    margin-top: 2px;
}

.t-px {
    font-size: 16px;
    font-weight: 700;
    color: #F2EEE6;
    font-family: 'DM Sans', sans-serif;
}

.t-chg {
    font-size: 14px;
    font-weight: 700;
    padding: 4px 10px;
    border-radius: 6px;
    display: inline-block;
}

.t-chg.cup {
    background: rgba(74, 222, 128, 0.12);
    color: #4ADE80;
    border: 1px solid rgba(74, 222, 128, 0.25);
}

.t-chg.cdn {
    background: rgba(248, 113, 113, 0.12);
    color: #F87171;
    border: 1px solid rgba(248, 113, 113, 0.25);
}

.t-vol {
    font-size: 15px;
    color: #AAA;
}

.t-spark {
    width: 120px;
    height: 32px;
    overflow: visible;
}

.btn-trade {
    background: rgba(255, 255, 255, 0.06);
    border: 1px solid rgba(255, 255, 255, 0.15);
    color: #F2EEE6;
    padding: 8px 20px;
    border-radius: 40px;
    font-size: 13px;
    font-weight: 700;
    cursor: pointer;
    transition: all 0.3s;
}

.btn-trade:hover {
    background: #F2EEE6;
    color: #0A0A0A;
    transform: scale(1.05);
    box-shadow: 0 4px 14px rgba(255, 255, 255, 0.2);
}

.gold-trade {
    background: linear-gradient(135deg, #E8C97A, #C9A84C);
    color: #0A0A0A;
    border: none;
    box-shadow: 0 4px 15px rgba(201, 168, 76, 0.3);
}

.gold-trade:hover {
    transform: scale(1.05);
    box-shadow: 0 6px 22px rgba(201, 168, 76, 0.5);
    background: linear-gradient(135deg, #F5E5B0, #C9A84C);
}

.mkt-footer {
    text-align: center;
    margin-top: 24px;
    padding-top: 24px;
    border-top: 1px solid rgba(255, 255, 255, 0.05);
}

.btn-view-all {
    display: inline-block;
    font-size: 15px;
    font-weight: 700;
    color: #C9A84C;
    text-decoration: none;
    transition: all 0.2s;
}

.btn-view-all:hover {
    color: #F5E5B0;
    transform: translateX(4px);
}

/* Security / Bento Layout */
.bento-grid {
    display: grid;
    grid-template-columns: 1.2fr 1fr;
    grid-template-rows: auto auto;
    gap: 24px;
    max-width: 1200px;
    margin: 0 auto;
}

.bento-card {
    background: rgba(18, 18, 24, 0.6);
    border: 1px solid rgba(255, 255, 255, 0.06);
    border-radius: 32px;
    padding: 48px;
    display: flex;
    flex-direction: column;
    position: relative;
    overflow: hidden;
    backdrop-filter: blur(5px);
    -webkit-backdrop-filter: blur(5px);
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.6);
    transition: all 0.4s;
}

.bento-card:hover {
    transform: translateY(-4px);
    border-color: rgba(255, 255, 255, 0.15);
    box-shadow: 0 30px 80px rgba(0, 0, 0, 0.8);
}

.bento-card.feat-large {
    grid-row: span 2;
    border: 1px solid rgba(201, 168, 76, 0.3);
    background: linear-gradient(180deg, rgba(201, 168, 76, 0.08), rgba(18, 18, 24, 0.8));
    justify-content: space-between;
}

.bento-card.feat-large:hover {
    border-color: rgba(201, 168, 76, 0.6);
    box-shadow: 0 30px 80px rgba(201, 168, 76, 0.2);
}

.bc-hdr {
    margin-bottom: 24px;
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.bc-ico-wrap {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.bc-badge {
    font-size: 11px;
    font-weight: 700;
    padding: 6px 14px;
    border-radius: 40px;
    background: rgba(255, 255, 255, 0.06);
    color: #AAA;
    border: 1px solid rgba(255, 255, 255, 0.1);
}

.bc-badge.gold {
    background: rgba(201, 168, 76, 0.15);
    color: #C9A84C;
    border-color: rgba(201, 168, 76, 0.3);
}

.bc-badge.green {
    background: rgba(74, 222, 128, 0.15);
    color: #4ADE80;
    border-color: rgba(74, 222, 128, 0.3);
}

.bc-title {
    font-size: 26px;
    font-weight: 700;
    color: #F2EEE6;
    line-height: 1.25;
}

.bento-card.feat-large .bc-title {
    font-size: 36px;
}

.bc-desc {
    font-size: 15px;
    color: #888;
    line-height: 1.7;
}

/* Animated Mockup Containers */
.bc-mockup {
    width: 100%;
    border-radius: 20px;
    background: rgba(0, 0, 0, 0.4);
    border: 1px solid rgba(255, 255, 255, 0.05);
    margin-top: 24px;
    flex-grow: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    overflow: hidden;
    min-height: 220px;
}

.bento-card.feat-large .bc-mockup {
    min-height: 280px;
}

/* Merkle Tree Mockup */
.merkle-svg {
    width: 100%;
    height: 100%;
    animation: pulseMerkle 3s infinite alternate ease-in-out;
}

@keyframes pulseMerkle {
    0% {
        filter: drop-shadow(0 0 10px rgba(201, 168, 76, 0.1));
    }

    100% {
        filter: drop-shadow(0 0 35px rgba(201, 168, 76, 0.4));
    }
}

.por-terminal {
    position: absolute;
    bottom: 24px;
    left: 24px;
    right: 24px;
    background: rgba(10, 10, 14, 0.95);
    border: 1px solid rgba(201, 168, 76, 0.3);
    border-radius: 14px;
    padding: 20px;
    font-family: monospace;
    font-size: 13px;
    color: #C9A84C;
    display: flex;
    flex-direction: column;
    gap: 12px;
    box-shadow: 0 15px 40px rgba(0, 0, 0, 0.8);
    -webkit-backdrop-filter: blur(5px);
            backdrop-filter: blur(5px);
}

.por-row-live {
    display: flex;
    justify-content: space-between;
    border-bottom: 1px dashed rgba(201, 168, 76, 0.2);
    padding-bottom: 8px;
}

.por-row-live:last-child {
    border-bottom: none;
    padding-bottom: 0;
}

.por-row-live strong {
    color: #4ADE80;
    font-size: 15px;
}

/* Shard Network Mockup */
.shard-net {
    display: flex;
    justify-content: space-between;
    width: 100%;
    padding: 0 40px;
    position: relative;
    z-index: 5;
}

.shard-node {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
}

.shard-box {
    width: 54px;
    height: 54px;
    background: rgba(255, 255, 255, 0.05);
    border: 1px solid rgba(255, 255, 255, 0.15);
    border-radius: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 22px;
    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.5);
    position: relative;
}

.shard-box::after {
    content: '';
    position: absolute;
    top: -4px;
    left: -4px;
    right: -4px;
    bottom: -4px;
    border: 1px solid rgba(74, 222, 128, 0.4);
    border-radius: 18px;
    animation: nodePulse 2s infinite;
}

@keyframes nodePulse {
    0% {
        transform: scale(1);
        opacity: 1;
    }

    100% {
        transform: scale(1.3);
        opacity: 0;
    }
}

.shard-lbl {
    font-size: 11px;
    color: #AAA;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.1em;
}

.shard-line {
    position: absolute;
    top: 50%;
    left: 10%;
    right: 10%;
    height: 2px;
    background: rgba(255, 255, 255, 0.05);
    z-index: 1;
    transform: translateY(-50%);
    overflow: hidden;
}

.shard-pulse {
    width: 25%;
    height: 100%;
    background: linear-gradient(90deg, transparent, #4ADE80, transparent);
    animation: travelPulse 2s infinite linear;
}

@keyframes travelPulse {
    0% {
        transform: translateX(-100%);
    }

    100% {
        transform: translateX(400%);
    }
}

/* Latency Chart Mockup */
.lat-chart {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: flex-end;
    padding: 24px;
    gap: 8px;
    position: relative;
}

.lat-bar {
    flex: 1 1;
    background: linear-gradient(0deg, rgba(74, 222, 128, 0.1), rgba(74, 222, 128, 0.3));
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
    border-top: 2px solid #4ADE80;
    animation: barBounce 1.5s infinite alternate ease-in-out;
}

.lat-bar:nth-child(1) {
    animation-delay: 0.0s;
    height: 40%;
}

.lat-bar:nth-child(2) {
    animation-delay: 0.2s;
    height: 60%;
}

.lat-bar:nth-child(3) {
    animation-delay: 0.4s;
    height: 30%;
}

.lat-bar:nth-child(4) {
    animation-delay: 0.1s;
    height: 80%;
}

.lat-bar:nth-child(5) {
    animation-delay: 0.5s;
    height: 50%;
}

.lat-bar:nth-child(6) {
    animation-delay: 0.3s;
    height: 70%;
}

.lat-bar:nth-child(7) {
    animation-delay: 0.6s;
    height: 45%;
}

.lat-bar:nth-child(8) {
    animation-delay: 0.2s;
    height: 90%;
}

@keyframes barBounce {
    0% {
        transform: scaleY(0.7);
        transform-origin: bottom;
    }

    100% {
        transform: scaleY(1);
        transform-origin: bottom;
    }
}

.lat-overlay {
    position: absolute;
    top: 32px;
    left: 32px;
    font-size: 48px;
    font-weight: 700;
    color: #F2EEE6;
    line-height: 1;
}

.lat-overlay span {
    display: block;
    font-size: 14px;
    color: #4ADE80;
    font-weight: 700;
    margin-top: 8px;
    text-transform: uppercase;
    letter-spacing: 0.1em;
}

@media (max-width:992px) {
    .bento-grid {
        grid-template-columns: 1fr;
    }

    .bento-card.feat-large {
        grid-row: auto;
    }
}

@media (max-width:768px) {

    .trust-bento-grid {
        margin: 20px auto 0;
    }

    .sec-pad {
        padding: 40px 4% 30px;
    }

    .orbit-showcase {
        margin: 20px auto 40px;
    }

    .agcex.orbit-card {
        max-width: 100% !important;
    }

    .sec-hdr {
        margin: 0 auto 0px;
    }

    .mkt-container {
        padding: 24px 20px;
    }

    .sec-grid {
        grid-template-columns: 1fr;
    }

    .mkt-table td {
        padding: 14px 12px;
    }

    .t-spark {
        display: none;
    }

    .mkt-table th:nth-child(5) {
        display: none;
    }
}

/* ─── ECOSYSTEM / PRODUCT SHOWCASE ─── */
.eco-grid {
    display: grid;
    grid-template-columns: 1.2fr 0.8fr;
    gap: 40px;
    margin-top: 40px;
    align-items: center;
}

.eco-card {
    background: rgba(18, 18, 24, 0.6);
    border: 1px solid rgba(255, 255, 255, 0.06);
    border-radius: 28px;
    padding: 48px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    box-shadow: 0 30px 80px rgba(0, 0, 0, 0.8);
    backdrop-filter: blur(5px);
    -webkit-backdrop-filter: blur(5px);
    overflow: hidden;
    position: relative;
}

.eco-card.gold-glow {
    border-color: rgba(201, 168, 76, 0.3);
    background: linear-gradient(180deg, rgba(201, 168, 76, 0.05), rgba(18, 18, 24, 0.8));
}

.eco-header {
    margin-bottom: 32px;
}

.eco-badge {
    display: inline-block;
    padding: 6px 16px;
    background: rgba(201, 168, 76, 0.15);
    color: #C9A84C;
    border: 1px solid rgba(201, 168, 76, 0.3);
    border-radius: 50px;
    font-size: 12px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.15em;
    margin-bottom: 16px;
}

.eco-title {
    font-size: clamp(24px, 2.5vw, 36px);
    font-weight: 700;
    color: #F2EEE6;
    line-height: 1.2;
    margin-bottom: 16px;
}

.eco-desc {
    font-size: 16px;
    color: #888;
    line-height: 1.6;
}

.browser-mockup {
    background: #0a0a0e;
    border: 1px solid rgba(255, 255, 255, 0.12);
    border-radius: 16px;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.9);
    overflow: hidden;
    margin-top: 24px;
}

.browser-bar {
    background: rgba(255, 255, 255, 0.04);
    padding: 12px 16px;
    display: flex;
    align-items: center;
    gap: 8px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.08);
}

.b-dot {
    width: 10px;
    height: 10px;
    border-radius: 50%;
}

.b-dot.r {
    background: #ED6A5E;
}

.b-dot.y {
    background: #F4BF4F;
}

.b-dot.g {
    background: #61C554;
}

.b-url {
    background: rgba(255, 255, 255, 0.06);
    border-radius: 6px;
    padding: 4px 12px;
    font-size: 11px;
    color: #888;
    font-family: monospace;
    flex-grow: 1;
    margin-left: 12px;
}

/* High-Fidelity Web UI */
.hf-web {
    background: #0a0a0e;
    font-family: 'DM Sans', sans-serif;
    color: #F2EEE6;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.hf-web-nav {
    display: flex;
    align-items: center;
    gap: 24px;
    padding: 12px 20px;
    background: rgba(255, 255, 255, 0.02);
    border-bottom: 1px solid rgba(255, 255, 255, 0.06);
    font-size: 13px;
}

.hf-pair {
    font-size: 16px;
    font-weight: 700;
    display: flex;
    align-items: center;
    gap: 8px;
}

.hf-stat {
    display: flex;
    flex-direction: column;
    font-size: 11px;
    color: #888;
    line-height: 1.3;
}

.hf-stat strong {
    color: #F2EEE6;
    font-size: 13px;
    font-weight: 600;
}

.hf-web-body {
    display: grid;
    grid-template-columns: 1fr 260px;
    min-height: 360px;
}

.hf-chart {
    padding: 20px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    border-right: 1px solid rgba(255, 255, 255, 0.06);
}

.hf-chart-hdr {
    display: flex;
    gap: 16px;
    font-size: 12px;
    color: #888;
}

.hf-candles {
    width: 100%;
    height: 100%;
    max-height: 220px;
    overflow: visible;
    margin-top: 10px;
}

.hf-vol-bars {
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    height: 36px;
    padding-top: 8px;
    border-top: 1px solid rgba(255, 255, 255, 0.05);
    width: 100%;
}

.hf-vb {
    width: 7%;
    border-radius: 2px 2px 0 0;
}

.hf-vb.g {
    background: rgba(74, 222, 128, 0.4);
}

.hf-vb.r {
    background: rgba(248, 113, 113, 0.4);
}

.hf-orderbook {
    padding: 16px;
    font-size: 12px;
    display: flex;
    flex-direction: column;
}

.hf-ob-hdr {
    font-weight: 700;
    color: #AAA;
    margin-bottom: 12px;
    text-transform: uppercase;
    letter-spacing: 0.08em;
    font-size: 11px;
}

.hf-ob-asks,
.hf-ob-bids {
    display: flex;
    flex-direction: column;
    gap: 5px;
}

.hf-ob-row {
    display: flex;
    justify-content: space-between;
    position: relative;
    padding: 2px 4px;
    z-index: 1;
}

.hf-ob-row span:nth-child(2) {
    color: #AAA;
    font-family: monospace;
}

.hf-ob-bar {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    z-index: -1;
    opacity: 0.15;
    border-radius: 2px;
}

.hf-ob-bar.r {
    background: #F87171;
}

.hf-ob-bar.g {
    background: #4ADE80;
}

.hf-ob-spread {
    padding: 8px 0;
    margin: 8px 0;
    border-top: 1px solid rgba(255, 255, 255, 0.06);
    border-bottom: 1px solid rgba(255, 255, 255, 0.06);
    font-size: 14px;
    font-weight: 700;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

/* High-Fidelity Mobile UI */
.hf-mob-container {
    padding: 20px 0;
    display: flex;
    justify-content: center;
}

.hf-mobile-phone {
    width: 342px;
    background: #0A0A0E;
    border: 6px solid #222;
    border-radius: 40px;
    padding: 24px 20px;
    box-shadow: 0 35px 90px rgba(0, 0, 0, 0.9), 0 0 0 2px rgba(255, 255, 255, 0.1);
    display: flex;
    flex-direction: column;
    gap: 20px;
    position: relative;
}

.hf-mob-hdr {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.hf-mob-logo img {
    height: 20px;
    width: auto;
}

.hf-mob-actions {
    display: flex;
    gap: 12px;
    font-size: 16px;
    color: #888;
}

.hf-mob-bal {
    background: linear-gradient(135deg, rgba(255, 255, 255, 0.04), rgba(255, 255, 255, 0.01));
    border: 1px solid rgba(255, 255, 255, 0.08);
    padding: 20px;
    border-radius: 24px;
}

.hf-mb-lbl {
    font-size: 12px;
    color: #888;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 8px;
}

.hf-mb-val {
    font-size: 28px;
    font-weight: 700;
    color: #F2EEE6;
    font-family: 'Cormorant Garamond', serif;
    line-height: 1;
    margin-bottom: 8px;
}

.hf-mb-sub {
    font-size: 12px;
    font-weight: 600;
}

.hf-mob-quick {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 10px;
    text-align: center;
}

.hf-mq-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 6px;
    font-size: 11px;
    color: #AAA;
}

.hf-mq-ico {
    width: 42px;
    height: 42px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.05);
    border: 1px solid rgba(255, 255, 255, 0.1);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    transition: all 0.3s;
}

.hf-mq-item:hover .hf-mq-ico {
    transform: scale(1.08);
}

.hf-mob-mkt {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.hf-mm-tabs {
    display: flex;
    gap: 16px;
    font-size: 13px;
    font-weight: 700;
    color: #888;
}

.hf-mm-tabs span:first-child {
    color: #C9A84C;
    border-bottom: 2px solid #C9A84C;
    padding-bottom: 4px;
}

.hf-mm-list {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.hf-mm-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 14px;
    background: rgba(255, 255, 255, 0.02);
    border: 1px solid rgba(255, 255, 255, 0.05);
    border-radius: 16px;
}

.hf-mm-row strong {
    font-size: 14px;
    color: #F2EEE6;
}

.hf-mm-row span {
    font-size: 11px;
    color: #888;
    display: block;
}

.hf-mm-px {
    display: flex;
    align-items: center;
    gap: 12px;
    text-align: right;
}

.hf-mm-px span:first-child {
    font-size: 14px;
    font-weight: 700;
    color: #F2EEE6;
}

.btn-pill {
    padding: 4px 8px;
    border-radius: 8px;
    font-size: 11px;
    font-weight: 700;
}

.btn-pill.g {
    background: rgba(74, 222, 128, 0.2);
    color: #4ADE80;
}

.btn-pill.r {
    background: rgba(248, 113, 113, 0.2);
    color: #F87171;
}

.store-buttons {
    display: flex;
    gap: 16px;
    margin-top: 20px;
    justify-content: center;
}

.store-btn {
    display: flex;
    align-items: center;
    gap: 12px;
    background: rgba(255, 255, 255, 0.05);
    border: 1px solid rgba(255, 255, 255, 0.15);
    padding: 10px 20px;
    border-radius: 12px;
    color: #F2EEE6;
    text-decoration: none;
    transition: all 0.3s;
}

.store-btn:hover {
    background: #f2eee621;
    color: #ffffff;
    transform: translateY(-3px);
    box-shadow: 0 10px 25px rgba(255, 255, 255, 0.2);
}

.store-ico {
    font-size: 24px;
}

.store-txt {
    display: flex;
    flex-direction: column;
    text-align: left;
}

.st-sub {
    font-size: 10px;
    color: #888;
    text-transform: uppercase;
    letter-spacing: 0.05em;
}

.store-btn:hover .st-sub {
    color: #555;
}

.st-title {
    font-size: 15px;
    font-weight: 700;
}

/* Onboarding Step Grid */
.step-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 32px;
    margin-top: 40px;
    position: relative;
}

.step-card {
    background: rgba(18, 18, 24, 0.6);
    border: 1px solid rgba(255, 255, 255, 0.06);
    border-radius: 28px;
    padding: 48px 40px;
    position: relative;
    box-shadow: 0 30px 80px rgba(0, 0, 0, 0.8);
    backdrop-filter: blur(5px);
    -webkit-backdrop-filter: blur(5px);
    transition: all 0.3s;
}

.step-card:hover {
    transform: translateY(-6px);
    border-color: rgba(201, 168, 76, 0.4);
    box-shadow: 0 35px 90px rgba(201, 168, 76, 0.15);
}

.step-num {
    font-size: 54px;
    font-weight: 700;
    color: rgba(201, 168, 76, 0.3);
    line-height: 1;
    margin-bottom: 20px;
    transition: color 0.3s;
}

.step-card:hover .step-num {
    color: #C9A84C;
}

.step-title {
    font-size: 22px;
    font-weight: 700;
    color: #F2EEE6;
    margin-bottom: 14px;
}

.step-text {
    font-size: 15px;
    color: #888;
    line-height: 1.6;
}


/* ─── FINAL CTA & FOOTER ─── */
.cta-sec {
    padding: 120px 5% 80px;
}

.cta-box {
    max-width: 1220px;
    margin: 0 auto;
    background: linear-gradient(135deg, rgba(201, 168, 76, 0.2), rgba(18, 18, 24, 0.8));
    border: 1px solid rgba(201, 168, 76, 0.4);
    border-radius: 36px;
    padding: 80px 60px;
    text-align: center;
    position: relative;
    overflow: hidden;
    box-shadow: 0 40px 100px rgba(201, 168, 76, 0.2);
    backdrop-filter: blur(5px);
    -webkit-backdrop-filter: blur(5px);
}

.cta-bg-glow {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 600px;
    height: 600px;
    background: radial-gradient(circle, rgba(201, 168, 76, 0.2) 0%, rgba(0, 0, 0, 0) 70%);
    z-index: 1;
    pointer-events: none;
}

.cta-content {
    position: relative;
    z-index: 5;
    max-width: 700px;
    margin: 0 auto;
}

.cta-title {
    font-size: clamp(32px, 4vw, 54px);
    font-weight: 700;
    color: #F2EEE6;
    line-height: 1.15;
    margin-bottom: 24px;
}

.cta-desc {
    font-size: clamp(16px, 1.2vw, 20px);
    color: #CCC;
    margin-bottom: 40px;
    line-height: 1.6;
}

.cta-form {
    display: flex;
    gap: 12px;
    max-width: 540px;
    margin: 0 auto;
}

.cta-input {
    flex-grow: 1;
    padding: 20px 28px;
    border-radius: 50px;
    background: rgba(0, 0, 0, 0.6);
    border: 1px solid rgba(255, 255, 255, 0.15);
    color: #F2EEE6;
    font-size: 16px;
    outline: none;
    transition: border-color 0.3s;
}

.cta-input:focus {
    border-color: #C9A84C;
    box-shadow: 0 0 20px rgba(201, 168, 76, 0.3);
}

.cta-btn {
    padding: 20px 40px;
    border-radius: 50px;
    background: linear-gradient(135deg, #E8C97A, #C9A84C);
    color: #0A0A0A;
    font-size: 16px;
    font-weight: 700;
    border: none;
    cursor: pointer;
    transition: all 0.3s;
    white-space: nowrap;
    box-shadow: 0 10px 30px rgba(201, 168, 76, 0.3);
}

.cta-btn:hover {
    transform: scale(1.05);
    box-shadow: 0 15px 40px rgba(201, 168, 76, 0.5);
    background: linear-gradient(135deg, #F5E5B0, #C9A84C);
}

/* .mkt-footer, .ob-footer {
    border-top: 1px solid rgba(255, 255, 255, 0.06);
    background: #070709;
    padding: 80px 5% 40px;
    color: #888;
    font-size: 14px;
    position: relative;
    z-index: 10;
} */

.ft-grid {
    max-width: 1400px;
    margin: 0 auto;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    gap: 60px;
    margin-bottom: 50px;
}

.ft-brand {
    display: flex;
    flex-direction: column;
    gap: 20px;
}

.ft-logo {
    display: flex;
    align-items: center;
    gap: 12px;
    text-decoration: none;
}

.ft-logo img {
    height: 60px;
    width: auto;
}

.ft-desc {
    line-height: 1.7;
    color: #777;
    max-width: 320px;
}

.ft-status {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 8px 16px;
    background: rgba(74, 222, 128, 0.1);
    border: 1px solid rgba(74, 222, 128, 0.2);
    border-radius: 50px;
    width: -moz-fit-content;
    width: fit-content;
}

.ft-status-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #4ADE80;
    box-shadow: 0 0 10px #4ADE80;
}

.ft-status-txt {
    font-size: 12px;
    font-weight: 700;
    color: #4ADE80;
    text-transform: uppercase;
    letter-spacing: 0.08em;
}

.ft-col {
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.ft-title {
    font-size: 18px;
    font-weight: 500;
    color: #F2EEE6;
    text-transform: uppercase;
    letter-spacing: 0px;
    margin-bottom: 8px;
}

.ft-link {
    text-decoration: none;
    color: #888;
    transition: color 0.2s;
}

.ft-copy .ft-link {
    text-decoration: underline !important;
}

.ft-link:hover {
    color: #C9A84C;
}

.ft-bottom {
    max-width: 1400px;
    margin: 0 auto;
    padding-top: 24px;
    border-top: 1px solid rgba(255, 255, 255, 0.05);
    display: flex;
    justify-content: space-between;
    align-items: center;
    text-align: center;
}

.ft-copy {
    font-size: 13px;
}

.ft-socials {
    display: flex;
    gap: 16px;
    font-size: 18px;
}

.ft-soc {
    color: #888;
    text-decoration: none;
    transition: color 0.2s;
}

.ft-soc:hover {
    color: #C9A84C;
}

/* Hero Background Animations & Shapes */
.float-shape {
    position: absolute;
    pointer-events: auto;
    /* Active pointer interactions */
    z-index: 2;
    /* Position behind phones but ahead of grid backgrounds */
    opacity: 0.25;
    cursor: grab;
    transition: opacity 0.3s ease, filter 0.3s ease;
    -webkit-user-select: none;
            user-select: none;
    -webkit-user-drag: none;
}

.float-shape.s1 {
    top: 15%;
    left: 45%;
    width: 350px;
    height: 350px;
    animation: floatShape1 20s infinite linear;
}

.float-shape.s2 {
    top: 40%;
    right: 10%;
    left: auto;
    width: 250px;
    height: 250px;
    animation: floatShape2 16s infinite ease-in-out;
    z-index: 2;
}

.float-shape.s3 {
    top: 5%;
    right: 10%;
    width: 180px;
    height: 180px;
    animation: floatShape3 12s infinite ease-in-out;
}

@keyframes floatShape1 {
    0% {
        transform: rotate(0deg) translate(0, 0) scale(1);
    }

    50% {
        transform: rotate(180deg) translate(40px, -30px) scale(1.1);
    }

    100% {
        transform: rotate(360deg) translate(0, 0) scale(1);
    }
}

@keyframes floatShape2 {

    0%,
    100% {
        transform: translate(0, 0) scale(1);
    }

    50% {
        transform: translate(-30px, -50px) scale(1.2);
    }
}

@keyframes floatShape3 {

    0%,
    100% {
        transform: translate(0, 0) rotate(0deg);
    }

    50% {
        transform: translate(40px, 40px) rotate(45deg);
    }
}

/* Live WebSocket Bar */
.live-status-bar {
    display: flex;
    align-items: center;
    gap: 10px;
    background: rgba(74, 222, 128, 0.1);
    border: 1px solid rgba(74, 222, 128, 0.3);
    padding: 8px 18px;
    border-radius: 50px;
    margin: 0 auto 24px;
    width: -moz-fit-content;
    width: fit-content;
}

.pulse-dot {
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: #4ADE80;
    box-shadow: 0 0 12px #4ADE80;
    animation: livePulse 1.5s infinite;
}

@keyframes livePulse {
    0% {
        transform: scale(0.95);
        opacity: 0.8;
    }

    50% {
        transform: scale(1.2);
        opacity: 1;
        box-shadow: 0 0 20px #4ADE80;
    }

    100% {
        transform: scale(0.95);
        opacity: 0.8;
    }
}

.live-txt {
    font-size: 12px;
    font-weight: 700;
    color: #4ADE80;
    text-transform: uppercase;
    letter-spacing: 0.1em;
}

/* Flash Animations */
@keyframes flashGreen {
    0% {
        background: rgba(74, 222, 128, 0.3);
    }

    100% {
        background: rgba(255, 255, 255, 0.015);
    }
}

@keyframes flashRed {
    0% {
        background: rgba(248, 113, 113, 0.3);
    }

    100% {
        background: rgba(255, 255, 255, 0.015);
    }
}

.flash-green {
    animation: flashGreen 1s ease-out !important;
}

.flash-red {
    animation: flashRed 1s ease-out !important;
}

/* Futuristic Orbit Showcase (\`#features\`) */
.orbit-showcase {
    position: relative;
    width: 100%;
    max-width: 1600px;
    min-height: 1060px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 60px auto 80px;
}

.orbit-rings {
    position: absolute;
    width: 960px;
    height: 960px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    pointer-events: none;
    z-index: 0;
}

.orbit-rings svg {
    width: 100%;
    height: 100%;
    animation: spinRings 60s linear infinite;
}

@keyframes spinRings {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}

.orbit-center-phone {
    position: relative;
    width: 310px;
    height: 630px;
    background: #0A0A0E;
    border: 6px solid #222;
    border-radius: 46px;
    box-shadow: 0 40px 100px rgba(0, 0, 0, 0.9), 0 0 0 2px rgba(255, 255, 255, 0.1), 0 0 80px rgba(201, 168, 76, 0.25);
    z-index: 10;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    margin-top: 280px;
}

.phone-notch {
    width: 100px;
    height: 24px;
    background: #000;
    border-bottom-left-radius: 16px;
    border-bottom-right-radius: 16px;
    margin: 0 auto;
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    z-index: 30;
}

/* Animated App Screen Container */
.phone-app-wrap {
    flex: 1 1;
    position: relative;
    margin-top: 24px;
    overflow: hidden;
}

.app-scr {
    position: absolute;
    inset: 0;
    padding: 16px 18px 0;
    display: flex;
    flex-direction: column;
    gap: 16px;
    opacity: 0;
    pointer-events: none;
    transition: opacity 0.6s ease-in-out;
}

.app-scr.s1 {
    animation: cycleApp1 12s infinite;
}

.app-scr.s2 {
    animation: cycleApp2 12s infinite;
}

.app-scr.s3 {
    animation: cycleApp3 12s infinite;
}

@keyframes cycleApp1 {

    0%,
    28% {
        opacity: 1;
        pointer-events: auto;
    }

    33%,
    100% {
        opacity: 0;
        pointer-events: none;
    }
}

@keyframes cycleApp2 {

    0%,
    30% {
        opacity: 0;
        pointer-events: none;
    }

    33%,
    61% {
        opacity: 1;
        pointer-events: auto;
    }

    66%,
    100% {
        opacity: 0;
        pointer-events: none;
    }
}

@keyframes cycleApp3 {

    0%,
    63% {
        opacity: 0;
        pointer-events: none;
    }

    66%,
    95% {
        opacity: 1;
        pointer-events: auto;
    }

    100% {
        opacity: 0;
        pointer-events: none;
    }
}


/* Radial External Control Wheel next to Center Phone */
.orbit-control-wheel {
    position: absolute;
    top: 50%;
    left: calc(50% + 225px);
    /* Perfectly aligned to the right side of the phone */
    transform: translateY(-50%);
    width: 200px;
    height: 200px;
    z-index: 25;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
}

.wheel-track {
    position: absolute;
    width: 150px;
    height: 150px;
    border: 1px dashed rgba(201, 168, 76, 0.25);
    border-radius: 50%;
    animation: rotateWheelTrack 35s infinite linear;
    pointer-events: none;
}

@keyframes rotateWheelTrack {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}

.wheel-center {
    width: 68px;
    height: 68px;
    border-radius: 50%;
    background: #09090D;
    border: 1.5px solid #C9A84C;
    box-shadow: 0 0 20px rgba(201, 168, 76, 0.35);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-weight: 700;
    font-size: 9.5px;
    z-index: 5;
    -webkit-user-select: none;
            user-select: none;
}

.wheel-item {
    position: absolute;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 3px;
    cursor: pointer;
    color: #666;
    transition: all 0.3s cubic-bezier(0.25, 1, 0.5, 1);
    transform: rotate(var(--angle)) translate(88px) rotate(calc(-1 * var(--angle)));
    z-index: 10;
}

.wheel-item span {
    font-size: 8.5px;
    font-weight: 700;
    letter-spacing: 0.2px;
    transition: color 0.3s;
}

.wheel-icon {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background: #0A0A0E;
    border: 1px solid rgba(255, 255, 255, 0.08);
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s cubic-bezier(0.25, 1, 0.5, 1);
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.5);
}

.wheel-icon svg {
    width: 14px;
    height: 14px;
    stroke: currentColor;
    fill: none;
    stroke-width: 2.2px;
}

/* Animation cycles matching phone screen sync */
.wheel-item.n1 {
    animation: cycleNav1 12s infinite;
}

.wheel-item.n2 {
    animation: cycleNav2 12s infinite;
}

.wheel-item.n3 {
    animation: cycleNav3 12s infinite;
}

/* Hover micro-interactions */
.wheel-item:hover {
    color: #FFF !important;
}

.wheel-item:hover .wheel-icon {
    border-color: #E8C97A;
    color: #E8C97A;
    transform: scale(1.12);
    box-shadow: 0 0 12px rgba(201, 168, 76, 0.45);
}

/* Tablet/Mobile Responsive Override */
@media (max-width: 991px) {
    .orbit-control-wheel {
        position: relative !important;
        top: auto !important;
        left: auto !important;
        transform: none !important;
        margin: 25px auto 35px !important;
        width: 100% !important;
        max-width: 310px !important;
        height: 200px !important;
    }
}


@keyframes cycleNav1 {

    0%,
    28% {
        color: #C9A84C;
    }

    33%,
    100% {
        color: #666;
    }
}

@keyframes cycleNav2 {

    0%,
    30% {
        color: #666;
    }

    33%,
    61% {
        color: #C9A84C;
    }

    66%,
    100% {
        color: #666;
    }
}

@keyframes cycleNav3 {

    0%,
    63% {
        color: #666;
    }

    66%,
    95% {
        color: #C9A84C;
    }

    100% {
        color: #666;
    }
}

/* App Screen Internal Styling */
.app-hdr {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 13px;
    color: #AAA;
}

.app-logo-mini {
    height: 18px;
    width: auto;
}

.app-search-pill {
    background: rgba(255, 255, 255, 0.05);
    border: 1px solid rgba(255, 255, 255, 0.1);
    padding: 4px 10px;
    border-radius: 14px;
    font-size: 11px;
    color: #888;
    display: flex;
    align-items: center;
    gap: 6px;
}

.app-card-bal {
    background: linear-gradient(135deg, rgba(201, 168, 76, 0.1), rgba(255, 255, 255, 0.02));
    border: 1px solid rgba(201, 168, 76, 0.3);
    padding: 16px;
    border-radius: 20px;
}

.app-card-lbl {
    font-size: 11px;
    color: #888;
    margin-bottom: 4px;
}

.app-card-val {
    font-size: 24px;
    font-weight: 700;
    color: #F2EEE6;
    font-family: 'Cormorant Garamond', serif;
    line-height: 1;
    margin-bottom: 6px;
}

.app-badge {
    display: inline-block;
    background: rgba(74, 222, 128, 0.15);
    color: #4ADE80;
    border: 1px solid rgba(74, 222, 128, 0.3);
    padding: 2px 8px;
    border-radius: 10px;
    font-size: 10px;
    font-weight: 700;
}

.app-quick-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 8px;
    text-align: center;
}

.app-q-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
    font-size: 10px;
    color: #AAA;
}

.app-q-ico {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.06);
    border: 1px solid rgba(255, 255, 255, 0.12);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
}

.app-q-item:hover .app-q-ico {
    background: #c9a84c00;
    color: #0A0A0A;
}

.app-list-hdr {
    font-size: 12px;
    font-weight: 700;
    color: #AAA;
    margin-bottom: 4px;
}

.app-list {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.app-mkt-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 12px;
    background: rgba(255, 255, 255, 0.02);
    border: 1px solid rgba(255, 255, 255, 0.05);
    border-radius: 14px;
}

.app-mkt-row strong {
    font-size: 13px;
    color: #F2EEE6;
    display: block;
}

.app-mkt-row span {
    font-size: 10px;
    color: #888;
}

.app-chart-box {
    background: rgba(255, 255, 255, 0.02);
    border: 1px solid rgba(255, 255, 255, 0.05);
    border-radius: 18px;
    padding: 12px;
    height: 140px;
}

.app-ob-box {
    display: grid;
    grid-template-columns: 1fr;
    max-width: 800px;
    gap: 12px;
    font-size: 10px;
    font-family: monospace;
    padding: 8px 0;
}

.app-buttons {
    display: flex;
    gap: 10px;
    margin-top: auto;
    padding-bottom: 10px;
}

.app-btn {
    flex: 1 1;
    padding: 12px 0;
    border-radius: 14px;
    font-size: 13px;
    font-weight: 700;
    border: none;
    text-align: center;
}

.app-btn.g {
    background: #4ADE80;
    color: #0A0A0A;
    box-shadow: 0 6px 15px rgba(74, 222, 128, 0.3);
}

.app-btn.r {
    background: #F87171;
    color: #0A0A0A;
    box-shadow: 0 6px 15px rgba(248, 113, 113, 0.3);
}

/* Connecting SVG Beams */
.orbit-beams {
    position: absolute;
    inset: 0;
    pointer-events: none;
    z-index: 2;
}

.orbit-beams svg {
    width: 100%;
    height: 100%;
}

.beam-line {
    stroke: rgba(201, 168, 76, 0.3);
    stroke-width: 2;
    stroke-dasharray: 8 6;
    animation: beamPulse 30s linear infinite;
}

@keyframes beamPulse {
    0% {
        stroke-dashoffset: 1000;
    }

    100% {
        stroke-dashoffset: 0;
    }
}

/* Reusable Orbit Animation Mechanics */
.orbit-track {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 1040px;
    height: 1040px;
    transform: translate(-50%, -50%);
    border-radius: 50%;
    z-index: 20;
    pointer-events: none;
    animation: spinTrack 60s linear infinite;
}

.orbit-track:hover {
    animation-play-state: paused;
}

.orbit-node {
    position: absolute;
    width: 0;
    height: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    animation: counterSpin 60s linear infinite;
}

.orbit-track:hover .orbit-node {
    animation-play-state: paused;
}

@keyframes spinTrack {
    0% {
        transform: translate(-50%, -50%) rotate(0deg);
    }

    100% {
        transform: translate(-50%, -50%) rotate(360deg);
    }
}

@keyframes counterSpin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(-360deg);
    }
}

/* Orbit Feature Cards */
.orbit-card {
    width: 460px;
    background: rgba(18, 18, 24, 0.75);
    border: 1px solid rgba(255, 255, 255, 0.08);
    border-radius: 20px;
    padding: 22px 28px;
    box-shadow: 0 25px 70px rgba(0, 0, 0, 0.85);
    backdrop-filter: blur(5px);
    -webkit-backdrop-filter: blur(5px);
    transition: all 0.4s cubic-bezier(0.16, 1, 0.3, 1);
    display: flex;
    flex-direction: column;
    pointer-events: auto;
    cursor: default;
}

.orbit-card:hover {
    transform: scale(1.06) translateY(-8px);
    border-color: #C9A84C;
    box-shadow: 0 35px 90px rgba(201, 168, 76, 0.25), 0 0 30px rgba(201, 168, 76, 0.1);
    z-index: 30;
}

.orbit-card.premium {
    border: 1px solid rgba(201, 168, 76, 0.4);
    background: linear-gradient(180deg, rgba(201, 168, 76, 0.12), rgba(18, 18, 24, 0.85));
    width: 480px;
}

/* Node Positions (Radius ~ 450px) */
.orbit-node.n1 {
    top: 0%;
    left: 50%;
}

.orbit-node.n2 {
    top: 50%;
    left: 100%;
}

.orbit-node.n3 {
    top: 100%;
    left: 50%;
}

.orbit-node.n4 {
    top: 50%;
    left: 0%;
}

.orbit-hdr {
    display: flex;
    align-items: center;
    gap: 16px;
    margin-bottom: 12px;
}

.orbit-ico {
    width: 44px;
    height: 44px;
    border-radius: 12px;
    background: rgba(201, 168, 76, 0.12);
    border: 1px solid rgba(201, 168, 76, 0.25);
    color: #C9A84C;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.4);
    flex-shrink: 0;
}

.orbit-title {
    font-size: 18px;
    font-weight: 700;
    color: #F2EEE6;
    margin: 0;
    line-height: 1.1;
}

.orbit-desc {
    font-size: 13px;
    color: #888;
    line-height: 1.5;
    margin-bottom: 0;
}

.orbit-link {
    margin-top: 14px;
    font-size: 13px;
    font-weight: 700;
    color: #C9A84C;
    text-decoration: none;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    transition: gap 0.2s;
}

.orbit-card:hover .orbit-link {
    gap: 10px;
    color: #E8C97A;
}

/* USP Section */
.usp-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 24px;
    margin-top: 40px;
}

.usp-card {
    box-sizing: border-box !important;
    background: rgba(18, 18, 24, 0.6);
    border: 1px solid rgba(255, 255, 255, 0.06);
    border-radius: 26px;
    padding: 40px 32px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    position: relative;
    box-shadow: 0 25px 70px rgba(0, 0, 0, 0.7);
    backdrop-filter: blur(5px);
    -webkit-backdrop-filter: blur(5px);
    transition: all 0.4s;
}

.usp-card:hover {
    transform: translateY(-6px);
    border-color: rgba(201, 168, 76, 0.4);
    box-shadow: 0 35px 90px rgba(201, 168, 76, 0.15);
}

.usp-vector {
    width: 100%;
    height: 140px;
    margin-bottom: 24px;
    background: rgba(0, 0, 0, 0.4);
    border: 1px solid rgba(255, 255, 255, 0.05);
    border-radius: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    position: relative;
}

.usp-vector svg {
    width: 100%;
    height: 100%;
}

.usp-title {
    font-size: 20px;
    font-weight: 700;
    color: #F2EEE6;
    margin-bottom: 12px;
}

.usp-desc {
    font-size: 14px;
    color: #888;
    line-height: 1.6;
}

/* Gamified Interactive Matrix Styling */
.usp-sim-box {
    width: 100%;
    box-sizing: border-box !important;
    margin: 20px 0;
    padding: 14px 16px;
    background: rgba(0, 0, 0, 0.5);
    border: 1px solid rgba(255, 255, 255, 0.08);
    border-radius: 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 13px;
    font-family: monospace;
}

.usp-sim-val {
    font-weight: 700;
    color: #F2EEE6;
    transition: color 0.3s;
}

.usp-sim-tag {
    padding: 4px 10px;
    border-radius: 12px;
    font-size: 11px;
    font-weight: 700;
    background: rgba(255, 255, 255, 0.1);
    color: #AAA;
    transition: all 0.3s;
}

.usp-sim-tag.active {
    background: rgba(74, 222, 128, 0.2);
    color: #4ADE80;
    box-shadow: 0 0 15px rgba(74, 222, 128, 0.4);
}

.usp-action-btn {
    width: 100%;
    padding: 14px 20px;
    background: linear-gradient(135deg, rgba(201, 168, 76, 0.15), rgba(201, 168, 76, 0.05));
    border: 1px solid #C9A84C;
    border-radius: 16px;
    color: #C9A84C;
    font-size: 13px;
    font-weight: 700;
    cursor: pointer;
    transition: all 0.3s;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    margin-top: auto;
}

.usp-action-btn svg.btn-svg-icon {
    width: 16px;
    height: 16px;
    stroke: currentColor;
    fill: none;
    stroke-width: 2.2px;
    flex-shrink: 0;
    transition: stroke 0.3s, transform 0.3s;
}

.usp-action-btn:hover {
    background: linear-gradient(135deg, #E8C97A, #C9A84C);
    color: #0A0A0A;
    transform: translateY(-2px);
    box-shadow: 0 10px 25px rgba(201, 168, 76, 0.3);
}

.usp-action-btn:active {
    transform: translateY(0);
}

.usp-action-btn:disabled {
    opacity: 0.6;
    cursor: not-allowed;
    background: rgba(255, 255, 255, 0.1);
    color: #888;
    border-color: rgba(255, 255, 255, 0.15);
}

/* Dynamic Simulation Animations */
.wave-path {
    transition: all 0.5s;
    stroke-dasharray: 400;
    stroke-dashoffset: 400;
}

.sim-running .wave-path {
    animation: surgeWaves 1.2s infinite linear;
}

@keyframes surgeWaves {
    0% {
        stroke-dashoffset: 400;
    }

    100% {
        stroke-dashoffset: 0;
    }
}

.ping-racer {
    stroke-dasharray: 20 200;
    stroke-dashoffset: 220;
}

.sim-running .ping-racer {
    animation: racePing 0.6s infinite linear;
}

@keyframes racePing {
    0% {
        stroke-dashoffset: 220;
    }

    100% {
        stroke-dashoffset: -200;
    }
}





/* --- LIGHT THEME OVERRIDES (DEFAULT) --- */


/* Typography & Hero */
body.light_theme .brand-name,
body.light_theme .tl.gold {
    background: linear-gradient(130deg, #D4AF37 0%, #B8860B 50%, #8B6508 100%) !important;
    -webkit-background-clip: text !important;
    -webkit-text-fill-color: transparent !important;
    background-clip: text !important;
}

body.light_theme .sub {
    color: #555;
}

body.light_theme .sub em {
    color: #B8860B !important;
}

body.light_theme .tl {
    color: #111;
}

body.light_theme .sec-title,
body.light_theme .cta-title,
body.light_theme .eco-title {
    color: #111;
}

body.light_theme .sec-sub,
body.light_theme .cta-desc {
    color: #555;
}

body.light_theme .sec-tag {
    background: rgba(0, 0, 0, 0.04);
    color: #333;
    border-color: rgba(0, 0, 0, 0.08);
}

/* Actions & Inputs */
body.light_theme .email-input,
body.light_theme .cta-input {
    background: #FFF;
    border-color: rgba(0, 0, 0, 0.1);
    color: #111;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.03);
}

body.light_theme .s-label {
    color: #666;
}

body.light_theme .s-ico-btn {
    background: #FFF;
    border-color: rgba(0, 0, 0, 0.1);
    color: #444;
}

body.light_theme .s-ico-btn svg path {
    fill: #444;
}

body.light_theme .s-divider-pro {
    background: rgba(0, 0, 0, 0.1);
}

body.light_theme .t-pill {
    background: #FFF;
    border-color: rgba(0, 0, 0, 0.08);
    color: #444;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.02);
}

body.light_theme .btn-trade {
    background: #FFF;
    border-color: rgba(0, 0, 0, 0.15);
    color: #111;
}

body.light_theme .btn-trade:hover {
    background: #111;
    color: #FFF;
}

body.light_theme .store-btn {
    background: #FFF;
    border-color: rgba(0, 0, 0, 0.15);
    color: #111;
}

body.light_theme .store-btn:hover {
    border-color: #C9A84C;
}

/* Cards & Modules */
body.light_theme .sec-card,
body.light_theme .bento-card,
body.light_theme .usp-card,
body.light_theme .orbit-card,
body.light_theme .eco-card,
body.light_theme .step-card,
body.light_theme .mkt-container {
    background: #FFF;
    border-color: rgba(0, 0, 0, 0.06);
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.04);
}

body.light_theme .sec-card:hover,
body.light_theme .bento-card:hover,
body.light_theme .usp-card:hover,
body.light_theme .orbit-card:hover,
body.light_theme .step-card:hover {
    border-color: rgba(201, 168, 76, 0.4);
    box-shadow: 0 20px 50px rgba(201, 168, 76, 0.1);
    transform: translateY(-4px);
}

body.light_theme .sc-title,
body.light_theme .bc-title,
body.light_theme .usp-title,
body.light_theme .orbit-title,
body.light_theme .step-title,
body.light_theme .eco-title {
    color: #111;
}

body.light_theme .sc-text,
body.light_theme .bc-desc,
body.light_theme .usp-desc,
body.light_theme .orbit-desc,
body.light_theme .step-text,
body.light_theme .eco-desc {
    color: #555;
}

body.light_theme .usp-vector,
body.light_theme .bc-mockup,
body.light_theme .sc-visual,
body.light_theme .sc-por,
body.light_theme .sc-speed {
    background: #F8F9FA !important;
    border-color: rgba(0, 0, 0, 0.04) !important;
}

body.light_theme .usp-sim-box {
    background: #FFF;
    border-color: rgba(0, 0, 0, 0.08);
}

body.light_theme .usp-sim-val {
    color: #111;
}

body.light_theme .por-terminal {
    background: #FFF;
    border-color: rgba(0, 0, 0, 0.1);
    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.05);
}

body.light_theme .shard-box {
    background: #FFF;
    border-color: rgba(0, 0, 0, 0.1);
    color: #111;
}

body.light_theme .lat-overlay {
    color: #111;
}

/* Table & Filters */
body.light_theme .mkt-tab {
    background: #F8F9FA;
    border-color: rgba(0, 0, 0, 0.08);
    color: #555;
}

body.light_theme .mkt-tab:hover {
    background: #EFEFEF;
    color: #111;
}

body.light_theme .mkt-tab.active {
    background: rgba(201, 168, 76, 0.1);
    border-color: rgba(201, 168, 76, 0.4);
    color: #C9A84C;
}

body.light_theme .mkt-table th {
    color: #666;
    border-bottom: 1px solid rgba(0, 0, 0, 0.08);
}

body.light_theme .mkt-table td {
    color: #111;
    border-bottom: 1px solid rgba(0, 0, 0, 0.04);
    border-top: 1px solid rgba(0, 0, 0, 0.02);
}

body.light_theme .mkt-table tbody tr {
    background: rgba(0, 0, 0, 0.015);
}

body.light_theme .mkt-table tr:hover td {
    background: rgba(0, 0, 0, 0.03);
}

body.light_theme .btn-filter {
    background: rgba(0, 0, 0, 0.04);
    color: #555;
}

body.light_theme .btn-filter:hover {
    background: rgba(0, 0, 0, 0.08);
    color: #111;
}

body.light_theme .btn-filter.active {
    background: #FFF;
    border: 1px solid rgba(0, 0, 0, 0.1);
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.05);
    color: #111;
}

body.light_theme .coin-sym {
    color: #888;
}

body.light_theme .mkt-footer {
    border-color: rgba(0, 0, 0, 0.08);
}

body.light_theme .t-name {
    color: #111;
}

body.light_theme .t-px {
    color: #111;
}

/* CTA Box & Misc overrides */
body.light_theme .cta-box {
    background: linear-gradient(135deg, rgba(201, 168, 76, 0.15), #FFFFFF) !important;
    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.05);
    border-color: rgba(201, 168, 76, 0.25);
}

body.light_theme .step-num {
    color: rgba(201, 168, 76, 0.8);
}

body.light_theme .auth-logos div {
    color: #111 !important;
}

body.light_theme .orbit-center-phone .app-ph {
    box-shadow: 0 30px 80px rgba(0, 0, 0, 0.2);
}

body.light_theme .float-shape svg polygon,
body.light_theme .float-shape svg circle {
    stroke: rgba(0, 0, 0, 0.15) !important;
}

body.light_theme .pg {
    background: radial-gradient(ellipse at center,
            rgba(201, 168, 76, 0.45) 0%,
            rgba(201, 168, 76, 0.22) 35%,
            rgba(232, 201, 122, 0.06) 60%,
            transparent 75%);
    filter: blur(60px);
}

/* Footer */

body.light_theme .ft-desc {
    color: #A0A3A7;
}

body.light_theme .ft-title {
    color: #fff;
}

body.light_theme .ft-link {
    color: #A0A3A7;
}

body.light_theme .ft-bottom {
    border-top: 1px solid rgb(143 143 143 / 16%);
}

body.light_theme .ft-copy {
    color: #A0A3A7;
}

body.light_theme .ft-soc {
    color: #666;
}

/* QR Modal */
.qr-modal {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 9999;
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0;
    pointer-events: none;
    transition: opacity 0.3s ease;
}

.qr-modal.active {
    opacity: 1;
    pointer-events: all;
}

.qr-modal-bg {
    position: absolute;
    inset: 0;
    background: rgba(0, 0, 0, 0.8);
    -webkit-backdrop-filter: blur(5px);
            backdrop-filter: blur(5px);
}

.qr-modal-content {
    position: relative;
    background: #0A0A0E;
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 24px;
    padding: 40px;
    text-align: center;
    max-width: 400px;
    width: 90%;
    transform: translateY(20px) scale(0.95);
    transition: transform 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
    box-shadow: 0 40px 100px rgba(0, 0, 0, 0.5);
}

.qr-modal.active .qr-modal-content {
    transform: translateY(0) scale(1);
}

.qr-close {
    position: absolute;
    top: 20px;
    right: 20px;
    font-size: 20px;
    color: #888;
    cursor: pointer;
    transition: color 0.2s;
}

.qr-close:hover {
    color: #F2EEE6;
}

.qr-title {
    font-size: 22px;
    font-weight: 700;
    color: #F2EEE6;
    margin-bottom: 12px;
}

.qr-desc {
    font-size: 14px;
    color: #888;
    margin-bottom: 30px;
    line-height: 1.5;
}

.qr-box {
    background: #FFF;
    padding: 20px;
    border-radius: 16px;
    display: inline-block;
    box-shadow: 0 0 30px rgba(201, 168, 76, 0.3);
}

body.light_theme .qr-modal-bg {
    background: rgb(255 255 255 / 20%);
}

body.light_theme .qr-modal-content {
    background: #FFF;
    border-color: rgba(0, 0, 0, 0.1);
    box-shadow: 0 40px 100px rgba(0, 0, 0, 0.15);
}

body.light_theme .qr-title {
    color: #111;
}

/* Step Graphics Animations */
.step-gfx {
    height: 120px;
    margin-bottom: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
}

.sg-scan-line {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 2px;
    background: #4ADE80;
    box-shadow: 0 0 10px #4ADE80;
    animation: scanLine 2s infinite linear;
}

@keyframes scanLine {
    0% {
        top: 10%;
        opacity: 0;
    }

    10% {
        opacity: 1;
    }

    90% {
        opacity: 1;
    }

    100% {
        top: 90%;
        opacity: 0;
    }
}

.sg-float {
    animation: sgFloat 3s ease-in-out infinite;
}

@keyframes sgFloat {

    0%,
    100% {
        transform: translateY(0);
    }

    50% {
        transform: translateY(-10px);
    }
}

.sg-glow {
    filter: drop-shadow(0 0 15px rgba(201, 168, 76, 0.5));
}

/* ─── High-Fidelity Mobile App Screens CSS ─── */
.s26-screen {
    container-type: inline-size;
}

.hf-screen {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
    -webkit-user-select: none;
            user-select: none;
    position: relative;
    padding-bottom: 12cqw;
    line-height: 1.2;
    overflow: hidden;
    transition: background 0.4s ease, color 0.4s ease;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    backface-visibility: hidden;
    transform: translate3d(0, 0, 0);
    background: #FFFFFF;
    color: #000000;
    --bg-bar: #F3F4F6;
    --bg-card: #F9FAFB;
    --border-color: #E5E7EB;
    --text-muted: #6B7280;
    --text-main: #111827;
    --bg-btn-inactive: #E5E7EB;
    --text-btn-inactive: #374151;
    --bg-tab-active: #FFFFFF;
    --shadow-sm: 0 1px 2px rgba(0, 0, 0, 0.05);
    --color-green: #2ebd85;
    --color-red: #ea3943;
    --color-gold: #C9A84C;
    --color-gold-hover: #E8C97A;
    --bg-green-soft: rgba(46, 189, 133, 0.15);
    --bg-red-soft: rgba(234, 57, 67, 0.15);
    --bg-gold-soft: rgba(201, 168, 76, 0.15);
}

body:not(.light_theme) .hf-screen {
    background: #0B0B0E;
    color: #F3F4F6;
    --bg-bar: #14141A;
    --bg-card: #181822;
    --border-color: #262635;
    --text-muted: #8E8E9F;
    --text-main: #F3F4F6;
    --bg-btn-inactive: #262635;
    --text-btn-inactive: #A1A1B5;
    --bg-tab-active: #262635;
    --shadow-sm: 0 1px 2px rgba(0, 0, 0, 0.5);
}

.hf-status-bar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 6.5cqw 4.5cqw 1.5cqw;
    font-size: 2.8cqw;
    font-weight: 600;
    color: var(--text-muted);
    background: transparent;
    z-index: 10;
}

.status-left,
.status-right {
    display: flex;
    align-items: center;
    gap: 1.5cqw;
}

.status-time {
    color: var(--text-main);
}

.status-icons span,
.status-right span {
    display: inline-flex;
    align-items: center;
    font-size: 2.6cqw;
}

.hf-nav-bar-tabs {
    display: flex;
    align-items: center;
    padding: 1cqw 3cqw;
    border-bottom: 1px solid var(--border-color);
    gap: 3cqw;
}

.back-arrow {
    font-size: 4cqw;
    font-weight: 700;
    color: var(--text-main);
    cursor: pointer;
}

.nav-tabs-scroll,
.segments-scroll {
    display: flex;
    gap: 4.5cqw;
    overflow-x: auto;
    scrollbar-width: none;
    flex: 1 1;
}

.nav-tabs-scroll::-webkit-scrollbar,
.segments-scroll::-webkit-scrollbar {
    display: none;
}

.nav-tab,
.segment,
.sub-tab {
    font-size: 3.3cqw;
    font-weight: 500;
    color: var(--text-muted);
    padding: 1.5cqw 0;
    position: relative;
    white-space: nowrap;
    cursor: pointer;
}

.nav-tab.active,
.segment.active,
.sub-tab.active {
    color: var(--text-main);
    font-weight: 700;
}

.nav-tab.active::after,
.segment.active::after,
.sub-tab.active::after {
    content: "";
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 0.6cqw;
    background: var(--color-green);
    border-radius: 1px;
}

.wallet-screen .segment.active::after {
    background: var(--text-main);
}

.hf-coin-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 2cqw 3.5cqw;
}

.coin-selector {
    display: flex;
    align-items: center;
    gap: 1.5cqw;
}

.coin-pair {
    font-size: 4.2cqw;
    font-weight: 700;
    color: var(--text-main);
}

.coin-arrow {
    font-size: 3.5cqw;
    color: var(--text-muted);
}

.coin-badge {
    font-size: 2.5cqw;
    font-weight: 700;
    padding: 0.5cqw 1.5cqw;
    border-radius: 0.8cqw;
}

.coin-badge.change-down {
    background: var(--bg-red-soft);
    color: var(--color-red);
}

.coin-badge.change-up {
    background: var(--bg-green-soft);
    color: var(--color-green);
}

.coin-actions {
    display: flex;
    gap: 3.5cqw;
    font-size: 3.8cqw;
    color: var(--text-muted);
}

.hf-main-grid {
    display: grid;
    grid-template-columns: 46% 51%;
    gap: 3%;
    padding: 1cqw 2cqw;
    flex: 1 1;
    overflow: hidden;
}

.hf-order-book {
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: space-between;
}

.ob-header {
    display: flex;
    justify-content: space-between;
    font-size: 2.4cqw;
    color: var(--text-muted);
    font-weight: 500;
    margin-bottom: 1.2cqw;
}

.ob-asks,
.ob-bids {
    display: flex;
    flex-direction: column;
    gap: 0.8cqw;
}

.ob-row {
    display: flex;
    justify-content: space-between;
    font-size: 2.5cqw;
    font-family: monospace;
    font-weight: 500;
}

.ob-row span:last-child {
    color: var(--text-muted);
}

.price-red {
    color: var(--color-red);
}

.price-green {
    color: var(--color-green);
}

.ob-mid-price {
    margin: 1.5cqw 0;
    padding: 0.5cqw 0;
    border-top: 1px dashed var(--border-color);
    border-bottom: 1px dashed var(--border-color);
    text-align: center;
}

.mid-value {
    font-size: 4cqw;
    font-weight: 700;
}

.mid-change {
    font-size: 2.4cqw;
    font-weight: 600;
}

.ob-bar-graph {
    display: flex;
    height: 0.8cqw;
    border-radius: 0.4cqw;
    overflow: hidden;
    margin-top: 1.5cqw;
}

.bar-red {
    background: var(--color-red);
    opacity: 0.8;
}

.bar-green {
    background: var(--color-green);
    opacity: 0.8;
}

.ob-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 1.5cqw;
    font-size: 2.6cqw;
    color: var(--text-muted);
}

.hf-trade-form {
    display: flex;
    flex-direction: column;
    gap: 1.8cqw;
    height: 100%;
}

.form-tabs {
    display: flex;
    border-radius: 1.2cqw;
    background: var(--bg-bar);
    padding: 0.6cqw;
    gap: 0.6cqw;
}

.form-tabs span {
    flex: 1 1;
    text-align: center;
    font-size: 3cqw;
    font-weight: 700;
    padding: 1cqw 0;
    border-radius: 0.8cqw;
    cursor: pointer;
}

.form-tabs .tab-buy.active {
    background: var(--color-green);
    color: #FFFFFF;
}

.form-tabs .tab-sell.active {
    background: var(--color-red);
    color: #FFFFFF;
}

.form-order-type {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: var(--bg-card);
    border: 1px solid var(--border-color);
    border-radius: 1cqw;
    padding: 1cqw 2cqw;
    font-size: 2.8cqw;
    font-weight: 600;
    color: var(--text-main);
}

.form-input {
    display: flex;
    align-items: center;
    background: var(--bg-card);
    border: 1px solid var(--border-color);
    border-radius: 1.2cqw;
    padding: 0.6cqw 1cqw;
    position: relative;
}

.btn-input {
    width: 4.5cqw;
    height: 4.5cqw;
    border-radius: 0.8cqw;
    background: var(--bg-bar);
    color: var(--text-main);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 3.5cqw;
    font-weight: 700;
    cursor: pointer;
}

.form-input input {
    flex: 1 1;
    border: none;
    background: transparent;
    outline: none;
    text-align: center;
    font-size: 3cqw;
    font-weight: 700;
    color: var(--text-main);
    padding: 0.8cqw 0;
    width: 100%;
}

.form-input input::placeholder {
    color: var(--text-muted);
    font-weight: 500;
    font-size: 2.7cqw;
}

.input-lbl {
    position: absolute;
    left: 2.2cqw;
    font-size: 2.2cqw;
    color: var(--text-muted);
    font-weight: 500;
    pointer-events: none;
    transform: scale(0.9);
}

.form-slider {
    display: flex;
    flex-direction: column;
    gap: 1cqw;
    margin: 0.5cqw 0;
}

.slider-track {
    position: relative;
    height: 0.8cqw;
    background: var(--bg-bar);
    border-radius: 0.4cqw;
}

.slider-fill {
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    background: var(--color-green);
    border-radius: inherit;
}

.slider-node {
    position: absolute;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 2cqw;
    height: 2cqw;
    border-radius: 50%;
    background: var(--bg-tab-active);
    border: 0.6cqw solid var(--border-color);
    z-index: 2;
}

.slider-node.active {
    border-color: var(--color-green);
    background: #FFFFFF;
}

.slider-labels {
    display: flex;
    justify-content: space-between;
    font-size: 2.2cqw;
    color: var(--text-muted);
    font-weight: 500;
}

.form-checkboxes {
    display: flex;
    gap: 3cqw;
    font-size: 2.5cqw;
    color: var(--text-muted);
    font-weight: 600;
}

.form-checkboxes label {
    display: flex;
    align-items: center;
    gap: 0.8cqw;
}

body.light_theme .vault-core {
    color: #000000;
}

.form-assets {
    display: flex;
    flex-direction: column;
    gap: 0.6cqw;
    font-size: 2.4cqw;
    color: var(--text-muted);
}

.asset-row {
    display: flex;
    justify-content: space-between;
}

.asset-row strong {
    color: var(--text-main);
}

.form-quick-btns {
    display: flex;
    gap: 1.5cqw;
}

.form-quick-btns span {
    flex: 1 1;
    text-align: center;
    font-size: 2.5cqw;
    font-weight: 700;
    background: var(--bg-btn-inactive);
    color: var(--text-btn-inactive);
    padding: 1cqw 0;
    border-radius: 0.8cqw;
    cursor: pointer;
}

.btn-submit-trade {
    width: 100%;
    border: none;
    outline: none;
    background: var(--color-green);
    color: #FFFFFF;
    font-weight: 700;
    font-size: 3.2cqw;
    padding: 1.8cqw 0;
    border-radius: 1.2cqw;
    cursor: pointer;
    box-shadow: 0 4px 10px rgba(46, 189, 133, 0.2);
}

.form-maker-taker {
    display: flex;
    justify-content: space-between;
    font-size: 2cqw;
    color: var(--text-muted);
}

.hf-promo-bar {
    background: rgba(201, 168, 76, 0.15);
    border-top: 1px solid rgba(201, 168, 76, 0.25);
    border-bottom: 1px solid rgba(201, 168, 76, 0.25);
    padding: 1.2cqw 3cqw;
    font-size: 2.5cqw;
    font-weight: 700;
    color: var(--color-gold);
    text-align: center;
    margin-top: 1cqw;
}

.hf-bottom-status {
    padding: 2cqw 3cqw 0;
    flex: 0.8 1;
    display: flex;
    flex-direction: column;
    gap: 1.5cqw;
    border-top: 1px solid var(--border-color);
    background: var(--bg-card);
}

.status-tabs {
    display: flex;
    gap: 4cqw;
}

.status-tabs span {
    font-size: 2.8cqw;
    font-weight: 600;
    color: var(--text-muted);
    cursor: pointer;
}

.status-tabs span.active {
    color: var(--text-main);
    font-weight: 700;
}

.empty-state {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 2cqw 0;
    color: var(--text-muted);
    gap: 1cqw;
}

.empty-icon {
    font-size: 5cqw;
    opacity: 0.4;
}

.empty-state span:last-child {
    font-size: 2.6cqw;
    font-weight: 500;
}

.hf-screen-nav {
    display: flex;
    border-top: 1px solid var(--border-color);
    background: var(--bg-bar);
    padding: 1cqw 0;
    justify-content: space-around;
    align-items: center;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 12cqw;
    z-index: 12;
}

.hf-screen-nav .nav-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    color: var(--text-muted);
    gap: 0.8cqw;
    cursor: pointer;
    flex: 1 1;
    text-align: center;
    transition: color 0.2s ease;
}

.hf-screen-nav .nav-item span {
    font-size: 2.2cqw;
    font-weight: 600;
    line-height: 1;
}

.hf-screen-nav .nav-item .nav-svg-icon {
    width: 4.8cqw;
    height: 4.8cqw;
    fill: none;
    stroke: currentColor;
    stroke-width: 2px;
    stroke-linecap: round;
    stroke-linejoin: round;
    display: inline-block;
    vertical-align: middle;
}

.hf-screen-nav .nav-item.active {
    color: var(--color-gold);
}

.ph-l .hf-screen-nav .nav-item.active {
    color: var(--color-green);
}


/* Home Screen Styles */
.hf-home-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 2cqw 3.5cqw;
}

.profile-avatar {
    width: 7cqw;
    height: 7cqw;
    border-radius: 50%;
    background: var(--bg-card);
    border: 1px solid var(--border-color);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 3.5cqw;
    color: var(--text-muted);
}

.brand-container {
    display: flex;
    align-items: center;
    gap: 1cqw;
}

.brand-logo-symbol {
    font-size: 4.8cqw;
    color: var(--color-gold);
}

.brand-logo-text {
    font-family: 'Cormorant Garamond', serif;
    font-weight: 700;
    font-size: 4cqw;
    color: var(--text-main);
    letter-spacing: 0.05em;
}

.header-utilities {
    display: flex;
    gap: 3cqw;
    font-size: 4cqw;
    color: var(--text-main);
}

.hf-home-search {
    display: flex;
    align-items: center;
    background: var(--bg-bar);
    border-radius: 3.5cqw;
    padding: 1.5cqw 3cqw;
    margin: 1cqw 3.5cqw 2cqw;
    gap: 1.5cqw;
}

.search-ico {
    font-size: 3.2cqw;
    color: var(--text-muted);
}

.search-flame {
    font-size: 3.2cqw;
}

.search-placeholder {
    font-size: 2.8cqw;
    color: var(--text-muted);
    font-weight: 500;
}

.hf-quick-grid {
    display: flex;
    justify-content: space-between;
    padding: 1cqw 4cqw;
    margin-bottom: 2cqw;
}

.grid-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1cqw;
    cursor: pointer;
}

.grid-ico {
    width: 8.5cqw;
    height: 8.5cqw;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 4cqw;
    font-weight: 700;
    transition: transform 0.2s;
}

.grid-item:hover .grid-ico {
    transform: translateY(-2px);
}

.grid-item span {
    font-size: 2.5cqw;
    font-weight: 600;
    color: var(--text-muted);
}

.hf-promo-banner {
    background: linear-gradient(135deg, #E0F2FE 0%, #BAE6FD 100%);
    border-radius: 3cqw;
    margin: 1cqw 3.5cqw 3cqw;
    padding: 3cqw 3.5cqw;
    display: flex;
    justify-content: space-between;
    position: relative;
    overflow: hidden;
    box-shadow: 0 4px 12px rgba(186, 230, 253, 0.2);
}

body:not(.light_theme) .hf-promo-banner {
    background: linear-gradient(135deg, #0C1E2F 0%, #071322 100%);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);
    border: 1px solid rgba(201, 168, 76, 0.2);
}

.banner-content {
    flex: 1.4 1;
    display: flex;
    flex-direction: column;
    gap: 1cqw;
}

.banner-tag {
    font-size: 2.2cqw;
    font-weight: 700;
    text-transform: uppercase;
    color: #0369A1;
    letter-spacing: 0.05em;
}

body:not(.light_theme) .banner-tag {
    color: var(--color-gold);
}

.banner-title {
    font-size: 3cqw;
    font-weight: 700;
    line-height: 1.3;
    color: #0F172A;
}

body:not(.light_theme) .banner-title {
    color: #FFFFFF;
}

.banner-link {
    font-size: 2.4cqw;
    font-weight: 700;
    color: #0284C7;
    text-decoration: underline;
    margin-top: 1cqw;
}

body:not(.light_theme) .banner-link {
    color: var(--color-gold);
}

.banner-gfx {
    flex: 0.8 1;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
}

.floating-gfx-svg {
    width: 100%;
    height: auto;
    max-height: 14cqw;
    animation: bannerFloat 3s ease-in-out infinite;
}

@keyframes bannerFloat {

    0%,
    100% {
        transform: translateY(0);
    }

    50% {
        transform: translateY(-3px);
    }
}

.banner-dots {
    position: absolute;
    right: 2cqw;
    bottom: 2cqw;
    font-size: 2cqw;
    font-weight: 700;
    background: rgba(0, 0, 0, 0.08);
    color: #0F172A;
    padding: 0.4cqw 1.2cqw;
    border-radius: 1cqw;
}

body:not(.light_theme) .banner-dots {
    background: rgba(255, 255, 255, 0.08);
    color: #FFFFFF;
}

.hf-market-cards {
    display: grid;
    grid-template-columns: 1fr;
    max-width: 800px;
    gap: 2.5cqw;
    padding: 0 3.5cqw;
    margin-bottom: 3cqw;
}

.mkt-card {
    background: var(--bg-card);
    border: 1px solid var(--border-color);
    border-radius: 2.5cqw;
    padding: 2.5cqw 3cqw;
    display: flex;
    flex-direction: column;
    gap: 1.5cqw;
}

.mkt-card .card-top {
    display: flex !important;
    flex-direction: row !important;
    justify-content: space-between !important;
    align-items: center !important;
    padding-bottom: 0px !important;
    margin-bottom: 0px !important;
}

.mkt-card .coin-info {
    display: flex;
    align-items: center;
    gap: 1.5cqw;
}

.mkt-card .coin-icon {
    width: 6cqw;
    height: 6cqw;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 3.5cqw;
    font-weight: 700;
}

.mkt-card .icon-btc {
    background: rgba(247, 147, 26, 0.15);
    color: #F7931A;
}

.mkt-card .icon-eth {
    background: rgba(98, 126, 234, 0.15);
    color: #627EEA;
}

.mkt-card .coin-symbol {
    font-size: 2.8cqw;
    font-weight: 700;
    color: var(--text-main);
    line-height: 1.1;
}

.mkt-card .coin-name {
    font-size: 2cqw;
    color: var(--text-muted);
    line-height: 1;
}

.mkt-card .card-spark {
    width: 12cqw;
    height: 5cqw;
}

.mkt-card .card-spark svg {
    width: 100%;
    height: 100%;
}

.mkt-card .card-bottom {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
}

.mkt-card .coin-price {
    font-size: 3.3cqw;
    font-weight: 700;
    color: var(--text-main);
}

.mkt-card .coin-pct {
    font-size: 2.3cqw;
    font-weight: 700;
}

.mkt-card .coin-pct.down {
    color: var(--color-red);
}

.mkt-card .coin-pct.up {
    color: var(--color-green);
}

.hf-mkt-tabs {
    display: flex;
    padding: 0.8cqw;
    background: var(--bg-bar);
    border-radius: 2cqw;
    margin: 1.5cqw 3.5cqw 2cqw;
    gap: 1.5cqw;
    box-sizing: border-box;
    border: 1px solid var(--border-color);
}

.hf-mkt-tab {
    flex: 1 1;
    text-align: center;
    font-size: 2.6cqw;
    font-weight: 700;
    color: var(--text-muted);
    padding: 1.2cqw 0;
    border-radius: 1.4cqw;
    cursor: pointer;
    background: transparent;
    border: none;
    transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);
    white-space: nowrap;
}

.hf-mkt-tab.active {
    background: var(--color-gold);
    color: #FFFFFF !important;
    box-shadow: 0 2px 6px rgba(201, 168, 76, 0.25);
}

.hf-coin-list {
    display: flex;
    flex-direction: column;
    padding: 0 3.5cqw;
    flex: 1 1;
    overflow-y: auto;
    scrollbar-width: none;
}

.hf-coin-list::-webkit-scrollbar {
    display: none;
}

.list-row {
    display: grid;
    grid-template-columns: 40% 32% 28%;
    align-items: center;
    padding: 1.6cqw 0;
    border-bottom: 1px solid var(--border-color);
}

.list-row.header {
    font-size: 2.3cqw;
    color: var(--text-muted);
    font-weight: 600;
    border-bottom: 1px solid var(--border-color);
    padding-bottom: 1cqw;
}

.coin-cell {
    display: flex;
    align-items: center;
    gap: 1.5cqw;
}

.coin-avatar {
    width: 5.5cqw;
    height: 5.5cqw;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 3.2cqw;
}

.green-avatar {
    background: rgba(74, 222, 128, 0.15);
    color: #4ADE80;
}

.orange-avatar {
    background: rgba(247, 147, 26, 0.15);
    color: #F7931A;
}

.yellow-avatar {
    background: rgba(201, 168, 76, 0.15);
    color: #C9A84C;
}

.blue-avatar {
    background: rgba(98, 126, 234, 0.15);
    color: #627EEA;
}

.gold-avatar {
    background: rgba(201, 168, 76, 0.15);
    color: #C9A84C;
}

.red-avatar {
    background: rgba(234, 57, 67, 0.15);
    color: #ea3943;
}

.coin-cell strong {
    font-size: 2.6cqw;
    font-weight: 700;
    color: var(--text-main);
    display: block;
}

.coin-cell span {
    font-size: 2cqw;
    color: var(--text-muted);
}

.price-cell {
    text-align: center;
}

.price-cell strong {
    font-size: 2.6cqw;
    font-weight: 700;
    color: var(--text-main);
    display: block;
}

.price-cell span {
    font-size: 1.8cqw;
    color: var(--text-muted);
}

.change-cell {
    text-align: right;
}

.change-cell span {
    font-size: 2.4cqw;
    font-weight: 700;
    padding: 0.8cqw 1.6cqw;
    border-radius: 0.8cqw;
    display: inline-block;
}

.badge-red {
    background: var(--bg-red-soft);
    color: var(--color-red);
}

.badge-green {
    background: var(--bg-green-soft);
    color: var(--color-green);
}

.hf-list-more {
    text-align: center;
    font-size: 2.6cqw;
    font-weight: 700;
    color: var(--color-gold);
    padding: 1.5cqw 0;
    cursor: pointer;
}

/* Wallet Screen Styles */
.hf-wallet-segments {
    display: flex;
    align-items: center;
    padding: 1cqw 3.5cqw;
    border-bottom: 1px solid var(--border-color);
    gap: 2cqw;
}

.segments-arrow {
    font-size: 3cqw;
    color: var(--text-muted);
    font-weight: 700;
}

.hf-assets-card {
    background: linear-gradient(135deg, rgba(201, 168, 76, 0.12), rgba(201, 168, 76, 0.03));
    border: 1px solid rgba(201, 168, 76, 0.2);
    border-radius: 3cqw;
    margin: 3cqw 3.5cqw 2cqw;
    padding: 3.5cqw 4cqw;
}

.card-title {
    font-size: 2.8cqw;
    font-weight: 700;
    color: var(--text-muted);
    margin-bottom: 2cqw;
}

.estimated-balance span {
    font-size: 2.4cqw;
    color: var(--text-muted);
    font-weight: 600;
    display: block;
    margin-bottom: 1cqw;
}

.btc-val {
    font-size: 5cqw;
    font-weight: 700;
    color: var(--text-main);
    margin-bottom: 0.5cqw;
}

.usd-val {
    font-size: 2.8cqw;
    color: var(--text-muted);
    font-weight: 600;
}

.hf-wallet-actions {
    display: flex;
    justify-content: space-between;
    padding: 1.5cqw 4.5cqw;
    margin-bottom: 2cqw;
}

.action-btn {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 1cqw;
    cursor: pointer;
}

.action-ico {
    width: 9cqw;
    height: 9cqw;
    border-radius: 50%;
    border: 1px solid var(--border-color);
    background: var(--bg-card);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 4.2cqw;
    color: var(--text-main);
    transition: all 0.2s;
}

.action-btn:hover .action-ico {
    background: var(--bg-bar);
    border-color: var(--color-gold);
}

.action-btn span {
    font-size: 2.4cqw;
    font-weight: 600;
    color: var(--text-main);
}

.hf-sub-segment {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 4cqw;
    border-bottom: 1px solid var(--border-color);
    margin-bottom: 2cqw;
}

.sub-tabs {
    display: flex;
    gap: 4cqw;
}

.hide-zero-bal {
    font-size: 2.4cqw;
    color: var(--text-muted);
    font-weight: 600;
}

.hide-zero-bal label {
    display: flex;
    align-items: center;
    gap: 0.8cqw;
}

.hf-wallet-search {
    background: var(--bg-bar);
    border-radius: 2.5cqw;
    padding: 1.5cqw 3cqw;
    margin: 0 3.5cqw 2.5cqw;
    font-size: 2.6cqw;
    color: var(--text-muted);
    font-weight: 500;
    display: flex;
    align-items: center;
}

.hf-assets-list {
    display: flex;
    flex-direction: column;
    padding: 0 3.5cqw;
    flex: 1 1;
    overflow-y: auto;
    scrollbar-width: none;
    gap: 1cqw;
}

.hf-assets-list::-webkit-scrollbar {
    display: none;
}

.hf-assets-list .asset-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 2cqw 0;
    border-bottom: 1px solid var(--border-color);
}

.asset-left {
    display: flex;
    align-items: center;
    gap: 2cqw;
    flex: 1.2 1;
}

.asset-left strong {
    font-size: 2.8cqw;
    font-weight: 700;
    color: var(--text-main);
    display: block;
}

.asset-left span {
    font-size: 2.2cqw;
    color: var(--text-muted);
}

.asset-right {
    text-align: right;
    flex: 1 1;
    padding-right: 2cqw;
}

.asset-right strong {
    font-size: 2.8cqw;
    font-weight: 700;
    color: var(--text-main);
    display: block;
}

.asset-right span {
    font-size: 2.2cqw;
    color: var(--text-muted);
}

.asset-menu {
    font-size: 3cqw;
    color: var(--text-muted);
    cursor: pointer;
}

.hf-overlay-capsule {
    position: absolute;
    bottom: 15cqw;
    left: 50%;
    transform: translateX(-50%);
    background: linear-gradient(135deg, rgba(201, 168, 76, 0.95), rgba(20, 20, 20, 0.95));
    border: 1px solid rgba(255, 255, 255, 0.15);
    border-radius: 3cqw;
    padding: 1.5cqw 4cqw;
    display: flex;
    align-items: center;
    gap: 1.5cqw;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
    z-index: 15;
}

body.light_theme .hf-overlay-capsule {
    background: linear-gradient(135deg, rgba(201, 168, 76, 0.95), rgba(255, 255, 255, 0.95));
    border: 1px solid rgba(0, 0, 0, 0.1);
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
}

.capsule-symbol {
    font-size: 3.5cqw;
    color: #FFFFFF;
}

body.light_theme .capsule-symbol {
    color: var(--color-gold);
}

.capsule-text {
    font-size: 2.6cqw;
    font-weight: 700;
    color: #FFFFFF;
    letter-spacing: 0.05em;
}

body.light_theme .capsule-text {
    color: #111;
}

/* ────────────────────────────────────────────────────────────────────────
       📱 PRECISE COMPREHENSIVE RESPONSIVENESS OVERRIDES FOR TABLET & MOBILE
       ──────────────────────────────────────────────────────────────────────── */

@media (min-width: 1930px) and (max-width: 2560px) {

    .hero-inner {
        max-width: 72%;
    }

    body.home .container {
        max-width: 72%;
    }

    body.home .sec-pad {
        max-width: 72%;
    }

}

/* ── Header Navigation Overrides ── */
@media (max-width: 1376px) {

    .taglines {
        column-gap: 0px;
    }

}

/* ── Header Navigation Overrides ── */
@media (max-width: 992px) {


    .nav-links {
        display: none !important;
    }

    .hamburger {
        display: flex !important;
    }

    .nav-right .btn-login,
    .nav-right .btn-signup {
        display: none !important;
    }
}

/* ── Hero Section Layout Overrides ── */
@media (max-width: 1024px) {
    #hero {
        padding: 40px 20px 30px !important;
        min-height: auto !important;
    }

    .hero-inner {
        grid-template-columns: 1fr !important;
        gap: 50px !important;
        text-align: center !important;
        justify-items: center !important;
        padding: 20px 0 10px !important;
        min-height: auto !important;
    }

    .copy {
        align-items: center !important;
    }

    .sub {
        max-width: 580px !important;
        margin: 0 auto 30px !important;
    }

    .email-cta {
        max-width: 480px !important;
        width: 100% !important;
        margin: 0 auto 24px !important;
    }

    .hero-actions-sec {
        align-self: center !important;
        align-items: center !important;
    }

    .action-row {
        justify-content: center !important;
    }

    .trust-grid {
        justify-content: center !important;
    }

    .phones {
        width: 100% !important;
        max-width: 480px !important;
        height: 450px !important;
        margin: 0 auto !important;
    }

    .ph-c {
        width: 220px !important;
        height: 397px !important;
    }

    .ph-l,
    .ph-r {
        width: 182px !important;
        height: 300px !important;
    }

    .hero-globe {
        left: 50% !important;
        bottom: 5% !important;
        /* Elevated to sit directly behind the mobile mockups on small screens */
        width: clamp(600px, 75vw, 900px) !important;
        height: clamp(300px, 37.5vw, 450px) !important;
        margin-left: calc(-1 * clamp(600px, 75vw, 900px) / 2) !important;
    }

    .hero-horizon-glow {
        left: 50% !important;
    }
}

@media (max-width:767px) {

    .agcex.copy {
        width: 100%;
    }

    .float-shape.s1 {
        top: 10%;
        left: 40%;
        width: 220px;
        height: 220px;
    }

    .step-num {
        color: rgb(201 168 76);
    }

    .agcex.phones {
        z-index: 9999 !important;
    }

}


/* ── Market Screener Responsive Overrides ── */
@media (max-width: 768px) {
    .mkt-tabs {
        overflow-x: auto !important;
        white-space: nowrap !important;
        padding-bottom: 8px !important;
        -webkit-overflow-scrolling: touch !important;
        display: flex !important;
        flex-wrap: nowrap !important;
    }

    .mkt-tab {
        flex: 0 0 auto !important;
    }

    .mkt-table th:nth-child(5),
    .mkt-table td:nth-child(5) {
        display: none !important;
        /* Hide the sparkline column fully in both headers and data cells */
    }
}

/* ── Onboarding Steps Responsive Overrides ── */
@media (max-width: 992px) {
    .step-grid {
        grid-template-columns: 1fr !important;
        gap: 24px !important;
    }

    .step-card {
        padding: 36px 30px !important;
    }
}

/* ── Footer Grid Responsive Overrides ── */
@media (max-width: 576px) {
    .ft-grid {
        grid-template-columns: 1fr !important;
        gap: 32px !important;
    }
}

/* ── Complete Institutional Crypto Suite (Orbital Showcase) Overrides ── */
@media (max-width: 1100px) {
    .orbit-showcase {
        min-height: auto !important;
        gap: 40px !important;
        padding: 20px 0% !important;
        /* lateral padding to prevent screen boundary bleed */
        box-sizing: border-box !important;
    }

    .bento-card.feat-large .bc-title {
        font-size: 26px;
    }

    .agcex.orbit-control-wheel {
        display: none;
    }

    .orbit-rings,
    .orbit-beams {
        display: none !important;
    }

    .orbit-track {
        position: relative !important;
        top: auto !important;
        left: auto !important;
        transform: none !important;
        width: 100% !important;
        height: auto !important;
        animation: none !important;
        display: flex !important;
        flex-direction: column !important;
        gap: 20px !important;
        align-items: center !important;
    }

    .orbit-node {
        position: relative !important;
        width: 100% !important;
        height: auto !important;
        top: auto !important;
        left: auto !important;
        transform: none !important;
        animation: none !important;
        display: block !important;
    }

    .orbit-center-phone {
        width: 470px;
        margin: 0 auto 20px !important;
        margin-top: 0 !important;
        /* fully override default top margin in stacked layout */
        order: -1 !important;
        /* Place center phone at top of stack for beautiful mobile priority flow */
    }

    .orbit-card {
        position: relative !important;
        width: 100% !important;
        max-width: 100% !important;
        margin: 0 auto !important;
        top: auto !important;
        left: auto !important;
        right: auto !important;
        bottom: auto !important;
        transform: none !important;
        box-sizing: border-box !important;
    }

    .orbit-card.premium {
        width: 100% !important;
        max-width: 100% !important;
        box-sizing: border-box !important;
    }
}

@media (max-width: 991px) {

    .orbit-card.premium {
        max-width: 100% !important;
    }

    .orbit-showcase {
        margin: 20px auto 30px;
    }

    .orbit-center-phone {
        width: 520px;
        max-width: 100%;
    }

}

/* ── 100% 1:1 Proof of Reserves Mobile Overrides ── */
@media (max-width: 768px) {

    .bento-card.feat-large .bc-mockup {
        min-height: auto !important;
        height: auto !important;
        flex-direction: column !important;
        align-items: stretch !important;
        padding: 20px 16px !important;
        gap: 16px !important;
        box-sizing: border-box !important;
    }

    .bento-grid {
        margin: 20px auto;
    }

    .merkle-svg {
        height: 180px !important;
        width: 100% !important;
    }

    .por-terminal {
        position: relative !important;
        bottom: auto !important;
        left: auto !important;
        right: auto !important;
        margin: 0 !important;
        padding: 12px 14px !important;
        font-size: 11px !important;
        width: 100% !important;
        box-sizing: border-box !important;
    }

    .por-row-live {
        font-size: 11px !important;
        gap: 6px !important;
        padding-bottom: 6px !important;
    }

    .por-row-live span {
        white-space: nowrap !important;
        overflow: hidden !important;
        text-overflow: ellipsis !important;
        max-width: 130px !important;
        /* prevents long stablecoin label from pushing percentage out of bounds */
    }

    .por-row-live strong {
        font-size: 12px !important;
    }
}

/* ── Professional Advanced Trading Terminal Overrides ── */
@media (max-width: 768px) {
    .browser-mockup {
        width: 100% !important;
        margin-top: 16px !important;
        box-sizing: border-box !important;
    }

    .hf-web-nav {
        flex-wrap: wrap !important;
        gap: 8px 12px !important;
        padding: 10px 12px !important;
    }

    .hf-pair {
        font-size: 14px !important;
        width: 100% !important;
        /* Let pair occupy its own line for clean layout */
        margin-bottom: 4px !important;
    }

    .hf-stat {
        flex: 1 1 30% !important;
        min-width: 80px !important;
    }

    .hf-web-body {
        grid-template-columns: 1fr !important;
        min-height: auto !important;
    }

    .hf-chart {
        border-right: none !important;
        border-bottom: 1px solid rgba(255, 255, 255, 0.06) !important;
        padding: 16px 12px !important;
    }

    .hf-candles {
        max-height: 180px !important;
    }

    .hf-vol-bars {
        margin-top: 12px !important;
        height: 28px !important;
    }

    .hf-orderbook {
        padding: 16px 12px !important;
    }
}

/* ── Built for Professional Dominance (USP Cards) Mobile/Tablet Overrides ── */
@media (max-width: 992px) {
    .usp-grid {
        grid-template-columns: 1fr !important;
        gap: 20px !important;
    }

    .usp-card {
        padding: 30px 20px !important;
        width: 100% !important;
        box-sizing: border-box !important;
    }
}

/* =======================================================================
       GLOBAL RESPONSIVE BULLETPROOFING OVERRIDES
       ======================================================================= */
#hero {
    overflow-x: hidden !important;
    width: 100%;
    max-width: 100vw;
    position: relative;
}



.trust-bento-grid {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 24px;
    max-width: 1200px;
    margin: 40px auto 0;
    padding: 0 4%;
}

@media (max-width: 992px) {
    .trust-bento-grid {
        grid-template-columns: repeat(2, 1fr);
    }
}

@media (max-width: 600px) {
    .trust-bento-grid {
        grid-template-columns: 1fr;
    }
}

.trust-card {
    background: linear-gradient(135deg, rgba(255, 255, 255, 0.03) 0%, rgba(255, 255, 255, 0.01) 100%);
    border: 1px solid rgba(255, 255, 255, 0.06);
    border-radius: 20px;
    padding: 32px;
    position: relative;
    overflow: hidden;
    transition: transform 0.4s cubic-bezier(0.25, 1, 0.22, 1), box-shadow 0.4s ease, border-color 0.4s ease;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    min-height: 220px;
    backdrop-filter: blur(5px);
    -webkit-backdrop-filter: blur(5px);
}

.trust-card.tc-large {
    grid-column: span 2;
    flex-direction: row;
    align-items: center;
    gap: 32px;
}

@media (max-width: 992px) {
    .trust-card.tc-large {
        flex-direction: column;
        align-items: flex-start;
        gap: 0;
    }
}

@media (max-width: 600px) {
    .trust-card.tc-large {
        grid-column: span 1;
    }
}

.tc-glow-orb {
    position: absolute;
    width: 150px;
    height: 150px;
    border-radius: 50%;
    filter: blur(60px);
    opacity: 0.3;
    z-index: 0;
    animation: orbFloat 8s infinite alternate ease-in-out;
    pointer-events: none;
    top: -30px;
    left: -30px;
}

.tc-large .tc-glow-orb {
    width: 300px;
    height: 300px;
    right: -100px;
    bottom: -100px;
    top: auto;
    left: auto;
    animation-direction: alternate-reverse;
    animation-duration: 12s;
}

@keyframes orbFloat {
    0% {
        transform: translate(0, 0) scale(1);
        opacity: 0.15;
    }

    100% {
        transform: translate(-30px, -20px) scale(1.3);
        opacity: 0.4;
    }
}

.trust-card:hover {
    transform: translateY(-8px);
    box-shadow: 0 25px 50px rgba(0, 0, 0, 0.3), inset 0 1px 0 rgba(255, 255, 255, 0.1);
}

body.light_theme .trust-card {
    background: linear-gradient(135deg, rgba(255, 255, 255, 1) 0%, rgba(245, 245, 245, 1) 100%);
    border-color: rgba(0, 0, 0, 0.06);
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.04);
}

body.light_theme .trust-card:hover {
    box-shadow: 0 25px 50px rgba(0, 0, 0, 0.08), inset 0 1px 0 rgba(255, 255, 255, 0.6);
}

body.light_theme .tc-glow-orb {
    opacity: 0.1;
}

.tc-content,
.tc-icon {
    position: relative;
    z-index: 2;
}

.tc-icon {
    width: 56px;
    height: 56px;
    border-radius: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 24px;
    color: #FFF;
    transition: transform 0.5s cubic-bezier(0.25, 1, 0.22, 1);
    flex-shrink: 0;
}

.trust-card.tc-large .tc-icon {
    margin-bottom: 0;
    width: 80px;
    height: 80px;
    border-radius: 24px;
}

@media (max-width: 992px) {
    .trust-card.tc-large .tc-icon {
        margin-bottom: 24px;
        width: 56px;
        height: 56px;
        border-radius: 16px;
    }
}

.trust-card:hover .tc-icon {
    transform: scale(1.15) rotate(5deg);
}

.tc-spot {
    background: rgba(247, 147, 26, 0.15);
    color: #F7931A;
    border: 1px solid rgba(247, 147, 26, 0.2);
}

.tc-margin {
    background: rgba(98, 126, 234, 0.15);
    color: #627EEA;
    border: 1px solid rgba(98, 126, 234, 0.2);
}

.tc-futures {
    background: rgba(74, 222, 128, 0.15);
    color: #4ADE80;
    border: 1px solid rgba(74, 222, 128, 0.2);
}

.tc-risk {
    background: rgba(248, 113, 113, 0.15);
    color: #F87171;
    border: 1px solid rgba(248, 113, 113, 0.2);
}

.tc-port {
    background: rgba(168, 85, 247, 0.15);
    color: #A855F7;
    border: 1px solid rgba(168, 85, 247, 0.2);
}

.tc-inst {
    background: rgba(201, 168, 76, 0.15);
    color: #C9A84C;
    border: 1px solid rgba(201, 168, 76, 0.2);
}

.tc-title {
    font-size: 20px;
    font-weight: 700;
    margin-bottom: 10px;
    color: var(--text-color);
}

.trust-card.tc-large .tc-title {
    font-size: 26px;
}

@media (max-width: 992px) {
    .trust-card.tc-large .tc-title {
        font-size: 20px;
    }
}

.tc-desc {
    font-size: 14px;
    color: var(--text-muted);
    line-height: 1.6;
}

/* Extracted from <style> */

.sec-vault-mockup {
    background: rgba(0, 0, 0, 0.4);
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    overflow: hidden;
}

.vault-core {
    position: relative;
    width: 64px;
    height: 64px;
    color: #FFF;
    z-index: 5;
}

.vault-core svg {
    width: 100%;
    height: 100%;
    filter: drop-shadow(0 0 8px rgba(255, 255, 255, 0.4));
}

.scan-laser {
    position: absolute;
    top: 0;
    left: 10%;
    width: 80%;
    height: 2px;
    background: #4ADE80;
    box-shadow: 0 0 10px #4ADE80, 0 0 20px #4ADE80;
    animation: laserScan 2s infinite ease-in-out;
}

.scan-ring {
    position: absolute;
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 50%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    animation: ringPulse 4s infinite cubic-bezier(0.215, 0.61, 0.355, 1);
}

.scan-ring.r1 {
    width: 100px;
    height: 100px;
    animation-delay: 0s;
}

.scan-ring.r2 {
    width: 160px;
    height: 160px;
    animation-delay: 1.3s;
}

.scan-ring.r3 {
    width: 220px;
    height: 220px;
    animation-delay: 2.6s;
}

@keyframes laserScan {
    0% {
        top: 10%;
        opacity: 0;
    }

    10% {
        opacity: 1;
    }

    90% {
        opacity: 1;
    }

    100% {
        top: 90%;
        opacity: 0;
    }
}

@keyframes ringPulse {
    0% {
        width: 40px;
        height: 40px;
        opacity: 1;
    }

    100% {
        width: 250px;
        height: 250px;
        opacity: 0;
    }
}


/* Extracted from <style> */

.kyc-mockup {
    background: rgba(0, 0, 0, 0.4);
    display: flex;
    align-items: center;
    justify-content: center;
}

.kyc-flow {
    display: flex;
    align-items: center;
    gap: 15px;
    flex-wrap: nowrap;
}

.kyc-step {
    width: 50px;
    height: 50px;
    flex-shrink: 0;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.05);
    border: 1px solid rgba(255, 255, 255, 0.1);
    display: flex;
    align-items: center;
    justify-content: center;
    color: rgba(255, 255, 255, 0.3);
    transition: all 0.3s;
    position: relative;
    z-index: 2;
}

.kyc-icon svg {
    width: 24px;
    height: 24px;
}

.kyc-line {
    width: 40px;
    height: 2px;
    flex-shrink: 1;
    background: rgba(255, 255, 255, 0.1);
    position: relative;
    z-index: 1;
    overflow: hidden;
}

.kyc-line::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background: #4ADE80;
    transform: translateX(-100%);
}

@media (max-width: 480px) {
    .kyc-flow {
        gap: 8px;
    }

    .kyc-step {
        width: 40px;
        height: 40px;
    }

    .kyc-icon svg {
        width: 20px;
        height: 20px;
    }

    .kyc-line {
        width: 20px;
    }
}

/* Animation Sequence */
.kyc-step.s1 {
    animation: stepActive 4s infinite 0s;
}

.kyc-line.l1::after {
    animation: lineFill 4s infinite 0.5s;
}

.kyc-step.s2 {
    animation: stepActive 4s infinite 1s;
}

.kyc-line.l2::after {
    animation: lineFill 4s infinite 1.5s;
}

.kyc-step.s3 {
    animation: stepActive 4s infinite 2s;
    color: #4ADE80 !important;
    background: rgba(74, 222, 128, 0.1) !important;
    border-color: #4ADE80 !important;
    box-shadow: 0 0 15px rgba(74, 222, 128, 0.4) !important;
}

@keyframes stepActive {

    0%,
    90% {
        color: #4ADE80;
        background: rgba(74, 222, 128, 0.1);
        border-color: #4ADE80;
        box-shadow: 0 0 15px rgba(74, 222, 128, 0.4);
    }

    95%,
    100% {
        color: rgba(255, 255, 255, 0.3);
        background: rgba(255, 255, 255, 0.05);
        border-color: rgba(255, 255, 255, 0.1);
        box-shadow: none;
    }
}

@keyframes lineFill {

    0%,
    90% {
        transform: translateX(0);
    }

    95%,
    100% {
        transform: translateX(-100%);
    }
}

body.light_theme .kyc-mockup {
    background: rgba(0, 0, 0, 0.02);
}

body.light_theme .kyc-step {
    background: rgba(0, 0, 0, 0.05);
    border-color: rgba(0, 0, 0, 0.1);
    color: rgba(0, 0, 0, 0.3);
}

body.light_theme .kyc-line {
    background: rgba(0, 0, 0, 0.1);
}


/* Extracted from <style> */

.comp-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
    gap: 24px;
    max-width: 1200px;
    margin: 0 auto;
    padding: 0;
    position: relative;
    z-index: 2;
}

.comp-card {
    background: rgba(18, 18, 24, 0.45);
    border: 1px solid rgba(255, 255, 255, 0.05);
    border-radius: 20px;
    padding: 30px 24px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    transition: all 0.3s ease;
    box-shadow: 0 15px 35px rgba(0, 0, 0, 0.2);
    backdrop-filter: blur(5px);
    -webkit-backdrop-filter: blur(5px);
}

body.light_theme .comp-card {
    background: rgb(255 255 255 / 20%);
    border-color: rgba(0, 0, 0, 0.06);
    box-shadow: 0 15px 35px rgba(0, 0, 0, 0.04);
}

.comp-card:hover {
    transform: translateY(-5px);
    border-color: rgba(201, 168, 76, 0.35);
    box-shadow: 0 20px 45px rgba(201, 168, 76, 0.08);
}

.comp-ico-wrap {
    width: 48px;
    height: 48px;
    border-radius: 12px;
    background: rgba(201, 168, 76, 0.08);
    border: 1px solid rgba(201, 168, 76, 0.2);
    color: #C9A84C;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 20px;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
}

body.light_theme .comp-ico-wrap {
    background: rgba(201, 168, 76, 0.05);
    border-color: rgba(201, 168, 76, 0.15);
}

.comp-partner {
    font-size: 18px;
    font-weight: 700;
    letter-spacing: -0.01em;
    color: #F2EEE6;
    margin-bottom: 4px;
}

body.light_theme .comp-partner {
    color: #111;
}

.comp-role {
    font-size: 11px;
    text-transform: uppercase;
    font-weight: 700;
    letter-spacing: 0.15em;
    color: #C9A84C;
    margin-bottom: 12px;
}

.comp-desc {
    font-size: 13.5px;
    line-height: 1.5;
    color: #888;
}

body.light_theme .comp-desc {
    color: #555;
}


/* Extracted from <style> */

.otc-wrap {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 4%;
    display: grid;
    grid-template-columns: 1fr;
    max-width: 800px;
    gap: 60px;
    align-items: center;
}

.otc-content {
    position: relative;
    z-index: 2;
}

.otc-title {
    font-size: clamp(32px, 4vw, 42px);
    font-weight: 700;
    margin-bottom: 20px;
    color: #FFF;
    letter-spacing: -0.02em;
    line-height: 1.1;
}

body.light_theme .otc-title {
    color: #111;
}

.otc-desc {
    color: #AAA;
    font-size: 18px;
    line-height: 1.6;
    margin-bottom: 30px;
}

body.light_theme .otc-desc {
    color: #555;
}

.otc-features {
    list-style: none;
    padding: 0;
    margin-bottom: 40px;
}

.otc-features li {
    display: flex;
    align-items: center;
    gap: 12px;
    color: #FFF;
    margin-bottom: 16px;
    font-size: 16px;
    font-weight: 500;
}

body.light_theme .otc-features li {
    color: #333;
}

.otc-features li svg {
    color: #C9A84C;
    flex-shrink: 0;
}

.otc-black-card-container {
    position: relative;
    z-index: 2;
    perspective: 1200px;
    width: 100%;
    max-width: 480px;
    margin: 0 auto;
}

.otc-black-card {
    background: linear-gradient(135deg, #111 0%, #1a1a1a 50%, #0a0a0a 100%);
    border: 1px solid rgba(201, 168, 76, 0.3);
    border-radius: 20px;
    padding: 40px;
    box-shadow: 0 30px 60px rgba(0, 0, 0, 0.6), inset 0 1px 0 rgba(255, 255, 255, 0.1);
    position: relative;
    overflow: hidden;
    transition: transform 0.4s ease, box-shadow 0.4s ease;
}

body.light_theme .otc-black-card {
    background: linear-gradient(135deg, #FFF 0%, #F5F5F5 50%, #E0E0E0 100%);
    box-shadow: 0 30px 60px rgba(0, 0, 0, 0.1), inset 0 1px 0 rgba(255, 255, 255, 0.8);
}

.otc-black-card:hover {
    box-shadow: 0 40px 80px rgba(201, 168, 76, 0.2), inset 0 1px 0 rgba(255, 255, 255, 0.1);
}

body.light_theme .otc-black-card:hover {
    box-shadow: 0 40px 80px rgba(201, 168, 76, 0.15), inset 0 1px 0 rgba(255, 255, 255, 0.8);
}

.otc-chip {
    position: absolute;
    top: 30px;
    right: 30px;
    width: 45px;
    height: 35px;
    background: linear-gradient(135deg, #E8C97A, #C9A84C, #A58427);
    border-radius: 6px;
    opacity: 0.9;
    box-shadow: inset 0 0 10px rgba(0, 0, 0, 0.5), 0 2px 4px rgba(0, 0, 0, 0.5);
}

.otc-chip::before,
.otc-chip::after {
    content: '';
    position: absolute;
    background: rgba(0, 0, 0, 0.3);
}

.otc-chip::before {
    top: 12px;
    left: 0;
    right: 0;
    height: 1px;
    box-shadow: 0 10px 0 rgba(0, 0, 0, 0.3);
}

.otc-chip::after {
    top: 0;
    bottom: 0;
    left: 15px;
    width: 1px;
    box-shadow: 15px 0 0 rgba(0, 0, 0, 0.3);
}

.otc-form-group {
    margin-bottom: 24px;
    position: relative;
    text-align: left;
}

.otc-label {
    display: block;
    font-size: 12px;
    text-transform: uppercase;
    letter-spacing: 0.1em;
    color: rgba(255, 255, 255, 0.6);
    margin-bottom: 8px;
    font-weight: 600;
}

body.light_theme .otc-label {
    color: rgba(0, 0, 0, 0.6);
}

.otc-input-vip {
    width: 100%;
    background: rgba(255, 255, 255, 0.03);
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 12px;
    padding: 16px;
    color: #FFF;
    font-family: inherit;
    font-size: 16px;
    transition: all 0.3s;
}

body.light_theme .otc-input-vip {
    background: rgba(0, 0, 0, 0.02);
    border: 1px solid rgba(0, 0, 0, 0.1);
    color: #111;
}

.otc-input-vip:focus {
    outline: none;
    border-color: #C9A84C;
    background: rgba(201, 168, 76, 0.05);
    box-shadow: 0 0 0 3px rgba(201, 168, 76, 0.1);
}

.otc-input-vip::placeholder {
    color: rgba(255, 255, 255, 0.3);
}

body.light_theme .otc-input-vip::placeholder {
    color: rgba(0, 0, 0, 0.3);
}

.otc-watermark {
    position: absolute;
    top: -50%;
    left: -50%;
    width: 200%;
    height: 200%;
    background: linear-gradient(45deg, transparent, rgba(201, 168, 76, 0.03), transparent);
    transform: rotate(45deg);
    pointer-events: none;
}

.otc-vip-title {
    font-size: 10px;
    text-transform: uppercase;
    letter-spacing: 0.2em;
    color: #888;
    margin-bottom: 40px;
}

.select-vip {
    appearance: none;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-repeat: no-repeat;
    background-position: right 16px center;
    background-size: 16px;
}

.otc-select-placeholder {
    color: #888;
}

.otc-select-option {
    color: #111;
}

.otc-submit-btn {
    width: 100%;
    padding: 18px;
    margin-top: 10px;
    font-size: 15px;
    font-weight: 700;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    box-shadow: 0 10px 25px rgba(201, 168, 76, 0.25);
}

@media (max-width: 992px) {
    .otc-wrap {
        grid-template-columns: 1fr;
        gap: 40px;
    }

    .otc-black-card {
        transform: none;
    }
}


/* Extracted from <style> */

.hf-web-real {
    background: transparent;
    display: flex;
    flex-direction: column;
    height: 100%;
    font-family: 'Inter', -apple-system, sans-serif;
    color: #B7BDC6;
    overflow: hidden;
}

body.light_theme .hf-web-real {
    background: #FAFAFA;
    color: #555;
}

.hf-top-nav {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 16px;
    background: #181a20;
    border-bottom: 1px solid #2b3139;
}

body.light_theme .hf-top-nav {
    background: #FFF;
    border-bottom: 1px solid #EAEAEA;
}

.hf-ticker-info {
    display: flex;
    gap: 24px;
    align-items: center;
    flex-wrap: wrap;
}

.hf-pair-name {
    font-size: 20px;
    font-weight: 700;
    color: #EAECEF;
}

body.light_theme .hf-pair-name {
    color: #111;
}

.hf-price-main {
    font-size: 20px;
    font-weight: 600;
    color: #0ecb81;
}

.hf-stat-item {
    display: flex;
    flex-direction: column;
    font-size: 10px;
}

.hf-stat-item span {
    color: #848E9C;
    margin-bottom: 2px;
}

.hf-stat-item strong {
    color: #EAECEF;
    font-weight: 500;
}

body.light_theme .hf-stat-item strong {
    color: #333;
}

.hf-main-grid {
    display: flex;
    flex: 1 1;
    height: calc(100% - 60px);
}

.hf-col-chart {
    width: 221px;
    flex: 1 1;
    border-right: 1px solid #2b3139;
    display: flex;
    flex-direction: column;
}

body.light_theme .hf-col-chart {
    border-right: 1px solid #EAEAEA;
}

.hf-chart-area {
    flex: 1 1;
    background: #161a1e;
    position: relative;
    overflow: hidden;
}

body.light_theme .hf-chart-area {
    background: #F5F5F5;
}



.hf-order-history {
    height: 120px;
    border-top: 1px solid #2b3139;
    padding: 12px 16px;
    background: #181a20;
}

body.light_theme .hf-order-history {
    border-top: 1px solid #EAEAEA;
    background: #FFF;
}

.hf-col-ob {
    width: 240px;
    border-right: 1px solid #2b3139;
    display: flex;
    flex-direction: column;
    font-size: 12px;
    font-family: 'Roboto Mono', monospace;
    background: #181a20;
}

body.light_theme .hf-col-ob {
    border-right: 1px solid #EAEAEA;
    background: #FFF;
}

.hf-ob-header {
    display: flex;
    justify-content: space-between;
    padding: 10px 16px;
    color: #848E9C;
    font-family: 'Inter', sans-serif;
    font-size: 11px;
}

.hf-ob-rows {
    flex: 1 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    padding: 0 16px;
}

.hf-ob-row {
    display: flex;
    justify-content: space-between;
    margin-bottom: 5px;
    position: relative;
    padding: 2px 0;
}

.hf-ob-row::after {
    content: '';
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;
    background: rgba(246, 70, 93, 0.15);
    width: 40%;
    z-index: 0;
}

.hf-ob-row.bid::after {
    background: rgba(14, 203, 129, 0.15);
    width: 60%;
}

.hf-ob-row span {
    position: relative;
    z-index: 1;
}

.hf-ob-price.ask {
    color: #f6465d;
    font-weight: 500;
}

.hf-ob-price.bid {
    color: #0ecb81;
    font-weight: 500;
}

.hf-ob-mid {
    text-align: center;
    font-size: 16px;
    font-weight: 600;
    color: #0ecb81;
    padding: 10px 0;
    border-top: 1px solid #2b3139;
    border-bottom: 1px solid #2b3139;
    margin-bottom: 6px;
}

body.light_theme .hf-ob-mid {
    border-color: #EAEAEA;
}

.hf-col-entry {
    width: 280px;
    padding: 16px;
    display: flex;
    flex-direction: column;
    background: #181a20;
}

body.light_theme .hf-col-entry {
    background: #FFF;
}

.hf-entry-tabs {
    display: flex;
    margin-bottom: 20px;
    gap: 16px;
    font-size: 14px;
    font-weight: 600;
}

.hf-entry-tab {
    color: #848E9C;
    cursor: pointer;
}

.hf-entry-tab.active {
    color: #FCD535;
    border-bottom: 2px solid #FCD535;
    padding-bottom: 4px;
}

.hf-entry-input {
    background: #2b3139;
    border-radius: 4px;
    display: flex;
    justify-content: space-between;
    padding: 10px 12px;
    margin-bottom: 14px;
    font-size: 11px;
    border: 1px solid transparent;
}

body.light_theme .hf-entry-input {
    background: #F0F0F0;
}

.hf-entry-input:focus-within {
    border-color: #FCD535;
}

.hf-entry-input span {
    color: #848E9C;
}

.hf-entry-input input {
    background: transparent;
    border: none;
    color: #EAECEF;
    text-align: right;
    width: 60%;
    outline: none;
    font-family: 'Roboto Mono', monospace;
}

body.light_theme .hf-entry-input input {
    color: #111;
}

.hf-btn-buy {
    background: #0ecb81;
    color: #fff;
    text-align: center;
    padding: 12px;
    border-radius: 4px;
    font-weight: 600;
    font-size: 15px;
    margin-top: auto;
    cursor: pointer;
    transition: background 0.2s;
}

.hf-btn-buy:hover {
    background: #0b9e65;
}

@media (max-width:1024px) {

    .trust-card.tc-large .tc-title {
        font-size: 22px;
    }

}

@media (max-width: 992px) {

    .hf-col-ob,
    .hf-col-entry {
        display: none;
    }



    .hf-web-real {
        height: 350px;
    }
}


/* Extracted from <style> */

.support-banner {
    max-width: 1290px;
    margin: 0 auto;
    padding: 48px;
    border-radius: 32px;
    background: linear-gradient(135deg, rgba(201, 168, 76, 0.08) 0%, rgba(18, 18, 24, 0.6) 100%);
    border: 1px solid rgba(201, 168, 76, 0.2);
    box-shadow: 0 30px 60px rgba(0, 0, 0, 0.5), inset 0 1px 0 rgba(255, 255, 255, 0.05);
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 40px;
    position: relative;
    overflow: hidden;
    backdrop-filter: blur(5px);
    -webkit-backdrop-filter: blur(5px);
    transition: all 0.4s ease;
}

body.light_theme .support-banner {
    background: linear-gradient(135deg, rgba(201, 168, 76, 0.05) 0%, rgba(255, 255, 255, 0.7) 100%);
    box-shadow: 0 30px 60px rgba(0, 0, 0, 0.05);
    border-color: rgba(201, 168, 76, 0.3);
}

.support-banner:hover {
    border-color: rgba(201, 168, 76, 0.5);
    box-shadow: 0 40px 80px rgba(0, 0, 0, 0.6), 0 0 40px rgba(201, 168, 76, 0.1);
}

body.light_theme .support-banner:hover {
    box-shadow: 0 40px 80px rgba(0, 0, 0, 0.1);
}

.support-bg-glow {
    position: absolute;
    width: 600px;
    height: 600px;
    background: radial-gradient(circle, rgba(201, 168, 76, 0.15) 0%, transparent 70%);
    top: 50%;
    left: -10%;
    transform: translateY(-50%);
    pointer-events: none;
    z-index: 1;
}

.support-content {
    position: relative;
    z-index: 2;
    flex: 1 1;
}

.support-title-wrap {
    display: flex;
    align-items: center;
    gap: 20px;
    margin-bottom: 24px;
}

.support-icon-ring {
    position: relative;
    width: 64px;
    min-width: 64px;
    height: 64px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(201, 168, 76, 0.1);
    border-radius: 50%;
    border: 1px solid rgba(201, 168, 76, 0.3);
    color: #C9A84C;
}

.support-icon-ring::before {
    content: '';
    position: absolute;
    top: -4px;
    right: -4px;
    bottom: -4px;
    left: -4px;
    border-radius: 50%;
    border: 2px solid #C9A84C;
    opacity: 0;
    animation: pulseRing 3s infinite cubic-bezier(0.215, 0.61, 0.355, 1);
}

@keyframes pulseRing {
    0% {
        transform: scale(0.8);
        opacity: 0.8;
    }

    100% {
        transform: scale(1.4);
        opacity: 0;
    }
}

.support-title {
    font-size: 32px;
    font-weight: 700;
    color: #FFF;
    margin: 0;
    line-height: 1.1;
}

body.light_theme .support-title {
    color: #111;
}

.support-desc {
    color: #AAA;
    font-size: 16px;
    line-height: 1.6;
    max-width: 500px;
    margin: 0;
}

body.light_theme .support-desc {
    color: #555;
}

.support-actions {
    position: relative;
    z-index: 2;
    display: flex;
    flex-direction: column;
    gap: 16px;
    min-width: 400px;
}

.contact-pill {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px 24px;
    background: rgba(255, 255, 255, 0.03);
    border: 1px solid rgba(255, 255, 255, 0.08);
    border-radius: 16px;
    text-decoration: none;
    transition: all 0.3s ease;
}

body.light_theme .contact-pill {
    background: rgba(0, 0, 0, 0.02);
    border-color: rgba(0, 0, 0, 0.1);
}

.contact-pill:hover {
    background: rgba(201, 168, 76, 0.1);
    border-color: rgba(201, 168, 76, 0.4);
    transform: translateX(-4px);
}

.pill-info {
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.pill-label {
    font-size: 11px;
    text-transform: uppercase;
    letter-spacing: 0.1em;
    color: rgba(255, 255, 255, 0.5);
    font-weight: 700;
}

body.light_theme .pill-label {
    color: rgba(0, 0, 0, 0.5);
}

.pill-email {
    font-size: 16px;
    font-weight: 600;
    color: #C9A84C;
}

.pill-arrow {
    color: #C9A84C;
    transition: transform 0.3s;
}

.contact-pill:hover .pill-arrow {
    transform: translateX(4px);
}

@media (max-width: 992px) {
    .support-banner {
        flex-direction: column;
        align-items: flex-start;
        padding: 32px;
        gap: 32px;
    }

    .support-actions {
        min-width: 100%;
        width: 100%;
    }

    .support-title {
        font-size: 26px;
    }
}

@media (max-width: 480px) {
    .contact-pill {
        flex-direction: column;
        align-items: flex-start;
        gap: 12px;
    }

    .pill-arrow {
        display: none;
    }
}


.agcex-inline-1 {
    stroke: rgba(74, 222, 128, 0.4);

}

.agcex-inline-2 {
    stroke: rgba(98, 126, 234, 0.4);

}

.agcex-inline-3 {
    stroke: rgba(153, 69, 255, 0.4);

}

.agcex-inline-4 {
    stroke: #C9A84C;
    stroke-width: 3;

}

.agcex-inline-5 {
    height: 14px;
    width: auto;
    object-fit: contain;
    display: block;
    filter: brightness(0) invert(1);

}

.agcex-inline-6 {
    display: flex;
    align-items: center;
    gap: 6px;

}

.agcex-inline-7 {
    background: transparent;

}

.agcex-inline-8 {
    color: #C9A84C;

}

.agcex-inline-9 {
    font-size: 12px;

}

.agcex-inline-10 {
    background: transparent;

}

.agcex-inline-11 {
    color: #C9A84C;

}

.agcex-inline-12 {
    font-size: 12px;

}

.agcex-inline-13 {
    background: transparent;

}

.agcex-inline-14 {
    color: #C9A84C;

}

.agcex-inline-15 {
    font-size: 12px;

}

.agcex-inline-16 {
    background: transparent;

}

.agcex-inline-17 {
    color: #C9A84C;

}

.agcex-inline-18 {
    font-size: 12px;

}

.agcex-inline-19 {
    display: flex;
    align-items: center;
    gap: 6px;

}

.agcex-inline-20 {
    color: #F97316;

}

.agcex-inline-21 {
    text-align: right;

}

.agcex-inline-22 {
    color: #4ADE80;

}

.agcex-inline-23 {
    text-align: right;

}

.agcex-inline-24 {
    color: #4ADE80;

}

.agcex-inline-25 {
    text-align: right;

}

.agcex-inline-26 {
    color: #4ADE80;

}

.agcex-inline-27 {
    margin-bottom: 4px;

}

.agcex-inline-28 {
    color: #F2EEE6;
    font-weight: 700;

}

.agcex-inline-29 {
    font-size: 10px;
    color: #888;

}

.agcex-inline-30 {
    background: rgba(201, 168, 76, 0.2);
    border-color: #C9A84C;
    color: #C9A84C;
    padding: 1px 4px;

}

.agcex-inline-31 {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    margin-bottom: 2px;

}

.agcex-inline-32 {
    font-size: 20px;
    font-weight: 700;
    color: #4ADE80;

}

.agcex-inline-33 {
    font-size: 9px;
    color: #888;

}

.agcex-inline-34 {
    position: relative;
    height: 75px;
    background: rgba(0, 0, 0, 0.2);
    border-radius: 6px;
    overflow: hidden;
    margin-bottom: 4px;
    border: 1px solid rgba(255, 255, 255, 0.03);

}

.agcex-inline-35 {
    width: 100%;
    height: 100%;

}

.agcex-inline-36 {
    position: absolute;
    right: 4px;
    top: 6px;
    background: #4ADE80;
    color: #0b0e11;
    font-size: 7px;
    font-weight: bold;
    padding: 1px 3px;
    border-radius: 2px;
    box-shadow: 0 2px 4px rgba(74, 222, 128, 0.25);

}

.agcex-inline-37 {
    display: grid;
    grid-template-columns: 1fr;
    max-width: 800px;
    gap: 6px;
    margin-bottom: 6px;
    font-size: 9px;
    font-family: monospace;
    background: rgba(0, 0, 0, 0.12);
    padding: 5px;
    border-radius: 6px;
    border: 1px solid rgba(255, 255, 255, 0.03);

}

.agcex-inline-38 {
    display: flex;
    flex-direction: column;
    gap: 2.5px;

}

.agcex-inline-39 {
    color: var(--text-muted);
    display: flex;
    justify-content: space-between;
    font-size: 7.5px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.04);
    padding-bottom: 1px;

}

.agcex-inline-40 {
    position: relative;
    display: flex;
    justify-content: space-between;
    color: #F87171;
    padding: 1px 0;

}

.agcex-inline-41 {
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;
    background: rgba(248, 113, 113, 0.08);
    width: 75%;

}

.agcex-inline-42 {
    z-index: 1;
    font-weight: bold;

}

.agcex-inline-43 {
    color: #888;
    z-index: 1;

}

.agcex-inline-44 {
    position: relative;
    display: flex;
    justify-content: space-between;
    color: #F87171;
    padding: 1px 0;

}

.agcex-inline-45 {
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;
    background: rgba(248, 113, 113, 0.08);
    width: 45%;

}

.agcex-inline-46 {
    z-index: 1;
    font-weight: bold;

}

.agcex-inline-47 {
    color: #888;
    z-index: 1;

}

.agcex-inline-48 {
    position: relative;
    display: flex;
    justify-content: space-between;
    color: #F87171;
    padding: 1px 0;

}

.agcex-inline-49 {
    position: absolute;
    right: 0;
    top: 0;
    bottom: 0;
    background: rgba(248, 113, 113, 0.08);
    width: 20%;

}

.agcex-inline-50 {
    z-index: 1;
    font-weight: bold;

}

.agcex-inline-51 {
    color: #888;
    z-index: 1;

}

.agcex-inline-52 {
    display: flex;
    flex-direction: column;
    gap: 2.5px;

}

.agcex-inline-53 {
    color: var(--text-muted);
    display: flex;
    justify-content: space-between;
    font-size: 7.5px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.04);
    padding-bottom: 1px;

}

.agcex-inline-54 {
    position: relative;
    display: flex;
    justify-content: space-between;
    color: #4ADE80;
    padding: 1px 0;

}

.agcex-inline-55 {
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    background: rgba(74, 222, 128, 0.08);
    width: 35%;

}

.agcex-inline-56 {
    z-index: 1;
    font-weight: bold;

}

.agcex-inline-57 {
    color: #888;
    z-index: 1;

}

.agcex-inline-58 {
    position: relative;
    display: flex;
    justify-content: space-between;
    color: #4ADE80;
    padding: 1px 0;

}

.agcex-inline-59 {
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    background: rgba(74, 222, 128, 0.08);
    width: 60%;

}

.agcex-inline-60 {
    z-index: 1;
    font-weight: bold;

}

.agcex-inline-61 {
    color: #888;
    z-index: 1;

}

.agcex-inline-62 {
    position: relative;
    display: flex;
    justify-content: space-between;
    color: #4ADE80;
    padding: 1px 0;

}

.agcex-inline-63 {
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    background: rgba(74, 222, 128, 0.08);
    width: 85%;

}

.agcex-inline-64 {
    z-index: 1;
    font-weight: bold;

}

.agcex-inline-65 {
    color: #888;
    z-index: 1;

}

.agcex-inline-66 {
    margin-top: 2px;

}

.agcex-inline-67 {
    padding: 6px 0;
    font-size: 10px;
    font-weight: bold;

}

.agcex-inline-68 {
    padding: 6px 0;
    font-size: 10px;
    font-weight: bold;

}

.agcex-inline-69 {
    margin-bottom: 6px;

}

.agcex-inline-70 {
    color: #F2EEE6;
    font-weight: 700;

}

.agcex-inline-71 {
    background: rgba(98, 126, 234, 0.2);
    border-color: #627EEA;
    color: #627EEA;
    padding: 1px 4px;

}

.agcex-inline-72 {
    display: flex;
    align-items: center;
    gap: 12px;
    margin: 8px 0;
    background: rgba(0, 0, 0, 0.15);
    padding: 6px;
    border-radius: 8px;
    border: 1px solid rgba(255, 255, 255, 0.03);

}

.agcex-inline-73 {
    position: relative;
    width: 64px;
    height: 64px;
    flex-shrink: 0;

}

.agcex-inline-74 {
    width: 100%;
    height: 100%;
    transform: rotate(-90deg);

}

.agcex-inline-75 {
    position: absolute;
    inset: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    line-height: 1;

}

.agcex-inline-76 {
    font-size: 7px;
    color: var(--text-muted);
    font-weight: 600;
    text-transform: uppercase;

}

.agcex-inline-77 {
    font-size: 10px;
    font-weight: 700;
    color: #E8C97A;
    margin-top: 2px;

}

.agcex-inline-78 {
    display: flex;
    flex-direction: column;
    gap: 4px;
    font-size: 8.5px;
    flex-grow: 1;
    text-align: left;

}

.agcex-inline-79 {
    display: flex;
    justify-content: space-between;
    align-items: center;

}

.agcex-inline-80 {
    color: #C9A84C;
    font-weight: 600;
    display: inline-flex;
    align-items: center;
    gap: 2px;

}

.agcex-inline-81 {
    color: #fff;

}

.agcex-inline-82 {
    display: flex;
    justify-content: space-between;
    align-items: center;

}

.agcex-inline-83 {
    color: #4ADE80;
    font-weight: 600;
    display: inline-flex;
    align-items: center;
    gap: 2px;

}

.agcex-inline-84 {
    color: #fff;

}

.agcex-inline-85 {
    display: flex;
    justify-content: space-between;
    align-items: center;

}

.agcex-inline-86 {
    color: #3b82f6;
    font-weight: 600;
    display: inline-flex;
    align-items: center;
    gap: 2px;

}

.agcex-inline-87 {
    color: #fff;

}

.agcex-inline-88 {
    margin-top: 6px;
    font-size: 9.5px;
    color: #C9A84C;
    font-weight: bold;

}

.agcex-inline-89 {
    display: flex;
    flex-direction: column;
    gap: 3px;

}

.agcex-inline-90 {
    padding: 4px 0;

}

.agcex-inline-91 {
    text-align: right;

}

.agcex-inline-92 {
    color: #4ADE80;
    font-size: 8px;

}

.agcex-inline-93 {
    padding: 4px 0;

}

.agcex-inline-94 {
    text-align: right;

}

.agcex-inline-95 {
    color: #4ADE80;
    font-size: 8px;

}

.agcex-inline-96 {
    padding: 4px 0;

}

.agcex-inline-97 {
    text-align: right;

}

.agcex-inline-98 {
    color: #888;
    font-size: 8px;

}

.agcex-inline-99 {
    color: #C9A84C;

}

.agcex-inline-100 {
    font-size: 6.5px;
    color: #4ADE80;
    font-weight: 700;
    letter-spacing: 0.5px;
    margin-top: 2px;

}

.agcex-inline-101 {
    background: rgba(74, 222, 128, 0.15);
    color: #4ADE80;
    border-color: rgba(74, 222, 128, 0.3);
    display: flex;
    align-items: center;
    justify-content: center;

}

.agcex-inline-102 {
    background: rgba(98, 126, 234, 0.15);
    color: #627EEA;
    border-color: rgba(98, 126, 234, 0.3);
    display: flex;
    align-items: center;
    justify-content: center;

}

.agcex-inline-103 {
    background: rgba(168, 85, 247, 0.15);
    color: #A855F7;
    border-color: rgba(168, 85, 247, 0.3);
    display: flex;
    align-items: center;
    justify-content: center;

}

.agcex-inline-104 {
    background: rgba(247, 147, 26, 0.15);
    color: #F7931A;
    border-color: rgba(247, 147, 26, 0.3);
    display: flex;
    align-items: center;
    justify-content: center;

}

.agcex-inline-105 {
    border-top: 1px solid rgba(255, 255, 255, 0.05);
    background: rgba(0, 0, 0, 0.1);
    position: relative;
    overflow: hidden;

}

.agcex-inline-106 {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 60%;
    height: 60%;
    background: radial-gradient(circle, rgba(201, 168, 76, 0.05) 0%, transparent 70%);
    filter: blur(80px);
    z-index: 1;
    pointer-events: none;

}

.agcex-inline-107 {
    position: relative;
    z-index: 2;
    margin-bottom: 40px;

}

.agcex-inline-108 {
    max-width: 800px;
    margin: 0 auto 16px;

}

.agcex-inline-109 {
    max-width: 650px;
    margin: 0 auto;

}

.agcex-inline-110 {
    background: rgba(201, 168, 76, 0.05);
    position: relative;
    overflow: hidden;
    border-top: 1px solid rgba(201, 168, 76, 0.1);
    border-bottom: 1px solid rgba(201, 168, 76, 0.1);

}

.agcex-inline-111 {
    position: absolute;
    right: -10%;
    top: -20%;
    width: 50%;
    height: 140%;
    background: radial-gradient(ellipse at center, rgba(201, 168, 76, 0.15) 0%, transparent 70%);
    filter: blur(60px);
    z-index: 1;
    pointer-events: none;

}

.agcex-inline-112 {
    position: absolute;
    top: -50%;
    left: -50%;
    width: 200%;
    height: 200%;
    background: linear-gradient(45deg, transparent, rgba(201, 168, 76, 0.03), transparent);
    transform: rotate(45deg);
    pointer-events: none;

}

.agcex-inline-113 {
    font-size: 10px;
    text-transform: uppercase;
    letter-spacing: 0.2em;
    color: #888;
    margin-bottom: 40px;

}

.agcex-inline-114 {
    color: #888;

}

.agcex-inline-115 {
    color: #111;

}

.agcex-inline-116 {
    color: #111;

}

.agcex-inline-117 {
    color: #111;

}

.agcex-inline-118 {
    color: #111;

}

.agcex-inline-119 {
    width: 100%;
    padding: 18px;
    margin-top: 10px;
    font-size: 15px;
    font-weight: 700;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    box-shadow: 0 10px 25px rgba(201, 168, 76, 0.25);

}

.agcex-inline-120 {
    width: 100%;
    aspect-ratio: 16 / 10;
    position: relative;
    overflow: hidden;
    background: #0b0e11;
    border-radius: 0 0 12px 12px;

}

.agcex-inline-121 {
    position: absolute;
    top: 0;
    left: 0;
    width: 1000px;
    height: 625px;
    transform-origin: top left;

}

.agcex-inline-122 {
    margin-left: 8px;

}

.agcex-inline-123 {
    color: #0ecb81;

}

.agcex-inline-124 {
    position: absolute;
    top: 12px;
    left: 16px;
    font-size: 12px;
    color: #848E9C;
    font-family: 'Roboto Mono', monospace;
    z-index: 10;

}

.agcex-inline-125 {
    padding-top: 40px;

}

.agcex-inline-126 {
    display: flex;
    gap: 24px;
    font-size: 14px;
    margin-bottom: 12px;
    font-weight: 600;

}

.agcex-inline-127 {
    color: #EAECEF;
    border-bottom: 2px solid #FCD535;
    padding-bottom: 4px;

}

.agcex-inline-128 {
    color: #848E9C;

}

.agcex-inline-129 {
    color: #848E9C;

}

.agcex-inline-130 {
    font-size: 12px;
    display: flex;
    justify-content: space-between;
    color: #848E9C;
    margin-bottom: 8px;

}

.agcex-inline-131 {
    width: 15%;

}

.agcex-inline-132 {
    width: 15%;

}

.agcex-inline-133 {
    width: 10%;

}

.agcex-inline-134 {
    width: 10%;

}

.agcex-inline-135 {
    width: 20%;
    text-align: right;

}

.agcex-inline-136 {
    width: 20%;
    text-align: right;

}

.agcex-inline-137 {
    width: 10%;
    text-align: right;

}

.agcex-inline-138 {
    font-size: 12px;
    display: flex;
    justify-content: space-between;
    color: #EAECEF;
    font-family: 'Roboto Mono', monospace;

}

.agcex-inline-139 {
    width: 15%;

}

.agcex-inline-140 {
    width: 15%;
    font-weight: 600;

}

.agcex-inline-141 {
    width: 10%;

}

.agcex-inline-142 {
    width: 10%;
    color: #0ecb81;
    font-weight: 600;

}

.agcex-inline-143 {
    width: 20%;
    text-align: right;

}

.agcex-inline-144 {
    width: 20%;
    text-align: right;

}

.agcex-inline-145 {
    width: 10%;
    text-align: right;

}

.agcex-inline-146 {
    margin-bottom: 0;

}

.agcex-inline-147 {
    font-size: 12px;
    color: #EAECEF;
    font-weight: 400;
    margin-left: 8px;

}

.agcex-inline-148 {
    justify-content: flex-start;

}

.agcex-inline-149 {
    display: flex;
    justify-content: space-between;
    font-size: 12px;
    margin-bottom: 16px;

}

.agcex-inline-150 {
    color: #848E9C;

}

.agcex-inline-151 {
    color: #EAECEF;
    font-family: 'Roboto Mono', monospace;

}

.agcex-inline-152 {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
    align-items: center;

}

.agcex-inline-153 {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: #2b3139;

}

.agcex-inline-154 {
    flex: 1 1;
    height: 2px;
    background: #2b3139;

}

.agcex-inline-155 {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: #2b3139;

}

.agcex-inline-156 {
    flex: 1 1;
    height: 2px;
    background: #2b3139;

}

.agcex-inline-157 {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: #2b3139;

}

.agcex-inline-158 {
    flex: 1 1;
    height: 2px;
    background: #2b3139;

}

.agcex-inline-159 {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: #2b3139;

}

.agcex-inline-160 {
    margin-bottom: 30px;

}

.agcex-inline-161 {
    background: rgba(74, 222, 128, 0.15);
    color: #4ADE80;
    border-color: rgba(74, 222, 128, 0.3);

}

.agcex-inline-162 {
    display: flex;
    gap: 14px;
    color: #848E9C;
    align-items: center;

}

.agcex-inline-163 {
    display: flex;
    align-items: center;
    gap: 6px;

}

.agcex-inline-164 {
    display: flex;
    align-items: center;

}

.agcex-inline-165 {
    color: #4ADE80;

}

.agcex-inline-166 {
    background: transparent;

}

.agcex-inline-167 {
    color: #C9A84C;

}

.agcex-inline-168 {
    font-size: 12px;
    font-weight: 600;

}

.agcex-inline-169 {
    background: transparent;

}

.agcex-inline-170 {
    color: #C9A84C;

}

.agcex-inline-171 {
    font-size: 12px;
    font-weight: 600;

}

.agcex-inline-172 {
    background: transparent;

}

.agcex-inline-173 {
    color: #C9A84C;

}

.agcex-inline-174 {
    font-size: 12px;
    font-weight: 600;

}

.agcex-inline-175 {
    background: transparent;

}

.agcex-inline-176 {
    color: #C9A84C;

}

.agcex-inline-177 {
    font-size: 12px;
    font-weight: 600;

}

.agcex-inline-178 {
    display: flex;
    gap: 16px;

}

.agcex-inline-179 {
    display: flex;
    align-items: center;
    gap: 6px;
    font-weight: 600;
    color: #EAECEF;

}

.agcex-inline-180 {
    color: #F97316;

}

.agcex-inline-181 {
    display: flex;
    align-items: center;
    gap: 6px;
    font-weight: 600;
    color: #848E9C;

}

.agcex-inline-182 {
    color: #C9A84C;

}

.agcex-inline-183 {
    border-top: 1px solid rgba(255, 255, 255, 0.05);
    position: relative;
    z-index: 5;

}

.agcex-inline-184 {
    padding: 0 4%;

}

.agcex-inline-185 {
    position: relative;
    width: 100px;
    margin: 0 auto 24px;

}

.agcex-inline-186 {
    margin: 0 auto;
    display: block;

}

.agcex-inline-187 {
    animation-delay: 0.5s;

}

.agcex-inline-188 {
    justify-content: center;

}

.agcex-inline-189 {
    padding: 24px 64px;
    font-size: 22px;
    border-radius: 16px;
    height: auto;

}

body.home.light_theme {
    background: #F8F9FA;
    color: #1A1A1A;
}

.icon_notificaton_r ul li.themetbs .ri-moon-line:before {
    color: #fff;
}

/* ============================================================
   Footer — New Design Classes
   ============================================================ */

body.light_theme footer {
    background-color: #fff;
    border-top: 1px solid rgba(0, 0, 0, 0.06);
    color: #fff;
}

footer {
    border-top: 1px solid rgba(255, 255, 255, 0.06);
    background: #181a20;
    padding: 52px 5% 40px;
    color: #888;
    font-size: 14px;
    position: relative;
    z-index: 10;
}

/* .ft-brand {
    grid-column: span 2;
} */

.ft-brand-company {
    margin-top: 0px;
    width: 100%;
    margin-left: -40px;
}

.ft-brand-company-name {
    color: inherit;
    pointer-events: none;
}

/* .ft-col-contact {
    grid-column: span 2;
} */

.ft-col-links-list {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.ft-col-contact-body {
    display: flex;
    flex-direction: column;
    gap: 12px;
    color: #AAA;
    font-size: 15px;
    line-height: 1.6;
}

.ft-col-contact-body p {
    margin: 0;
}

.ft-link-email {
    color: #C9A84C !important;
    font-weight: 600;
}

.ft-copy {
    max-width: 100%;
    line-height: 1.4;
    width: 100%;
    display: flex;
    justify-content: center;
    text-align: center;
    gap: 3px;
}

.ft-col.linkftr {
    padding-left: 40px;
}

.ft-copy-sub {
    max-width: 100%;
    color: #848E9C;
    font-size: 12px;
}

/* 
body.light_theme.home .hot_trading_s img.coinimg {
    filter: invert(1);
} */

@media (max-width:1440px) {

    .tl {
        font-size: clamp(32px, 4vw, 66px);
    }

}

@media (max-width:1200px) {

    .support-title {
        font-size: 26px;
    }

    .agcex-inline-189 {
        padding: 15px 48px;
        font-size: 18px;
    }

    .trust-card {
        padding: 20px;
    }


    .usp-grid {
        grid-template-columns: repeat(2, 1fr);
    }
}

@media (max-width:1100px) {
    .orbit-showcase {
        min-height: auto;
        gap: 30px;
    }

    .orbit-rings,
    .orbit-beams {
        display: none;
    }

    .orbit-center-phone {
        margin: 0 auto 40px;
    }

    .orbit-card {
        position: relative;
        width: 100%;
        top: auto !important;
        left: auto !important;
        right: auto !important;
        bottom: auto !important;
        transform: none !important;
    }

    .orbit-card.top-center {
        width: 100%;
    }

    .eco-grid,
    .vip-grid {
        grid-template-columns: 1fr;
    }

    .ft-grid {
        grid-template-columns: 1fr 1fr 1fr 1fr;
    }

    .ft-col.linkftr {
        padding-left: 20px;
    }

    .app-ph.left,
    .app-ph.right {
        display: none;
    }

    .app-ph.center {
        position: relative;
        transform: none;
    }
}

@media (max-width:768px) {
    .ft-grid {
        grid-template-columns: 1fr;
        max-width: 800px;
    }

    .cta-form {
        flex-direction: column;
    }

    .cta-box {
        padding: 40px 24px;
    }

    .ft-bottom {
        flex-direction: column;
        gap: 20px;
        text-align: center;
    }
}


@media (max-width: 768px) {

    .comp-grid {
        grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    }

    /* Fix Hero Mobile Overlaps */
    #hero {
        overflow: hidden !important;
        /* Contain the absolute globe */
        padding-bottom: 10px !important;
    }

    .hero-globe {
        transform: scale(0.6) translateX(-50%) !important;
        transform-origin: bottom left !important;
        /* Left because translateX(-50%) shifts it */
        bottom: -5% !important;
        left: 50% !important;
        margin-left: 0 !important;
    }


    .hero-inner {
        position: relative !important;
    }

    .copy {
        position: relative !important;
        z-index: 10 !important;
    }

    .phones {
        top: 0% !important;
        right: 0% !important;
        transform: scale(0.7) !important;
        transform-origin: center !important;
        pointer-events: none !important;
        z-index: 1 !important;
        height: 300px !important;
    }


    /* Footer Grid Fix */
    .ft-grid {
        grid-template-columns: 1fr 1fr 1fr 1fr !important;
        gap: 24px !important;
    }

    .ft-col.linkftr {
        padding-left: 0px;
    }

    .ft-brand,
    .ft-col {
        grid-column: span 1 !important;
    }

    /* Trust Bento Grid Mobile Fix */
    /* .trust-bento-grid {
        grid-template-columns: 1fr !important;
    } */

    .t-bento-card {
        grid-column: span 1 !important;
        grid-row: span 1 !important;
        min-height: auto !important;
    }

    /* Ensure ecosystem phone scales smoothly */
    .orbit-center-phone {
        transform: scale(0.8);
        transform-origin: center center;
        margin-bottom: 0px !important;
    }

    .orbit-control-wheel {
        display: none !important;
        /* Hide external wheel on small mobile, too cluttered */
    }

    .ft-brand-company {
        margin-left: -20px;
    }
}


@media (max-width: 767px) {

    .eco-title {
        font-size: clamp(20px, 2.5vw, 36px);
        margin-bottom: 10px;
    }

    .eco-desc {
        font-size: 14px;
    }

    .support-desc {
        font-size: 14px;
    }

    body.home .cta-sec {
        padding: 10px 20px 40px;
    }

    .ft-grid {
        grid-template-columns: 1fr !important;
        gap: 32px !important;
    }

    .comp-grid {
        grid-template-columns: 1fr;
    }

    .orbit-showcase {
        flex-direction: column;
    }

    .trust-bento-grid {
        margin: 10px auto 0;
    }

    .crypto_section .hot_spot_outer {
        min-height: 330px;
    }


    .hero-inner {
        gap: 15px !important;
        padding: 10px 0 10px !important;
    }

    .hero-actions-sec {
        margin-bottom: 15px;
    }

    .ft-copy {
        flex-direction: column;
    }

    .ft-copy-sub {
        max-width: 100%;
    }

    .orbit-showcase {
        margin: -70px auto 30px;
        gap: 10px !important;
    }

    .bento-card {
        border-radius: 24px;
        padding: 24px;
    }

    .bento-card.feat-large .bc-title {
        font-size: 24px;
    }

    .bc-title {
        font-size: 24px;
        margin: 0px;
    }

    .agcex-inline-107 {
        margin-bottom: 20px;
    }

    .eco-card {
        border-radius: 24px;
        padding: 24px;

    }

    .bc-hdr {
        margin-bottom: 0px;
    }

    .browser-mockup {
        margin-top: 0px !important;
    }

    .eco-header {
        margin-bottom: 18px;
    }


    .sec-pad {
        padding: 30px 20px 30px;
    }

    .support-title {
        font-size: 22px;
    }

    .support-banner {
        padding: 24px;
        gap: 24px;
    }

    .step-grid {
        margin-top: 10px;
    }

    .step-card {
        padding: 24px !important;
    }

    .step-num {
        font-size: 36px;
    }

    .cta-sec {
        padding: 24px 20px 40px;
    }

    .agcex-inline-184 {
        padding: 0 0%;
    }

    .orbit-showcase {
        padding: 20px 0% !important;
    }

    .trust-bento-grid {
        padding: 0 0%;
    }

    .cta-title {
        font-size: clamp(24px, 4vw, 54px);
    }

    .agcex-inline-189 {
        padding: 12px 36px;
        font-size: 15px;
        border-radius: 12px;
    }

    footer {
        padding: 30px 5% 20px;
    }

    .sub {
        margin: 0 auto 10px !important;
    }

    .ft-brand-company {
        margin-top: 0px;
        margin-left: 0px;
    }

    .ft-col.linkftr {
        padding-left: 0px;
    }

    .ft-grid {
        margin-bottom: 24px;
    }

    .ft-bottom {
        padding-top: 24px;
    }

    section#ecosystem {
        padding-bottom: 15px;
    }

    #ecosystem .eco-grid {
        margin-top: 10px;
    }

    .agcex.t-pill {
        width: 30%;
    }

}


@media (max-width: 576px) {

    .float-shape.s3 {
        top: 65%;
    }

    .bento-card.feat-large .bc-title {
        font-size: 20px;
    }

    .float-shape.s1 {
        top: 60%;
        left: 10%;
        width: 180px;
        height: 180px;
    }

    #hero {
        padding: 35px 20px 30px !important;
    }

    .phones {
        height: 350px !important;
        transform: scale(0.7);
        transform-origin: top center;
        margin-top: 0px !important;
    }

    .email-cta {
        max-width: 100% !important;
        width: 100% !important;
        gap: 7px !important;
    }

    .bento-card.feat-large .bc-title {
        font-size: 20px;
    }

    .bc-title {
        font-size: 20px;
    }

    .email-input {
        padding: 11px 15px !important;
        min-height: 42px;
    }

    .email-btn {
        padding: 7px 16px !important;
        min-height: 42px;
    }

    .trust-grid {
        align-items: center !important;
        gap: 6px !important;
    }

    .bc-desc {
        font-size: 14px;
    }

    body .step-text {
        font-size: 14px;
    }
}

@media (max-width: 370px) {

    .email-input {
        padding: 10px 10px !important;
    }

    .email-btn {
        padding: 6px 13px !important;
    }
}



@media (max-width: 480px) {

    .hero-globe {
        transform: scale(0.45) translateX(-50%) !important;
    }

    .agcex.t-pill {
        width: 49%;
    }

    .support-icon-ring {
        width: 54px;
        min-width: 54px;
        height: 54px;
    }


    .sec-title {
        font-size: clamp(24px, 3.5vw, 46px);
    }

    .agcex.orbit-track {
        margin-top: -40px;
    }

    .orbit-showcase {
        margin: -100px auto 0px;
        padding-bottom: 0px !important;
    }

    .phones {
        transform: scale(0.7) !important;
        height: 300px !important;
        margin-top: -20px !important;
    }

    .orbit-center-phone {
        transform: scale(0.65);
    }

    .tl {
        font-size: clamp(24px, 4.5vw, 66px);
    }
}


@media (max-width: 420px) {

    .store-buttons {
        flex-direction: column;
    }

}


@media (max-width: 360px) {

    .agcex.t-pill {
        width: 47%;
        text-align: left;
    }
}`, "",{"version":3,"sources":["webpack://./src/ui/Pages/LandingPage/new-home.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,oBAAoB;IACpB,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;IACI,qCAAqC;IACrC,yBAAyB;IACzB,8BAA8B;IAC9B,yCAAyC;IACzC,kCAAkC;IAClC,8CAA8C;AAClD;;AAEA;IACI,WAAW;AACf;;AAEA,iBAAiB;AACjB;IACI,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,oBAAoB;IACpB,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,WAAW;IACX,YAAY;IACZ;;8EAE0E;IAC1E,0BAA0B;IAC1B,+BAA+B;IAC/B,4CAA4C;IAC5C,6FAA6F;IAC7F,kHAAkH;IAClH,0HAA0H;AAC9H;;AAEA;IACI;;wEAEoE;AACxE;;AAEA,8EAA8E;AAC9E;IACI,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,iCAAiC;IACjC,iCAAiC;IACjC,sDAAsD;IACtD,0HAA0H;IAC1H,kBAAkB;IAClB,oBAAoB;IACpB,UAAU;IACV,+CAA+C;AACnD;;AAEA;IACI,0HAA0H;AAC9H;;AAEA;;IAEI;;QAEI,aAAa;QACb,mBAAmB;IACvB;;IAEA;QACI,UAAU;QACV,sBAAsB;IAC1B;AACJ;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,uDAAuD;IACvD,SAAS;IACT,uCAAuC;IACvC,iCAAiC;IACjC,iCAAiC;IACjC,qDAAqD;IACrD,sDAAsD;IACtD,4DAA4D;IAC5D,yDAAyD;IACzD,4BAA4B;IAC5B,oBAAoB;IACpB,aAAa;IACb,kDAAkD;AACtD;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,4BAA4B;IAC5B,2EAA2E;AAC/E;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;;IAEI,oBAAoB;IACpB,+CAA+C;AACnD;;AAEA,qCAAqC;AACrC;IACI,4BAA4B;IAC5B,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA,6BAA6B;AAC7B;IACI,4BAA4B;IAC5B,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA,mCAAmC;AACnC;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA;IACI,8BAA8B;IAC9B,gCAAgC;IAChC,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;IAC9B,gCAAgC;AACpC;;AAEA;IACI,+BAA+B;IAC/B,iCAAiC;IACjC,mBAAmB;IACnB,8DAA8D;AAClE;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;AAC/B;;AAEA;IACI,8BAA8B;IAC9B,+BAA+B;IAC/B,oDAAoD;IACpD,iBAAiB;AACrB;;AAEA;IACI,UAAU;IACV,iCAAiC;IACjC,mBAAmB;AACvB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,oCAAoC;AACxC;;AAEA;;IAEI;;QAEI,mBAAmB;QACnB,YAAY;IAChB;;IAEA;QACI,qBAAqB;QACrB,YAAY;IAChB;AACJ;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,SAAS;IACT,UAAU;IACV,6EAA6E;IAC7E,yCAAyC;AAC7C;;AAEA;IACI,aAAa;IACb,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;IACZ,SAAS;IACT,8EAA8E;IAC9E,iDAAiD;AACrD;;AAEA;IACI,cAAc;AAClB;;AAEA;;IAEI;;QAEI,0BAA0B;IAC9B;;IAEA;QACI,kCAAkC;IACtC;AACJ;;AAEA;IACI,WAAW;IACX,aAAa;IACb,8BAA8B;IAC9B,iBAAiB;IACjB,cAAc;IACd,mBAAmB;IACnB,OAAO;IACP,kBAAkB;IAClB,4DAA4D;IAC5D,8BAA8B;IAC9B,oBAAoB;AACxB;;AAEA,sBAAsB;AACtB;IACI,aAAa;IACb,sBAAsB;IACtB,MAAM;IACN,kBAAkB;IAClB,UAAU;IACV,+CAA+C;AACnD;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,mCAAmC;IACnC,gBAAgB;IAChB,sBAAsB;IACtB,yBAAyB;IACzB,cAAc;IACd,0EAA0E;IAC1E,6BAA6B;IAC7B,oCAAoC;IACpC,qBAAqB;AACzB;;AAEA;IACI,mCAAmC;IACnC,sBAAsB;IACtB,cAAc;IACd,yBAAyB;IACzB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,+BAA+B;IAC/B,gBAAgB;IAChB,yEAAyE;AAC7E;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kCAAkC;IAClC,YAAY;IACZ,oCAAoC;AACxC;;AAEA;IACI,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,mCAAmC;IACnC,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;IACd,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,cAAc;IACd,gBAAgB;IAChB,sBAAsB;IACtB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,+BAA+B;AACnC;;AAEA;IACI,uEAAuE;AAC3E;;AAEA;IACI,wEAAwE;AAC5E;;AAEA;IACI;QACI,2BAA2B;QAC3B,UAAU;IACd;;IAEA;QACI,wBAAwB;QACxB,UAAU;IACd;AACJ;;AAEA;IACI;QACI,wBAAwB;QACxB,UAAU;IACd;;IAEA;QACI,4BAA4B;QAC5B,UAAU;IACd;AACJ;;AAEA;IACI,kEAAkE;IAClE,6BAA6B;IAC7B,oCAAoC;IACpC,qBAAqB;AACzB;;AAEA;IACI,oCAAoC;IACpC,cAAc;IACd,iBAAiB;IACjB,oCAAoC;IACpC,uCAAuC;IACvC,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA,cAAc;AACd;IACI,aAAa;IACb,QAAQ;IACR,oCAAoC;IACpC,uCAAuC;AAC3C;;AAEA;IACI,SAAO;IACP,YAAY;IACZ,qCAAqC;IACrC,0CAA0C;IAC1C,mBAAmB;IACnB,0DAA0D;IAC1D,oCAAoC;IACpC,cAAc;IACd,kCAAkC;IAClC,aAAa;IACb,6BAA6B;AACjC;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,cAAc;IACd,qDAAqD;IACrD,cAAc;IACd,wDAAwD;IACxD,mBAAmB;IACnB,oCAAoC;IACpC,gBAAgB;IAChB,sBAAsB;IACtB,qBAAqB;IACrB,oBAAoB;IACpB,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,+CAA+C;AACnD;;AAEA;IACI,2BAA2B;IAC3B,+CAA+C;AACnD;;AAEA,gCAAgC;AAChC;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,yBAAyB;IACzB,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,2CAA2C;IAC3C,qCAAqC;IACrC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,oBAAoB;IACpB,qBAAqB;AACzB;;AAEA;IACI,mCAAmC;IACnC,qCAAqC;IACrC,cAAc;IACd,2BAA2B;AAC/B;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,oCAAoC;IACpC,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,eAAe;IACf,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,qCAAqC;IACrC,2CAA2C;IAC3C,mBAAmB;AACvB;;AAEA,6CAA6C;AAC7C;IACI,kBAAkB;IAClB,iCAAiC;IACjC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,qCAAqC;IACrC,4BAA4B;IAC5B,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB;;;;4BAIwB;IACxB,oBAAoB;IACpB,kBAAkB;IAClB,qCAAqC;IACrC,UAAU;AACd;;AAEA;;IAEI;;QAEI,YAAY;QACZ,yCAAyC;IAC7C;;IAEA;QACI,UAAU;QACV,2CAA2C;IAC/C;AACJ;;AAEA,wCAAwC;AACxC;IACI,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,gCAAgC;IAChC,gCAAgC;IAChC,mCAAmC;IACnC,YAAY;IACZ,uCAAuC;IACvC,qDAAqD;IACrD,4BAA4B;AAChC;;AAEA;IACI,WAAW;IACX,uDAAuD;IACvD,4BAA4B;IAC5B,0CAA0C;AAC9C;;AAEA;IACI,+BAA+B;IAC/B,2DAA2D;AAC/D;;AAEA;IACI,kGAAkG;IAClG,4DAA4D;AAChE;;AAEA,mCAAmC;AACnC;IACI,kBAAkB;IAClB,0BAA0B;IAC1B,QAAQ;IACR,yCAAyC;IACzC,gCAAgC;IAChC,iCAAiC;IACjC,UAAU;IACV,uCAAuC;IACvC,qBAAqB;IACrB,qDAAqD;IACrD,4BAA4B;AAChC;;AAEA;IACI,WAAW;IACX,sGAAsG;IACtG,4BAA4B;AAChC;;AAEA;IACI,+BAA+B;IAC/B,2DAA2D;AAC/D;;AAEA;IACI,sGAAsG;IACtG,4DAA4D;AAChE;;AAEA,qCAAqC;AACrC;IACI,kBAAkB;IAClB,2BAA2B;IAC3B,QAAQ;IACR,wCAAwC;IACxC,gCAAgC;IAChC,iCAAiC;IACjC,UAAU;IACV,yCAAyC;IACzC,qBAAqB;IACrB,qDAAqD;IACrD,4BAA4B;AAChC;;AAEA;IACI,WAAW;IACX,kGAAkG;IAClG,4BAA4B;AAChC;;AAEA;IACI,+BAA+B;IAC/B,2DAA2D;AAC/D;;AAEA;IACI,sGAAsG;IACtG,4DAA4D;AAChE;;AAEA,+EAA+E;AAC/E;IACI,WAAW;IACX,YAAY;IACZ,sCAAsC;IACtC,+CAA+C;IAC/C,gCAAgC;IAChC,sBAAsB;IACtB,kBAAkB;IAClB,yBAAyB;IACzB,UAAU;AACd;;AAEA,kEAAkE;AAClE;;IAEI,oGAAoG;IACpG;;iDAE6C;AACjD;;AAEA,gEAAgE;AAChE;IACI,oGAAoG;IACpG;;;oCAGgC;AACpC;;AAEA,2CAA2C;AAC3C;IACI,kBAAkB;IAClB,aAAa;IACb,YAAY;IACZ,UAAU;IACV,yBAAyB;IACzB,0BAA0B;AAC9B;;AAEA;IACI,QAAQ;IACR,UAAU;AACd;;AAEA;IACI,QAAQ;IACR,UAAU;AACd;;AAEA;IACI,QAAQ;IACR,WAAW;AACf;;AAEA,uDAAuD;AACvD;;IAEI,6DAA6D;IAC7D,6DAA6D;AACjE;;AAEA;IACI,6DAA6D;IAC7D,6DAA6D;AACjE;;AAEA,kFAAkF;AAClF;IACI,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,SAAS;IACT,UAAU;IACV,kBAAkB;IAClB,UAAU;IACV,oBAAoB;IACpB,UAAU;IACV,6BAA6B;AACjC;;AAEA,mEAAmE;AACnE;IACI,UAAU;AACd;;AAEA;IACI,+GAA+G;AACnH;;AAEA;IACI,gHAAgH;AACpH;;AAEA;IACI,+GAA+G;AACnH;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,uCAAuC;IACvC,+CAA+C;IAC/C,gBAAgB;IAChB,kBAAkB;IAClB,gDAAgD;IAChD,6CAA6C;IAC7C,sBAAsB;IACtB,aAAa;IACb,sBAAsB;AAC1B;;AAEA,uCAAuC;AACvC;IACI,kBAAkB;IAClB,4BAA4B;IAC5B,SAAS;IACT,2BAA2B;IAC3B,8BAA8B;IAC9B,+BAA+B;IAC/B,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sDAAsD;AAC1D;;AAEA;IACI,6BAA6B;IAC7B,8BAA8B;IAC9B,kBAAkB;IAClB,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA,6CAA6C;AAC7C;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,SAAS;IACT,UAAU;IACV,yHAAyH;IACzH,wBAAwB;IACxB,WAAW;IACX,oBAAoB;AACxB;;AAEA,2EAA2E;AAC3E;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT;;;;wCAIoC;IACpC,oBAAoB;IACpB,WAAW;IACX,sBAAsB;IACtB,iCAAiC;AACrC;;AAEA,8CAA8C;AAC9C;IACI,kBAAkB;IAClB,+BAA+B;IAC/B,SAAS;IACT,2BAA2B;IAC3B,6BAA6B;IAC7B,iCAAiC;IACjC,kBAAkB;IAClB,WAAW;IACX,oBAAoB;IACpB,gCAAgC;AACpC;;AAEA;;IAEI,kCAAkC;AACtC;;AAEA;IACI,+BAA+B;AACnC;;AAEA,2BAA2B;AAC3B;IACI,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,kCAAkC;IAClC,WAAW;IACX,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,kCAAkC;IAClC,gBAAgB;IAChB,sBAAsB;IACtB,cAAc;IACd,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,+BAA+B;IAC/B,gCAAgC;IAChC,kBAAkB;IAClB,mCAAmC;IACnC,yCAAyC;IACzC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iCAAiC;IACjC,cAAc;AAClB;;AAEA;IACI,uFAAuF;IACvF,0CAA0C;IAC1C,oCAAoC;IACpC,gCAAgC;IAChC,iBAAiB;AACrB;;AAEA;IACI,iCAAiC;IACjC,WAAW;IACX,sBAAsB;IACtB,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA;IACI,mCAAmC;IACnC,gBAAgB;IAChB,cAAc;IACd,wCAAwC;IACxC,cAAc;AAClB;;AAEA;IACI,kCAAkC;IAClC,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,0BAA0B;IAC1B,gBAAgB;IAChB,OAAO;IACP,iBAAiB;AACrB;;AAEA;IACI,mCAAmC;IACnC,0CAA0C;IAC1C,qCAAqC;IACrC,WAAW;IACX,kBAAkB;IAClB,iCAAiC;IACjC,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,qCAAqC;IACrC,2CAA2C;IAC3C,qCAAqC;IACrC,WAAW;IACX,kBAAkB;IAClB,iCAAiC;IACjC,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,kCAAkC;IAClC,WAAW;IACX,qBAAqB;IACrB,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,aAAa;IACb,kDAAkD;AACtD;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,OAAO;AACX;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,cAAc;IACd,+BAA+B;IAC/B,gCAAgC;IAChC,kCAAkC;AACtC;;AAEA;IACI,mCAAmC;IACnC,cAAc;AAClB;;AAEA;IACI,kCAAkC;IAClC,WAAW;AACf;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,QAAQ;IACR,gCAAgC;AACpC;;AAEA;IACI,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,mCAAmC;IACnC,cAAc;AAClB;;AAEA;IACI,kCAAkC;IAClC,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,aAAa;IACb,6BAA6B;IAC7B,iBAAiB;IACjB,+CAA+C;IAC/C,8BAA8B;AAClC;;AAEA;IACI,kCAAkC;AACtC;;AAEA,4DAA4D;AAC5D;IACI,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,OAAO;IACP,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,kCAAkC;IAClC,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,iCAAiC;IACjC,oCAAoC;IACpC,yCAAyC;IACzC,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,iCAAiC;IACjC,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,QAAQ;IACR,iBAAiB;AACrB;;AAEA;IACI,mCAAmC;IACnC,gBAAgB;IAChB,cAAc;IACd,wCAAwC;IACxC,cAAc;AAClB;;AAEA;IACI,kCAAkC;IAClC,WAAW;AACf;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,8BAA8B;IAC9B,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,iCAAiC;IACjC,WAAW;IACX,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,mCAAmC;IACnC,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,qCAAqC;IACrC,2CAA2C;IAC3C,kBAAkB;IAClB,WAAW;IACX,kBAAkB;IAClB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,kCAAkC;IAClC,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,8BAA8B;IAC9B,WAAW;IACX,eAAe;IACf,+CAA+C;IAC/C,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;IAC9B,kBAAkB;IAClB,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,YAAY;IACZ,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,iCAAiC;IACjC,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,kDAAkD;AACtD;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,kBAAkB;IAClB,kCAAkC;IAClC,kCAAkC;IAClC,gBAAgB;IAChB,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,QAAQ;IACR,WAAW;IACX,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,gBAAgB;IAChB,oCAAoC;IACpC,yCAAyC;IACzC,kBAAkB;IAClB,aAAa;IACb,iCAAiC;IACjC,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,iCAAiC;IACjC,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,0BAA0B;IAC1B,gBAAgB;IAChB,QAAQ;IACR,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,qDAAqD;IACrD,cAAc;IACd,iCAAiC;IACjC,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,8CAA8C;AAClD;;AAEA;IACI,qDAAqD;IACrD,cAAc;IACd,iCAAiC;IACjC,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,+CAA+C;AACnD;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,aAAa;IACb,6BAA6B;IAC7B,iBAAiB;IACjB,+CAA+C;IAC/C,8BAA8B;AAClC;;AAEA;IACI,kCAAkC;AACtC;;AAEA,gCAAgC;AAChC;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,kCAAkC;IAClC,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,iCAAiC;IACjC,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kCAAkC;IAClC,WAAW;IACX,sBAAsB;IACtB,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA;IACI,mCAAmC;IACnC,gBAAgB;IAChB,cAAc;IACd,wCAAwC;IACxC,cAAc;AAClB;;AAEA;IACI,kCAAkC;IAClC,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,OAAO;IACP,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,OAAO;AACX;;AAEA;IACI,+BAA+B;IAC/B,gCAAgC;IAChC,kBAAkB;IAClB,qCAAqC;IACrC,2CAA2C;IAC3C,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kCAAkC;IAClC,WAAW;AACf;;AAEA;IACI,kCAAkC;IAClC,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,aAAa;IACb,kDAAkD;AACtD;;AAEA;IACI,mBAAmB;AACvB;;AAEA,oDAAoD;AACpD;IACI,kBAAkB;IAClB,WAAW;IACX,+DAA+D;IAC/D,uCAAuC;IACvC,wDAAwD;IACxD,0BAA0B;IAC1B,kCAAkC;IAClC,qDAAqD;IACrD,4BAA4B;IAC5B,2BAA2B;IAC3B,2CAA2C;IAC3C,oBAAoB;AACxB;;AAEA;IACI,oEAAoE;IACpE,yFAAyF;IACzF,WAAW;AACf;;AAEA;;IAEI,kCAAkC;IAClC,2CAA2C;IAC3C,6EAA6E;IAC7E,cAAc;AAClB;;AAEA;;IAEI,qCAAqC;AACzC;;AAEA;IACI,kCAAkC;IAClC,qCAAqC;IACrC,yEAAyE;IACzE,cAAc;AAClB;;AAEA;IACI,sCAAsC;IACtC,qCAAqC;AACzC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA,cAAc;AACd;IACI,UAAU;IACV,QAAQ;IACR,sCAAsC;AAC1C;;AAEA;IACI,OAAO;IACP,SAAS;IACT,sCAAsC;IACtC,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,SAAS;IACT,wCAAwC;IACxC,qBAAqB;AACzB;;AAEA;;IAEI;;QAEI,yCAAyC;IAC7C;;IAEA;QACI,4CAA4C;IAChD;AACJ;;AAEA;IACI,mCAAmC;IACnC,WAAW;IACX,sBAAsB;IACtB,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,oCAAoC;IACpC,gBAAgB;IAChB,cAAc;IACd,wCAAwC;IACxC,gBAAgB;AACpB;;AAEA;IACI,mCAAmC;IACnC,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,6BAA6B;AACjC;;AAEA;IACI,+BAA+B;IAC/B,gCAAgC;IAChC,kBAAkB;IAClB,mCAAmC;IACnC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,oCAAoC;AACxC;;AAEA;IACI,mCAAmC;IACnC,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,mCAAmC;IACnC,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,2CAA2C;IAC3C,iBAAiB;IACjB,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA;;IAEI;;QAEI,2CAA2C;IAC/C;;IAEA;QACI,2CAA2C;IAC/C;AACJ;;AAEA,sBAAsB;AACtB;IACI,aAAa;IACb,qCAAqC;IACrC,iBAAiB;IACjB,uBAAuB;IACvB,6DAA6D;IAC7D,2BAA2B;IAC3B,0BAA0B;IAC1B,kCAAkC;IAClC,qCAAqC;IACrC,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;IACX,2CAA2C;IAC3C,qDAAqD;AACzD;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,2BAA2B;IAC3B,2CAA2C;AAC/C;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,wDAAwD;IACxD,kBAAkB;IAClB,gDAAgD;IAChD,sCAAsC;AAC1C;;AAEA;IACI,4BAA4B;IAC5B,+BAA+B;AACnC;;AAEA;IACI,kBAAkB;IAClB,6BAA6B;IAC7B,gCAAgC;AACpC;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI;QACI,qCAAqC;QACrC,qBAAqB;IACzB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,gDAAgD;IACpD;;IAEA;;QAEI,iDAAiD;IACrD;;IAEA;QACI,4BAA4B;QAC5B,4BAA4B;IAChC;;IAEA;QACI,6BAA6B;QAC7B,6BAA6B;IACjC;;IAEA;QACI,+BAA+B;QAC/B,yBAAyB;IAC7B;;IAEA;QACI,gCAAgC;QAChC,0BAA0B;QAC1B,4BAA4B;IAChC;AACJ;;AAEA;IACI,mCAAmC;IACnC,gBAAgB;IAChB,cAAc;IACd,wCAAwC;IACxC,cAAc;AAClB;;AAEA;IACI,mCAAmC;IACnC,WAAW;IACX,eAAe;IACf,sBAAsB;IACtB,yBAAyB;AAC7B;;AAEA,+CAA+C;AAC/C;IACI,sBAAsB;IACtB,8BAA8B;IAC9B,kBAAkB;IAClB,WAAW;IACX,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,cAAc;IACd,yBAAyB;IACzB,oCAAoC;IACpC,0CAA0C;IAC1C,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,mCAAmC;IACnC,gBAAgB;IAChB,uBAAuB;IACvB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,mCAAmC;IACnC,WAAW;IACX,gBAAgB;AACpB;;AAEA,oBAAoB;AACpB;IACI,iCAAiC;IACjC,2CAA2C;IAC3C,mBAAmB;IACnB,kBAAkB;IAClB,0CAA0C;IAC1C,0BAA0B;IAC1B,kCAAkC;AACtC;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,qCAAqC;IACrC,2CAA2C;IAC3C,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,qCAAqC;AACzC;;AAEA;IACI,uFAAuF;IACvF,qCAAqC;IACrC,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,yBAAyB;IACzB,qBAAqB;IACrB,mBAAmB;IACnB,kDAAkD;AACtD;;AAEA;IACI,sCAAsC;IACtC,2CAA2C;AAC/C;;AAEA;IACI,qCAAqC;IACrC,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,+CAA+C;IAC/C,kDAAkD;AACtD;;AAEA;IACI,gDAAgD;IAChD,4BAA4B;IAC5B,+BAA+B;AACnC;;AAEA;IACI,iDAAiD;IACjD,6BAA6B;IAC7B,gCAAgC;AACpC;;AAEA;IACI,iGAAiG;IACjG,oDAAoD;AACxD;;AAEA;IACI,iDAAiD;AACrD;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,0CAA0C;IAC1C,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kCAAkC;AACtC;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,oCAAoC;IACpC,cAAc;IACd,0CAA0C;AAC9C;;AAEA;IACI,qCAAqC;IACrC,cAAc;IACd,2CAA2C;AAC/C;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,qCAAqC;IACrC,2CAA2C;IAC3C,cAAc;IACd,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,sBAAsB;IACtB,+CAA+C;AACnD;;AAEA;IACI,qDAAqD;IACrD,cAAc;IACd,YAAY;IACZ,8CAA8C;AAClD;;AAEA;IACI,sBAAsB;IACtB,8CAA8C;IAC9C,qDAAqD;AACzD;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,+CAA+C;AACnD;;AAEA;IACI,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,qBAAqB;IACrB,oBAAoB;AACxB;;AAEA;IACI,cAAc;IACd,0BAA0B;AAC9B;;AAEA,4BAA4B;AAC5B;IACI,aAAa;IACb,gCAAgC;IAChC,6BAA6B;IAC7B,SAAS;IACT,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,iCAAiC;IACjC,2CAA2C;IAC3C,mBAAmB;IACnB,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,0BAA0B;IAC1B,kCAAkC;IAClC,0CAA0C;IAC1C,oBAAoB;AACxB;;AAEA;IACI,2BAA2B;IAC3B,uCAAuC;IACvC,0CAA0C;AAC9C;;AAEA;IACI,gBAAgB;IAChB,yCAAyC;IACzC,oFAAoF;IACpF,8BAA8B;AAClC;;AAEA;IACI,qCAAqC;IACrC,+CAA+C;AACnD;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;IACnB,qCAAqC;IACrC,WAAW;IACX,0CAA0C;AAC9C;;AAEA;IACI,oCAAoC;IACpC,cAAc;IACd,qCAAqC;AACzC;;AAEA;IACI,oCAAoC;IACpC,cAAc;IACd,qCAAqC;AACzC;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,gBAAgB;AACpB;;AAEA,+BAA+B;AAC/B;IACI,WAAW;IACX,mBAAmB;IACnB,8BAA8B;IAC9B,2CAA2C;IAC3C,gBAAgB;IAChB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;AACrB;;AAEA,uBAAuB;AACvB;IACI,WAAW;IACX,YAAY;IACZ,wDAAwD;AAC5D;;AAEA;IACI;QACI,qDAAqD;IACzD;;IAEA;QACI,qDAAqD;IACzD;AACJ;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,WAAW;IACX,kCAAkC;IAClC,yCAAyC;IACzC,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,0CAA0C;IAC1C,kCAA0B;YAA1B,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,iDAAiD;IACjD,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA,yBAAyB;AACzB;IACI,aAAa;IACb,8BAA8B;IAC9B,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,qCAAqC;IACrC,2CAA2C;IAC3C,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,0CAA0C;IAC1C,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,WAAW;IACX,YAAY;IACZ,yCAAyC;IACzC,mBAAmB;IACnB,gCAAgC;AACpC;;AAEA;IACI;QACI,mBAAmB;QACnB,UAAU;IACd;;IAEA;QACI,qBAAqB;QACrB,UAAU;IACd;AACJ;;AAEA;IACI,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,UAAU;IACV,WAAW;IACX,qCAAqC;IACrC,UAAU;IACV,2BAA2B;IAC3B,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,qEAAqE;IACrE,yCAAyC;AAC7C;;AAEA;IACI;QACI,4BAA4B;IAChC;;IAEA;QACI,2BAA2B;IAC/B;AACJ;;AAEA,yBAAyB;AACzB;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,qBAAqB;IACrB,aAAa;IACb,QAAQ;IACR,kBAAkB;AACtB;;AAEA;IACI,SAAO;IACP,mFAAmF;IACnF,2BAA2B;IAC3B,4BAA4B;IAC5B,6BAA6B;IAC7B,wDAAwD;AAC5D;;AAEA;IACI,qBAAqB;IACrB,WAAW;AACf;;AAEA;IACI,qBAAqB;IACrB,WAAW;AACf;;AAEA;IACI,qBAAqB;IACrB,WAAW;AACf;;AAEA;IACI,qBAAqB;IACrB,WAAW;AACf;;AAEA;IACI,qBAAqB;IACrB,WAAW;AACf;;AAEA;IACI,qBAAqB;IACrB,WAAW;AACf;;AAEA;IACI,qBAAqB;IACrB,WAAW;AACf;;AAEA;IACI,qBAAqB;IACrB,WAAW;AACf;;AAEA;IACI;QACI,sBAAsB;QACtB,wBAAwB;IAC5B;;IAEA;QACI,oBAAoB;QACpB,wBAAwB;IAC5B;AACJ;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI;QACI,0BAA0B;IAC9B;;IAEA;QACI,cAAc;IAClB;AACJ;;AAEA;;IAEI;QACI,mBAAmB;IACvB;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;AACJ;;AAEA,yCAAyC;AACzC;IACI,aAAa;IACb,kCAAkC;IAClC,SAAS;IACT,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,iCAAiC;IACjC,2CAA2C;IAC3C,mBAAmB;IACnB,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,0CAA0C;IAC1C,0BAA0B;IAC1B,kCAAkC;IAClC,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,qCAAqC;IACrC,oFAAoF;AACxF;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,oCAAoC;IACpC,cAAc;IACd,yCAAyC;IACzC,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,mCAAmC;IACnC,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,2CAA2C;IAC3C,mBAAmB;IACnB,0CAA0C;IAC1C,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,qCAAqC;IACrC,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,kDAAkD;AACtD;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,qCAAqC;IACrC,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,WAAW;IACX,sBAAsB;IACtB,YAAY;IACZ,iBAAiB;AACrB;;AAEA,yBAAyB;AACzB;IACI,mBAAmB;IACnB,kCAAkC;IAClC,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,qCAAqC;IACrC,kDAAkD;IAClD,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,gCAAgC;IAChC,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,iDAAiD;AACrD;;AAEA;IACI,aAAa;IACb,SAAS;IACT,eAAe;IACf,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,8BAA8B;IAC9B,YAAY;IACZ,gBAAgB;IAChB,+CAA+C;IAC/C,WAAW;AACf;;AAEA;IACI,SAAS;IACT,0BAA0B;AAC9B;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,aAAa;IACb,eAAe;IACf,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,mBAAmB;IACnB,yBAAyB;IACzB,sBAAsB;IACtB,eAAe;AACnB;;AAEA;;IAEI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,kBAAkB;IAClB,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,WAAW;IACX,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,SAAS;IACT,WAAW;IACX,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,aAAa;IACb,+CAA+C;IAC/C,kDAAkD;IAClD,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA,4BAA4B;AAC5B;IACI,eAAe;IACf,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,sBAAsB;IACtB,mBAAmB;IACnB,kBAAkB;IAClB,8EAA8E;IAC9E,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,aAAa;IACb,SAAS;IACT,eAAe;IACf,WAAW;AACf;;AAEA;IACI,yFAAyF;IACzF,2CAA2C;IAC3C,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,wCAAwC;IACxC,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,qCAAqC;IACrC,0CAA0C;IAC1C,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,cAAc;IACd,gCAAgC;IAChC,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,qCAAqC;IACrC,2CAA2C;IAC3C,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,mCAAmC;IACnC,cAAc;AAClB;;AAEA;IACI,oCAAoC;IACpC,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,qCAAqC;IACrC,2CAA2C;IAC3C,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,qBAAqB;IACrB,oBAAoB;AACxB;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,2BAA2B;IAC3B,gDAAgD;AACpD;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA,yBAAyB;AACzB;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,iCAAiC;IACjC,2CAA2C;IAC3C,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,0CAA0C;IAC1C,0BAA0B;IAC1B,kCAAkC;IAClC,oBAAoB;AACxB;;AAEA;IACI,2BAA2B;IAC3B,qCAAqC;IACrC,gDAAgD;AACpD;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,8BAA8B;IAC9B,cAAc;IACd,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,gBAAgB;AACpB;;;AAGA,+BAA+B;AAC/B;IACI,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,mFAAmF;IACnF,yCAAyC;IACzC,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,gDAAgD;IAChD,0BAA0B;IAC1B,kCAAkC;AACtC;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,YAAY;IACZ,aAAa;IACb,qFAAqF;IACrF,UAAU;IACV,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,iCAAiC;IACjC,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,mCAAmC;IACnC,WAAW;IACX,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,8BAA8B;IAC9B,2CAA2C;IAC3C,cAAc;IACd,eAAe;IACf,aAAa;IACb,6BAA6B;AACjC;;AAEA;IACI,qBAAqB;IACrB,4CAA4C;AAChD;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,qDAAqD;IACrD,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,oBAAoB;IACpB,mBAAmB;IACnB,+CAA+C;AACnD;;AAEA;IACI,sBAAsB;IACtB,+CAA+C;IAC/C,qDAAqD;AACzD;;AAEA;;;;;;;;GAQG;;AAEH;IACI,iBAAiB;IACjB,cAAc;IACd,aAAa;IACb,sCAAsC;IACtC,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,iBAAiB;IACjB,mCAAmC;IACnC,yCAAyC;IACzC,mBAAmB;IACnB,uBAAkB;IAAlB,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,4BAA4B;AAChC;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,WAAW;IACX,sBAAsB;AAC1B;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,iBAAiB;IACjB,+CAA+C;IAC/C,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;IACI,cAAc;AAClB;;AAEA,wCAAwC;AACxC;IACI,kBAAkB;IAClB,oBAAoB;IACpB,gCAAgC;IAChC,UAAU;IACV,yDAAyD;IACzD,aAAa;IACb,YAAY;IACZ,+CAA+C;IAC/C,yBAAiB;YAAjB,iBAAiB;IACjB,uBAAuB;AAC3B;;AAEA;IACI,QAAQ;IACR,SAAS;IACT,YAAY;IACZ,aAAa;IACb,0CAA0C;AAC9C;;AAEA;IACI,QAAQ;IACR,UAAU;IACV,UAAU;IACV,YAAY;IACZ,aAAa;IACb,+CAA+C;IAC/C,UAAU;AACd;;AAEA;IACI,OAAO;IACP,UAAU;IACV,YAAY;IACZ,aAAa;IACb,+CAA+C;AACnD;;AAEA;IACI;QACI,gDAAgD;IACpD;;IAEA;QACI,2DAA2D;IAC/D;;IAEA;QACI,kDAAkD;IACtD;AACJ;;AAEA;;IAEI;;QAEI,mCAAmC;IACvC;;IAEA;QACI,6CAA6C;IACjD;AACJ;;AAEA;;IAEI;;QAEI,uCAAuC;IAC3C;;IAEA;QACI,8CAA8C;IAClD;AACJ;;AAEA,uBAAuB;AACvB;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mCAAmC;IACnC,yCAAyC;IACzC,iBAAiB;IACjB,mBAAmB;IACnB,mBAAmB;IACnB,uBAAkB;IAAlB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,4BAA4B;IAC5B,kCAAkC;AACtC;;AAEA;IACI;QACI,sBAAsB;QACtB,YAAY;IAChB;;IAEA;QACI,qBAAqB;QACrB,UAAU;QACV,4BAA4B;IAChC;;IAEA;QACI,sBAAsB;QACtB,YAAY;IAChB;AACJ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA,qBAAqB;AACrB;IACI;QACI,mCAAmC;IACvC;;IAEA;QACI,sCAAsC;IAC1C;AACJ;;AAEA;IACI;QACI,oCAAoC;IACxC;;IAEA;QACI,sCAAsC;IAC1C;AACJ;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI,0CAA0C;AAC9C;;AAEA,4CAA4C;AAC5C;IACI,kBAAkB;IAClB,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,oBAAoB;IACpB,UAAU;AACd;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,wCAAwC;AAC5C;;AAEA;IACI;QACI,uBAAuB;IAC3B;;IAEA;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,mBAAmB;IACnB,kHAAkH;IAClH,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,+BAA+B;IAC/B,gCAAgC;IAChC,cAAc;IACd,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,2BAA2B;IAC3B,WAAW;AACf;;AAEA,kCAAkC;AAClC;IACI,SAAO;IACP,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,oBAAoB;IACpB,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,UAAU;IACV,oBAAoB;IACpB,oCAAoC;AACxC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;;IAEI;;QAEI,UAAU;QACV,oBAAoB;IACxB;;IAEA;;QAEI,UAAU;QACV,oBAAoB;IACxB;AACJ;;AAEA;;IAEI;;QAEI,UAAU;QACV,oBAAoB;IACxB;;IAEA;;QAEI,UAAU;QACV,oBAAoB;IACxB;;IAEA;;QAEI,UAAU;QACV,oBAAoB;IACxB;AACJ;;AAEA;;IAEI;;QAEI,UAAU;QACV,oBAAoB;IACxB;;IAEA;;QAEI,UAAU;QACV,oBAAoB;IACxB;;IAEA;QACI,UAAU;QACV,oBAAoB;IACxB;AACJ;;;AAGA,uDAAuD;AACvD;IACI,kBAAkB;IAClB,QAAQ;IACR,uBAAuB;IACvB,qDAAqD;IACrD,2BAA2B;IAC3B,YAAY;IACZ,aAAa;IACb,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,2CAA2C;IAC3C,kBAAkB;IAClB,+CAA+C;IAC/C,oBAAoB;AACxB;;AAEA;IACI;QACI,uBAAuB;IAC3B;;IAEA;QACI,yBAAyB;IAC7B;AACJ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,2BAA2B;IAC3B,6CAA6C;IAC7C,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,UAAU;IACV,yBAAiB;YAAjB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,WAAW;IACX,kDAAkD;IAClD,+EAA+E;IAC/E,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,2CAA2C;IAC3C,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kDAAkD;IAClD,yCAAyC;AAC7C;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,UAAU;IACV,mBAAmB;AACvB;;AAEA,gDAAgD;AAChD;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,iCAAiC;AACrC;;AAEA,6BAA6B;AAC7B;IACI,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,sBAAsB;IACtB,6CAA6C;AACjD;;AAEA,sCAAsC;AACtC;IACI;QACI,6BAA6B;QAC7B,oBAAoB;QACpB,qBAAqB;QACrB,0BAA0B;QAC1B,iCAAiC;QACjC,sBAAsB;QACtB,2BAA2B;QAC3B,wBAAwB;IAC5B;AACJ;;;AAGA;;IAEI;;QAEI,cAAc;IAClB;;IAEA;;QAEI,WAAW;IACf;AACJ;;AAEA;;IAEI;;QAEI,WAAW;IACf;;IAEA;;QAEI,cAAc;IAClB;;IAEA;;QAEI,WAAW;IACf;AACJ;;AAEA;;IAEI;;QAEI,WAAW;IACf;;IAEA;;QAEI,cAAc;IAClB;;IAEA;QACI,WAAW;IACf;AACJ;;AAEA,gCAAgC;AAChC;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,qCAAqC;IACrC,0CAA0C;IAC1C,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,uFAAuF;IACvF,yCAAyC;IACzC,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,wCAAwC;IACxC,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,oCAAoC;IACpC,cAAc;IACd,yCAAyC;IACzC,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,QAAQ;IACR,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,qCAAqC;IACrC,2CAA2C;IAC3C,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,iBAAiB;IACjB,qCAAqC;IACrC,2CAA2C;IAC3C,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA;IACI,qCAAqC;IACrC,2CAA2C;IAC3C,mBAAmB;IACnB,aAAa;IACb,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,0BAA0B;IAC1B,gBAAgB;IAChB,SAAS;IACT,eAAe;IACf,sBAAsB;IACtB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,SAAO;IACP,eAAe;IACf,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,8CAA8C;AAClD;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,+CAA+C;AACnD;;AAEA,yBAAyB;AACzB;IACI,kBAAkB;IAClB,QAAQ;IACR,oBAAoB;IACpB,UAAU;AACd;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,+BAA+B;IAC/B,eAAe;IACf,qBAAqB;IACrB,wCAAwC;AAC5C;;AAEA;IACI;QACI,uBAAuB;IAC3B;;IAEA;QACI,oBAAoB;IACxB;AACJ;;AAEA,uCAAuC;AACvC;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,aAAa;IACb,cAAc;IACd,gCAAgC;IAChC,kBAAkB;IAClB,WAAW;IACX,oBAAoB;IACpB,wCAAwC;AAC5C;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,0CAA0C;AAC9C;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI;QACI,6CAA6C;IACjD;;IAEA;QACI,+CAA+C;IACnD;AACJ;;AAEA;IACI;QACI,uBAAuB;IAC3B;;IAEA;QACI,0BAA0B;IAC9B;AACJ;;AAEA,wBAAwB;AACxB;IACI,YAAY;IACZ,kCAAkC;IAClC,2CAA2C;IAC3C,mBAAmB;IACnB,kBAAkB;IAClB,2CAA2C;IAC3C,0BAA0B;IAC1B,kCAAkC;IAClC,kDAAkD;IAClD,aAAa;IACb,sBAAsB;IACtB,oBAAoB;IACpB,eAAe;AACnB;;AAEA;IACI,uCAAuC;IACvC,qBAAqB;IACrB,kFAAkF;IAClF,WAAW;AACf;;AAEA;IACI,yCAAyC;IACzC,qFAAqF;IACrF,YAAY;AAChB;;AAEA,oCAAoC;AACpC;IACI,OAAO;IACP,SAAS;AACb;;AAEA;IACI,QAAQ;IACR,UAAU;AACd;;AAEA;IACI,SAAS;IACT,SAAS;AACb;;AAEA;IACI,QAAQ;IACR,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,oCAAoC;IACpC,0CAA0C;IAC1C,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,yCAAyC;IACzC,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,qBAAqB;IACrB,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,oBAAoB;AACxB;;AAEA;IACI,SAAS;IACT,cAAc;AAClB;;AAEA,gBAAgB;AAChB;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,iCAAiC;IACjC,iCAAiC;IACjC,2CAA2C;IAC3C,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,kBAAkB;IAClB,0CAA0C;IAC1C,0BAA0B;IAC1B,kCAAkC;IAClC,oBAAoB;AACxB;;AAEA;IACI,2BAA2B;IAC3B,qCAAqC;IACrC,gDAAgD;AACpD;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,2CAA2C;IAC3C,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,gBAAgB;AACpB;;AAEA,wCAAwC;AACxC;IACI,WAAW;IACX,iCAAiC;IACjC,cAAc;IACd,kBAAkB;IAClB,8BAA8B;IAC9B,2CAA2C;IAC3C,mBAAmB;IACnB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,sBAAsB;AAC1B;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,oCAAoC;IACpC,WAAW;IACX,oBAAoB;AACxB;;AAEA;IACI,mCAAmC;IACnC,cAAc;IACd,4CAA4C;AAChD;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,uFAAuF;IACvF,yBAAyB;IACzB,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,oBAAoB;IACpB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,UAAU;IACV,mBAAmB;IACnB,cAAc;IACd,uCAAuC;AAC3C;;AAEA;IACI,qDAAqD;IACrD,cAAc;IACd,2BAA2B;IAC3B,+CAA+C;AACnD;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,oCAAoC;IACpC,WAAW;IACX,uCAAuC;AAC3C;;AAEA,kCAAkC;AAClC;IACI,oBAAoB;IACpB,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI;QACI,sBAAsB;IAC1B;;IAEA;QACI,oBAAoB;IACxB;AACJ;;AAEA;IACI,wBAAwB;IACxB,sBAAsB;AAC1B;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI;QACI,sBAAsB;IAC1B;;IAEA;QACI,uBAAuB;IAC3B;AACJ;;;;;;AAMA,4CAA4C;;;AAG5C,sBAAsB;AACtB;;IAEI,qFAAqF;IACrF,wCAAwC;IACxC,+CAA+C;IAC/C,gCAAgC;AACpC;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;AACf;;AAEA;;;IAGI,WAAW;AACf;;AAEA;;IAEI,WAAW;AACf;;AAEA;IACI,+BAA+B;IAC/B,WAAW;IACX,iCAAiC;AACrC;;AAEA,qBAAqB;AACrB;;IAEI,gBAAgB;IAChB,gCAAgC;IAChC,WAAW;IACX,0CAA0C;AAC9C;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,gCAAgC;IAChC,WAAW;AACf;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,gBAAgB;IAChB,iCAAiC;IACjC,WAAW;IACX,yCAAyC;AAC7C;;AAEA;IACI,gBAAgB;IAChB,iCAAiC;IACjC,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,iCAAiC;IACjC,WAAW;AACf;;AAEA;IACI,qBAAqB;AACzB;;AAEA,oBAAoB;AACpB;;;;;;;IAOI,gBAAgB;IAChB,iCAAiC;IACjC,2CAA2C;AAC/C;;AAEA;;;;;IAKI,qCAAqC;IACrC,+CAA+C;IAC/C,2BAA2B;AAC/B;;AAEA;;;;;;IAMI,WAAW;AACf;;AAEA;;;;;;IAMI,WAAW;AACf;;AAEA;;;;;IAKI,8BAA8B;IAC9B,4CAA4C;AAChD;;AAEA;IACI,gBAAgB;IAChB,iCAAiC;AACrC;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,gCAAgC;IAChC,2CAA2C;AAC/C;;AAEA;IACI,gBAAgB;IAChB,gCAAgC;IAChC,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA,oBAAoB;AACpB;IACI,mBAAmB;IACnB,iCAAiC;IACjC,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,mCAAmC;IACnC,qCAAqC;IACrC,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,4CAA4C;AAChD;;AAEA;IACI,WAAW;IACX,4CAA4C;IAC5C,yCAAyC;AAC7C;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,+BAA+B;IAC/B,WAAW;AACf;;AAEA;IACI,+BAA+B;IAC/B,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,oCAAoC;IACpC,0CAA0C;IAC1C,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA,6BAA6B;AAC7B;IACI,iFAAiF;IACjF,2CAA2C;IAC3C,sCAAsC;AAC1C;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;;IAEI,sCAAsC;AAC1C;;AAEA;IACI;;;;4BAIwB;IACxB,kBAAkB;AACtB;;AAEA,WAAW;;AAEX;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;AAEA,aAAa;AACb;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;IACV,oBAAoB;IACpB,6BAA6B;AACjC;;AAEA;IACI,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,8BAA8B;IAC9B,kCAA0B;YAA1B,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,0CAA0C;IAC1C,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,UAAU;IACV,uCAAuC;IACvC,kEAAkE;IAClE,2CAA2C;AAC/C;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,eAAe;IACf,WAAW;IACX,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,qBAAqB;IACrB,4CAA4C;AAChD;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,gBAAgB;IAChB,gCAAgC;IAChC,4CAA4C;AAChD;;AAEA;IACI,WAAW;AACf;;AAEA,6BAA6B;AAC7B;IACI,aAAa;IACb,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,WAAW;IACX,mBAAmB;IACnB,4BAA4B;IAC5B,sCAAsC;AAC1C;;AAEA;IACI;QACI,QAAQ;QACR,UAAU;IACd;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,QAAQ;QACR,UAAU;IACd;AACJ;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;;IAEI;;QAEI,wBAAwB;IAC5B;;IAEA;QACI,4BAA4B;IAChC;AACJ;;AAEA;IACI,qDAAqD;AACzD;;AAEA,iDAAiD;AACjD;IACI,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,gGAAgG;IAChG,yBAAiB;YAAjB,iBAAiB;IACjB,kBAAkB;IAClB,qBAAqB;IACrB,gBAAgB;IAChB,gBAAgB;IAChB,iDAAiD;IACjD,mCAAmC;IACnC,kCAAkC;IAClC,2BAA2B;IAC3B,+BAA+B;IAC/B,mBAAmB;IACnB,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,uBAAuB;IACvB,qBAAqB;IACrB,oBAAoB;IACpB,0BAA0B;IAC1B,4BAA4B;IAC5B,wBAAwB;IACxB,0CAA0C;IAC1C,sBAAsB;IACtB,oBAAoB;IACpB,qBAAqB;IACrB,2BAA2B;IAC3B,yCAAyC;IACzC,sCAAsC;IACtC,wCAAwC;AAC5C;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,uBAAuB;IACvB,qBAAqB;IACrB,oBAAoB;IACpB,0BAA0B;IAC1B,4BAA4B;IAC5B,wBAAwB;IACxB,yCAAyC;AAC7C;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,6BAA6B;IAC7B,iBAAiB;IACjB,gBAAgB;IAChB,wBAAwB;IACxB,uBAAuB;IACvB,WAAW;AACf;;AAEA;;IAEI,aAAa;IACb,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;;IAEI,oBAAoB;IACpB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,4CAA4C;IAC5C,SAAS;AACb;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,uBAAuB;IACvB,eAAe;AACnB;;AAEA;;IAEI,aAAa;IACb,WAAW;IACX,gBAAgB;IAChB,qBAAqB;IACrB,SAAO;AACX;;AAEA;;IAEI,aAAa;AACjB;;AAEA;;;IAGI,iBAAiB;IACjB,gBAAgB;IAChB,wBAAwB;IACxB,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;;;IAGI,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;;;IAGI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,cAAc;IACd,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;IACjB,wBAAwB;AAC5B;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,sBAAsB;IACtB,qBAAqB;AACzB;;AAEA;IACI,8BAA8B;IAC9B,uBAAuB;AAC3B;;AAEA;IACI,gCAAgC;IAChC,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,WAAW;IACX,iBAAiB;IACjB,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,OAAO;IACP,kBAAkB;IAClB,SAAO;IACP,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,iBAAiB;IACjB,wBAAwB;IACxB,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;;IAEI,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,iBAAiB;IACjB,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,0CAA0C;IAC1C,6CAA6C;IAC7C,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,cAAc;IACd,qBAAqB;IACrB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,4BAA4B;IAC5B,YAAY;AAChB;;AAEA;IACI,8BAA8B;IAC9B,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;IACjB,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,yBAAyB;IACzB,eAAe;IACf,WAAW;AACf;;AAEA;IACI,SAAO;IACP,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,qBAAqB;IACrB,eAAe;AACnB;;AAEA;IACI,8BAA8B;IAC9B,cAAc;AAClB;;AAEA;IACI,4BAA4B;IAC5B,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,0BAA0B;IAC1B,qCAAqC;IACrC,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,0BAA0B;IAC1B,qCAAqC;IACrC,qBAAqB;IACrB,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,cAAc;IACd,qBAAqB;IACrB,yBAAyB;IACzB,uBAAuB;IACvB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,SAAO;IACP,YAAY;IACZ,uBAAuB;IACvB,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,uBAAuB;IACvB,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,wBAAwB;IACxB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,iBAAiB;IACjB,wBAAwB;IACxB,gBAAgB;IAChB,oBAAoB;IACpB,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,YAAY;IACZ,8BAA8B;IAC9B,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,gCAAgC;IAChC,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,gCAAgC;IAChC,wCAAwC;IACxC,UAAU;AACd;;AAEA;IACI,gCAAgC;IAChC,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,iBAAiB;IACjB,wBAAwB;IACxB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,iBAAiB;IACjB,wBAAwB;IACxB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,iBAAiB;IACjB,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,WAAW;AACf;;AAEA;IACI,SAAO;IACP,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,kCAAkC;IAClC,+BAA+B;IAC/B,eAAe;IACf,qBAAqB;IACrB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,8BAA8B;IAC9B,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;IACjB,qBAAqB;IACrB,eAAe;IACf,8CAA8C;AAClD;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,eAAe;IACf,wBAAwB;AAC5B;;AAEA;IACI,oCAAoC;IACpC,8CAA8C;IAC9C,iDAAiD;IACjD,oBAAoB;IACpB,iBAAiB;IACjB,gBAAgB;IAChB,wBAAwB;IACxB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,WAAS;IACT,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,yCAAyC;IACzC,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,wBAAwB;IACxB,eAAe;AACnB;;AAEA;IACI,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,wBAAwB;IACxB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,yCAAyC;IACzC,yBAAyB;IACzB,eAAe;IACf,6BAA6B;IAC7B,mBAAmB;IACnB,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,aAAa;IACb,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,wBAAwB;IACxB,WAAW;IACX,eAAe;IACf,SAAO;IACP,kBAAkB;IAClB,2BAA2B;AAC/B;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,cAAc;IACd,UAAU;IACV,oBAAoB;IACpB,iBAAiB;IACjB,qBAAqB;IACrB,sBAAsB;IACtB,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,yBAAyB;AAC7B;;;AAGA,uBAAuB;AACvB;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,0BAA0B;IAC1B,qCAAqC;IACrC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,iBAAiB;IACjB,wBAAwB;AAC5B;;AAEA;IACI,wCAAwC;IACxC,gBAAgB;IAChB,eAAe;IACf,uBAAuB;IACvB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,SAAS;IACT,eAAe;IACf,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,qBAAqB;IACrB,oBAAoB;IACpB,wBAAwB;IACxB,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,wBAAwB;AAC5B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,wBAAwB;IACxB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,cAAc;IACd,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,wBAAwB;AAC5B;;AAEA;IACI,6DAA6D;IAC7D,mBAAmB;IACnB,wBAAwB;IACxB,oBAAoB;IACpB,aAAa;IACb,8BAA8B;IAC9B,kBAAkB;IAClB,gBAAgB;IAChB,+CAA+C;AACnD;;AAEA;IACI,6DAA6D;IAC7D,yCAAyC;IACzC,yCAAyC;AAC7C;;AAEA;IACI,WAAS;IACT,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,yBAAyB;IACzB,cAAc;IACd,sBAAsB;AAC1B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,0BAA0B;IAC1B,gBAAgB;AACpB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,WAAS;IACT,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,8CAA8C;AAClD;;AAEA;;IAEI;;QAEI,wBAAwB;IAC5B;;IAEA;QACI,2BAA2B;IAC/B;AACJ;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,+BAA+B;IAC/B,cAAc;IACd,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,qCAAqC;IACrC,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,0BAA0B;IAC1B,gBAAgB;IAChB,WAAW;IACX,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,0BAA0B;IAC1B,qCAAqC;IACrC,qBAAqB;IACrB,oBAAoB;IACpB,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,wBAAwB;IACxB,8BAA8B;IAC9B,yCAAyC;IACzC,8BAA8B;IAC9B,8BAA8B;IAC9B,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,oCAAoC;IACpC,cAAc;AAClB;;AAEA;IACI,oCAAoC;IACpC,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,wBAAwB;IACxB,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,eAAe;IACf,yBAAyB;IACzB,mBAAmB;IACnB,0BAA0B;IAC1B,WAAW;IACX,sBAAsB;IACtB,qCAAqC;AACzC;;AAEA;IACI,SAAO;IACP,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,wBAAwB;IACxB,iBAAiB;IACjB,qBAAqB;IACrB,eAAe;IACf,uBAAuB;IACvB,YAAY;IACZ,kDAAkD;IAClD,mBAAmB;AACvB;;AAEA;IACI,6BAA6B;IAC7B,yBAAyB;IACzB,8CAA8C;AAClD;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,iBAAiB;IACjB,SAAO;IACP,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,kCAAkC;IAClC,mBAAmB;IACnB,iBAAiB;IACjB,4CAA4C;AAChD;;AAEA;IACI,iBAAiB;IACjB,wBAAwB;IACxB,gBAAgB;IAChB,4CAA4C;IAC5C,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,cAAc;IACd,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;AACrB;;AAEA;IACI,oCAAoC;IACpC,cAAc;AAClB;;AAEA;IACI,oCAAoC;IACpC,cAAc;AAClB;;AAEA;IACI,oCAAoC;IACpC,cAAc;AAClB;;AAEA;IACI,oCAAoC;IACpC,cAAc;AAClB;;AAEA;IACI,oCAAoC;IACpC,cAAc;AAClB;;AAEA;IACI,mCAAmC;IACnC,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,wBAAwB;AAC5B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,wBAAwB;AAC5B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,sBAAsB;IACtB,qBAAqB;IACrB,qBAAqB;AACzB;;AAEA;IACI,8BAA8B;IAC9B,uBAAuB;AAC3B;;AAEA;IACI,gCAAgC;IAChC,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,wBAAwB;IACxB,iBAAiB;IACjB,eAAe;AACnB;;AAEA,yBAAyB;AACzB;IACI,aAAa;IACb,mBAAmB;IACnB,oBAAoB;IACpB,4CAA4C;IAC5C,SAAS;AACb;;AAEA;IACI,eAAe;IACf,wBAAwB;IACxB,gBAAgB;AACpB;;AAEA;IACI,uFAAuF;IACvF,yCAAyC;IACzC,mBAAmB;IACnB,wBAAwB;IACxB,oBAAoB;AACxB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,wBAAwB;IACxB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,wBAAwB;IACxB,gBAAgB;IAChB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,uBAAuB;IACvB,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;IACjB,wBAAwB;IACxB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,qCAAqC;IACrC,0BAA0B;IAC1B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,uBAAuB;IACvB,oBAAoB;AACxB;;AAEA;IACI,yBAAyB;IACzB,+BAA+B;AACnC;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,4CAA4C;IAC5C,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,iBAAiB;IACjB,wBAAwB;IACxB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,oBAAoB;IACpB,uBAAuB;IACvB,iBAAiB;IACjB,wBAAwB;IACxB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,iBAAiB;IACjB,SAAO;IACP,gBAAgB;IAChB,qBAAqB;IACrB,SAAS;AACb;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,4CAA4C;AAChD;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,WAAS;AACb;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,wBAAwB;AAC5B;;AAEA;IACI,iBAAiB;IACjB,SAAO;IACP,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,wBAAwB;AAC5B;;AAEA;IACI,eAAe;IACf,wBAAwB;IACxB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,SAAS;IACT,2BAA2B;IAC3B,qFAAqF;IACrF,2CAA2C;IAC3C,mBAAmB;IACnB,oBAAoB;IACpB,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,0CAA0C;IAC1C,WAAW;AACf;;AAEA;IACI,wFAAwF;IACxF,oCAAoC;IACpC,2CAA2C;AAC/C;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,sBAAsB;AAC1B;;AAEA;IACI,WAAW;AACf;;AAEA;;iFAEiF;;AAEjF;;IAEI;QACI,cAAc;IAClB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,cAAc;IAClB;;AAEJ;;AAEA,sCAAsC;AACtC;;IAEI;QACI,eAAe;IACnB;;AAEJ;;AAEA,sCAAsC;AACtC;;;IAGI;QACI,wBAAwB;IAC5B;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;;QAEI,wBAAwB;IAC5B;AACJ;;AAEA,wCAAwC;AACxC;IACI;QACI,kCAAkC;QAClC,2BAA2B;IAC/B;;IAEA;QACI,qCAAqC;QACrC,oBAAoB;QACpB,6BAA6B;QAC7B,gCAAgC;QAChC,+BAA+B;QAC/B,2BAA2B;IAC/B;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,2BAA2B;QAC3B,8BAA8B;IAClC;;IAEA;QACI,2BAA2B;QAC3B,sBAAsB;QACtB,8BAA8B;IAClC;;IAEA;QACI,6BAA6B;QAC7B,8BAA8B;IAClC;;IAEA;QACI,kCAAkC;IACtC;;IAEA;QACI,kCAAkC;IACtC;;IAEA;QACI,sBAAsB;QACtB,2BAA2B;QAC3B,wBAAwB;QACxB,yBAAyB;IAC7B;;IAEA;QACI,uBAAuB;QACvB,wBAAwB;IAC5B;;IAEA;;QAEI,uBAAuB;QACvB,wBAAwB;IAC5B;;IAEA;QACI,oBAAoB;QACpB,qBAAqB;QACrB,wEAAwE;QACxE,2CAA2C;QAC3C,8CAA8C;QAC9C,gEAAgE;IACpE;;IAEA;QACI,oBAAoB;IACxB;AACJ;;AAEA;;IAEI;QACI,WAAW;IACf;;IAEA;QACI,QAAQ;QACR,SAAS;QACT,YAAY;QACZ,aAAa;IACjB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,wBAAwB;IAC5B;;AAEJ;;;AAGA,+CAA+C;AAC/C;IACI;QACI,2BAA2B;QAC3B,8BAA8B;QAC9B,8BAA8B;QAC9B,4CAA4C;QAC5C,wBAAwB;QACxB,4BAA4B;IAChC;;IAEA;QACI,yBAAyB;IAC7B;;IAEA;;QAEI,wBAAwB;QACxB,mEAAmE;IACvE;AACJ;;AAEA,gDAAgD;AAChD;IACI;QACI,qCAAqC;QACrC,oBAAoB;IACxB;;IAEA;QACI,6BAA6B;IACjC;AACJ;;AAEA,2CAA2C;AAC3C;IACI;QACI,qCAAqC;QACrC,oBAAoB;IACxB;AACJ;;AAEA,2EAA2E;AAC3E;IACI;QACI,2BAA2B;QAC3B,oBAAoB;QACpB,2BAA2B;QAC3B,qDAAqD;QACrD,iCAAiC;IACrC;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB;;IAEA;;QAEI,wBAAwB;IAC5B;;IAEA;QACI,6BAA6B;QAC7B,oBAAoB;QACpB,qBAAqB;QACrB,0BAA0B;QAC1B,sBAAsB;QACtB,uBAAuB;QACvB,0BAA0B;QAC1B,wBAAwB;QACxB,iCAAiC;QACjC,oBAAoB;QACpB,8BAA8B;IAClC;;IAEA;QACI,6BAA6B;QAC7B,sBAAsB;QACtB,uBAAuB;QACvB,oBAAoB;QACpB,qBAAqB;QACrB,0BAA0B;QAC1B,0BAA0B;QAC1B,yBAAyB;IAC7B;;IAEA;QACI,YAAY;QACZ,8BAA8B;QAC9B,wBAAwB;QACxB,wDAAwD;QACxD,oBAAoB;QACpB,0EAA0E;IAC9E;;IAEA;QACI,6BAA6B;QAC7B,sBAAsB;QACtB,0BAA0B;QAC1B,yBAAyB;QACzB,oBAAoB;QACpB,qBAAqB;QACrB,sBAAsB;QACtB,uBAAuB;QACvB,0BAA0B;QAC1B,iCAAiC;IACrC;;IAEA;QACI,sBAAsB;QACtB,0BAA0B;QAC1B,iCAAiC;IACrC;AACJ;;AAEA;;IAEI;QACI,0BAA0B;IAC9B;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,YAAY;QACZ,eAAe;IACnB;;AAEJ;;AAEA,sDAAsD;AACtD;;IAEI;QACI,2BAA2B;QAC3B,uBAAuB;QACvB,iCAAiC;QACjC,+BAA+B;QAC/B,6BAA6B;QAC7B,oBAAoB;QACpB,iCAAiC;IACrC;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,wBAAwB;QACxB,sBAAsB;IAC1B;;IAEA;QACI,6BAA6B;QAC7B,uBAAuB;QACvB,qBAAqB;QACrB,sBAAsB;QACtB,oBAAoB;QACpB,6BAA6B;QAC7B,0BAA0B;QAC1B,sBAAsB;QACtB,iCAAiC;IACrC;;IAEA;QACI,0BAA0B;QAC1B,mBAAmB;QACnB,8BAA8B;IAClC;;IAEA;QACI,8BAA8B;QAC9B,2BAA2B;QAC3B,kCAAkC;QAClC,2BAA2B;QAC3B,yEAAyE;IAC7E;;IAEA;QACI,0BAA0B;IAC9B;AACJ;;AAEA,2DAA2D;AAC3D;IACI;QACI,sBAAsB;QACtB,2BAA2B;QAC3B,iCAAiC;IACrC;;IAEA;QACI,0BAA0B;QAC1B,wBAAwB;QACxB,6BAA6B;IACjC;;IAEA;QACI,0BAA0B;QAC1B,sBAAsB;QACtB,kDAAkD;QAClD,6BAA6B;IACjC;;IAEA;QACI,wBAAwB;QACxB,0BAA0B;IAC9B;;IAEA;QACI,qCAAqC;QACrC,2BAA2B;IAC/B;;IAEA;QACI,6BAA6B;QAC7B,6DAA6D;QAC7D,6BAA6B;IACjC;;IAEA;QACI,4BAA4B;IAChC;;IAEA;QACI,2BAA2B;QAC3B,uBAAuB;IAC3B;;IAEA;QACI,6BAA6B;IACjC;AACJ;;AAEA,+EAA+E;AAC/E;IACI;QACI,qCAAqC;QACrC,oBAAoB;IACxB;;IAEA;QACI,6BAA6B;QAC7B,sBAAsB;QACtB,iCAAiC;IACrC;AACJ;;AAEA;;gFAEgF;AAChF;IACI,6BAA6B;IAC7B,WAAW;IACX,gBAAgB;IAChB,kBAAkB;AACtB;;;;AAIA;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,iBAAiB;IACjB,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI;QACI,qCAAqC;IACzC;AACJ;;AAEA;IACI;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI,iGAAiG;IACjG,2CAA2C;IAC3C,mBAAmB;IACnB,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,uGAAuG;IACvG,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,iBAAiB;IACjB,0BAA0B;IAC1B,kCAAkC;AACtC;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI;QACI,sBAAsB;QACtB,uBAAuB;QACvB,MAAM;IACV;AACJ;;AAEA;IACI;QACI,mBAAmB;IACvB;AACJ;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,qDAAqD;IACrD,oBAAoB;IACpB,UAAU;IACV,WAAW;AACf;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,aAAa;IACb,cAAc;IACd,SAAS;IACT,UAAU;IACV,sCAAsC;IACtC,uBAAuB;AAC3B;;AAEA;IACI;QACI,mCAAmC;QACnC,aAAa;IACjB;;IAEA;QACI,6CAA6C;QAC7C,YAAY;IAChB;AACJ;;AAEA;IACI,2BAA2B;IAC3B,kFAAkF;AACtF;;AAEA;IACI,2FAA2F;IAC3F,iCAAiC;IACjC,2CAA2C;AAC/C;;AAEA;IACI,mFAAmF;AACvF;;AAEA;IACI,YAAY;AAChB;;AAEA;;IAEI,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,yDAAyD;IACzD,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI;QACI,mBAAmB;QACnB,WAAW;QACX,YAAY;QACZ,mBAAmB;IACvB;AACJ;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,oCAAoC;IACpC,cAAc;IACd,yCAAyC;AAC7C;;AAEA;IACI,oCAAoC;IACpC,cAAc;IACd,yCAAyC;AAC7C;;AAEA;IACI,oCAAoC;IACpC,cAAc;IACd,yCAAyC;AAC7C;;AAEA;IACI,qCAAqC;IACrC,cAAc;IACd,0CAA0C;AAC9C;;AAEA;IACI,oCAAoC;IACpC,cAAc;IACd,yCAAyC;AAC7C;;AAEA;IACI,oCAAoC;IACpC,cAAc;IACd,yCAAyC;AAC7C;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,wBAAwB;AAC5B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI,eAAe;IACf,wBAAwB;IACxB,gBAAgB;AACpB;;AAEA,2BAA2B;;AAE3B;IACI,8BAA8B;IAC9B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,WAAW;IACX,UAAU;AACd;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,qDAAqD;AACzD;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,UAAU;IACV,WAAW;IACX,mBAAmB;IACnB,8CAA8C;IAC9C,4CAA4C;AAChD;;AAEA;IACI,kBAAkB;IAClB,0CAA0C;IAC1C,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,oEAAoE;AACxE;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,qBAAqB;AACzB;;AAEA;IACI;QACI,QAAQ;QACR,UAAU;IACd;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,QAAQ;QACR,UAAU;IACd;AACJ;;AAEA;IACI;QACI,WAAW;QACX,YAAY;QACZ,UAAU;IACd;;IAEA;QACI,YAAY;QACZ,aAAa;QACb,UAAU;IACd;AACJ;;;AAGA,2BAA2B;;AAE3B;IACI,8BAA8B;IAC9B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;IACd,kBAAkB;IAClB,qCAAqC;IACrC,0CAA0C;IAC1C,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,+BAA+B;IAC/B,oBAAoB;IACpB,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,cAAc;IACd,oCAAoC;IACpC,kBAAkB;IAClB,UAAU;IACV,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,4BAA4B;AAChC;;AAEA;IACI;QACI,QAAQ;IACZ;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,WAAW;IACf;AACJ;;AAEA,uBAAuB;AACvB;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;IACpC,yBAAyB;IACzB,8CAA8C;IAC9C,gCAAgC;IAChC,uDAAuD;AAC3D;;AAEA;;IAEI;;QAEI,cAAc;QACd,mCAAmC;QACnC,qBAAqB;QACrB,4CAA4C;IAChD;;IAEA;;QAEI,+BAA+B;QAC/B,qCAAqC;QACrC,sCAAsC;QACtC,gBAAgB;IACpB;AACJ;;AAEA;;IAEI;;QAEI,wBAAwB;IAC5B;;IAEA;;QAEI,4BAA4B;IAChC;AACJ;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,+BAA+B;IAC/B,gCAAgC;IAChC,yBAAyB;AAC7B;;AAEA;IACI,8BAA8B;AAClC;;;AAGA,2BAA2B;;AAE3B;IACI,aAAa;IACb,2DAA2D;IAC3D,SAAS;IACT,iBAAiB;IACjB,cAAc;IACd,UAAU;IACV,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,kCAAkC;IAClC,2CAA2C;IAC3C,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,yBAAyB;IACzB,0CAA0C;IAC1C,0BAA0B;IAC1B,kCAAkC;AACtC;;AAEA;IACI,kCAAkC;IAClC,iCAAiC;IACjC,2CAA2C;AAC/C;;AAEA;IACI,2BAA2B;IAC3B,sCAAsC;IACtC,gDAAgD;AACpD;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,oCAAoC;IACpC,yCAAyC;IACzC,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,0CAA0C;AAC9C;;AAEA;IACI,oCAAoC;IACpC,sCAAsC;AAC1C;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,uBAAuB;IACvB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,gBAAgB;IAChB,sBAAsB;IACtB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;;AAGA,2BAA2B;;AAE3B;IACI,iBAAiB;IACjB,cAAc;IACd,aAAa;IACb,aAAa;IACb,0BAA0B;IAC1B,gBAAgB;IAChB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,iCAAiC;IACjC,gBAAgB;IAChB,mBAAmB;IACnB,WAAW;IACX,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,WAAW;IACX,mBAAmB;IACnB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,cAAc;IACd,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,mBAAmB;IACnB,WAAW;IACX,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,uEAAuE;IACvE,yCAAyC;IACzC,mBAAmB;IACnB,aAAa;IACb,kFAAkF;IAClF,kBAAkB;IAClB,gBAAgB;IAChB,qDAAqD;AACzD;;AAEA;IACI,uEAAuE;IACvE,kFAAkF;AACtF;;AAEA;IACI,uFAAuF;AAC3F;;AAEA;IACI,wFAAwF;AAC5F;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,WAAW;IACX,YAAY;IACZ,8DAA8D;IAC9D,kBAAkB;IAClB,YAAY;IACZ,2EAA2E;AAC/E;;AAEA;;IAEI,WAAW;IACX,kBAAkB;IAClB,8BAA8B;AAClC;;AAEA;IACI,SAAS;IACT,OAAO;IACP,QAAQ;IACR,WAAW;IACX,uCAAuC;AAC3C;;AAEA;IACI,MAAM;IACN,SAAS;IACT,UAAU;IACV,UAAU;IACV,uCAAuC;AAC3C;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,yBAAyB;IACzB,qBAAqB;IACrB,+BAA+B;IAC/B,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,qCAAqC;IACrC,0CAA0C;IAC1C,mBAAmB;IACnB,aAAa;IACb,WAAW;IACX,oBAAoB;IACpB,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,+BAA+B;IAC/B,oCAAoC;IACpC,WAAW;AACf;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,oCAAoC;IACpC,6CAA6C;AACjD;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,WAAW;IACX,YAAY;IACZ,sFAAsF;IACtF,wBAAwB;IACxB,oBAAoB;AACxB;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,qBAAqB;IACrB,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,yDAAkP;IAClP,4BAA4B;IAC5B,sCAAsC;IACtC,qBAAqB;AACzB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,aAAa;IACb,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,yBAAyB;IACzB,gDAAgD;AACpD;;AAEA;IACI;QACI,0BAA0B;QAC1B,SAAS;IACb;;IAEA;QACI,eAAe;IACnB;AACJ;;;AAGA,2BAA2B;;AAE3B;IACI,uBAAuB;IACvB,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,+CAA+C;IAC/C,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;IAClB,mBAAmB;IACnB,gCAAgC;AACpC;;AAEA;IACI,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,SAAO;IACP,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,SAAO;IACP,+BAA+B;IAC/B,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,SAAO;IACP,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;;;AAIA;IACI,aAAa;IACb,6BAA6B;IAC7B,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,6BAA6B;IAC7B,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,+BAA+B;IAC/B,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,qCAAqC;IACrC,mBAAmB;AACvB;;AAEA;IACI,+BAA+B;IAC/B,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,kBAAkB;IAClB,cAAc;IACd,gCAAgC;IAChC,eAAe;AACnB;;AAEA;IACI,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,MAAM;IACN,SAAS;IACT,mCAAmC;IACnC,UAAU;IACV,UAAU;AACd;;AAEA;IACI,oCAAoC;IACpC,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,6BAA6B;IAC7B,gCAAgC;IAChC,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,gCAAgC;IAChC,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,6BAA6B;AACjC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,cAAc;IACd,iBAAiB;IACjB,UAAU;IACV,aAAa;IACb,qCAAqC;AACzC;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;IAEI;QACI,eAAe;IACnB;;AAEJ;;AAEA;;IAEI;;QAEI,aAAa;IACjB;;;;IAIA;QACI,aAAa;IACjB;AACJ;;;AAGA,2BAA2B;;AAE3B;IACI,iBAAiB;IACjB,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,4FAA4F;IAC5F,yCAAyC;IACzC,mFAAmF;IACnF,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,kBAAkB;IAClB,gBAAgB;IAChB,0BAA0B;IAC1B,kCAAkC;IAClC,yBAAyB;AAC7B;;AAEA;IACI,+FAA+F;IAC/F,2CAA2C;IAC3C,qCAAqC;AACzC;;AAEA;IACI,qCAAqC;IACrC,4EAA4E;AAChF;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,iFAAiF;IACjF,QAAQ;IACR,UAAU;IACV,2BAA2B;IAC3B,oBAAoB;IACpB,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,SAAO;AACX;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mCAAmC;IACnC,kBAAkB;IAClB,yCAAyC;IACzC,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,YAAY;IACZ,UAAU;IACV,kBAAkB;IAClB,yBAAyB;IACzB,UAAU;IACV,oEAAoE;AACxE;;AAEA;IACI;QACI,qBAAqB;QACrB,YAAY;IAChB;;IAEA;QACI,qBAAqB;QACrB,UAAU;IACd;AACJ;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,kBAAkB;IAClB,qCAAqC;IACrC,2CAA2C;IAC3C,mBAAmB;IACnB,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,+BAA+B;IAC/B,gCAAgC;AACpC;;AAEA;IACI,mCAAmC;IACnC,qCAAqC;IACrC,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,qBAAqB;IACrB,+BAA+B;IAC/B,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI;QACI,sBAAsB;QACtB,uBAAuB;QACvB,aAAa;QACb,SAAS;IACb;;IAEA;QACI,eAAe;QACf,WAAW;IACf;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,sBAAsB;QACtB,uBAAuB;QACvB,SAAS;IACb;;IAEA;QACI,aAAa;IACjB;AACJ;;;AAGA;IACI,+BAA+B;;AAEnC;;AAEA;IACI,+BAA+B;;AAEnC;;AAEA;IACI,+BAA+B;;AAEnC;;AAEA;IACI,eAAe;IACf,eAAe;;AAEnB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,mBAAmB;IACnB,cAAc;IACd,+BAA+B;;AAEnC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;;AAEZ;;AAEA;IACI,uBAAuB;;AAE3B;;AAEA;IACI,cAAc;;AAElB;;AAEA;IACI,eAAe;;AAEnB;;AAEA;IACI,uBAAuB;;AAE3B;;AAEA;IACI,cAAc;;AAElB;;AAEA;IACI,eAAe;;AAEnB;;AAEA;IACI,uBAAuB;;AAE3B;;AAEA;IACI,cAAc;;AAElB;;AAEA;IACI,eAAe;;AAEnB;;AAEA;IACI,uBAAuB;;AAE3B;;AAEA;IACI,cAAc;;AAElB;;AAEA;IACI,eAAe;;AAEnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;;AAEZ;;AAEA;IACI,cAAc;;AAElB;;AAEA;IACI,iBAAiB;;AAErB;;AAEA;IACI,cAAc;;AAElB;;AAEA;IACI,iBAAiB;;AAErB;;AAEA;IACI,cAAc;;AAElB;;AAEA;IACI,iBAAiB;;AAErB;;AAEA;IACI,cAAc;;AAElB;;AAEA;IACI,kBAAkB;;AAEtB;;AAEA;IACI,cAAc;IACd,gBAAgB;;AAEpB;;AAEA;IACI,eAAe;IACf,WAAW;;AAEf;;AAEA;IACI,mCAAmC;IACnC,qBAAqB;IACrB,cAAc;IACd,gBAAgB;;AAEpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,qBAAqB;IACrB,kBAAkB;;AAEtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;;AAElB;;AAEA;IACI,cAAc;IACd,WAAW;;AAEf;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,8BAA8B;IAC9B,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB;IAClB,2CAA2C;;AAE/C;;AAEA;IACI,WAAW;IACX,YAAY;;AAEhB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,mBAAmB;IACnB,cAAc;IACd,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,8CAA8C;;AAElD;;AAEA;IACI,aAAa;IACb,0BAA0B;IAC1B,gBAAgB;IAChB,QAAQ;IACR,kBAAkB;IAClB,cAAc;IACd,sBAAsB;IACtB,+BAA+B;IAC/B,YAAY;IACZ,kBAAkB;IAClB,2CAA2C;;AAE/C;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,UAAU;;AAEd;;AAEA;IACI,wBAAwB;IACxB,aAAa;IACb,8BAA8B;IAC9B,gBAAgB;IAChB,kDAAkD;IAClD,mBAAmB;;AAEvB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,cAAc;IACd,cAAc;;AAElB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,MAAM;IACN,SAAS;IACT,qCAAqC;IACrC,UAAU;;AAEd;;AAEA;IACI,UAAU;IACV,iBAAiB;;AAErB;;AAEA;IACI,WAAW;IACX,UAAU;;AAEd;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,cAAc;IACd,cAAc;;AAElB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,MAAM;IACN,SAAS;IACT,qCAAqC;IACrC,UAAU;;AAEd;;AAEA;IACI,UAAU;IACV,iBAAiB;;AAErB;;AAEA;IACI,WAAW;IACX,UAAU;;AAEd;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,cAAc;IACd,cAAc;;AAElB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,MAAM;IACN,SAAS;IACT,qCAAqC;IACrC,UAAU;;AAEd;;AAEA;IACI,UAAU;IACV,iBAAiB;;AAErB;;AAEA;IACI,WAAW;IACX,UAAU;;AAEd;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,UAAU;;AAEd;;AAEA;IACI,wBAAwB;IACxB,aAAa;IACb,8BAA8B;IAC9B,gBAAgB;IAChB,kDAAkD;IAClD,mBAAmB;;AAEvB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,cAAc;IACd,cAAc;;AAElB;;AAEA;IACI,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,SAAS;IACT,oCAAoC;IACpC,UAAU;;AAEd;;AAEA;IACI,UAAU;IACV,iBAAiB;;AAErB;;AAEA;IACI,WAAW;IACX,UAAU;;AAEd;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,cAAc;IACd,cAAc;;AAElB;;AAEA;IACI,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,SAAS;IACT,oCAAoC;IACpC,UAAU;;AAEd;;AAEA;IACI,UAAU;IACV,iBAAiB;;AAErB;;AAEA;IACI,WAAW;IACX,UAAU;;AAEd;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,cAAc;IACd,cAAc;;AAElB;;AAEA;IACI,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,SAAS;IACT,oCAAoC;IACpC,UAAU;;AAEd;;AAEA;IACI,UAAU;IACV,iBAAiB;;AAErB;;AAEA;IACI,WAAW;IACX,UAAU;;AAEd;;AAEA;IACI,eAAe;;AAEnB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;;AAErB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;;AAErB;;AAEA;IACI,kBAAkB;;AAEtB;;AAEA;IACI,cAAc;IACd,gBAAgB;;AAEpB;;AAEA;IACI,mCAAmC;IACnC,qBAAqB;IACrB,cAAc;IACd,gBAAgB;;AAEpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,aAAa;IACb,+BAA+B;IAC/B,YAAY;IACZ,kBAAkB;IAClB,2CAA2C;;AAE/C;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,cAAc;;AAElB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;;AAE7B;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;;AAElB;;AAEA;IACI,cAAc;IACd,wBAAwB;IACxB,gBAAgB;IAChB,yBAAyB;;AAE7B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,eAAe;;AAEnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;;AAEpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;;AAEvB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;;AAEZ;;AAEA;IACI,WAAW;;AAEf;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;;AAEvB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;;AAEZ;;AAEA;IACI,WAAW;;AAEf;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;;AAEvB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;;AAEZ;;AAEA;IACI,WAAW;;AAEf;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,iBAAiB;;AAErB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;;AAEZ;;AAEA;IACI,cAAc;;AAElB;;AAEA;IACI,iBAAiB;;AAErB;;AAEA;IACI,cAAc;IACd,cAAc;;AAElB;;AAEA;IACI,cAAc;;AAElB;;AAEA;IACI,iBAAiB;;AAErB;;AAEA;IACI,cAAc;IACd,cAAc;;AAElB;;AAEA;IACI,cAAc;;AAElB;;AAEA;IACI,iBAAiB;;AAErB;;AAEA;IACI,WAAW;IACX,cAAc;;AAElB;;AAEA;IACI,cAAc;;AAElB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,qBAAqB;IACrB,eAAe;;AAEnB;;AAEA;IACI,oCAAoC;IACpC,cAAc;IACd,qCAAqC;IACrC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;;AAE3B;;AAEA;IACI,oCAAoC;IACpC,cAAc;IACd,qCAAqC;IACrC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;;AAE3B;;AAEA;IACI,oCAAoC;IACpC,cAAc;IACd,qCAAqC;IACrC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;;AAE3B;;AAEA;IACI,oCAAoC;IACpC,cAAc;IACd,qCAAqC;IACrC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;;AAE3B;;AAEA;IACI,+CAA+C;IAC/C,8BAA8B;IAC9B,kBAAkB;IAClB,gBAAgB;;AAEpB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,gCAAgC;IAChC,UAAU;IACV,WAAW;IACX,iFAAiF;IACjF,kBAAkB;IAClB,UAAU;IACV,oBAAoB;;AAExB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,mBAAmB;;AAEvB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;;AAEvB;;AAEA;IACI,gBAAgB;IAChB,cAAc;;AAElB;;AAEA;IACI,oCAAoC;IACpC,kBAAkB;IAClB,gBAAgB;IAChB,6CAA6C;IAC7C,gDAAgD;;AAEpD;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,UAAU;IACV,YAAY;IACZ,4FAA4F;IAC5F,kBAAkB;IAClB,UAAU;IACV,oBAAoB;;AAExB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,WAAW;IACX,YAAY;IACZ,sFAAsF;IACtF,wBAAwB;IACxB,oBAAoB;;AAExB;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,qBAAqB;IACrB,WAAW;IACX,mBAAmB;;AAEvB;;AAEA;IACI,WAAW;;AAEf;;AAEA;IACI,WAAW;;AAEf;;AAEA;IACI,WAAW;;AAEf;;AAEA;IACI,WAAW;;AAEf;;AAEA;IACI,WAAW;;AAEf;;AAEA;IACI,WAAW;IACX,aAAa;IACb,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,yBAAyB;IACzB,gDAAgD;;AAEpD;;AAEA;IACI,WAAW;IACX,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,4BAA4B;;AAEhC;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,aAAa;IACb,aAAa;IACb,0BAA0B;;AAE9B;;AAEA;IACI,gBAAgB;;AAEpB;;AAEA;IACI,cAAc;;AAElB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,eAAe;IACf,cAAc;IACd,qCAAqC;IACrC,WAAW;;AAEf;;AAEA;IACI,iBAAiB;;AAErB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,eAAe;IACf,mBAAmB;IACnB,gBAAgB;;AAEpB;;AAEA;IACI,cAAc;IACd,gCAAgC;IAChC,mBAAmB;;AAEvB;;AAEA;IACI,cAAc;;AAElB;;AAEA;IACI,cAAc;;AAElB;;AAEA;IACI,eAAe;IACf,aAAa;IACb,8BAA8B;IAC9B,cAAc;IACd,kBAAkB;;AAEtB;;AAEA;IACI,UAAU;;AAEd;;AAEA;IACI,UAAU;;AAEd;;AAEA;IACI,UAAU;;AAEd;;AAEA;IACI,UAAU;;AAEd;;AAEA;IACI,UAAU;IACV,iBAAiB;;AAErB;;AAEA;IACI,UAAU;IACV,iBAAiB;;AAErB;;AAEA;IACI,UAAU;IACV,iBAAiB;;AAErB;;AAEA;IACI,eAAe;IACf,aAAa;IACb,8BAA8B;IAC9B,cAAc;IACd,qCAAqC;;AAEzC;;AAEA;IACI,UAAU;;AAEd;;AAEA;IACI,UAAU;IACV,gBAAgB;;AAEpB;;AAEA;IACI,UAAU;;AAEd;;AAEA;IACI,UAAU;IACV,cAAc;IACd,gBAAgB;;AAEpB;;AAEA;IACI,UAAU;IACV,iBAAiB;;AAErB;;AAEA;IACI,UAAU;IACV,iBAAiB;;AAErB;;AAEA;IACI,UAAU;IACV,iBAAiB;;AAErB;;AAEA;IACI,gBAAgB;;AAEpB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,gBAAgB;;AAEpB;;AAEA;IACI,2BAA2B;;AAE/B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,eAAe;IACf,mBAAmB;;AAEvB;;AAEA;IACI,cAAc;;AAElB;;AAEA;IACI,cAAc;IACd,qCAAqC;;AAEzC;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;;AAEvB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,mBAAmB;;AAEvB;;AAEA;IACI,SAAO;IACP,WAAW;IACX,mBAAmB;;AAEvB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,mBAAmB;;AAEvB;;AAEA;IACI,SAAO;IACP,WAAW;IACX,mBAAmB;;AAEvB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,mBAAmB;;AAEvB;;AAEA;IACI,SAAO;IACP,WAAW;IACX,mBAAmB;;AAEvB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,mBAAmB;;AAEvB;;AAEA;IACI,mBAAmB;;AAEvB;;AAEA;IACI,oCAAoC;IACpC,cAAc;IACd,qCAAqC;;AAEzC;;AAEA;IACI,aAAa;IACb,SAAS;IACT,cAAc;IACd,mBAAmB;;AAEvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;;AAEZ;;AAEA;IACI,aAAa;IACb,mBAAmB;;AAEvB;;AAEA;IACI,cAAc;;AAElB;;AAEA;IACI,uBAAuB;;AAE3B;;AAEA;IACI,cAAc;;AAElB;;AAEA;IACI,eAAe;IACf,gBAAgB;;AAEpB;;AAEA;IACI,uBAAuB;;AAE3B;;AAEA;IACI,cAAc;;AAElB;;AAEA;IACI,eAAe;IACf,gBAAgB;;AAEpB;;AAEA;IACI,uBAAuB;;AAE3B;;AAEA;IACI,cAAc;;AAElB;;AAEA;IACI,eAAe;IACf,gBAAgB;;AAEpB;;AAEA;IACI,uBAAuB;;AAE3B;;AAEA;IACI,cAAc;;AAElB;;AAEA;IACI,eAAe;IACf,gBAAgB;;AAEpB;;AAEA;IACI,aAAa;IACb,SAAS;;AAEb;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,cAAc;;AAElB;;AAEA;IACI,cAAc;;AAElB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,cAAc;;AAElB;;AAEA;IACI,cAAc;;AAElB;;AAEA;IACI,+CAA+C;IAC/C,kBAAkB;IAClB,UAAU;;AAEd;;AAEA;IACI,aAAa;;AAEjB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,mBAAmB;;AAEvB;;AAEA;IACI,cAAc;IACd,cAAc;;AAElB;;AAEA;IACI,qBAAqB;;AAEzB;;AAEA;IACI,uBAAuB;;AAE3B;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,YAAY;;AAEhB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;AAEA;;iEAEiE;;AAEjE;IACI,sBAAsB;IACtB,yCAAyC;IACzC,WAAW;AACf;;AAEA;IACI,+CAA+C;IAC/C,mBAAmB;IACnB,qBAAqB;IACrB,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB,WAAW;AACf;;AAEA;;GAEG;;AAEH;IACI,eAAe;IACf,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,oBAAoB;AACxB;;AAEA;;GAEG;;AAEH;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,WAAW;IACX,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,kBAAkB;IAClB,QAAQ;AACZ;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,eAAe;AACnB;;AAEA;;;GAGG;;AAEH;;IAEI;QACI,iCAAiC;IACrC;;AAEJ;;AAEA;;IAEI;QACI,eAAe;IACnB;;IAEA;QACI,kBAAkB;QAClB,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB;;;IAGA;QACI,qCAAqC;IACzC;AACJ;;AAEA;IACI;QACI,gBAAgB;QAChB,SAAS;IACb;;IAEA;;QAEI,aAAa;IACjB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX,oBAAoB;QACpB,qBAAqB;QACrB,sBAAsB;QACtB,uBAAuB;QACvB,0BAA0B;IAC9B;;IAEA;QACI,WAAW;IACf;;IAEA;;QAEI,0BAA0B;IAC9B;;IAEA;QACI,sCAAsC;IAC1C;;IAEA;QACI,kBAAkB;IACtB;;IAEA;;QAEI,aAAa;IACjB;;IAEA;QACI,kBAAkB;QAClB,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,0BAA0B;QAC1B,gBAAgB;IACpB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,sBAAsB;QACtB,SAAS;QACT,kBAAkB;IACtB;AACJ;;;AAGA;;IAEI;QACI,2DAA2D;IAC/D;;IAEA,6BAA6B;IAC7B;QACI,2BAA2B;QAC3B,+BAA+B;QAC/B,+BAA+B;IACnC;;IAEA;QACI,iDAAiD;QACjD,wCAAwC;QACxC,4CAA4C;QAC5C,sBAAsB;QACtB,oBAAoB;QACpB,yBAAyB;IAC7B;;;IAGA;QACI,6BAA6B;IACjC;;IAEA;QACI,6BAA6B;QAC7B,sBAAsB;IAC1B;;IAEA;QACI,kBAAkB;QAClB,oBAAoB;QACpB,gCAAgC;QAChC,mCAAmC;QACnC,+BAA+B;QAC/B,qBAAqB;QACrB,wBAAwB;IAC5B;;;IAGA,oBAAoB;IACpB;QACI,iDAAiD;QACjD,oBAAoB;IACxB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;;QAEI,8BAA8B;IAClC;;IAEA,gCAAgC;IAChC;;OAEG;;IAEH;QACI,8BAA8B;QAC9B,2BAA2B;QAC3B,2BAA2B;IAC/B;;IAEA,2CAA2C;IAC3C;QACI,qBAAqB;QACrB,+BAA+B;QAC/B,6BAA6B;IACjC;;IAEA;QACI,wBAAwB;QACxB,uDAAuD;IAC3D;;IAEA;QACI,kBAAkB;IACtB;AACJ;;;AAGA;;IAEI;QACI,mCAAmC;QACnC,mBAAmB;IACvB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,qCAAqC;QACrC,oBAAoB;IACxB;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,iBAAiB;IACrB;;;IAGA;QACI,oBAAoB;QACpB,+BAA+B;IACnC;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,uBAAuB;QACvB,oBAAoB;IACxB;;IAEA;QACI,mBAAmB;QACnB,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,WAAW;IACf;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;QACnB,aAAa;;IAEjB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,mBAAmB;IACvB;;;IAGA;QACI,uBAAuB;IAC3B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;QACb,SAAS;IACb;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,wBAAwB;IAC5B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,iCAAiC;IACrC;;IAEA;QACI,kBAAkB;QAClB,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,UAAU;IACd;;AAEJ;;;AAGA;;IAEI;QACI,QAAQ;IACZ;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,QAAQ;QACR,SAAS;QACT,YAAY;QACZ,aAAa;IACjB;;IAEA;QACI,kCAAkC;IACtC;;IAEA;QACI,wBAAwB;QACxB,qBAAqB;QACrB,4BAA4B;QAC5B,0BAA0B;IAC9B;;IAEA;QACI,0BAA0B;QAC1B,sBAAsB;QACtB,mBAAmB;IACvB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,6BAA6B;QAC7B,gBAAgB;IACpB;;IAEA;QACI,4BAA4B;QAC5B,gBAAgB;IACpB;;IAEA;QACI,8BAA8B;QAC9B,mBAAmB;IACvB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;;IAEI;QACI,6BAA6B;IACjC;;IAEA;QACI,4BAA4B;IAChC;AACJ;;;;AAIA;;IAEI;QACI,kDAAkD;IACtD;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,WAAW;QACX,eAAe;QACf,YAAY;IAChB;;;IAGA;QACI,mCAAmC;IACvC;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,uBAAuB;QACvB,8BAA8B;IAClC;;IAEA;QACI,gCAAgC;QAChC,wBAAwB;QACxB,4BAA4B;IAChC;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,mCAAmC;IACvC;AACJ;;;AAGA;;IAEI;QACI,sBAAsB;IAC1B;;AAEJ;;;AAGA;;IAEI;QACI,UAAU;QACV,gBAAgB;IACpB;AACJ","sourcesContent":[":root {\n    --bg-dark: #0A0A0A;\n    --bg-light: #FFFFFF;\n    --text-dark: #F2EEE6;\n    --text-light: #0A0A0E;\n    --accent-gold: #C9A84C;\n}\n\nbody:not(.light_theme) {\n    --bg-color: var(--bg-dark) !important;\n    background-color: #0a0a0a;\n    --text-color: var(--text-dark);\n    --stats-border: rgba(255, 255, 255, 0.06);\n    --stats-bg: rgba(10, 10, 10, 0.75);\n    --stats-cell-border: rgba(255, 255, 255, 0.04);\n}\n\nbody:not(.light_theme) .tc-desc {\n    color: #fff;\n}\n\n/* ─── HERO ─── */\n#hero {\n    min-height: 100vh;\n    display: flex;\n    align-items: center;\n    padding: 68px 5% 0;\n    position: relative;\n    overflow: hidden;\n}\n\n.hero-perspective-bg {\n    position: absolute;\n    inset: 0;\n    pointer-events: none;\n    z-index: 1;\n    overflow: hidden;\n}\n\n.hero-grid-floor {\n    position: absolute;\n    bottom: -15%;\n    left: -20%;\n    width: 140%;\n    height: 60vh;\n    background-image:\n        linear-gradient(rgba(255, 255, 255, 0.45) 1px, transparent 1px),\n        linear-gradient(90deg, rgba(255, 255, 255, 0.45) 1px, transparent 1px);\n    background-size: 60px 60px;\n    transform-origin: bottom center;\n    transform: perspective(600px) rotateX(75deg);\n    /* Premium double-directional mask: dissolves grid before the bottom edge to preserve depth */\n    mask-image: linear-gradient(to top, transparent 0%, rgba(0, 0, 0, 0.8) 12%, rgba(0, 0, 0, 1) 30%, transparent 95%);\n    -webkit-mask-image: linear-gradient(to top, transparent 0%, rgba(0, 0, 0, 0.8) 12%, rgba(0, 0, 0, 1) 30%, transparent 95%);\n}\n\nbody.light_theme .hero-grid-floor {\n    background-image:\n        linear-gradient(rgba(0, 0, 0, 0.35) 1px, transparent 1px),\n        linear-gradient(90deg, rgba(0, 0, 0, 0.35) 1px, transparent 1px);\n}\n\n/* Horizon Ambient Glow centered at bottom right to blend clipped Globe edge */\n.hero-horizon-glow {\n    position: absolute;\n    bottom: 0;\n    left: 60%;\n    width: clamp(600px, 45vw, 1000px);\n    height: clamp(200px, 15vw, 350px);\n    margin-left: calc(-1 * clamp(600px, 45vw, 1000px) / 2);\n    background: radial-gradient(ellipse at center, rgba(201, 168, 76, 0.22) 0%, rgba(201, 168, 76, 0.05) 45%, transparent 70%);\n    filter: blur(40px);\n    pointer-events: none;\n    z-index: 2;\n    animation: horizonPulse 8s ease-in-out infinite;\n}\n\nbody.light_theme .hero-horizon-glow {\n    background: radial-gradient(ellipse at center, rgba(201, 168, 76, 0.15) 0%, rgba(201, 168, 76, 0.03) 45%, transparent 70%);\n}\n\n@keyframes horizonPulse {\n\n    0%,\n    100% {\n        opacity: 0.85;\n        transform: scale(1);\n    }\n\n    50% {\n        opacity: 1;\n        transform: scale(1.05);\n    }\n}\n\n.hero-globe {\n    position: absolute;\n    top: 15%;\n    /* Elevated to sit directly behind the mobile mockups */\n    left: 60%;\n    /* Centered visuals on the grid floor */\n    width: clamp(800px, 60vw, 1200px);\n    height: clamp(467px, 35vw, 700px);\n    /* 1.71 aspect ratio matching the high-fidelity SVG */\n    margin-left: calc(-1 * clamp(800px, 60vw, 1200px) / 2);\n    transform: perspective(1200px) rotateX(64deg) rotateZ(-8deg);\n    /* Tilted slightly more up to ensure geographic clarity */\n    transform-style: preserve-3d;\n    pointer-events: none;\n    opacity: 0.85;\n    transition: all 0.5s cubic-bezier(0.25, 1, 0.5, 1);\n}\n\n.hero-globe .map-layer {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    transform-style: preserve-3d;\n    transition: transform 0.6s cubic-bezier(0.25, 1, 0.5, 1), opacity 0.6s ease;\n}\n\n.hero-globe svg {\n    width: 100%;\n    height: 100%;\n    overflow: visible;\n}\n\n.hero-globe svg path,\n.hero-globe svg circle {\n    pointer-events: auto;\n    /* Enable mouse hover/clicks on path elements */\n}\n\n/* 3D Stacking and Parallax Offsets */\n.hero-globe .shadow-layer {\n    transform: translateZ(-28px);\n    opacity: 0.45;\n    filter: blur(6px);\n}\n\n.hero-globe .base-layer {\n    transform: translateZ(4px);\n}\n\n.hero-globe .surface-layer {\n    transform: translateZ(16px);\n}\n\n.hero-globe .network-layer {\n    transform: translateZ(30px);\n}\n\n/* Hover Parallax Mechanics */\n.hero-globe:hover .shadow-layer {\n    transform: translateZ(-40px);\n    opacity: 0.25;\n    filter: blur(8px);\n}\n\n.hero-globe:hover .base-layer {\n    transform: translateZ(8px);\n}\n\n.hero-globe:hover .surface-layer {\n    transform: translateZ(28px);\n}\n\n.hero-globe:hover .network-layer {\n    transform: translateZ(48px);\n}\n\n/* Country/Continent Path Styling */\n.hero-globe .shadow-layer .map-continents path {\n    fill: rgba(0, 0, 0, 0.75);\n    stroke: none;\n}\n\nbody.light_theme .hero-globe .shadow-layer .map-continents path {\n    fill: rgba(0, 0, 0, 0.12);\n    filter: blur(4px);\n}\n\n.hero-globe .base-layer .map-continents path {\n    fill: rgba(201, 168, 76, 0.12);\n    stroke: rgba(201, 168, 76, 0.35);\n    stroke-width: 0.8px;\n}\n\nbody.light_theme .hero-globe .base-layer .map-continents path {\n    fill: rgba(201, 168, 76, 0.04);\n    stroke: rgba(201, 168, 76, 0.18);\n}\n\n.hero-globe .surface-layer .map-continents path {\n    fill: rgba(255, 255, 255, 0.08);\n    stroke: rgba(255, 255, 255, 0.24);\n    stroke-width: 0.5px;\n    transition: fill 0.3s ease, stroke 0.3s ease, filter 0.3s ease;\n}\n\nbody.light_theme .hero-globe .surface-layer .map-continents path {\n    fill: rgba(0, 0, 0, 0.03);\n    stroke: rgba(0, 0, 0, 0.12);\n}\n\n.hero-globe .surface-layer .map-continents path:hover {\n    fill: rgba(201, 168, 76, 0.35);\n    stroke: rgba(201, 168, 76, 0.8);\n    filter: drop-shadow(0 0 8px rgba(201, 168, 76, 0.5));\n    cursor: crosshair;\n}\n\n.hero-globe .globe-ring {\n    fill: none;\n    stroke: rgba(255, 255, 255, 0.18);\n    stroke-width: 0.8px;\n}\n\nbody.light_theme .hero-globe .globe-ring {\n    stroke: rgba(0, 0, 0, 0.15);\n}\n\n.hero-globe .globe-node {\n    fill: #C9A84C;\n    filter: drop-shadow(0 0 6px #C9A84C);\n}\n\n@keyframes pulseNode {\n\n    0%,\n    100% {\n        transform: scale(1);\n        opacity: 0.4;\n    }\n\n    50% {\n        transform: scale(1.4);\n        opacity: 0.8;\n    }\n}\n\n.orb {\n    position: absolute;\n    border-radius: 50%;\n    pointer-events: none;\n    filter: blur(110px);\n}\n\n.orb1 {\n    width: 55vw;\n    height: 55vw;\n    max-width: 680px;\n    max-height: 680px;\n    top: -20%;\n    left: -12%;\n    background: radial-gradient(circle, rgba(201, 168, 76, 0.1), transparent 65%);\n    animation: drift 16s ease-in-out infinite;\n}\n\n.orb2 {\n    display: none;\n    width: 35vw;\n    height: 35vw;\n    max-width: 450px;\n    max-height: 450px;\n    bottom: -15%;\n    left: 22%;\n    background: radial-gradient(circle, rgba(201, 168, 76, 0.04), transparent 65%);\n    animation: drift 12s ease-in-out infinite reverse;\n}\n\nbody.light_theme .orb2 {\n    display: block;\n}\n\n@keyframes drift {\n\n    0%,\n    100% {\n        transform: translate(0, 0);\n    }\n\n    50% {\n        transform: translate(-20px, -28px);\n    }\n}\n\n.hero-inner {\n    width: 100%;\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    max-width: 1260px;\n    margin: 0 auto;\n    align-items: center;\n    gap: 4%;\n    position: relative;\n    /* Stacking context is now deferred to individual children */\n    min-height: calc(100vh - 68px);\n    padding: 60px 0 80px;\n}\n\n/* ─── LEFT COPY ─── */\n.copy {\n    display: flex;\n    flex-direction: column;\n    gap: 0;\n    position: relative;\n    z-index: 5;\n    /* Floats above background shapes (z-index 2) */\n}\n\n.brand {\n    margin-bottom: clamp(18px, 2.2vw, 32px);\n}\n\n.brand-name {\n    font-size: clamp(20px, 2.6vw, 36px);\n    font-weight: 700;\n    letter-spacing: 0.08em;\n    text-transform: uppercase;\n    line-height: 1;\n    background: linear-gradient(130deg, #F5E5B0 0%, #C9A84C 50%, #8B6B2A 100%);\n    -webkit-background-clip: text;\n    -webkit-text-fill-color: transparent;\n    background-clip: text;\n}\n\n.brand-exchange {\n    font-size: clamp(8px, 0.85vw, 11px);\n    letter-spacing: 0.28em;\n    color: #B5AE9E;\n    text-transform: uppercase;\n    margin-top: 5px;\n    font-weight: 500;\n}\n\n.brand-rule {\n    height: 1px;\n    width: clamp(90px, 11vw, 160px);\n    margin-top: 10px;\n    background: linear-gradient(90deg, rgba(201, 168, 76, 0.55), transparent);\n}\n\n.taglines {\n    display: flex;\n    align-items: center;\n    column-gap: clamp(8px, 1.2vw, 5px);\n    row-gap: 4px;\n    margin: 0 0 clamp(16px, 2vw, 26px) 0;\n}\n\n.agcex.copy {\n    width: 630px;\n    max-width: 100%;\n}\n\n.tl {\n    display: inline-block;\n    font-size: clamp(32px, 4.5vw, 66px);\n    font-weight: 700;\n    line-height: 1.15;\n    color: #F2EEE6;\n    letter-spacing: -0.02em;\n    margin: 0;\n}\n\n.scroolcounter_hd {\n    display: inline-flex;\n    align-items: center;\n    height: 1.25em;\n    overflow: hidden;\n    vertical-align: middle;\n    position: relative;\n    padding: 0 4px;\n}\n\n.scroolcounter_item {\n    display: inline-block;\n    height: 1.25em;\n    line-height: 1.25;\n    white-space: nowrap;\n    padding-right: 6px;\n    will-change: transform, opacity;\n}\n\n.scroolcounter_item.anim-in {\n    animation: heroWordSlideIn 0.35s cubic-bezier(0.16, 1, 0.3, 1) forwards;\n}\n\n.scroolcounter_item.anim-out {\n    animation: heroWordSlideOut 0.35s cubic-bezier(0.7, 0, 0.84, 0) forwards;\n}\n\n@keyframes heroWordSlideIn {\n    0% {\n        transform: translateY(100%);\n        opacity: 0;\n    }\n\n    100% {\n        transform: translateY(0);\n        opacity: 1;\n    }\n}\n\n@keyframes heroWordSlideOut {\n    0% {\n        transform: translateY(0);\n        opacity: 1;\n    }\n\n    100% {\n        transform: translateY(-100%);\n        opacity: 0;\n    }\n}\n\n.tl.gold {\n    background: linear-gradient(130deg, #F5E5B0, #C9A84C 60%, #8B6B2A);\n    -webkit-background-clip: text;\n    -webkit-text-fill-color: transparent;\n    background-clip: text;\n}\n\n.sub {\n    font-size: clamp(13px, 1.05vw, 16px);\n    color: #d1d1d1;\n    line-height: 1.85;\n    max-width: clamp(260px, 36vw, 460px);\n    margin-bottom: clamp(22px, 2.8vw, 38px);\n    font-weight: 300;\n}\n\nbody.light_theme .sub {\n    color: #666;\n}\n\n.sub em {\n    color: #C9A84C;\n    font-style: normal;\n    font-weight: 500;\n}\n\n/* EMAIL CTA */\n.email-cta {\n    display: flex;\n    gap: 8px;\n    max-width: clamp(280px, 36vw, 460px);\n    margin-bottom: clamp(14px, 1.6vw, 22px);\n}\n\n.email-input {\n    flex: 1;\n    min-width: 0;\n    background: rgba(255, 255, 255, 0.05);\n    border: 1px solid rgba(255, 255, 255, 0.1);\n    border-radius: 50px;\n    padding: clamp(11px, 1.1vw, 15px) clamp(16px, 1.5vw, 22px);\n    font-size: clamp(12px, 0.95vw, 14px);\n    color: #F2EEE6;\n    font-family: 'DM Sans', sans-serif;\n    outline: none;\n    transition: border-color 0.3s;\n}\n\n.email-input::placeholder {\n    color: #444;\n}\n\n.email-input:focus {\n    border-color: rgba(201, 168, 76, 0.4);\n}\n\n.email-btn {\n    flex-shrink: 0;\n    background: linear-gradient(135deg, #E8C97A, #C9A84C);\n    color: #0A0A0A;\n    padding: clamp(11px, 1.1vw, 15px) clamp(18px, 2vw, 28px);\n    border-radius: 50px;\n    font-size: clamp(12px, 0.95vw, 14px);\n    font-weight: 700;\n    letter-spacing: 0.04em;\n    text-decoration: none;\n    transition: all 0.3s;\n    white-space: nowrap;\n    border: none;\n    cursor: pointer;\n    box-shadow: 0 4px 20px rgba(201, 168, 76, 0.28);\n}\n\n.email-btn:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 8px 30px rgba(201, 168, 76, 0.45);\n}\n\n/* Hero Action & Trust Section */\n.hero-actions-sec {\n    display: flex;\n    gap: 16px;\n    margin-bottom: 30px;\n}\n\n.action-row {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    flex-wrap: wrap;\n}\n\n.s-label {\n    font-size: 11px;\n    color: #888;\n    font-weight: 600;\n    text-transform: uppercase;\n    letter-spacing: 0.05em;\n    white-space: nowrap;\n}\n\n.s-icons-pro {\n    display: flex;\n    gap: 10px;\n}\n\n.s-ico-btn {\n    width: 36px;\n    height: 36px;\n    border-radius: 10px;\n    border: 1px solid rgba(255, 255, 255, 0.08);\n    background: rgba(255, 255, 255, 0.03);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: #BBB;\n    transition: all 0.3s;\n    text-decoration: none;\n}\n\n.s-ico-btn:hover {\n    background: rgba(201, 168, 76, 0.1);\n    border-color: rgba(201, 168, 76, 0.4);\n    color: #C9A84C;\n    transform: translateY(-2px);\n}\n\n.s-divider-pro {\n    width: 1px;\n    height: 20px;\n    background: rgba(255, 255, 255, 0.1);\n    margin: 0 4px;\n}\n\n.qr-btn {\n    width: 36px;\n    height: 36px;\n}\n\n.trust-grid {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    flex-wrap: wrap;\n}\n\n.t-pill {\n    width: 33%;\n    font-size: 11px;\n    color: #AAA;\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    padding: 6px 12px;\n    background: rgba(255, 255, 255, 0.02);\n    border: 1px solid rgba(255, 255, 255, 0.05);\n    border-radius: 20px;\n}\n\n/* ─── RIGHT PHONES (overlapping stack) ─── */\n.phones {\n    position: relative;\n    height: clamp(500px, 68vh, 800px);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    perspective: 1200px;\n    /* Crucial for 3D depth perspective */\n    transform-style: preserve-3d;\n    z-index: 10;\n}\n\n.pg {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    width: 140%;\n    height: 120%;\n    border-radius: 50%;\n    background: radial-gradient(ellipse at center,\n            rgba(201, 168, 76, 0.58) 0%,\n            rgba(201, 168, 76, 0.32) 35%,\n            rgba(232, 201, 122, 0.08) 60%,\n            transparent 80%);\n    pointer-events: none;\n    filter: blur(80px);\n    animation: gp 7s ease-in-out infinite;\n    z-index: 1;\n}\n\n@keyframes gp {\n\n    0%,\n    100% {\n        opacity: 0.8;\n        transform: translate(-50%, -50%) scale(1);\n    }\n\n    50% {\n        opacity: 1;\n        transform: translate(-50%, -50%) scale(1.1);\n    }\n}\n\n/* ── Centre phone — biggest, front ── */\n.ph-c {\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    transform: translate(-50%, -50%);\n    width: clamp(175px, 19vw, 270px);\n    height: clamp(357px, 38.8vw, 550px);\n    z-index: 999;\n    animation: bob0 5s ease-in-out infinite;\n    transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);\n    transform-style: preserve-3d;\n}\n\n.ph-c:hover {\n    z-index: 12;\n    transform: translate(-50%, -50%) scale(1.08) !important;\n    animation-play-state: paused;\n    /* Pause bobbing while cursor is hovered */\n}\n\n.ph-c .s26-shell {\n    transform: translate3d(0, 0, 0);\n    transition: transform 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);\n}\n\n.phones:hover .ph-c .s26-shell {\n    transform: translateZ(45px) rotateY(calc(var(--mx, 0) * 3deg)) rotateX(calc(var(--my, 0) * -3deg));\n    transition: transform 0.15s cubic-bezier(0.25, 0.8, 0.25, 1);\n}\n\n/* ── Left phone — behind left ── */\n.ph-l {\n    position: absolute;\n    left: clamp(0px, 2%, 40px);\n    top: 50%;\n    transform: translateY(-42%) rotate(-8deg);\n    width: clamp(140px, 15vw, 210px);\n    height: clamp(280px, 30vw, 420px);\n    z-index: 3;\n    animation: bobL 6s ease-in-out infinite;\n    animation-delay: 0.8s;\n    transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);\n    transform-style: preserve-3d;\n}\n\n.ph-l:hover {\n    z-index: 12;\n    transform: translateY(-42%) rotate(-4deg) translateX(clamp(-50px, -4vw, -20px)) scale(1.05) !important;\n    animation-play-state: paused;\n}\n\n.ph-l .s26-shell {\n    transform: translate3d(0, 0, 0);\n    transition: transform 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);\n}\n\n.phones:hover .ph-l .s26-shell {\n    transform: translateZ(20px) rotateY(calc(var(--mx, 0) * 2.5deg)) rotateX(calc(var(--my, 0) * -2.5deg));\n    transition: transform 0.15s cubic-bezier(0.25, 0.8, 0.25, 1);\n}\n\n/* ── Right phone — behind right ── */\n.ph-r {\n    position: absolute;\n    right: clamp(0px, 2%, 40px);\n    top: 50%;\n    transform: translateY(-44%) rotate(8deg);\n    width: clamp(140px, 15vw, 210px);\n    height: clamp(280px, 30vw, 420px);\n    z-index: 3;\n    animation: bobR 5.5s ease-in-out infinite;\n    animation-delay: 1.4s;\n    transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);\n    transform-style: preserve-3d;\n}\n\n.ph-r:hover {\n    z-index: 12;\n    transform: translateY(-44%) rotate(4deg) translateX(clamp(20px, 4vw, 50px)) scale(1.05) !important;\n    animation-play-state: paused;\n}\n\n.ph-r .s26-shell {\n    transform: translate3d(0, 0, 0);\n    transition: transform 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);\n}\n\n.phones:hover .ph-r .s26-shell {\n    transform: translateZ(20px) rotateY(calc(var(--mx, 0) * 2.5deg)) rotateX(calc(var(--my, 0) * -2.5deg));\n    transition: transform 0.15s cubic-bezier(0.25, 0.8, 0.25, 1);\n}\n\n/* ─── Unified Ultra-High Fidelity Samsung Galaxy S26 Ultra Mockup System ─── */\n.s26-shell {\n    width: 100%;\n    height: 100%;\n    border-radius: clamp(8px, 0.9vw, 15px);\n    /* Sharp, boxy signature Galaxy Ultra corners */\n    padding: clamp(3px, 0.35vw, 5px);\n    box-sizing: border-box;\n    position: relative;\n    transition: all 0.4s ease;\n    z-index: 2;\n}\n\n/* Specular charcoal black titanium armor chassis for dark theme */\nbody:not(.light_theme) .s26-shell,\nbody .s26-shell {\n    background: linear-gradient(135deg, #2D2D35 0%, #1A1A20 25%, #0F0F12 50%, #1A1A20 75%, #2D2D35 100%);\n    box-shadow: 0 50px 110px rgba(0, 0, 0, 0.95),\n        0 0 0 1px rgba(255, 255, 255, 0.06),\n        inset 0 1px 1px rgba(255, 255, 255, 0.12);\n}\n\n/* Specular silver/gray titanium armor chassis for light theme */\nbody.light_theme .s26-shell {\n    background: linear-gradient(135deg, #FFFFFF 0%, #D8D8DC 25%, #9E9EA3 50%, #D8D8DC 75%, #FFFFFF 100%);\n    box-shadow: 0 45px 95px rgba(0, 0, 0, 0.12),\n        0 0 0 1px rgba(0, 0, 0, 0.06),\n        inset 0 1px 1.5px rgba(255, 255, 255, 0.7),\n        0 0 30px rgba(0, 0, 0, 0.02);\n}\n\n/* Specular physical buttons on S26 Ultra */\n.s26-btn {\n    position: absolute;\n    right: -2.5px;\n    width: 2.5px;\n    z-index: 1;\n    transition: all 0.4s ease;\n    border-radius: 0 2px 2px 0;\n}\n\n.s26-btn-vol-up {\n    top: 20%;\n    height: 8%;\n}\n\n.s26-btn-vol-down {\n    top: 29%;\n    height: 8%;\n}\n\n.s26-btn-power {\n    top: 42%;\n    height: 12%;\n}\n\n/* Specular button colors matching active theme frame */\nbody:not(.light_theme) .s26-btn,\nbody .s26-btn {\n    background: linear-gradient(180deg, #3D3D48 0%, #151519 100%);\n    box-shadow: inset -0.5px 0.5px 0.5px rgba(255, 255, 255, 0.1);\n}\n\nbody.light_theme .s26-btn {\n    background: linear-gradient(180deg, #FFFFFF 0%, #A1A1A6 100%);\n    box-shadow: inset -0.5px 0.5px 0.5px rgba(255, 255, 255, 0.4);\n}\n\n/* Dynamic screen ambient glow projection (projects screen colors onto backwall) */\n.ambient-glow {\n    position: absolute;\n    top: 5%;\n    left: 5%;\n    right: 5%;\n    bottom: 5%;\n    filter: blur(45px);\n    z-index: 1;\n    pointer-events: none;\n    opacity: 0;\n    transition: opacity 0.6s ease;\n}\n\n/* Enable glows only in dark theme for realistic premium contrast */\nbody:not(.light_theme) .ambient-glow {\n    opacity: 1;\n}\n\n.ph-l .ambient-glow {\n    background: radial-gradient(circle, rgba(16, 185, 129, 0.18) 0%, rgba(239, 68, 68, 0.08) 60%, transparent 100%);\n}\n\n.ph-c .ambient-glow {\n    background: radial-gradient(circle, rgba(201, 168, 76, 0.15) 0%, rgba(59, 130, 246, 0.12) 60%, transparent 100%);\n}\n\n.ph-r .ambient-glow {\n    background: radial-gradient(circle, rgba(59, 130, 246, 0.2) 0%, rgba(139, 92, 246, 0.08) 60%, transparent 100%);\n}\n\n.s26-screen {\n    width: 100%;\n    height: 100%;\n    background: #FFFFFF;\n    border-radius: clamp(6px, 0.75vw, 12px);\n    /* Perfectly matching boxy inner screen ratio */\n    overflow: hidden;\n    position: relative;\n    border: clamp(2.5px, 0.3vw, 4.5px) solid #09090B;\n    /* Minimalist ultra-thin uniform S26 bezels */\n    box-sizing: border-box;\n    display: flex;\n    flex-direction: column;\n}\n\n/* Infinity-O Front Camera Punch-hole */\n.punch-hole {\n    position: absolute;\n    top: clamp(6px, 0.7vw, 10px);\n    left: 50%;\n    transform: translateX(-50%);\n    width: clamp(8px, 0.9vw, 12px);\n    height: clamp(8px, 0.9vw, 12px);\n    background: #09090B;\n    border-radius: 50%;\n    z-index: 15;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    box-shadow: inset 0 0.5px 1px rgba(255, 255, 255, 0.2);\n}\n\n.punch-lens {\n    width: clamp(3px, 0.3vw, 5px);\n    height: clamp(3px, 0.3vw, 5px);\n    border-radius: 50%;\n    background: #141419;\n    border: 0.5px solid #22222B;\n}\n\n/* Specular vertical glass curve reflection */\n.s26-screen::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 12%;\n    width: 14%;\n    background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.06) 50%, rgba(255, 255, 255, 0) 100%);\n    transform: skewX(-15deg);\n    z-index: 12;\n    pointer-events: none;\n}\n\n/* Specular holographic glass shine sweep (moves dynamically with cursor) */\n.s26-screen::after {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: linear-gradient(calc(135deg + var(--mx, 0) * 15deg),\n            rgba(255, 255, 255, calc(0.18 + var(--my, 0) * 0.05)) 0%,\n            rgba(255, 255, 255, 0.04) calc(30% + var(--mx, 0) * 5%),\n            rgba(255, 255, 255, 0) calc(31% + var(--mx, 0) * 5%),\n            rgba(255, 255, 255, 0) 100%);\n    pointer-events: none;\n    z-index: 13;\n    border-radius: inherit;\n    transition: background 0.15s ease;\n}\n\n/* Razor-sharp vector navigation gesture bar */\n.s26-nav-bar {\n    position: absolute;\n    bottom: clamp(4px, 0.45vw, 6px);\n    left: 50%;\n    transform: translateX(-50%);\n    width: clamp(45px, 5vw, 75px);\n    height: clamp(2px, 0.25vw, 3.5px);\n    border-radius: 2px;\n    z-index: 14;\n    pointer-events: none;\n    transition: background 0.4s ease;\n}\n\nbody:not(.light_theme) .s26-nav-bar,\nbody .s26-nav-bar {\n    background: rgb(255 255 255 / 20%);\n}\n\nbody.light_theme .s26-nav-bar {\n    background: rgba(0, 0, 0, 0.65);\n}\n\n/* Screen content helpers */\n.scr {\n    padding: 8% 7% 18%;\n    height: 100%;\n}\n\n.scr-status {\n    display: flex;\n    justify-content: space-between;\n    font-size: clamp(6px, 0.58vw, 9px);\n    color: #444;\n    font-weight: 600;\n    margin-bottom: 4%;\n}\n\n.scr-hdr {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 4%;\n}\n\n.scr-logo {\n    font-size: clamp(9px, 0.9vw, 13px);\n    font-weight: 700;\n    letter-spacing: 0.08em;\n    color: #C9A84C;\n    display: flex;\n    align-items: center;\n}\n\n.scr-bell {\n    width: clamp(14px, 1.5vw, 20px);\n    height: clamp(14px, 1.5vw, 20px);\n    border-radius: 50%;\n    background: rgba(201, 168, 76, 0.1);\n    border: 1px solid rgba(201, 168, 76, 0.2);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: clamp(6px, 0.6vw, 9px);\n    color: #C9A84C;\n}\n\n.bal-card {\n    background: linear-gradient(135deg, rgba(201, 168, 76, 0.12), rgba(201, 168, 76, 0.04));\n    border: 1px solid rgba(201, 168, 76, 0.18);\n    border-radius: clamp(8px, 1vw, 14px);\n    padding: clamp(7px, 0.9vw, 13px);\n    margin-bottom: 4%;\n}\n\n.bal-lbl {\n    font-size: clamp(5px, 0.5vw, 8px);\n    color: #555;\n    letter-spacing: 0.08em;\n    text-transform: uppercase;\n    margin-bottom: 2%;\n}\n\n.bal-amt {\n    font-size: clamp(14px, 1.6vw, 24px);\n    font-weight: 700;\n    color: #F2EEE6;\n    font-family: 'Cormorant Garamond', serif;\n    line-height: 1;\n}\n\n.bal-chg {\n    font-size: clamp(6px, 0.58vw, 9px);\n    color: #4ADE80;\n    margin-top: 3%;\n}\n\n.q-btns {\n    display: grid;\n    grid-template-columns: 1fr;\n    max-width: 800px;\n    gap: 4%;\n    margin-bottom: 4%;\n}\n\n.q-buy {\n    background: rgba(74, 222, 128, 0.1);\n    border: 1px solid rgba(74, 222, 128, 0.18);\n    border-radius: clamp(5px, 0.6vw, 9px);\n    padding: 5%;\n    text-align: center;\n    font-size: clamp(6px, 0.6vw, 9px);\n    color: #4ADE80;\n    font-weight: 600;\n}\n\n.q-sell {\n    background: rgba(248, 113, 113, 0.08);\n    border: 1px solid rgba(248, 113, 113, 0.18);\n    border-radius: clamp(5px, 0.6vw, 9px);\n    padding: 5%;\n    text-align: center;\n    font-size: clamp(6px, 0.6vw, 9px);\n    color: #F87171;\n    font-weight: 600;\n}\n\n.mkt-lbl {\n    font-size: clamp(5px, 0.48vw, 7px);\n    color: #333;\n    letter-spacing: 0.1em;\n    text-transform: uppercase;\n    margin-bottom: 3%;\n}\n\n.c-row {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 3% 0;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.03);\n}\n\n.c-row:last-of-type {\n    border-bottom: none;\n}\n\n.c-left {\n    display: flex;\n    align-items: center;\n    gap: 5%;\n}\n\n.c-ico {\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-weight: 700;\n    flex-shrink: 0;\n    width: clamp(14px, 1.5vw, 22px);\n    height: clamp(14px, 1.5vw, 22px);\n    font-size: clamp(6px, 0.58vw, 9px);\n}\n\n.c-nm {\n    font-size: clamp(6px, 0.62vw, 10px);\n    color: #F2EEE6;\n}\n\n.c-tk {\n    font-size: clamp(5px, 0.48vw, 8px);\n    color: #444;\n}\n\n.spark {\n    display: flex;\n    align-items: flex-end;\n    gap: 2px;\n    height: clamp(10px, 1.1vw, 16px);\n}\n\n.sp {\n    width: clamp(2px, 0.24vw, 4px);\n    border-radius: 1px;\n}\n\n.c-right {\n    text-align: right;\n}\n\n.c-px {\n    font-size: clamp(6px, 0.62vw, 10px);\n    color: #F2EEE6;\n}\n\n.c-ch {\n    font-size: clamp(5px, 0.52vw, 8px);\n    margin-top: 1px;\n}\n\n.scr-nav {\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    display: flex;\n    justify-content: space-around;\n    padding: 3% 2% 5%;\n    border-top: 1px solid rgba(255, 255, 255, 0.05);\n    background: rgba(0, 0, 0, 0.6);\n}\n\n.scr-nav span {\n    font-size: clamp(5px, 0.52vw, 8px);\n}\n\n/* Android screen content - High Fidelity Trading Terminal */\n.and-c {\n    padding: 12% 7% 0;\n    display: flex;\n    flex-direction: column;\n    gap: 3%;\n    height: calc(100% - 25px);\n}\n\n.trd-head {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.trd-pair {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n}\n\n.trd-coin {\n    font-size: clamp(8px, 0.8vw, 11px);\n    font-weight: 700;\n    color: #F2EEE6;\n}\n\n.trd-tag {\n    font-size: clamp(4px, 0.4vw, 6px);\n    background: rgba(201, 168, 76, 0.15);\n    border: 1px solid rgba(201, 168, 76, 0.3);\n    color: #C9A84C;\n    padding: 1px 4px;\n    border-radius: 3px;\n    font-weight: 600;\n}\n\n.trd-change {\n    font-size: clamp(6px, 0.6vw, 9px);\n    color: #4ADE80;\n    font-weight: 600;\n}\n\n.trd-price-row {\n    display: flex;\n    align-items: baseline;\n    gap: 6px;\n    margin-bottom: 1%;\n}\n\n.trd-big-px {\n    font-size: clamp(14px, 1.6vw, 24px);\n    font-weight: 700;\n    color: #4ADE80;\n    font-family: 'Cormorant Garamond', serif;\n    line-height: 1;\n}\n\n.trd-sub-px {\n    font-size: clamp(6px, 0.55vw, 8px);\n    color: #666;\n}\n\n.trd-tf {\n    display: flex;\n    justify-content: space-between;\n    background: rgba(0, 0, 0, 0.4);\n    border-radius: 4px;\n    padding: 2px 4px;\n    margin-bottom: 2%;\n}\n\n.trd-tf span {\n    font-size: clamp(5px, 0.5vw, 8px);\n    color: #777;\n    padding: 2px 6px;\n    border-radius: 3px;\n    font-weight: 500;\n}\n\n.trd-tf span.active {\n    background: rgba(201, 168, 76, 0.2);\n    color: #C9A84C;\n    font-weight: 700;\n}\n\n.trd-chart-box {\n    background: rgba(255, 255, 255, 0.02);\n    border: 1px solid rgba(255, 255, 255, 0.05);\n    border-radius: 6px;\n    padding: 4%;\n    position: relative;\n    margin-bottom: 2%;\n    flex-shrink: 0;\n}\n\n.trd-ma {\n    font-size: clamp(4px, 0.45vw, 7px);\n    color: #888;\n    margin-bottom: 4px;\n    display: flex;\n    gap: 8px;\n}\n\n.trd-candles-rich {\n    position: relative;\n    width: 100%;\n    aspect-ratio: 2.2 / 1;\n}\n\n.trd-svg-graph {\n    width: 100%;\n    height: 100%;\n    overflow: visible;\n}\n\n.trd-vol {\n    display: flex;\n    align-items: flex-end;\n    justify-content: space-between;\n    height: 15%;\n    margin-top: 4px;\n    border-top: 1px solid rgba(255, 255, 255, 0.04);\n    padding-top: 2px;\n}\n\n.v-bar {\n    width: 8%;\n    border-radius: 1px;\n    opacity: 0.8;\n}\n\n.cup {\n    background: #4ADE80;\n}\n\n.cdn {\n    background: #F87171;\n}\n\n.v-bar.cup {\n    background: #4ADE80;\n}\n\n.v-bar.cdn {\n    background: #F87171;\n}\n\n.trd-ob-box {\n    background: rgba(0, 0, 0, 0.3);\n    border-radius: 6px;\n    padding: 3% 4%;\n    display: flex;\n    flex-direction: column;\n    gap: 3px;\n    flex-grow: 1;\n    min-height: 0;\n    overflow: hidden;\n}\n\n.ob-hdr {\n    display: flex;\n    justify-content: space-between;\n    font-size: clamp(5px, 0.5vw, 7px);\n    color: #888;\n    font-weight: 600;\n    padding-bottom: 2px;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.05);\n}\n\n.ob-list {\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n    overflow: hidden;\n}\n\n.ob-row {\n    display: flex;\n    justify-content: space-between;\n    position: relative;\n    font-size: clamp(6px, 0.58vw, 8px);\n    font-family: 'DM Sans', sans-serif;\n    font-weight: 500;\n    z-index: 1;\n    padding: 1px 2px;\n}\n\n.ob-depth {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    right: 0;\n    z-index: -1;\n    opacity: 0.15;\n    border-radius: 2px;\n}\n\n.ob-depth.cup {\n    background: #4ADE80;\n}\n\n.ob-depth.cdn {\n    background: #F87171;\n}\n\n.ask {\n    color: #F87171;\n}\n\n.bid {\n    color: #4ADE80;\n}\n\n.ob-qty {\n    color: #BBB;\n}\n\n.ob-spread {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 2px 4px;\n    background: rgba(201, 168, 76, 0.08);\n    border: 1px solid rgba(201, 168, 76, 0.2);\n    border-radius: 3px;\n    margin: 1px 0;\n    font-size: clamp(6px, 0.6vw, 9px);\n    font-weight: 700;\n    color: #4ADE80;\n}\n\n.spread-ind {\n    font-size: clamp(5px, 0.5vw, 7px);\n    color: #4ADE80;\n}\n\n.trd-actions {\n    display: grid;\n    grid-template-columns: 1fr;\n    max-width: 800px;\n    gap: 6px;\n    margin-top: auto;\n    margin-bottom: 8px;\n}\n\n.btn-buy-long {\n    background: linear-gradient(135deg, #4ADE80, #22C55E);\n    color: #0A0A0A;\n    font-size: clamp(6px, 0.6vw, 9px);\n    font-weight: 700;\n    text-align: center;\n    padding: 6px;\n    border-radius: 4px;\n    box-shadow: 0 2px 8px rgba(74, 222, 128, 0.25);\n}\n\n.btn-sell-short {\n    background: linear-gradient(135deg, #F87171, #EF4444);\n    color: #0A0A0A;\n    font-size: clamp(6px, 0.6vw, 9px);\n    font-weight: 700;\n    text-align: center;\n    padding: 6px;\n    border-radius: 4px;\n    box-shadow: 0 2px 8px rgba(248, 113, 113, 0.25);\n}\n\n.and-nav {\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    display: flex;\n    justify-content: space-around;\n    padding: 3% 2% 5%;\n    border-top: 1px solid rgba(255, 255, 255, 0.04);\n    background: rgba(0, 0, 0, 0.5);\n}\n\n.and-nav span {\n    font-size: clamp(5px, 0.48vw, 7px);\n}\n\n/* Wallet screen (right phone) */\n.wal-c {\n    padding: 13% 8% 0;\n}\n\n.wal-hdr {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 6%;\n}\n\n.wal-title {\n    font-size: clamp(8px, 0.8vw, 11px);\n    font-weight: 700;\n    color: #F2EEE6;\n}\n\n.wal-sub {\n    font-size: clamp(5px, 0.5vw, 7px);\n    color: #555;\n    margin-top: 1%;\n}\n\n.wal-total {\n    margin-bottom: 5%;\n}\n\n.wal-lbl {\n    font-size: clamp(5px, 0.48vw, 7px);\n    color: #555;\n    letter-spacing: 0.08em;\n    text-transform: uppercase;\n    margin-bottom: 1%;\n}\n\n.wal-amt {\n    font-size: clamp(14px, 1.5vw, 22px);\n    font-weight: 700;\n    color: #F2EEE6;\n    font-family: 'Cormorant Garamond', serif;\n    line-height: 1;\n}\n\n.wal-chg {\n    font-size: clamp(6px, 0.58vw, 8px);\n    color: #4ADE80;\n    margin-top: 1%;\n}\n\n.act-row {\n    display: grid;\n    grid-template-columns: repeat(4, 1fr);\n    gap: 4%;\n    margin-bottom: 6%;\n}\n\n.act-item {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 4%;\n}\n\n.act-ico {\n    width: clamp(18px, 1.9vw, 28px);\n    height: clamp(18px, 1.9vw, 28px);\n    border-radius: 50%;\n    background: rgba(255, 255, 255, 0.06);\n    border: 1px solid rgba(255, 255, 255, 0.08);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: clamp(7px, 0.7vw, 10px);\n    color: #888;\n}\n\n.act-lbl {\n    font-size: clamp(4px, 0.44vw, 6px);\n    color: #444;\n    text-align: center;\n}\n\n.asset-row {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 3% 0;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.03);\n}\n\n.asset-row:last-of-type {\n    border-bottom: none;\n}\n\n/* Floating badges-glassmorphism theme adjustments */\n.badge {\n    position: absolute;\n    z-index: 15;\n    /* Floats above all phone mockup scales & hovers (z-index 12) */\n    border-radius: clamp(10px, 1.1vw, 16px);\n    padding: clamp(8px, 0.85vw, 13px) clamp(10px, 1vw, 16px);\n    backdrop-filter: blur(5px);\n    -webkit-backdrop-filter: blur(5px);\n    transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);\n    transform-style: preserve-3d;\n    transform: translateZ(85px);\n    /* Elevated 3D stereoscopic depth spacing */\n    pointer-events: auto;\n}\n\n.badge:hover {\n    transform: translateZ(125px) scale(1.08) translateY(-4px) !important;\n    box-shadow: 0 35px 75px rgba(0, 0, 0, 0.85), 0 0 25px rgba(201, 168, 76, 0.15) !important;\n    z-index: 16;\n}\n\nbody:not(.light_theme) .badge,\nbody .badge {\n    background: rgba(10, 10, 18, 0.88);\n    border: 1px solid rgba(255, 255, 255, 0.08);\n    box-shadow: 0 20px 50px rgba(0, 0, 0, 0.7), 0 0 15px rgba(201, 168, 76, 0.05);\n    color: #F2EEE6;\n}\n\nbody:not(.light_theme) .badge.gold,\nbody .badge.gold {\n    border-color: rgba(201, 168, 76, 0.3);\n}\n\nbody.light_theme .badge {\n    background: rgb(255 255 255 / 20%);\n    border: 1px solid rgba(0, 0, 0, 0.08);\n    box-shadow: 0 15px 40px rgba(0, 0, 0, 0.08), 0 0 10px rgba(0, 0, 0, 0.01);\n    color: #1A1A1A;\n}\n\nbody.light_theme .badge.gold {\n    border-color: rgba(201, 168, 76, 0.35);\n    background: rgba(253, 251, 242, 0.92);\n}\n\nbody.light_theme .badge .b-val {\n    color: #1A1A1A;\n}\n\nbody.light_theme .badge .b-sub {\n    color: #666 !important;\n}\n\n/* positions */\n.b-btc {\n    bottom: 7%;\n    left: 1%;\n    animation: bbl 5s ease-in-out infinite;\n}\n\n.b-pnl {\n    top: 6%;\n    right: 0%;\n    animation: bbl 6s ease-in-out infinite;\n    animation-delay: 1.5s;\n}\n\n.b-sec {\n    bottom: 28%;\n    right: 0%;\n    animation: bbl 4.5s ease-in-out infinite;\n    animation-delay: 0.7s;\n}\n\n@keyframes bbl {\n\n    0%,\n    100% {\n        transform: translateZ(85px) translateY(0);\n    }\n\n    50% {\n        transform: translateZ(85px) translateY(-9px);\n    }\n}\n\n.b-label {\n    font-size: clamp(7px, 0.62vw, 10px);\n    color: #444;\n    letter-spacing: 0.09em;\n    text-transform: uppercase;\n    margin-bottom: 4px;\n}\n\n.b-val {\n    font-size: clamp(14px, 1.35vw, 20px);\n    font-weight: 700;\n    color: #F2EEE6;\n    font-family: 'Cormorant Garamond', serif;\n    line-height: 1.1;\n}\n\n.b-sub {\n    font-size: clamp(8px, 0.68vw, 11px);\n    margin-top: 3px;\n}\n\n.b-row {\n    display: flex;\n    align-items: center;\n    gap: clamp(6px, 0.65vw, 10px);\n}\n\n.b-ico {\n    width: clamp(22px, 2.1vw, 30px);\n    height: clamp(22px, 2.1vw, 30px);\n    border-radius: 50%;\n    background: rgba(22, 163, 74, 0.12);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: clamp(10px, 0.95vw, 14px);\n}\n\n.b-t {\n    font-size: clamp(9px, 0.78vw, 12px);\n    font-weight: 600;\n    color: #C9A84C;\n}\n\n.b-s {\n    font-size: clamp(7px, 0.62vw, 10px);\n    color: #444;\n    margin-top: 2px;\n}\n\n.live-dot {\n    display: inline-block;\n    width: 5px;\n    height: 5px;\n    border-radius: 50%;\n    background: #4ADE80;\n    box-shadow: 0 0 6px rgba(74, 222, 128, 0.7);\n    margin-right: 5px;\n    vertical-align: middle;\n    animation: lp 2s infinite;\n}\n\n@keyframes lp {\n\n    0%,\n    100% {\n        box-shadow: 0 0 0 0 rgba(74, 222, 128, 0.7);\n    }\n\n    50% {\n        box-shadow: 0 0 0 5px rgba(74, 222, 128, 0);\n    }\n}\n\n/* ─── STATS BAR ─── */\n.stats {\n    display: grid;\n    grid-template-columns: repeat(4, 1fr);\n    max-width: 1200px;\n    margin: -40px auto 40px;\n    /* Pulls it up so it floats on top of the hero's grid floor */\n    background: var(--stats-bg);\n    backdrop-filter: blur(5px);\n    -webkit-backdrop-filter: blur(5px);\n    border: 1px solid var(--stats-border);\n    border-radius: 16px;\n    position: relative;\n    z-index: 25;\n    box-shadow: 0 30px 70px rgba(0, 0, 0, 0.35);\n    transition: transform 0.3s ease, box-shadow 0.3s ease;\n}\n\nbody.light_theme .stats {\n    box-shadow: 0 15px 40px rgba(0, 0, 0, 0.05);\n}\n\n.stats:hover {\n    transform: translateY(-2px);\n    box-shadow: 0 35px 80px rgba(0, 0, 0, 0.45);\n}\n\nbody.light_theme .stats:hover {\n    box-shadow: 0 20px 50px rgba(0, 0, 0, 0.08);\n}\n\n.s-cell {\n    padding: clamp(16px, 2vw, 28px) clamp(12px, 1.5vw, 20px);\n    text-align: center;\n    border-right: 1px solid var(--stats-cell-border);\n    transition: background-color 0.3s ease;\n}\n\n.s-cell:first-child {\n    border-top-left-radius: 15px;\n    border-bottom-left-radius: 15px;\n}\n\n.s-cell:last-child {\n    border-right: none;\n    border-top-right-radius: 15px;\n    border-bottom-right-radius: 15px;\n}\n\n.s-cell:hover {\n    background-color: rgba(201, 168, 76, 0.04);\n}\n\n@media (max-width: 768px) {\n    .stats {\n        grid-template-columns: repeat(2, 1fr);\n        margin: -20px 4% 30px;\n    }\n\n    .s-cell:nth-child(2) {\n        border-right: none;\n    }\n\n    .s-cell:nth-child(2n) {\n        border-right: none;\n    }\n\n    .s-cell:nth-child(2n+1) {\n        border-right: 1px solid var(--stats-cell-border);\n    }\n\n    .s-cell:nth-child(1),\n    .s-cell:nth-child(2) {\n        border-bottom: 1px solid var(--stats-cell-border);\n    }\n\n    .s-cell:first-child {\n        border-top-left-radius: 15px;\n        border-bottom-left-radius: 0;\n    }\n\n    .s-cell:nth-child(2) {\n        border-top-right-radius: 15px;\n        border-bottom-right-radius: 0;\n    }\n\n    .s-cell:nth-child(3) {\n        border-bottom-left-radius: 15px;\n        border-top-left-radius: 0;\n    }\n\n    .s-cell:last-child {\n        border-bottom-right-radius: 15px;\n        border-top-right-radius: 0;\n        border-bottom-left-radius: 0;\n    }\n}\n\n.s-num {\n    font-size: clamp(16px, 1.8vw, 26px);\n    font-weight: 700;\n    color: #C9A84C;\n    font-family: 'Cormorant Garamond', serif;\n    line-height: 1;\n}\n\n.s-lbl {\n    font-size: clamp(8px, 0.68vw, 10px);\n    color: #888;\n    margin-top: 4px;\n    letter-spacing: 0.07em;\n    text-transform: uppercase;\n}\n\n/* ─── NEXT SECTIONS (Markets & Security) ─── */\n.sec-pad {\n    padding: 100px 5% 40px;\n    border-bottom: none !important;\n    position: relative;\n    z-index: 10;\n    max-width: 1590px;\n    margin: 0 auto;\n}\n\n.sec-hdr {\n    text-align: center;\n    max-width: 700px;\n    margin: 0 auto 50px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 12px;\n}\n\n.sec-tag {\n    font-size: 11px;\n    font-weight: 700;\n    letter-spacing: 0.2em;\n    color: #C9A84C;\n    text-transform: uppercase;\n    background: rgba(201, 168, 76, 0.12);\n    border: 1px solid rgba(201, 168, 76, 0.25);\n    padding: 6px 16px;\n    border-radius: 50px;\n}\n\n.sec-title {\n    font-size: clamp(28px, 3.5vw, 46px);\n    font-weight: 700;\n    letter-spacing: -0.02em;\n    color: #F2EEE6;\n    line-height: 1.15;\n}\n\n.sec-sub {\n    font-size: clamp(14px, 1.1vw, 17px);\n    color: #888;\n    line-height: 1.6;\n}\n\n/* Markets section */\n.mkt-container {\n    background: rgba(18, 18, 24, 0.6);\n    border: 1px solid rgba(255, 255, 255, 0.06);\n    border-radius: 24px;\n    padding: 32px 40px;\n    box-shadow: 0 30px 80px rgba(0, 0, 0, 0.8);\n    backdrop-filter: blur(5px);\n    -webkit-backdrop-filter: blur(5px);\n}\n\n.mkt-tabs {\n    display: flex;\n    gap: 12px;\n    margin-bottom: 30px;\n    overflow-x: auto;\n    padding-bottom: 8px;\n    scrollbar-width: none;\n}\n\n.mkt-tabs::-webkit-scrollbar {\n    display: none;\n}\n\n.mkt-tab {\n    background: rgba(255, 255, 255, 0.03);\n    border: 1px solid rgba(255, 255, 255, 0.08);\n    color: #888;\n    padding: 10px 22px;\n    border-radius: 40px;\n    font-size: 14px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: all 0.3s;\n    white-space: nowrap;\n}\n\n.mkt-tab:hover {\n    color: #F2EEE6;\n    background: rgba(255, 255, 255, 0.07);\n}\n\n.mkt-tab.active {\n    background: linear-gradient(135deg, rgba(201, 168, 76, 0.25), rgba(201, 168, 76, 0.08));\n    border-color: rgba(201, 168, 76, 0.4);\n    color: #C9A84C;\n    font-weight: 700;\n}\n\n.table-wrap {\n    overflow-x: auto;\n}\n\n.mkt-table {\n    width: 100%;\n    border-collapse: separate;\n    border-spacing: 0 12px;\n    text-align: left;\n}\n\n.mkt-table th {\n    font-size: 12px;\n    font-weight: 600;\n    color: #666;\n    text-transform: uppercase;\n    letter-spacing: 0.1em;\n    padding: 0 20px 8px;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.05);\n}\n\n.mkt-table tbody tr {\n    background: rgba(255, 255, 255, 0.015);\n    transition: transform 0.2s, background 0.2s;\n}\n\n.mkt-table tbody tr:hover {\n    background: rgba(255, 255, 255, 0.04);\n    transform: translateY(-2px);\n}\n\n.mkt-table td {\n    padding: 18px 20px;\n    vertical-align: middle;\n    border-top: 1px solid rgba(255, 255, 255, 0.03);\n    border-bottom: 1px solid rgba(255, 255, 255, 0.03);\n}\n\n.mkt-table td:first-child {\n    border-left: 1px solid rgba(255, 255, 255, 0.03);\n    border-top-left-radius: 14px;\n    border-bottom-left-radius: 14px;\n}\n\n.mkt-table td:last-child {\n    border-right: 1px solid rgba(255, 255, 255, 0.03);\n    border-top-right-radius: 14px;\n    border-bottom-right-radius: 14px;\n}\n\n.highlight-row {\n    background: linear-gradient(90deg, rgba(201, 168, 76, 0.08), rgba(201, 168, 76, 0.02)) !important;\n    border: 1px solid rgba(201, 168, 76, 0.3) !important;\n}\n\n.highlight-row td {\n    border-color: rgba(201, 168, 76, 0.25) !important;\n}\n\n.t-asset {\n    display: flex;\n    align-items: center;\n    gap: 14px;\n}\n\n.t-ico {\n    width: 38px;\n    height: 38px;\n    border-radius: 10px;\n    border: 1px solid rgba(255, 255, 255, 0.1);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 16px;\n    font-weight: 700;\n}\n\n.t-name {\n    font-size: 16px;\n    font-weight: 700;\n    color: #F2EEE6;\n}\n\n.t-tk {\n    font-size: 12px;\n    color: #777;\n    margin-top: 2px;\n}\n\n.t-px {\n    font-size: 16px;\n    font-weight: 700;\n    color: #F2EEE6;\n    font-family: 'DM Sans', sans-serif;\n}\n\n.t-chg {\n    font-size: 14px;\n    font-weight: 700;\n    padding: 4px 10px;\n    border-radius: 6px;\n    display: inline-block;\n}\n\n.t-chg.cup {\n    background: rgba(74, 222, 128, 0.12);\n    color: #4ADE80;\n    border: 1px solid rgba(74, 222, 128, 0.25);\n}\n\n.t-chg.cdn {\n    background: rgba(248, 113, 113, 0.12);\n    color: #F87171;\n    border: 1px solid rgba(248, 113, 113, 0.25);\n}\n\n.t-vol {\n    font-size: 15px;\n    color: #AAA;\n}\n\n.t-spark {\n    width: 120px;\n    height: 32px;\n    overflow: visible;\n}\n\n.btn-trade {\n    background: rgba(255, 255, 255, 0.06);\n    border: 1px solid rgba(255, 255, 255, 0.15);\n    color: #F2EEE6;\n    padding: 8px 20px;\n    border-radius: 40px;\n    font-size: 13px;\n    font-weight: 700;\n    cursor: pointer;\n    transition: all 0.3s;\n}\n\n.btn-trade:hover {\n    background: #F2EEE6;\n    color: #0A0A0A;\n    transform: scale(1.05);\n    box-shadow: 0 4px 14px rgba(255, 255, 255, 0.2);\n}\n\n.gold-trade {\n    background: linear-gradient(135deg, #E8C97A, #C9A84C);\n    color: #0A0A0A;\n    border: none;\n    box-shadow: 0 4px 15px rgba(201, 168, 76, 0.3);\n}\n\n.gold-trade:hover {\n    transform: scale(1.05);\n    box-shadow: 0 6px 22px rgba(201, 168, 76, 0.5);\n    background: linear-gradient(135deg, #F5E5B0, #C9A84C);\n}\n\n.mkt-footer {\n    text-align: center;\n    margin-top: 24px;\n    padding-top: 24px;\n    border-top: 1px solid rgba(255, 255, 255, 0.05);\n}\n\n.btn-view-all {\n    display: inline-block;\n    font-size: 15px;\n    font-weight: 700;\n    color: #C9A84C;\n    text-decoration: none;\n    transition: all 0.2s;\n}\n\n.btn-view-all:hover {\n    color: #F5E5B0;\n    transform: translateX(4px);\n}\n\n/* Security / Bento Layout */\n.bento-grid {\n    display: grid;\n    grid-template-columns: 1.2fr 1fr;\n    grid-template-rows: auto auto;\n    gap: 24px;\n    max-width: 1200px;\n    margin: 0 auto;\n}\n\n.bento-card {\n    background: rgba(18, 18, 24, 0.6);\n    border: 1px solid rgba(255, 255, 255, 0.06);\n    border-radius: 32px;\n    padding: 48px;\n    display: flex;\n    flex-direction: column;\n    position: relative;\n    overflow: hidden;\n    backdrop-filter: blur(5px);\n    -webkit-backdrop-filter: blur(5px);\n    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.6);\n    transition: all 0.4s;\n}\n\n.bento-card:hover {\n    transform: translateY(-4px);\n    border-color: rgba(255, 255, 255, 0.15);\n    box-shadow: 0 30px 80px rgba(0, 0, 0, 0.8);\n}\n\n.bento-card.feat-large {\n    grid-row: span 2;\n    border: 1px solid rgba(201, 168, 76, 0.3);\n    background: linear-gradient(180deg, rgba(201, 168, 76, 0.08), rgba(18, 18, 24, 0.8));\n    justify-content: space-between;\n}\n\n.bento-card.feat-large:hover {\n    border-color: rgba(201, 168, 76, 0.6);\n    box-shadow: 0 30px 80px rgba(201, 168, 76, 0.2);\n}\n\n.bc-hdr {\n    margin-bottom: 24px;\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n}\n\n.bc-ico-wrap {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.bc-badge {\n    font-size: 11px;\n    font-weight: 700;\n    padding: 6px 14px;\n    border-radius: 40px;\n    background: rgba(255, 255, 255, 0.06);\n    color: #AAA;\n    border: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.bc-badge.gold {\n    background: rgba(201, 168, 76, 0.15);\n    color: #C9A84C;\n    border-color: rgba(201, 168, 76, 0.3);\n}\n\n.bc-badge.green {\n    background: rgba(74, 222, 128, 0.15);\n    color: #4ADE80;\n    border-color: rgba(74, 222, 128, 0.3);\n}\n\n.bc-title {\n    font-size: 26px;\n    font-weight: 700;\n    color: #F2EEE6;\n    line-height: 1.25;\n}\n\n.bento-card.feat-large .bc-title {\n    font-size: 36px;\n}\n\n.bc-desc {\n    font-size: 15px;\n    color: #888;\n    line-height: 1.7;\n}\n\n/* Animated Mockup Containers */\n.bc-mockup {\n    width: 100%;\n    border-radius: 20px;\n    background: rgba(0, 0, 0, 0.4);\n    border: 1px solid rgba(255, 255, 255, 0.05);\n    margin-top: 24px;\n    flex-grow: 1;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    position: relative;\n    overflow: hidden;\n    min-height: 220px;\n}\n\n.bento-card.feat-large .bc-mockup {\n    min-height: 280px;\n}\n\n/* Merkle Tree Mockup */\n.merkle-svg {\n    width: 100%;\n    height: 100%;\n    animation: pulseMerkle 3s infinite alternate ease-in-out;\n}\n\n@keyframes pulseMerkle {\n    0% {\n        filter: drop-shadow(0 0 10px rgba(201, 168, 76, 0.1));\n    }\n\n    100% {\n        filter: drop-shadow(0 0 35px rgba(201, 168, 76, 0.4));\n    }\n}\n\n.por-terminal {\n    position: absolute;\n    bottom: 24px;\n    left: 24px;\n    right: 24px;\n    background: rgba(10, 10, 14, 0.95);\n    border: 1px solid rgba(201, 168, 76, 0.3);\n    border-radius: 14px;\n    padding: 20px;\n    font-family: monospace;\n    font-size: 13px;\n    color: #C9A84C;\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    box-shadow: 0 15px 40px rgba(0, 0, 0, 0.8);\n    backdrop-filter: blur(5px);\n}\n\n.por-row-live {\n    display: flex;\n    justify-content: space-between;\n    border-bottom: 1px dashed rgba(201, 168, 76, 0.2);\n    padding-bottom: 8px;\n}\n\n.por-row-live:last-child {\n    border-bottom: none;\n    padding-bottom: 0;\n}\n\n.por-row-live strong {\n    color: #4ADE80;\n    font-size: 15px;\n}\n\n/* Shard Network Mockup */\n.shard-net {\n    display: flex;\n    justify-content: space-between;\n    width: 100%;\n    padding: 0 40px;\n    position: relative;\n    z-index: 5;\n}\n\n.shard-node {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 12px;\n}\n\n.shard-box {\n    width: 54px;\n    height: 54px;\n    background: rgba(255, 255, 255, 0.05);\n    border: 1px solid rgba(255, 255, 255, 0.15);\n    border-radius: 14px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 22px;\n    box-shadow: 0 10px 20px rgba(0, 0, 0, 0.5);\n    position: relative;\n}\n\n.shard-box::after {\n    content: '';\n    position: absolute;\n    top: -4px;\n    left: -4px;\n    right: -4px;\n    bottom: -4px;\n    border: 1px solid rgba(74, 222, 128, 0.4);\n    border-radius: 18px;\n    animation: nodePulse 2s infinite;\n}\n\n@keyframes nodePulse {\n    0% {\n        transform: scale(1);\n        opacity: 1;\n    }\n\n    100% {\n        transform: scale(1.3);\n        opacity: 0;\n    }\n}\n\n.shard-lbl {\n    font-size: 11px;\n    color: #AAA;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 0.1em;\n}\n\n.shard-line {\n    position: absolute;\n    top: 50%;\n    left: 10%;\n    right: 10%;\n    height: 2px;\n    background: rgba(255, 255, 255, 0.05);\n    z-index: 1;\n    transform: translateY(-50%);\n    overflow: hidden;\n}\n\n.shard-pulse {\n    width: 25%;\n    height: 100%;\n    background: linear-gradient(90deg, transparent, #4ADE80, transparent);\n    animation: travelPulse 2s infinite linear;\n}\n\n@keyframes travelPulse {\n    0% {\n        transform: translateX(-100%);\n    }\n\n    100% {\n        transform: translateX(400%);\n    }\n}\n\n/* Latency Chart Mockup */\n.lat-chart {\n    width: 100%;\n    height: 100%;\n    display: flex;\n    align-items: flex-end;\n    padding: 24px;\n    gap: 8px;\n    position: relative;\n}\n\n.lat-bar {\n    flex: 1;\n    background: linear-gradient(0deg, rgba(74, 222, 128, 0.1), rgba(74, 222, 128, 0.3));\n    border-top-left-radius: 6px;\n    border-top-right-radius: 6px;\n    border-top: 2px solid #4ADE80;\n    animation: barBounce 1.5s infinite alternate ease-in-out;\n}\n\n.lat-bar:nth-child(1) {\n    animation-delay: 0.0s;\n    height: 40%;\n}\n\n.lat-bar:nth-child(2) {\n    animation-delay: 0.2s;\n    height: 60%;\n}\n\n.lat-bar:nth-child(3) {\n    animation-delay: 0.4s;\n    height: 30%;\n}\n\n.lat-bar:nth-child(4) {\n    animation-delay: 0.1s;\n    height: 80%;\n}\n\n.lat-bar:nth-child(5) {\n    animation-delay: 0.5s;\n    height: 50%;\n}\n\n.lat-bar:nth-child(6) {\n    animation-delay: 0.3s;\n    height: 70%;\n}\n\n.lat-bar:nth-child(7) {\n    animation-delay: 0.6s;\n    height: 45%;\n}\n\n.lat-bar:nth-child(8) {\n    animation-delay: 0.2s;\n    height: 90%;\n}\n\n@keyframes barBounce {\n    0% {\n        transform: scaleY(0.7);\n        transform-origin: bottom;\n    }\n\n    100% {\n        transform: scaleY(1);\n        transform-origin: bottom;\n    }\n}\n\n.lat-overlay {\n    position: absolute;\n    top: 32px;\n    left: 32px;\n    font-size: 48px;\n    font-weight: 700;\n    color: #F2EEE6;\n    line-height: 1;\n}\n\n.lat-overlay span {\n    display: block;\n    font-size: 14px;\n    color: #4ADE80;\n    font-weight: 700;\n    margin-top: 8px;\n    text-transform: uppercase;\n    letter-spacing: 0.1em;\n}\n\n@media (max-width:992px) {\n    .bento-grid {\n        grid-template-columns: 1fr;\n    }\n\n    .bento-card.feat-large {\n        grid-row: auto;\n    }\n}\n\n@media (max-width:768px) {\n\n    .trust-bento-grid {\n        margin: 20px auto 0;\n    }\n\n    .sec-pad {\n        padding: 40px 4% 30px;\n    }\n\n    .orbit-showcase {\n        margin: 20px auto 40px;\n    }\n\n    .agcex.orbit-card {\n        max-width: 100% !important;\n    }\n\n    .sec-hdr {\n        margin: 0 auto 0px;\n    }\n\n    .mkt-container {\n        padding: 24px 20px;\n    }\n\n    .sec-grid {\n        grid-template-columns: 1fr;\n    }\n\n    .mkt-table td {\n        padding: 14px 12px;\n    }\n\n    .t-spark {\n        display: none;\n    }\n\n    .mkt-table th:nth-child(5) {\n        display: none;\n    }\n}\n\n/* ─── ECOSYSTEM / PRODUCT SHOWCASE ─── */\n.eco-grid {\n    display: grid;\n    grid-template-columns: 1.2fr 0.8fr;\n    gap: 40px;\n    margin-top: 40px;\n    align-items: center;\n}\n\n.eco-card {\n    background: rgba(18, 18, 24, 0.6);\n    border: 1px solid rgba(255, 255, 255, 0.06);\n    border-radius: 28px;\n    padding: 48px;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    box-shadow: 0 30px 80px rgba(0, 0, 0, 0.8);\n    backdrop-filter: blur(5px);\n    -webkit-backdrop-filter: blur(5px);\n    overflow: hidden;\n    position: relative;\n}\n\n.eco-card.gold-glow {\n    border-color: rgba(201, 168, 76, 0.3);\n    background: linear-gradient(180deg, rgba(201, 168, 76, 0.05), rgba(18, 18, 24, 0.8));\n}\n\n.eco-header {\n    margin-bottom: 32px;\n}\n\n.eco-badge {\n    display: inline-block;\n    padding: 6px 16px;\n    background: rgba(201, 168, 76, 0.15);\n    color: #C9A84C;\n    border: 1px solid rgba(201, 168, 76, 0.3);\n    border-radius: 50px;\n    font-size: 12px;\n    font-weight: 700;\n    text-transform: uppercase;\n    letter-spacing: 0.15em;\n    margin-bottom: 16px;\n}\n\n.eco-title {\n    font-size: clamp(24px, 2.5vw, 36px);\n    font-weight: 700;\n    color: #F2EEE6;\n    line-height: 1.2;\n    margin-bottom: 16px;\n}\n\n.eco-desc {\n    font-size: 16px;\n    color: #888;\n    line-height: 1.6;\n}\n\n.browser-mockup {\n    background: #0a0a0e;\n    border: 1px solid rgba(255, 255, 255, 0.12);\n    border-radius: 16px;\n    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.9);\n    overflow: hidden;\n    margin-top: 24px;\n}\n\n.browser-bar {\n    background: rgba(255, 255, 255, 0.04);\n    padding: 12px 16px;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.08);\n}\n\n.b-dot {\n    width: 10px;\n    height: 10px;\n    border-radius: 50%;\n}\n\n.b-dot.r {\n    background: #ED6A5E;\n}\n\n.b-dot.y {\n    background: #F4BF4F;\n}\n\n.b-dot.g {\n    background: #61C554;\n}\n\n.b-url {\n    background: rgba(255, 255, 255, 0.06);\n    border-radius: 6px;\n    padding: 4px 12px;\n    font-size: 11px;\n    color: #888;\n    font-family: monospace;\n    flex-grow: 1;\n    margin-left: 12px;\n}\n\n/* High-Fidelity Web UI */\n.hf-web {\n    background: #0a0a0e;\n    font-family: 'DM Sans', sans-serif;\n    color: #F2EEE6;\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n}\n\n.hf-web-nav {\n    display: flex;\n    align-items: center;\n    gap: 24px;\n    padding: 12px 20px;\n    background: rgba(255, 255, 255, 0.02);\n    border-bottom: 1px solid rgba(255, 255, 255, 0.06);\n    font-size: 13px;\n}\n\n.hf-pair {\n    font-size: 16px;\n    font-weight: 700;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.hf-stat {\n    display: flex;\n    flex-direction: column;\n    font-size: 11px;\n    color: #888;\n    line-height: 1.3;\n}\n\n.hf-stat strong {\n    color: #F2EEE6;\n    font-size: 13px;\n    font-weight: 600;\n}\n\n.hf-web-body {\n    display: grid;\n    grid-template-columns: 1fr 260px;\n    min-height: 360px;\n}\n\n.hf-chart {\n    padding: 20px;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    border-right: 1px solid rgba(255, 255, 255, 0.06);\n}\n\n.hf-chart-hdr {\n    display: flex;\n    gap: 16px;\n    font-size: 12px;\n    color: #888;\n}\n\n.hf-candles {\n    width: 100%;\n    height: 100%;\n    max-height: 220px;\n    overflow: visible;\n    margin-top: 10px;\n}\n\n.hf-vol-bars {\n    display: flex;\n    align-items: flex-end;\n    justify-content: space-between;\n    height: 36px;\n    padding-top: 8px;\n    border-top: 1px solid rgba(255, 255, 255, 0.05);\n    width: 100%;\n}\n\n.hf-vb {\n    width: 7%;\n    border-radius: 2px 2px 0 0;\n}\n\n.hf-vb.g {\n    background: rgba(74, 222, 128, 0.4);\n}\n\n.hf-vb.r {\n    background: rgba(248, 113, 113, 0.4);\n}\n\n.hf-orderbook {\n    padding: 16px;\n    font-size: 12px;\n    display: flex;\n    flex-direction: column;\n}\n\n.hf-ob-hdr {\n    font-weight: 700;\n    color: #AAA;\n    margin-bottom: 12px;\n    text-transform: uppercase;\n    letter-spacing: 0.08em;\n    font-size: 11px;\n}\n\n.hf-ob-asks,\n.hf-ob-bids {\n    display: flex;\n    flex-direction: column;\n    gap: 5px;\n}\n\n.hf-ob-row {\n    display: flex;\n    justify-content: space-between;\n    position: relative;\n    padding: 2px 4px;\n    z-index: 1;\n}\n\n.hf-ob-row span:nth-child(2) {\n    color: #AAA;\n    font-family: monospace;\n}\n\n.hf-ob-bar {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    z-index: -1;\n    opacity: 0.15;\n    border-radius: 2px;\n}\n\n.hf-ob-bar.r {\n    background: #F87171;\n}\n\n.hf-ob-bar.g {\n    background: #4ADE80;\n}\n\n.hf-ob-spread {\n    padding: 8px 0;\n    margin: 8px 0;\n    border-top: 1px solid rgba(255, 255, 255, 0.06);\n    border-bottom: 1px solid rgba(255, 255, 255, 0.06);\n    font-size: 14px;\n    font-weight: 700;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n/* High-Fidelity Mobile UI */\n.hf-mob-container {\n    padding: 20px 0;\n    display: flex;\n    justify-content: center;\n}\n\n.hf-mobile-phone {\n    width: 342px;\n    background: #0A0A0E;\n    border: 6px solid #222;\n    border-radius: 40px;\n    padding: 24px 20px;\n    box-shadow: 0 35px 90px rgba(0, 0, 0, 0.9), 0 0 0 2px rgba(255, 255, 255, 0.1);\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n    position: relative;\n}\n\n.hf-mob-hdr {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.hf-mob-logo img {\n    height: 20px;\n    width: auto;\n}\n\n.hf-mob-actions {\n    display: flex;\n    gap: 12px;\n    font-size: 16px;\n    color: #888;\n}\n\n.hf-mob-bal {\n    background: linear-gradient(135deg, rgba(255, 255, 255, 0.04), rgba(255, 255, 255, 0.01));\n    border: 1px solid rgba(255, 255, 255, 0.08);\n    padding: 20px;\n    border-radius: 24px;\n}\n\n.hf-mb-lbl {\n    font-size: 12px;\n    color: #888;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 8px;\n}\n\n.hf-mb-val {\n    font-size: 28px;\n    font-weight: 700;\n    color: #F2EEE6;\n    font-family: 'Cormorant Garamond', serif;\n    line-height: 1;\n    margin-bottom: 8px;\n}\n\n.hf-mb-sub {\n    font-size: 12px;\n    font-weight: 600;\n}\n\n.hf-mob-quick {\n    display: grid;\n    grid-template-columns: repeat(4, 1fr);\n    gap: 10px;\n    text-align: center;\n}\n\n.hf-mq-item {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 6px;\n    font-size: 11px;\n    color: #AAA;\n}\n\n.hf-mq-ico {\n    width: 42px;\n    height: 42px;\n    border-radius: 50%;\n    background: rgba(255, 255, 255, 0.05);\n    border: 1px solid rgba(255, 255, 255, 0.1);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 18px;\n    transition: all 0.3s;\n}\n\n.hf-mq-item:hover .hf-mq-ico {\n    transform: scale(1.08);\n}\n\n.hf-mob-mkt {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n}\n\n.hf-mm-tabs {\n    display: flex;\n    gap: 16px;\n    font-size: 13px;\n    font-weight: 700;\n    color: #888;\n}\n\n.hf-mm-tabs span:first-child {\n    color: #C9A84C;\n    border-bottom: 2px solid #C9A84C;\n    padding-bottom: 4px;\n}\n\n.hf-mm-list {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n}\n\n.hf-mm-row {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 10px 14px;\n    background: rgba(255, 255, 255, 0.02);\n    border: 1px solid rgba(255, 255, 255, 0.05);\n    border-radius: 16px;\n}\n\n.hf-mm-row strong {\n    font-size: 14px;\n    color: #F2EEE6;\n}\n\n.hf-mm-row span {\n    font-size: 11px;\n    color: #888;\n    display: block;\n}\n\n.hf-mm-px {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    text-align: right;\n}\n\n.hf-mm-px span:first-child {\n    font-size: 14px;\n    font-weight: 700;\n    color: #F2EEE6;\n}\n\n.btn-pill {\n    padding: 4px 8px;\n    border-radius: 8px;\n    font-size: 11px;\n    font-weight: 700;\n}\n\n.btn-pill.g {\n    background: rgba(74, 222, 128, 0.2);\n    color: #4ADE80;\n}\n\n.btn-pill.r {\n    background: rgba(248, 113, 113, 0.2);\n    color: #F87171;\n}\n\n.store-buttons {\n    display: flex;\n    gap: 16px;\n    margin-top: 20px;\n    justify-content: center;\n}\n\n.store-btn {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    background: rgba(255, 255, 255, 0.05);\n    border: 1px solid rgba(255, 255, 255, 0.15);\n    padding: 10px 20px;\n    border-radius: 12px;\n    color: #F2EEE6;\n    text-decoration: none;\n    transition: all 0.3s;\n}\n\n.store-btn:hover {\n    background: #f2eee621;\n    color: #ffffff;\n    transform: translateY(-3px);\n    box-shadow: 0 10px 25px rgba(255, 255, 255, 0.2);\n}\n\n.store-ico {\n    font-size: 24px;\n}\n\n.store-txt {\n    display: flex;\n    flex-direction: column;\n    text-align: left;\n}\n\n.st-sub {\n    font-size: 10px;\n    color: #888;\n    text-transform: uppercase;\n    letter-spacing: 0.05em;\n}\n\n.store-btn:hover .st-sub {\n    color: #555;\n}\n\n.st-title {\n    font-size: 15px;\n    font-weight: 700;\n}\n\n/* Onboarding Step Grid */\n.step-grid {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 32px;\n    margin-top: 40px;\n    position: relative;\n}\n\n.step-card {\n    background: rgba(18, 18, 24, 0.6);\n    border: 1px solid rgba(255, 255, 255, 0.06);\n    border-radius: 28px;\n    padding: 48px 40px;\n    position: relative;\n    box-shadow: 0 30px 80px rgba(0, 0, 0, 0.8);\n    backdrop-filter: blur(5px);\n    -webkit-backdrop-filter: blur(5px);\n    transition: all 0.3s;\n}\n\n.step-card:hover {\n    transform: translateY(-6px);\n    border-color: rgba(201, 168, 76, 0.4);\n    box-shadow: 0 35px 90px rgba(201, 168, 76, 0.15);\n}\n\n.step-num {\n    font-size: 54px;\n    font-weight: 700;\n    color: rgba(201, 168, 76, 0.3);\n    line-height: 1;\n    margin-bottom: 20px;\n    transition: color 0.3s;\n}\n\n.step-card:hover .step-num {\n    color: #C9A84C;\n}\n\n.step-title {\n    font-size: 22px;\n    font-weight: 700;\n    color: #F2EEE6;\n    margin-bottom: 14px;\n}\n\n.step-text {\n    font-size: 15px;\n    color: #888;\n    line-height: 1.6;\n}\n\n\n/* ─── FINAL CTA & FOOTER ─── */\n.cta-sec {\n    padding: 120px 5% 80px;\n}\n\n.cta-box {\n    max-width: 1220px;\n    margin: 0 auto;\n    background: linear-gradient(135deg, rgba(201, 168, 76, 0.2), rgba(18, 18, 24, 0.8));\n    border: 1px solid rgba(201, 168, 76, 0.4);\n    border-radius: 36px;\n    padding: 80px 60px;\n    text-align: center;\n    position: relative;\n    overflow: hidden;\n    box-shadow: 0 40px 100px rgba(201, 168, 76, 0.2);\n    backdrop-filter: blur(5px);\n    -webkit-backdrop-filter: blur(5px);\n}\n\n.cta-bg-glow {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    width: 600px;\n    height: 600px;\n    background: radial-gradient(circle, rgba(201, 168, 76, 0.2) 0%, rgba(0, 0, 0, 0) 70%);\n    z-index: 1;\n    pointer-events: none;\n}\n\n.cta-content {\n    position: relative;\n    z-index: 5;\n    max-width: 700px;\n    margin: 0 auto;\n}\n\n.cta-title {\n    font-size: clamp(32px, 4vw, 54px);\n    font-weight: 700;\n    color: #F2EEE6;\n    line-height: 1.15;\n    margin-bottom: 24px;\n}\n\n.cta-desc {\n    font-size: clamp(16px, 1.2vw, 20px);\n    color: #CCC;\n    margin-bottom: 40px;\n    line-height: 1.6;\n}\n\n.cta-form {\n    display: flex;\n    gap: 12px;\n    max-width: 540px;\n    margin: 0 auto;\n}\n\n.cta-input {\n    flex-grow: 1;\n    padding: 20px 28px;\n    border-radius: 50px;\n    background: rgba(0, 0, 0, 0.6);\n    border: 1px solid rgba(255, 255, 255, 0.15);\n    color: #F2EEE6;\n    font-size: 16px;\n    outline: none;\n    transition: border-color 0.3s;\n}\n\n.cta-input:focus {\n    border-color: #C9A84C;\n    box-shadow: 0 0 20px rgba(201, 168, 76, 0.3);\n}\n\n.cta-btn {\n    padding: 20px 40px;\n    border-radius: 50px;\n    background: linear-gradient(135deg, #E8C97A, #C9A84C);\n    color: #0A0A0A;\n    font-size: 16px;\n    font-weight: 700;\n    border: none;\n    cursor: pointer;\n    transition: all 0.3s;\n    white-space: nowrap;\n    box-shadow: 0 10px 30px rgba(201, 168, 76, 0.3);\n}\n\n.cta-btn:hover {\n    transform: scale(1.05);\n    box-shadow: 0 15px 40px rgba(201, 168, 76, 0.5);\n    background: linear-gradient(135deg, #F5E5B0, #C9A84C);\n}\n\n/* .mkt-footer, .ob-footer {\n    border-top: 1px solid rgba(255, 255, 255, 0.06);\n    background: #070709;\n    padding: 80px 5% 40px;\n    color: #888;\n    font-size: 14px;\n    position: relative;\n    z-index: 10;\n} */\n\n.ft-grid {\n    max-width: 1400px;\n    margin: 0 auto;\n    display: grid;\n    grid-template-columns: 1fr 1fr 1fr 1fr;\n    gap: 60px;\n    margin-bottom: 50px;\n}\n\n.ft-brand {\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n}\n\n.ft-logo {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    text-decoration: none;\n}\n\n.ft-logo img {\n    height: 60px;\n    width: auto;\n}\n\n.ft-desc {\n    line-height: 1.7;\n    color: #777;\n    max-width: 320px;\n}\n\n.ft-status {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    padding: 8px 16px;\n    background: rgba(74, 222, 128, 0.1);\n    border: 1px solid rgba(74, 222, 128, 0.2);\n    border-radius: 50px;\n    width: fit-content;\n}\n\n.ft-status-dot {\n    width: 8px;\n    height: 8px;\n    border-radius: 50%;\n    background: #4ADE80;\n    box-shadow: 0 0 10px #4ADE80;\n}\n\n.ft-status-txt {\n    font-size: 12px;\n    font-weight: 700;\n    color: #4ADE80;\n    text-transform: uppercase;\n    letter-spacing: 0.08em;\n}\n\n.ft-col {\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n}\n\n.ft-title {\n    font-size: 18px;\n    font-weight: 500;\n    color: #F2EEE6;\n    text-transform: uppercase;\n    letter-spacing: 0px;\n    margin-bottom: 8px;\n}\n\n.ft-link {\n    text-decoration: none;\n    color: #888;\n    transition: color 0.2s;\n}\n\n.ft-copy .ft-link {\n    text-decoration: underline !important;\n}\n\n.ft-link:hover {\n    color: #C9A84C;\n}\n\n.ft-bottom {\n    max-width: 1400px;\n    margin: 0 auto;\n    padding-top: 24px;\n    border-top: 1px solid rgba(255, 255, 255, 0.05);\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    text-align: center;\n}\n\n.ft-copy {\n    font-size: 13px;\n}\n\n.ft-socials {\n    display: flex;\n    gap: 16px;\n    font-size: 18px;\n}\n\n.ft-soc {\n    color: #888;\n    text-decoration: none;\n    transition: color 0.2s;\n}\n\n.ft-soc:hover {\n    color: #C9A84C;\n}\n\n/* Hero Background Animations & Shapes */\n.float-shape {\n    position: absolute;\n    pointer-events: auto;\n    /* Active pointer interactions */\n    z-index: 2;\n    /* Position behind phones but ahead of grid backgrounds */\n    opacity: 0.25;\n    cursor: grab;\n    transition: opacity 0.3s ease, filter 0.3s ease;\n    user-select: none;\n    -webkit-user-drag: none;\n}\n\n.float-shape.s1 {\n    top: 15%;\n    left: 45%;\n    width: 350px;\n    height: 350px;\n    animation: floatShape1 20s infinite linear;\n}\n\n.float-shape.s2 {\n    top: 40%;\n    right: 10%;\n    left: auto;\n    width: 250px;\n    height: 250px;\n    animation: floatShape2 16s infinite ease-in-out;\n    z-index: 2;\n}\n\n.float-shape.s3 {\n    top: 5%;\n    right: 10%;\n    width: 180px;\n    height: 180px;\n    animation: floatShape3 12s infinite ease-in-out;\n}\n\n@keyframes floatShape1 {\n    0% {\n        transform: rotate(0deg) translate(0, 0) scale(1);\n    }\n\n    50% {\n        transform: rotate(180deg) translate(40px, -30px) scale(1.1);\n    }\n\n    100% {\n        transform: rotate(360deg) translate(0, 0) scale(1);\n    }\n}\n\n@keyframes floatShape2 {\n\n    0%,\n    100% {\n        transform: translate(0, 0) scale(1);\n    }\n\n    50% {\n        transform: translate(-30px, -50px) scale(1.2);\n    }\n}\n\n@keyframes floatShape3 {\n\n    0%,\n    100% {\n        transform: translate(0, 0) rotate(0deg);\n    }\n\n    50% {\n        transform: translate(40px, 40px) rotate(45deg);\n    }\n}\n\n/* Live WebSocket Bar */\n.live-status-bar {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    background: rgba(74, 222, 128, 0.1);\n    border: 1px solid rgba(74, 222, 128, 0.3);\n    padding: 8px 18px;\n    border-radius: 50px;\n    margin: 0 auto 24px;\n    width: fit-content;\n}\n\n.pulse-dot {\n    width: 10px;\n    height: 10px;\n    border-radius: 50%;\n    background: #4ADE80;\n    box-shadow: 0 0 12px #4ADE80;\n    animation: livePulse 1.5s infinite;\n}\n\n@keyframes livePulse {\n    0% {\n        transform: scale(0.95);\n        opacity: 0.8;\n    }\n\n    50% {\n        transform: scale(1.2);\n        opacity: 1;\n        box-shadow: 0 0 20px #4ADE80;\n    }\n\n    100% {\n        transform: scale(0.95);\n        opacity: 0.8;\n    }\n}\n\n.live-txt {\n    font-size: 12px;\n    font-weight: 700;\n    color: #4ADE80;\n    text-transform: uppercase;\n    letter-spacing: 0.1em;\n}\n\n/* Flash Animations */\n@keyframes flashGreen {\n    0% {\n        background: rgba(74, 222, 128, 0.3);\n    }\n\n    100% {\n        background: rgba(255, 255, 255, 0.015);\n    }\n}\n\n@keyframes flashRed {\n    0% {\n        background: rgba(248, 113, 113, 0.3);\n    }\n\n    100% {\n        background: rgba(255, 255, 255, 0.015);\n    }\n}\n\n.flash-green {\n    animation: flashGreen 1s ease-out !important;\n}\n\n.flash-red {\n    animation: flashRed 1s ease-out !important;\n}\n\n/* Futuristic Orbit Showcase (`#features`) */\n.orbit-showcase {\n    position: relative;\n    width: 100%;\n    max-width: 1600px;\n    min-height: 1060px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin: 60px auto 80px;\n}\n\n.orbit-rings {\n    position: absolute;\n    width: 960px;\n    height: 960px;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    pointer-events: none;\n    z-index: 0;\n}\n\n.orbit-rings svg {\n    width: 100%;\n    height: 100%;\n    animation: spinRings 60s linear infinite;\n}\n\n@keyframes spinRings {\n    0% {\n        transform: rotate(0deg);\n    }\n\n    100% {\n        transform: rotate(360deg);\n    }\n}\n\n.orbit-center-phone {\n    position: relative;\n    width: 310px;\n    height: 630px;\n    background: #0A0A0E;\n    border: 6px solid #222;\n    border-radius: 46px;\n    box-shadow: 0 40px 100px rgba(0, 0, 0, 0.9), 0 0 0 2px rgba(255, 255, 255, 0.1), 0 0 80px rgba(201, 168, 76, 0.25);\n    z-index: 10;\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n    margin-top: 280px;\n}\n\n.phone-notch {\n    width: 100px;\n    height: 24px;\n    background: #000;\n    border-bottom-left-radius: 16px;\n    border-bottom-right-radius: 16px;\n    margin: 0 auto;\n    position: absolute;\n    top: 0;\n    left: 50%;\n    transform: translateX(-50%);\n    z-index: 30;\n}\n\n/* Animated App Screen Container */\n.phone-app-wrap {\n    flex: 1;\n    position: relative;\n    margin-top: 24px;\n    overflow: hidden;\n}\n\n.app-scr {\n    position: absolute;\n    inset: 0;\n    padding: 16px 18px 0;\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n    opacity: 0;\n    pointer-events: none;\n    transition: opacity 0.6s ease-in-out;\n}\n\n.app-scr.s1 {\n    animation: cycleApp1 12s infinite;\n}\n\n.app-scr.s2 {\n    animation: cycleApp2 12s infinite;\n}\n\n.app-scr.s3 {\n    animation: cycleApp3 12s infinite;\n}\n\n@keyframes cycleApp1 {\n\n    0%,\n    28% {\n        opacity: 1;\n        pointer-events: auto;\n    }\n\n    33%,\n    100% {\n        opacity: 0;\n        pointer-events: none;\n    }\n}\n\n@keyframes cycleApp2 {\n\n    0%,\n    30% {\n        opacity: 0;\n        pointer-events: none;\n    }\n\n    33%,\n    61% {\n        opacity: 1;\n        pointer-events: auto;\n    }\n\n    66%,\n    100% {\n        opacity: 0;\n        pointer-events: none;\n    }\n}\n\n@keyframes cycleApp3 {\n\n    0%,\n    63% {\n        opacity: 0;\n        pointer-events: none;\n    }\n\n    66%,\n    95% {\n        opacity: 1;\n        pointer-events: auto;\n    }\n\n    100% {\n        opacity: 0;\n        pointer-events: none;\n    }\n}\n\n\n/* Radial External Control Wheel next to Center Phone */\n.orbit-control-wheel {\n    position: absolute;\n    top: 50%;\n    left: calc(50% + 225px);\n    /* Perfectly aligned to the right side of the phone */\n    transform: translateY(-50%);\n    width: 200px;\n    height: 200px;\n    z-index: 25;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    box-sizing: border-box;\n}\n\n.wheel-track {\n    position: absolute;\n    width: 150px;\n    height: 150px;\n    border: 1px dashed rgba(201, 168, 76, 0.25);\n    border-radius: 50%;\n    animation: rotateWheelTrack 35s infinite linear;\n    pointer-events: none;\n}\n\n@keyframes rotateWheelTrack {\n    0% {\n        transform: rotate(0deg);\n    }\n\n    100% {\n        transform: rotate(360deg);\n    }\n}\n\n.wheel-center {\n    width: 68px;\n    height: 68px;\n    border-radius: 50%;\n    background: #09090D;\n    border: 1.5px solid #C9A84C;\n    box-shadow: 0 0 20px rgba(201, 168, 76, 0.35);\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    color: #fff;\n    font-weight: 700;\n    font-size: 9.5px;\n    z-index: 5;\n    user-select: none;\n}\n\n.wheel-item {\n    position: absolute;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 3px;\n    cursor: pointer;\n    color: #666;\n    transition: all 0.3s cubic-bezier(0.25, 1, 0.5, 1);\n    transform: rotate(var(--angle)) translate(88px) rotate(calc(-1 * var(--angle)));\n    z-index: 10;\n}\n\n.wheel-item span {\n    font-size: 8.5px;\n    font-weight: 700;\n    letter-spacing: 0.2px;\n    transition: color 0.3s;\n}\n\n.wheel-icon {\n    width: 32px;\n    height: 32px;\n    border-radius: 50%;\n    background: #0A0A0E;\n    border: 1px solid rgba(255, 255, 255, 0.08);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: all 0.3s cubic-bezier(0.25, 1, 0.5, 1);\n    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.5);\n}\n\n.wheel-icon svg {\n    width: 14px;\n    height: 14px;\n    stroke: currentColor;\n    fill: none;\n    stroke-width: 2.2px;\n}\n\n/* Animation cycles matching phone screen sync */\n.wheel-item.n1 {\n    animation: cycleNav1 12s infinite;\n}\n\n.wheel-item.n2 {\n    animation: cycleNav2 12s infinite;\n}\n\n.wheel-item.n3 {\n    animation: cycleNav3 12s infinite;\n}\n\n/* Hover micro-interactions */\n.wheel-item:hover {\n    color: #FFF !important;\n}\n\n.wheel-item:hover .wheel-icon {\n    border-color: #E8C97A;\n    color: #E8C97A;\n    transform: scale(1.12);\n    box-shadow: 0 0 12px rgba(201, 168, 76, 0.45);\n}\n\n/* Tablet/Mobile Responsive Override */\n@media (max-width: 991px) {\n    .orbit-control-wheel {\n        position: relative !important;\n        top: auto !important;\n        left: auto !important;\n        transform: none !important;\n        margin: 25px auto 35px !important;\n        width: 100% !important;\n        max-width: 310px !important;\n        height: 200px !important;\n    }\n}\n\n\n@keyframes cycleNav1 {\n\n    0%,\n    28% {\n        color: #C9A84C;\n    }\n\n    33%,\n    100% {\n        color: #666;\n    }\n}\n\n@keyframes cycleNav2 {\n\n    0%,\n    30% {\n        color: #666;\n    }\n\n    33%,\n    61% {\n        color: #C9A84C;\n    }\n\n    66%,\n    100% {\n        color: #666;\n    }\n}\n\n@keyframes cycleNav3 {\n\n    0%,\n    63% {\n        color: #666;\n    }\n\n    66%,\n    95% {\n        color: #C9A84C;\n    }\n\n    100% {\n        color: #666;\n    }\n}\n\n/* App Screen Internal Styling */\n.app-hdr {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    font-size: 13px;\n    color: #AAA;\n}\n\n.app-logo-mini {\n    height: 18px;\n    width: auto;\n}\n\n.app-search-pill {\n    background: rgba(255, 255, 255, 0.05);\n    border: 1px solid rgba(255, 255, 255, 0.1);\n    padding: 4px 10px;\n    border-radius: 14px;\n    font-size: 11px;\n    color: #888;\n    display: flex;\n    align-items: center;\n    gap: 6px;\n}\n\n.app-card-bal {\n    background: linear-gradient(135deg, rgba(201, 168, 76, 0.1), rgba(255, 255, 255, 0.02));\n    border: 1px solid rgba(201, 168, 76, 0.3);\n    padding: 16px;\n    border-radius: 20px;\n}\n\n.app-card-lbl {\n    font-size: 11px;\n    color: #888;\n    margin-bottom: 4px;\n}\n\n.app-card-val {\n    font-size: 24px;\n    font-weight: 700;\n    color: #F2EEE6;\n    font-family: 'Cormorant Garamond', serif;\n    line-height: 1;\n    margin-bottom: 6px;\n}\n\n.app-badge {\n    display: inline-block;\n    background: rgba(74, 222, 128, 0.15);\n    color: #4ADE80;\n    border: 1px solid rgba(74, 222, 128, 0.3);\n    padding: 2px 8px;\n    border-radius: 10px;\n    font-size: 10px;\n    font-weight: 700;\n}\n\n.app-quick-grid {\n    display: grid;\n    grid-template-columns: repeat(4, 1fr);\n    gap: 8px;\n    text-align: center;\n}\n\n.app-q-item {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 4px;\n    font-size: 10px;\n    color: #AAA;\n}\n\n.app-q-ico {\n    width: 36px;\n    height: 36px;\n    border-radius: 50%;\n    background: rgba(255, 255, 255, 0.06);\n    border: 1px solid rgba(255, 255, 255, 0.12);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 16px;\n}\n\n.app-q-item:hover .app-q-ico {\n    background: #c9a84c00;\n    color: #0A0A0A;\n}\n\n.app-list-hdr {\n    font-size: 12px;\n    font-weight: 700;\n    color: #AAA;\n    margin-bottom: 4px;\n}\n\n.app-list {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n}\n\n.app-mkt-row {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 8px 12px;\n    background: rgba(255, 255, 255, 0.02);\n    border: 1px solid rgba(255, 255, 255, 0.05);\n    border-radius: 14px;\n}\n\n.app-mkt-row strong {\n    font-size: 13px;\n    color: #F2EEE6;\n    display: block;\n}\n\n.app-mkt-row span {\n    font-size: 10px;\n    color: #888;\n}\n\n.app-chart-box {\n    background: rgba(255, 255, 255, 0.02);\n    border: 1px solid rgba(255, 255, 255, 0.05);\n    border-radius: 18px;\n    padding: 12px;\n    height: 140px;\n}\n\n.app-ob-box {\n    display: grid;\n    grid-template-columns: 1fr;\n    max-width: 800px;\n    gap: 12px;\n    font-size: 10px;\n    font-family: monospace;\n    padding: 8px 0;\n}\n\n.app-buttons {\n    display: flex;\n    gap: 10px;\n    margin-top: auto;\n    padding-bottom: 10px;\n}\n\n.app-btn {\n    flex: 1;\n    padding: 12px 0;\n    border-radius: 14px;\n    font-size: 13px;\n    font-weight: 700;\n    border: none;\n    text-align: center;\n}\n\n.app-btn.g {\n    background: #4ADE80;\n    color: #0A0A0A;\n    box-shadow: 0 6px 15px rgba(74, 222, 128, 0.3);\n}\n\n.app-btn.r {\n    background: #F87171;\n    color: #0A0A0A;\n    box-shadow: 0 6px 15px rgba(248, 113, 113, 0.3);\n}\n\n/* Connecting SVG Beams */\n.orbit-beams {\n    position: absolute;\n    inset: 0;\n    pointer-events: none;\n    z-index: 2;\n}\n\n.orbit-beams svg {\n    width: 100%;\n    height: 100%;\n}\n\n.beam-line {\n    stroke: rgba(201, 168, 76, 0.3);\n    stroke-width: 2;\n    stroke-dasharray: 8 6;\n    animation: beamPulse 30s linear infinite;\n}\n\n@keyframes beamPulse {\n    0% {\n        stroke-dashoffset: 1000;\n    }\n\n    100% {\n        stroke-dashoffset: 0;\n    }\n}\n\n/* Reusable Orbit Animation Mechanics */\n.orbit-track {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    width: 1040px;\n    height: 1040px;\n    transform: translate(-50%, -50%);\n    border-radius: 50%;\n    z-index: 20;\n    pointer-events: none;\n    animation: spinTrack 60s linear infinite;\n}\n\n.orbit-track:hover {\n    animation-play-state: paused;\n}\n\n.orbit-node {\n    position: absolute;\n    width: 0;\n    height: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    animation: counterSpin 60s linear infinite;\n}\n\n.orbit-track:hover .orbit-node {\n    animation-play-state: paused;\n}\n\n@keyframes spinTrack {\n    0% {\n        transform: translate(-50%, -50%) rotate(0deg);\n    }\n\n    100% {\n        transform: translate(-50%, -50%) rotate(360deg);\n    }\n}\n\n@keyframes counterSpin {\n    0% {\n        transform: rotate(0deg);\n    }\n\n    100% {\n        transform: rotate(-360deg);\n    }\n}\n\n/* Orbit Feature Cards */\n.orbit-card {\n    width: 460px;\n    background: rgba(18, 18, 24, 0.75);\n    border: 1px solid rgba(255, 255, 255, 0.08);\n    border-radius: 20px;\n    padding: 22px 28px;\n    box-shadow: 0 25px 70px rgba(0, 0, 0, 0.85);\n    backdrop-filter: blur(5px);\n    -webkit-backdrop-filter: blur(5px);\n    transition: all 0.4s cubic-bezier(0.16, 1, 0.3, 1);\n    display: flex;\n    flex-direction: column;\n    pointer-events: auto;\n    cursor: default;\n}\n\n.orbit-card:hover {\n    transform: scale(1.06) translateY(-8px);\n    border-color: #C9A84C;\n    box-shadow: 0 35px 90px rgba(201, 168, 76, 0.25), 0 0 30px rgba(201, 168, 76, 0.1);\n    z-index: 30;\n}\n\n.orbit-card.premium {\n    border: 1px solid rgba(201, 168, 76, 0.4);\n    background: linear-gradient(180deg, rgba(201, 168, 76, 0.12), rgba(18, 18, 24, 0.85));\n    width: 480px;\n}\n\n/* Node Positions (Radius ~ 450px) */\n.orbit-node.n1 {\n    top: 0%;\n    left: 50%;\n}\n\n.orbit-node.n2 {\n    top: 50%;\n    left: 100%;\n}\n\n.orbit-node.n3 {\n    top: 100%;\n    left: 50%;\n}\n\n.orbit-node.n4 {\n    top: 50%;\n    left: 0%;\n}\n\n.orbit-hdr {\n    display: flex;\n    align-items: center;\n    gap: 16px;\n    margin-bottom: 12px;\n}\n\n.orbit-ico {\n    width: 44px;\n    height: 44px;\n    border-radius: 12px;\n    background: rgba(201, 168, 76, 0.12);\n    border: 1px solid rgba(201, 168, 76, 0.25);\n    color: #C9A84C;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 20px;\n    box-shadow: 0 6px 12px rgba(0, 0, 0, 0.4);\n    flex-shrink: 0;\n}\n\n.orbit-title {\n    font-size: 18px;\n    font-weight: 700;\n    color: #F2EEE6;\n    margin: 0;\n    line-height: 1.1;\n}\n\n.orbit-desc {\n    font-size: 13px;\n    color: #888;\n    line-height: 1.5;\n    margin-bottom: 0;\n}\n\n.orbit-link {\n    margin-top: 14px;\n    font-size: 13px;\n    font-weight: 700;\n    color: #C9A84C;\n    text-decoration: none;\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    transition: gap 0.2s;\n}\n\n.orbit-card:hover .orbit-link {\n    gap: 10px;\n    color: #E8C97A;\n}\n\n/* USP Section */\n.usp-grid {\n    display: grid;\n    grid-template-columns: repeat(4, 1fr);\n    gap: 24px;\n    margin-top: 40px;\n}\n\n.usp-card {\n    box-sizing: border-box !important;\n    background: rgba(18, 18, 24, 0.6);\n    border: 1px solid rgba(255, 255, 255, 0.06);\n    border-radius: 26px;\n    padding: 40px 32px;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    position: relative;\n    box-shadow: 0 25px 70px rgba(0, 0, 0, 0.7);\n    backdrop-filter: blur(5px);\n    -webkit-backdrop-filter: blur(5px);\n    transition: all 0.4s;\n}\n\n.usp-card:hover {\n    transform: translateY(-6px);\n    border-color: rgba(201, 168, 76, 0.4);\n    box-shadow: 0 35px 90px rgba(201, 168, 76, 0.15);\n}\n\n.usp-vector {\n    width: 100%;\n    height: 140px;\n    margin-bottom: 24px;\n    background: rgba(0, 0, 0, 0.4);\n    border: 1px solid rgba(255, 255, 255, 0.05);\n    border-radius: 16px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    overflow: hidden;\n    position: relative;\n}\n\n.usp-vector svg {\n    width: 100%;\n    height: 100%;\n}\n\n.usp-title {\n    font-size: 20px;\n    font-weight: 700;\n    color: #F2EEE6;\n    margin-bottom: 12px;\n}\n\n.usp-desc {\n    font-size: 14px;\n    color: #888;\n    line-height: 1.6;\n}\n\n/* Gamified Interactive Matrix Styling */\n.usp-sim-box {\n    width: 100%;\n    box-sizing: border-box !important;\n    margin: 20px 0;\n    padding: 14px 16px;\n    background: rgba(0, 0, 0, 0.5);\n    border: 1px solid rgba(255, 255, 255, 0.08);\n    border-radius: 16px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    font-size: 13px;\n    font-family: monospace;\n}\n\n.usp-sim-val {\n    font-weight: 700;\n    color: #F2EEE6;\n    transition: color 0.3s;\n}\n\n.usp-sim-tag {\n    padding: 4px 10px;\n    border-radius: 12px;\n    font-size: 11px;\n    font-weight: 700;\n    background: rgba(255, 255, 255, 0.1);\n    color: #AAA;\n    transition: all 0.3s;\n}\n\n.usp-sim-tag.active {\n    background: rgba(74, 222, 128, 0.2);\n    color: #4ADE80;\n    box-shadow: 0 0 15px rgba(74, 222, 128, 0.4);\n}\n\n.usp-action-btn {\n    width: 100%;\n    padding: 14px 20px;\n    background: linear-gradient(135deg, rgba(201, 168, 76, 0.15), rgba(201, 168, 76, 0.05));\n    border: 1px solid #C9A84C;\n    border-radius: 16px;\n    color: #C9A84C;\n    font-size: 13px;\n    font-weight: 700;\n    cursor: pointer;\n    transition: all 0.3s;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n    margin-top: auto;\n}\n\n.usp-action-btn svg.btn-svg-icon {\n    width: 16px;\n    height: 16px;\n    stroke: currentColor;\n    fill: none;\n    stroke-width: 2.2px;\n    flex-shrink: 0;\n    transition: stroke 0.3s, transform 0.3s;\n}\n\n.usp-action-btn:hover {\n    background: linear-gradient(135deg, #E8C97A, #C9A84C);\n    color: #0A0A0A;\n    transform: translateY(-2px);\n    box-shadow: 0 10px 25px rgba(201, 168, 76, 0.3);\n}\n\n.usp-action-btn:active {\n    transform: translateY(0);\n}\n\n.usp-action-btn:disabled {\n    opacity: 0.6;\n    cursor: not-allowed;\n    background: rgba(255, 255, 255, 0.1);\n    color: #888;\n    border-color: rgba(255, 255, 255, 0.15);\n}\n\n/* Dynamic Simulation Animations */\n.wave-path {\n    transition: all 0.5s;\n    stroke-dasharray: 400;\n    stroke-dashoffset: 400;\n}\n\n.sim-running .wave-path {\n    animation: surgeWaves 1.2s infinite linear;\n}\n\n@keyframes surgeWaves {\n    0% {\n        stroke-dashoffset: 400;\n    }\n\n    100% {\n        stroke-dashoffset: 0;\n    }\n}\n\n.ping-racer {\n    stroke-dasharray: 20 200;\n    stroke-dashoffset: 220;\n}\n\n.sim-running .ping-racer {\n    animation: racePing 0.6s infinite linear;\n}\n\n@keyframes racePing {\n    0% {\n        stroke-dashoffset: 220;\n    }\n\n    100% {\n        stroke-dashoffset: -200;\n    }\n}\n\n\n\n\n\n/* --- LIGHT THEME OVERRIDES (DEFAULT) --- */\n\n\n/* Typography & Hero */\nbody.light_theme .brand-name,\nbody.light_theme .tl.gold {\n    background: linear-gradient(130deg, #D4AF37 0%, #B8860B 50%, #8B6508 100%) !important;\n    -webkit-background-clip: text !important;\n    -webkit-text-fill-color: transparent !important;\n    background-clip: text !important;\n}\n\nbody.light_theme .sub {\n    color: #555;\n}\n\nbody.light_theme .sub em {\n    color: #B8860B !important;\n}\n\nbody.light_theme .tl {\n    color: #111;\n}\n\nbody.light_theme .sec-title,\nbody.light_theme .cta-title,\nbody.light_theme .eco-title {\n    color: #111;\n}\n\nbody.light_theme .sec-sub,\nbody.light_theme .cta-desc {\n    color: #555;\n}\n\nbody.light_theme .sec-tag {\n    background: rgba(0, 0, 0, 0.04);\n    color: #333;\n    border-color: rgba(0, 0, 0, 0.08);\n}\n\n/* Actions & Inputs */\nbody.light_theme .email-input,\nbody.light_theme .cta-input {\n    background: #FFF;\n    border-color: rgba(0, 0, 0, 0.1);\n    color: #111;\n    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.03);\n}\n\nbody.light_theme .s-label {\n    color: #666;\n}\n\nbody.light_theme .s-ico-btn {\n    background: #FFF;\n    border-color: rgba(0, 0, 0, 0.1);\n    color: #444;\n}\n\nbody.light_theme .s-ico-btn svg path {\n    fill: #444;\n}\n\nbody.light_theme .s-divider-pro {\n    background: rgba(0, 0, 0, 0.1);\n}\n\nbody.light_theme .t-pill {\n    background: #FFF;\n    border-color: rgba(0, 0, 0, 0.08);\n    color: #444;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.02);\n}\n\nbody.light_theme .btn-trade {\n    background: #FFF;\n    border-color: rgba(0, 0, 0, 0.15);\n    color: #111;\n}\n\nbody.light_theme .btn-trade:hover {\n    background: #111;\n    color: #FFF;\n}\n\nbody.light_theme .store-btn {\n    background: #FFF;\n    border-color: rgba(0, 0, 0, 0.15);\n    color: #111;\n}\n\nbody.light_theme .store-btn:hover {\n    border-color: #C9A84C;\n}\n\n/* Cards & Modules */\nbody.light_theme .sec-card,\nbody.light_theme .bento-card,\nbody.light_theme .usp-card,\nbody.light_theme .orbit-card,\nbody.light_theme .eco-card,\nbody.light_theme .step-card,\nbody.light_theme .mkt-container {\n    background: #FFF;\n    border-color: rgba(0, 0, 0, 0.06);\n    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.04);\n}\n\nbody.light_theme .sec-card:hover,\nbody.light_theme .bento-card:hover,\nbody.light_theme .usp-card:hover,\nbody.light_theme .orbit-card:hover,\nbody.light_theme .step-card:hover {\n    border-color: rgba(201, 168, 76, 0.4);\n    box-shadow: 0 20px 50px rgba(201, 168, 76, 0.1);\n    transform: translateY(-4px);\n}\n\nbody.light_theme .sc-title,\nbody.light_theme .bc-title,\nbody.light_theme .usp-title,\nbody.light_theme .orbit-title,\nbody.light_theme .step-title,\nbody.light_theme .eco-title {\n    color: #111;\n}\n\nbody.light_theme .sc-text,\nbody.light_theme .bc-desc,\nbody.light_theme .usp-desc,\nbody.light_theme .orbit-desc,\nbody.light_theme .step-text,\nbody.light_theme .eco-desc {\n    color: #555;\n}\n\nbody.light_theme .usp-vector,\nbody.light_theme .bc-mockup,\nbody.light_theme .sc-visual,\nbody.light_theme .sc-por,\nbody.light_theme .sc-speed {\n    background: #F8F9FA !important;\n    border-color: rgba(0, 0, 0, 0.04) !important;\n}\n\nbody.light_theme .usp-sim-box {\n    background: #FFF;\n    border-color: rgba(0, 0, 0, 0.08);\n}\n\nbody.light_theme .usp-sim-val {\n    color: #111;\n}\n\nbody.light_theme .por-terminal {\n    background: #FFF;\n    border-color: rgba(0, 0, 0, 0.1);\n    box-shadow: 0 10px 25px rgba(0, 0, 0, 0.05);\n}\n\nbody.light_theme .shard-box {\n    background: #FFF;\n    border-color: rgba(0, 0, 0, 0.1);\n    color: #111;\n}\n\nbody.light_theme .lat-overlay {\n    color: #111;\n}\n\n/* Table & Filters */\nbody.light_theme .mkt-tab {\n    background: #F8F9FA;\n    border-color: rgba(0, 0, 0, 0.08);\n    color: #555;\n}\n\nbody.light_theme .mkt-tab:hover {\n    background: #EFEFEF;\n    color: #111;\n}\n\nbody.light_theme .mkt-tab.active {\n    background: rgba(201, 168, 76, 0.1);\n    border-color: rgba(201, 168, 76, 0.4);\n    color: #C9A84C;\n}\n\nbody.light_theme .mkt-table th {\n    color: #666;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.08);\n}\n\nbody.light_theme .mkt-table td {\n    color: #111;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.04);\n    border-top: 1px solid rgba(0, 0, 0, 0.02);\n}\n\nbody.light_theme .mkt-table tbody tr {\n    background: rgba(0, 0, 0, 0.015);\n}\n\nbody.light_theme .mkt-table tr:hover td {\n    background: rgba(0, 0, 0, 0.03);\n}\n\nbody.light_theme .btn-filter {\n    background: rgba(0, 0, 0, 0.04);\n    color: #555;\n}\n\nbody.light_theme .btn-filter:hover {\n    background: rgba(0, 0, 0, 0.08);\n    color: #111;\n}\n\nbody.light_theme .btn-filter.active {\n    background: #FFF;\n    border: 1px solid rgba(0, 0, 0, 0.1);\n    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.05);\n    color: #111;\n}\n\nbody.light_theme .coin-sym {\n    color: #888;\n}\n\nbody.light_theme .mkt-footer {\n    border-color: rgba(0, 0, 0, 0.08);\n}\n\nbody.light_theme .t-name {\n    color: #111;\n}\n\nbody.light_theme .t-px {\n    color: #111;\n}\n\n/* CTA Box & Misc overrides */\nbody.light_theme .cta-box {\n    background: linear-gradient(135deg, rgba(201, 168, 76, 0.15), #FFFFFF) !important;\n    box-shadow: 0 20px 60px rgba(0, 0, 0, 0.05);\n    border-color: rgba(201, 168, 76, 0.25);\n}\n\nbody.light_theme .step-num {\n    color: rgba(201, 168, 76, 0.8);\n}\n\nbody.light_theme .auth-logos div {\n    color: #111 !important;\n}\n\nbody.light_theme .orbit-center-phone .app-ph {\n    box-shadow: 0 30px 80px rgba(0, 0, 0, 0.2);\n}\n\nbody.light_theme .float-shape svg polygon,\nbody.light_theme .float-shape svg circle {\n    stroke: rgba(0, 0, 0, 0.15) !important;\n}\n\nbody.light_theme .pg {\n    background: radial-gradient(ellipse at center,\n            rgba(201, 168, 76, 0.45) 0%,\n            rgba(201, 168, 76, 0.22) 35%,\n            rgba(232, 201, 122, 0.06) 60%,\n            transparent 75%);\n    filter: blur(60px);\n}\n\n/* Footer */\n\nbody.light_theme .ft-desc {\n    color: #A0A3A7;\n}\n\nbody.light_theme .ft-title {\n    color: #fff;\n}\n\nbody.light_theme .ft-link {\n    color: #A0A3A7;\n}\n\nbody.light_theme .ft-bottom {\n    border-top: 1px solid rgb(143 143 143 / 16%);\n}\n\nbody.light_theme .ft-copy {\n    color: #A0A3A7;\n}\n\nbody.light_theme .ft-soc {\n    color: #666;\n}\n\n/* QR Modal */\n.qr-modal {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    z-index: 9999;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    opacity: 0;\n    pointer-events: none;\n    transition: opacity 0.3s ease;\n}\n\n.qr-modal.active {\n    opacity: 1;\n    pointer-events: all;\n}\n\n.qr-modal-bg {\n    position: absolute;\n    inset: 0;\n    background: rgba(0, 0, 0, 0.8);\n    backdrop-filter: blur(5px);\n}\n\n.qr-modal-content {\n    position: relative;\n    background: #0A0A0E;\n    border: 1px solid rgba(255, 255, 255, 0.1);\n    border-radius: 24px;\n    padding: 40px;\n    text-align: center;\n    max-width: 400px;\n    width: 90%;\n    transform: translateY(20px) scale(0.95);\n    transition: transform 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);\n    box-shadow: 0 40px 100px rgba(0, 0, 0, 0.5);\n}\n\n.qr-modal.active .qr-modal-content {\n    transform: translateY(0) scale(1);\n}\n\n.qr-close {\n    position: absolute;\n    top: 20px;\n    right: 20px;\n    font-size: 20px;\n    color: #888;\n    cursor: pointer;\n    transition: color 0.2s;\n}\n\n.qr-close:hover {\n    color: #F2EEE6;\n}\n\n.qr-title {\n    font-size: 22px;\n    font-weight: 700;\n    color: #F2EEE6;\n    margin-bottom: 12px;\n}\n\n.qr-desc {\n    font-size: 14px;\n    color: #888;\n    margin-bottom: 30px;\n    line-height: 1.5;\n}\n\n.qr-box {\n    background: #FFF;\n    padding: 20px;\n    border-radius: 16px;\n    display: inline-block;\n    box-shadow: 0 0 30px rgba(201, 168, 76, 0.3);\n}\n\nbody.light_theme .qr-modal-bg {\n    background: rgb(255 255 255 / 20%);\n}\n\nbody.light_theme .qr-modal-content {\n    background: #FFF;\n    border-color: rgba(0, 0, 0, 0.1);\n    box-shadow: 0 40px 100px rgba(0, 0, 0, 0.15);\n}\n\nbody.light_theme .qr-title {\n    color: #111;\n}\n\n/* Step Graphics Animations */\n.step-gfx {\n    height: 120px;\n    margin-bottom: 24px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    position: relative;\n}\n\n.sg-scan-line {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    height: 2px;\n    background: #4ADE80;\n    box-shadow: 0 0 10px #4ADE80;\n    animation: scanLine 2s infinite linear;\n}\n\n@keyframes scanLine {\n    0% {\n        top: 10%;\n        opacity: 0;\n    }\n\n    10% {\n        opacity: 1;\n    }\n\n    90% {\n        opacity: 1;\n    }\n\n    100% {\n        top: 90%;\n        opacity: 0;\n    }\n}\n\n.sg-float {\n    animation: sgFloat 3s ease-in-out infinite;\n}\n\n@keyframes sgFloat {\n\n    0%,\n    100% {\n        transform: translateY(0);\n    }\n\n    50% {\n        transform: translateY(-10px);\n    }\n}\n\n.sg-glow {\n    filter: drop-shadow(0 0 15px rgba(201, 168, 76, 0.5));\n}\n\n/* ─── High-Fidelity Mobile App Screens CSS ─── */\n.s26-screen {\n    container-type: inline-size;\n}\n\n.hf-screen {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    height: 100%;\n    box-sizing: border-box;\n    font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif;\n    user-select: none;\n    position: relative;\n    padding-bottom: 12cqw;\n    line-height: 1.2;\n    overflow: hidden;\n    transition: background 0.4s ease, color 0.4s ease;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    backface-visibility: hidden;\n    transform: translate3d(0, 0, 0);\n    background: #FFFFFF;\n    color: #000000;\n    --bg-bar: #F3F4F6;\n    --bg-card: #F9FAFB;\n    --border-color: #E5E7EB;\n    --text-muted: #6B7280;\n    --text-main: #111827;\n    --bg-btn-inactive: #E5E7EB;\n    --text-btn-inactive: #374151;\n    --bg-tab-active: #FFFFFF;\n    --shadow-sm: 0 1px 2px rgba(0, 0, 0, 0.05);\n    --color-green: #2ebd85;\n    --color-red: #ea3943;\n    --color-gold: #C9A84C;\n    --color-gold-hover: #E8C97A;\n    --bg-green-soft: rgba(46, 189, 133, 0.15);\n    --bg-red-soft: rgba(234, 57, 67, 0.15);\n    --bg-gold-soft: rgba(201, 168, 76, 0.15);\n}\n\nbody:not(.light_theme) .hf-screen {\n    background: #0B0B0E;\n    color: #F3F4F6;\n    --bg-bar: #14141A;\n    --bg-card: #181822;\n    --border-color: #262635;\n    --text-muted: #8E8E9F;\n    --text-main: #F3F4F6;\n    --bg-btn-inactive: #262635;\n    --text-btn-inactive: #A1A1B5;\n    --bg-tab-active: #262635;\n    --shadow-sm: 0 1px 2px rgba(0, 0, 0, 0.5);\n}\n\n.hf-status-bar {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 6.5cqw 4.5cqw 1.5cqw;\n    font-size: 2.8cqw;\n    font-weight: 600;\n    color: var(--text-muted);\n    background: transparent;\n    z-index: 10;\n}\n\n.status-left,\n.status-right {\n    display: flex;\n    align-items: center;\n    gap: 1.5cqw;\n}\n\n.status-time {\n    color: var(--text-main);\n}\n\n.status-icons span,\n.status-right span {\n    display: inline-flex;\n    align-items: center;\n    font-size: 2.6cqw;\n}\n\n.hf-nav-bar-tabs {\n    display: flex;\n    align-items: center;\n    padding: 1cqw 3cqw;\n    border-bottom: 1px solid var(--border-color);\n    gap: 3cqw;\n}\n\n.back-arrow {\n    font-size: 4cqw;\n    font-weight: 700;\n    color: var(--text-main);\n    cursor: pointer;\n}\n\n.nav-tabs-scroll,\n.segments-scroll {\n    display: flex;\n    gap: 4.5cqw;\n    overflow-x: auto;\n    scrollbar-width: none;\n    flex: 1;\n}\n\n.nav-tabs-scroll::-webkit-scrollbar,\n.segments-scroll::-webkit-scrollbar {\n    display: none;\n}\n\n.nav-tab,\n.segment,\n.sub-tab {\n    font-size: 3.3cqw;\n    font-weight: 500;\n    color: var(--text-muted);\n    padding: 1.5cqw 0;\n    position: relative;\n    white-space: nowrap;\n    cursor: pointer;\n}\n\n.nav-tab.active,\n.segment.active,\n.sub-tab.active {\n    color: var(--text-main);\n    font-weight: 700;\n}\n\n.nav-tab.active::after,\n.segment.active::after,\n.sub-tab.active::after {\n    content: \"\";\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    height: 0.6cqw;\n    background: var(--color-green);\n    border-radius: 1px;\n}\n\n.wallet-screen .segment.active::after {\n    background: var(--text-main);\n}\n\n.hf-coin-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 2cqw 3.5cqw;\n}\n\n.coin-selector {\n    display: flex;\n    align-items: center;\n    gap: 1.5cqw;\n}\n\n.coin-pair {\n    font-size: 4.2cqw;\n    font-weight: 700;\n    color: var(--text-main);\n}\n\n.coin-arrow {\n    font-size: 3.5cqw;\n    color: var(--text-muted);\n}\n\n.coin-badge {\n    font-size: 2.5cqw;\n    font-weight: 700;\n    padding: 0.5cqw 1.5cqw;\n    border-radius: 0.8cqw;\n}\n\n.coin-badge.change-down {\n    background: var(--bg-red-soft);\n    color: var(--color-red);\n}\n\n.coin-badge.change-up {\n    background: var(--bg-green-soft);\n    color: var(--color-green);\n}\n\n.coin-actions {\n    display: flex;\n    gap: 3.5cqw;\n    font-size: 3.8cqw;\n    color: var(--text-muted);\n}\n\n.hf-main-grid {\n    display: grid;\n    grid-template-columns: 46% 51%;\n    gap: 3%;\n    padding: 1cqw 2cqw;\n    flex: 1;\n    overflow: hidden;\n}\n\n.hf-order-book {\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n    justify-content: space-between;\n}\n\n.ob-header {\n    display: flex;\n    justify-content: space-between;\n    font-size: 2.4cqw;\n    color: var(--text-muted);\n    font-weight: 500;\n    margin-bottom: 1.2cqw;\n}\n\n.ob-asks,\n.ob-bids {\n    display: flex;\n    flex-direction: column;\n    gap: 0.8cqw;\n}\n\n.ob-row {\n    display: flex;\n    justify-content: space-between;\n    font-size: 2.5cqw;\n    font-family: monospace;\n    font-weight: 500;\n}\n\n.ob-row span:last-child {\n    color: var(--text-muted);\n}\n\n.price-red {\n    color: var(--color-red);\n}\n\n.price-green {\n    color: var(--color-green);\n}\n\n.ob-mid-price {\n    margin: 1.5cqw 0;\n    padding: 0.5cqw 0;\n    border-top: 1px dashed var(--border-color);\n    border-bottom: 1px dashed var(--border-color);\n    text-align: center;\n}\n\n.mid-value {\n    font-size: 4cqw;\n    font-weight: 700;\n}\n\n.mid-change {\n    font-size: 2.4cqw;\n    font-weight: 600;\n}\n\n.ob-bar-graph {\n    display: flex;\n    height: 0.8cqw;\n    border-radius: 0.4cqw;\n    overflow: hidden;\n    margin-top: 1.5cqw;\n}\n\n.bar-red {\n    background: var(--color-red);\n    opacity: 0.8;\n}\n\n.bar-green {\n    background: var(--color-green);\n    opacity: 0.8;\n}\n\n.ob-footer {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-top: 1.5cqw;\n    font-size: 2.6cqw;\n    color: var(--text-muted);\n}\n\n.hf-trade-form {\n    display: flex;\n    flex-direction: column;\n    gap: 1.8cqw;\n    height: 100%;\n}\n\n.form-tabs {\n    display: flex;\n    border-radius: 1.2cqw;\n    background: var(--bg-bar);\n    padding: 0.6cqw;\n    gap: 0.6cqw;\n}\n\n.form-tabs span {\n    flex: 1;\n    text-align: center;\n    font-size: 3cqw;\n    font-weight: 700;\n    padding: 1cqw 0;\n    border-radius: 0.8cqw;\n    cursor: pointer;\n}\n\n.form-tabs .tab-buy.active {\n    background: var(--color-green);\n    color: #FFFFFF;\n}\n\n.form-tabs .tab-sell.active {\n    background: var(--color-red);\n    color: #FFFFFF;\n}\n\n.form-order-type {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    background: var(--bg-card);\n    border: 1px solid var(--border-color);\n    border-radius: 1cqw;\n    padding: 1cqw 2cqw;\n    font-size: 2.8cqw;\n    font-weight: 600;\n    color: var(--text-main);\n}\n\n.form-input {\n    display: flex;\n    align-items: center;\n    background: var(--bg-card);\n    border: 1px solid var(--border-color);\n    border-radius: 1.2cqw;\n    padding: 0.6cqw 1cqw;\n    position: relative;\n}\n\n.btn-input {\n    width: 4.5cqw;\n    height: 4.5cqw;\n    border-radius: 0.8cqw;\n    background: var(--bg-bar);\n    color: var(--text-main);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 3.5cqw;\n    font-weight: 700;\n    cursor: pointer;\n}\n\n.form-input input {\n    flex: 1;\n    border: none;\n    background: transparent;\n    outline: none;\n    text-align: center;\n    font-size: 3cqw;\n    font-weight: 700;\n    color: var(--text-main);\n    padding: 0.8cqw 0;\n    width: 100%;\n}\n\n.form-input input::placeholder {\n    color: var(--text-muted);\n    font-weight: 500;\n    font-size: 2.7cqw;\n}\n\n.input-lbl {\n    position: absolute;\n    left: 2.2cqw;\n    font-size: 2.2cqw;\n    color: var(--text-muted);\n    font-weight: 500;\n    pointer-events: none;\n    transform: scale(0.9);\n}\n\n.form-slider {\n    display: flex;\n    flex-direction: column;\n    gap: 1cqw;\n    margin: 0.5cqw 0;\n}\n\n.slider-track {\n    position: relative;\n    height: 0.8cqw;\n    background: var(--bg-bar);\n    border-radius: 0.4cqw;\n}\n\n.slider-fill {\n    position: absolute;\n    left: 0;\n    top: 0;\n    height: 100%;\n    background: var(--color-green);\n    border-radius: inherit;\n}\n\n.slider-node {\n    position: absolute;\n    top: 50%;\n    transform: translate(-50%, -50%);\n    width: 2cqw;\n    height: 2cqw;\n    border-radius: 50%;\n    background: var(--bg-tab-active);\n    border: 0.6cqw solid var(--border-color);\n    z-index: 2;\n}\n\n.slider-node.active {\n    border-color: var(--color-green);\n    background: #FFFFFF;\n}\n\n.slider-labels {\n    display: flex;\n    justify-content: space-between;\n    font-size: 2.2cqw;\n    color: var(--text-muted);\n    font-weight: 500;\n}\n\n.form-checkboxes {\n    display: flex;\n    gap: 3cqw;\n    font-size: 2.5cqw;\n    color: var(--text-muted);\n    font-weight: 600;\n}\n\n.form-checkboxes label {\n    display: flex;\n    align-items: center;\n    gap: 0.8cqw;\n}\n\nbody.light_theme .vault-core {\n    color: #000000;\n}\n\n.form-assets {\n    display: flex;\n    flex-direction: column;\n    gap: 0.6cqw;\n    font-size: 2.4cqw;\n    color: var(--text-muted);\n}\n\n.asset-row {\n    display: flex;\n    justify-content: space-between;\n}\n\n.asset-row strong {\n    color: var(--text-main);\n}\n\n.form-quick-btns {\n    display: flex;\n    gap: 1.5cqw;\n}\n\n.form-quick-btns span {\n    flex: 1;\n    text-align: center;\n    font-size: 2.5cqw;\n    font-weight: 700;\n    background: var(--bg-btn-inactive);\n    color: var(--text-btn-inactive);\n    padding: 1cqw 0;\n    border-radius: 0.8cqw;\n    cursor: pointer;\n}\n\n.btn-submit-trade {\n    width: 100%;\n    border: none;\n    outline: none;\n    background: var(--color-green);\n    color: #FFFFFF;\n    font-weight: 700;\n    font-size: 3.2cqw;\n    padding: 1.8cqw 0;\n    border-radius: 1.2cqw;\n    cursor: pointer;\n    box-shadow: 0 4px 10px rgba(46, 189, 133, 0.2);\n}\n\n.form-maker-taker {\n    display: flex;\n    justify-content: space-between;\n    font-size: 2cqw;\n    color: var(--text-muted);\n}\n\n.hf-promo-bar {\n    background: rgba(201, 168, 76, 0.15);\n    border-top: 1px solid rgba(201, 168, 76, 0.25);\n    border-bottom: 1px solid rgba(201, 168, 76, 0.25);\n    padding: 1.2cqw 3cqw;\n    font-size: 2.5cqw;\n    font-weight: 700;\n    color: var(--color-gold);\n    text-align: center;\n    margin-top: 1cqw;\n}\n\n.hf-bottom-status {\n    padding: 2cqw 3cqw 0;\n    flex: 0.8;\n    display: flex;\n    flex-direction: column;\n    gap: 1.5cqw;\n    border-top: 1px solid var(--border-color);\n    background: var(--bg-card);\n}\n\n.status-tabs {\n    display: flex;\n    gap: 4cqw;\n}\n\n.status-tabs span {\n    font-size: 2.8cqw;\n    font-weight: 600;\n    color: var(--text-muted);\n    cursor: pointer;\n}\n\n.status-tabs span.active {\n    color: var(--text-main);\n    font-weight: 700;\n}\n\n.empty-state {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    padding: 2cqw 0;\n    color: var(--text-muted);\n    gap: 1cqw;\n}\n\n.empty-icon {\n    font-size: 5cqw;\n    opacity: 0.4;\n}\n\n.empty-state span:last-child {\n    font-size: 2.6cqw;\n    font-weight: 500;\n}\n\n.hf-screen-nav {\n    display: flex;\n    border-top: 1px solid var(--border-color);\n    background: var(--bg-bar);\n    padding: 1cqw 0;\n    justify-content: space-around;\n    align-items: center;\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    height: 12cqw;\n    z-index: 12;\n}\n\n.hf-screen-nav .nav-item {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    color: var(--text-muted);\n    gap: 0.8cqw;\n    cursor: pointer;\n    flex: 1;\n    text-align: center;\n    transition: color 0.2s ease;\n}\n\n.hf-screen-nav .nav-item span {\n    font-size: 2.2cqw;\n    font-weight: 600;\n    line-height: 1;\n}\n\n.hf-screen-nav .nav-item .nav-svg-icon {\n    width: 4.8cqw;\n    height: 4.8cqw;\n    fill: none;\n    stroke: currentColor;\n    stroke-width: 2px;\n    stroke-linecap: round;\n    stroke-linejoin: round;\n    display: inline-block;\n    vertical-align: middle;\n}\n\n.hf-screen-nav .nav-item.active {\n    color: var(--color-gold);\n}\n\n.ph-l .hf-screen-nav .nav-item.active {\n    color: var(--color-green);\n}\n\n\n/* Home Screen Styles */\n.hf-home-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 2cqw 3.5cqw;\n}\n\n.profile-avatar {\n    width: 7cqw;\n    height: 7cqw;\n    border-radius: 50%;\n    background: var(--bg-card);\n    border: 1px solid var(--border-color);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 3.5cqw;\n    color: var(--text-muted);\n}\n\n.brand-container {\n    display: flex;\n    align-items: center;\n    gap: 1cqw;\n}\n\n.brand-logo-symbol {\n    font-size: 4.8cqw;\n    color: var(--color-gold);\n}\n\n.brand-logo-text {\n    font-family: 'Cormorant Garamond', serif;\n    font-weight: 700;\n    font-size: 4cqw;\n    color: var(--text-main);\n    letter-spacing: 0.05em;\n}\n\n.header-utilities {\n    display: flex;\n    gap: 3cqw;\n    font-size: 4cqw;\n    color: var(--text-main);\n}\n\n.hf-home-search {\n    display: flex;\n    align-items: center;\n    background: var(--bg-bar);\n    border-radius: 3.5cqw;\n    padding: 1.5cqw 3cqw;\n    margin: 1cqw 3.5cqw 2cqw;\n    gap: 1.5cqw;\n}\n\n.search-ico {\n    font-size: 3.2cqw;\n    color: var(--text-muted);\n}\n\n.search-flame {\n    font-size: 3.2cqw;\n}\n\n.search-placeholder {\n    font-size: 2.8cqw;\n    color: var(--text-muted);\n    font-weight: 500;\n}\n\n.hf-quick-grid {\n    display: flex;\n    justify-content: space-between;\n    padding: 1cqw 4cqw;\n    margin-bottom: 2cqw;\n}\n\n.grid-item {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 1cqw;\n    cursor: pointer;\n}\n\n.grid-ico {\n    width: 8.5cqw;\n    height: 8.5cqw;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 4cqw;\n    font-weight: 700;\n    transition: transform 0.2s;\n}\n\n.grid-item:hover .grid-ico {\n    transform: translateY(-2px);\n}\n\n.grid-item span {\n    font-size: 2.5cqw;\n    font-weight: 600;\n    color: var(--text-muted);\n}\n\n.hf-promo-banner {\n    background: linear-gradient(135deg, #E0F2FE 0%, #BAE6FD 100%);\n    border-radius: 3cqw;\n    margin: 1cqw 3.5cqw 3cqw;\n    padding: 3cqw 3.5cqw;\n    display: flex;\n    justify-content: space-between;\n    position: relative;\n    overflow: hidden;\n    box-shadow: 0 4px 12px rgba(186, 230, 253, 0.2);\n}\n\nbody:not(.light_theme) .hf-promo-banner {\n    background: linear-gradient(135deg, #0C1E2F 0%, #071322 100%);\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.4);\n    border: 1px solid rgba(201, 168, 76, 0.2);\n}\n\n.banner-content {\n    flex: 1.4;\n    display: flex;\n    flex-direction: column;\n    gap: 1cqw;\n}\n\n.banner-tag {\n    font-size: 2.2cqw;\n    font-weight: 700;\n    text-transform: uppercase;\n    color: #0369A1;\n    letter-spacing: 0.05em;\n}\n\nbody:not(.light_theme) .banner-tag {\n    color: var(--color-gold);\n}\n\n.banner-title {\n    font-size: 3cqw;\n    font-weight: 700;\n    line-height: 1.3;\n    color: #0F172A;\n}\n\nbody:not(.light_theme) .banner-title {\n    color: #FFFFFF;\n}\n\n.banner-link {\n    font-size: 2.4cqw;\n    font-weight: 700;\n    color: #0284C7;\n    text-decoration: underline;\n    margin-top: 1cqw;\n}\n\nbody:not(.light_theme) .banner-link {\n    color: var(--color-gold);\n}\n\n.banner-gfx {\n    flex: 0.8;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    position: relative;\n}\n\n.floating-gfx-svg {\n    width: 100%;\n    height: auto;\n    max-height: 14cqw;\n    animation: bannerFloat 3s ease-in-out infinite;\n}\n\n@keyframes bannerFloat {\n\n    0%,\n    100% {\n        transform: translateY(0);\n    }\n\n    50% {\n        transform: translateY(-3px);\n    }\n}\n\n.banner-dots {\n    position: absolute;\n    right: 2cqw;\n    bottom: 2cqw;\n    font-size: 2cqw;\n    font-weight: 700;\n    background: rgba(0, 0, 0, 0.08);\n    color: #0F172A;\n    padding: 0.4cqw 1.2cqw;\n    border-radius: 1cqw;\n}\n\nbody:not(.light_theme) .banner-dots {\n    background: rgba(255, 255, 255, 0.08);\n    color: #FFFFFF;\n}\n\n.hf-market-cards {\n    display: grid;\n    grid-template-columns: 1fr;\n    max-width: 800px;\n    gap: 2.5cqw;\n    padding: 0 3.5cqw;\n    margin-bottom: 3cqw;\n}\n\n.mkt-card {\n    background: var(--bg-card);\n    border: 1px solid var(--border-color);\n    border-radius: 2.5cqw;\n    padding: 2.5cqw 3cqw;\n    display: flex;\n    flex-direction: column;\n    gap: 1.5cqw;\n}\n\n.mkt-card .card-top {\n    display: flex !important;\n    flex-direction: row !important;\n    justify-content: space-between !important;\n    align-items: center !important;\n    padding-bottom: 0px !important;\n    margin-bottom: 0px !important;\n}\n\n.mkt-card .coin-info {\n    display: flex;\n    align-items: center;\n    gap: 1.5cqw;\n}\n\n.mkt-card .coin-icon {\n    width: 6cqw;\n    height: 6cqw;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 3.5cqw;\n    font-weight: 700;\n}\n\n.mkt-card .icon-btc {\n    background: rgba(247, 147, 26, 0.15);\n    color: #F7931A;\n}\n\n.mkt-card .icon-eth {\n    background: rgba(98, 126, 234, 0.15);\n    color: #627EEA;\n}\n\n.mkt-card .coin-symbol {\n    font-size: 2.8cqw;\n    font-weight: 700;\n    color: var(--text-main);\n    line-height: 1.1;\n}\n\n.mkt-card .coin-name {\n    font-size: 2cqw;\n    color: var(--text-muted);\n    line-height: 1;\n}\n\n.mkt-card .card-spark {\n    width: 12cqw;\n    height: 5cqw;\n}\n\n.mkt-card .card-spark svg {\n    width: 100%;\n    height: 100%;\n}\n\n.mkt-card .card-bottom {\n    display: flex;\n    justify-content: space-between;\n    align-items: baseline;\n}\n\n.mkt-card .coin-price {\n    font-size: 3.3cqw;\n    font-weight: 700;\n    color: var(--text-main);\n}\n\n.mkt-card .coin-pct {\n    font-size: 2.3cqw;\n    font-weight: 700;\n}\n\n.mkt-card .coin-pct.down {\n    color: var(--color-red);\n}\n\n.mkt-card .coin-pct.up {\n    color: var(--color-green);\n}\n\n.hf-mkt-tabs {\n    display: flex;\n    padding: 0.8cqw;\n    background: var(--bg-bar);\n    border-radius: 2cqw;\n    margin: 1.5cqw 3.5cqw 2cqw;\n    gap: 1.5cqw;\n    box-sizing: border-box;\n    border: 1px solid var(--border-color);\n}\n\n.hf-mkt-tab {\n    flex: 1;\n    text-align: center;\n    font-size: 2.6cqw;\n    font-weight: 700;\n    color: var(--text-muted);\n    padding: 1.2cqw 0;\n    border-radius: 1.4cqw;\n    cursor: pointer;\n    background: transparent;\n    border: none;\n    transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1);\n    white-space: nowrap;\n}\n\n.hf-mkt-tab.active {\n    background: var(--color-gold);\n    color: #FFFFFF !important;\n    box-shadow: 0 2px 6px rgba(201, 168, 76, 0.25);\n}\n\n.hf-coin-list {\n    display: flex;\n    flex-direction: column;\n    padding: 0 3.5cqw;\n    flex: 1;\n    overflow-y: auto;\n    scrollbar-width: none;\n}\n\n.hf-coin-list::-webkit-scrollbar {\n    display: none;\n}\n\n.list-row {\n    display: grid;\n    grid-template-columns: 40% 32% 28%;\n    align-items: center;\n    padding: 1.6cqw 0;\n    border-bottom: 1px solid var(--border-color);\n}\n\n.list-row.header {\n    font-size: 2.3cqw;\n    color: var(--text-muted);\n    font-weight: 600;\n    border-bottom: 1px solid var(--border-color);\n    padding-bottom: 1cqw;\n}\n\n.coin-cell {\n    display: flex;\n    align-items: center;\n    gap: 1.5cqw;\n}\n\n.coin-avatar {\n    width: 5.5cqw;\n    height: 5.5cqw;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 3.2cqw;\n}\n\n.green-avatar {\n    background: rgba(74, 222, 128, 0.15);\n    color: #4ADE80;\n}\n\n.orange-avatar {\n    background: rgba(247, 147, 26, 0.15);\n    color: #F7931A;\n}\n\n.yellow-avatar {\n    background: rgba(201, 168, 76, 0.15);\n    color: #C9A84C;\n}\n\n.blue-avatar {\n    background: rgba(98, 126, 234, 0.15);\n    color: #627EEA;\n}\n\n.gold-avatar {\n    background: rgba(201, 168, 76, 0.15);\n    color: #C9A84C;\n}\n\n.red-avatar {\n    background: rgba(234, 57, 67, 0.15);\n    color: #ea3943;\n}\n\n.coin-cell strong {\n    font-size: 2.6cqw;\n    font-weight: 700;\n    color: var(--text-main);\n    display: block;\n}\n\n.coin-cell span {\n    font-size: 2cqw;\n    color: var(--text-muted);\n}\n\n.price-cell {\n    text-align: center;\n}\n\n.price-cell strong {\n    font-size: 2.6cqw;\n    font-weight: 700;\n    color: var(--text-main);\n    display: block;\n}\n\n.price-cell span {\n    font-size: 1.8cqw;\n    color: var(--text-muted);\n}\n\n.change-cell {\n    text-align: right;\n}\n\n.change-cell span {\n    font-size: 2.4cqw;\n    font-weight: 700;\n    padding: 0.8cqw 1.6cqw;\n    border-radius: 0.8cqw;\n    display: inline-block;\n}\n\n.badge-red {\n    background: var(--bg-red-soft);\n    color: var(--color-red);\n}\n\n.badge-green {\n    background: var(--bg-green-soft);\n    color: var(--color-green);\n}\n\n.hf-list-more {\n    text-align: center;\n    font-size: 2.6cqw;\n    font-weight: 700;\n    color: var(--color-gold);\n    padding: 1.5cqw 0;\n    cursor: pointer;\n}\n\n/* Wallet Screen Styles */\n.hf-wallet-segments {\n    display: flex;\n    align-items: center;\n    padding: 1cqw 3.5cqw;\n    border-bottom: 1px solid var(--border-color);\n    gap: 2cqw;\n}\n\n.segments-arrow {\n    font-size: 3cqw;\n    color: var(--text-muted);\n    font-weight: 700;\n}\n\n.hf-assets-card {\n    background: linear-gradient(135deg, rgba(201, 168, 76, 0.12), rgba(201, 168, 76, 0.03));\n    border: 1px solid rgba(201, 168, 76, 0.2);\n    border-radius: 3cqw;\n    margin: 3cqw 3.5cqw 2cqw;\n    padding: 3.5cqw 4cqw;\n}\n\n.card-title {\n    font-size: 2.8cqw;\n    font-weight: 700;\n    color: var(--text-muted);\n    margin-bottom: 2cqw;\n}\n\n.estimated-balance span {\n    font-size: 2.4cqw;\n    color: var(--text-muted);\n    font-weight: 600;\n    display: block;\n    margin-bottom: 1cqw;\n}\n\n.btc-val {\n    font-size: 5cqw;\n    font-weight: 700;\n    color: var(--text-main);\n    margin-bottom: 0.5cqw;\n}\n\n.usd-val {\n    font-size: 2.8cqw;\n    color: var(--text-muted);\n    font-weight: 600;\n}\n\n.hf-wallet-actions {\n    display: flex;\n    justify-content: space-between;\n    padding: 1.5cqw 4.5cqw;\n    margin-bottom: 2cqw;\n}\n\n.action-btn {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 1cqw;\n    cursor: pointer;\n}\n\n.action-ico {\n    width: 9cqw;\n    height: 9cqw;\n    border-radius: 50%;\n    border: 1px solid var(--border-color);\n    background: var(--bg-card);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 4.2cqw;\n    color: var(--text-main);\n    transition: all 0.2s;\n}\n\n.action-btn:hover .action-ico {\n    background: var(--bg-bar);\n    border-color: var(--color-gold);\n}\n\n.action-btn span {\n    font-size: 2.4cqw;\n    font-weight: 600;\n    color: var(--text-main);\n}\n\n.hf-sub-segment {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 0 4cqw;\n    border-bottom: 1px solid var(--border-color);\n    margin-bottom: 2cqw;\n}\n\n.sub-tabs {\n    display: flex;\n    gap: 4cqw;\n}\n\n.hide-zero-bal {\n    font-size: 2.4cqw;\n    color: var(--text-muted);\n    font-weight: 600;\n}\n\n.hide-zero-bal label {\n    display: flex;\n    align-items: center;\n    gap: 0.8cqw;\n}\n\n.hf-wallet-search {\n    background: var(--bg-bar);\n    border-radius: 2.5cqw;\n    padding: 1.5cqw 3cqw;\n    margin: 0 3.5cqw 2.5cqw;\n    font-size: 2.6cqw;\n    color: var(--text-muted);\n    font-weight: 500;\n    display: flex;\n    align-items: center;\n}\n\n.hf-assets-list {\n    display: flex;\n    flex-direction: column;\n    padding: 0 3.5cqw;\n    flex: 1;\n    overflow-y: auto;\n    scrollbar-width: none;\n    gap: 1cqw;\n}\n\n.hf-assets-list::-webkit-scrollbar {\n    display: none;\n}\n\n.hf-assets-list .asset-row {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 2cqw 0;\n    border-bottom: 1px solid var(--border-color);\n}\n\n.asset-left {\n    display: flex;\n    align-items: center;\n    gap: 2cqw;\n    flex: 1.2;\n}\n\n.asset-left strong {\n    font-size: 2.8cqw;\n    font-weight: 700;\n    color: var(--text-main);\n    display: block;\n}\n\n.asset-left span {\n    font-size: 2.2cqw;\n    color: var(--text-muted);\n}\n\n.asset-right {\n    text-align: right;\n    flex: 1;\n    padding-right: 2cqw;\n}\n\n.asset-right strong {\n    font-size: 2.8cqw;\n    font-weight: 700;\n    color: var(--text-main);\n    display: block;\n}\n\n.asset-right span {\n    font-size: 2.2cqw;\n    color: var(--text-muted);\n}\n\n.asset-menu {\n    font-size: 3cqw;\n    color: var(--text-muted);\n    cursor: pointer;\n}\n\n.hf-overlay-capsule {\n    position: absolute;\n    bottom: 15cqw;\n    left: 50%;\n    transform: translateX(-50%);\n    background: linear-gradient(135deg, rgba(201, 168, 76, 0.95), rgba(20, 20, 20, 0.95));\n    border: 1px solid rgba(255, 255, 255, 0.15);\n    border-radius: 3cqw;\n    padding: 1.5cqw 4cqw;\n    display: flex;\n    align-items: center;\n    gap: 1.5cqw;\n    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);\n    z-index: 15;\n}\n\nbody.light_theme .hf-overlay-capsule {\n    background: linear-gradient(135deg, rgba(201, 168, 76, 0.95), rgba(255, 255, 255, 0.95));\n    border: 1px solid rgba(0, 0, 0, 0.1);\n    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);\n}\n\n.capsule-symbol {\n    font-size: 3.5cqw;\n    color: #FFFFFF;\n}\n\nbody.light_theme .capsule-symbol {\n    color: var(--color-gold);\n}\n\n.capsule-text {\n    font-size: 2.6cqw;\n    font-weight: 700;\n    color: #FFFFFF;\n    letter-spacing: 0.05em;\n}\n\nbody.light_theme .capsule-text {\n    color: #111;\n}\n\n/* ────────────────────────────────────────────────────────────────────────\n       📱 PRECISE COMPREHENSIVE RESPONSIVENESS OVERRIDES FOR TABLET & MOBILE\n       ──────────────────────────────────────────────────────────────────────── */\n\n@media (min-width: 1930px) and (max-width: 2560px) {\n\n    .hero-inner {\n        max-width: 72%;\n    }\n\n    body.home .container {\n        max-width: 72%;\n    }\n\n    body.home .sec-pad {\n        max-width: 72%;\n    }\n\n}\n\n/* ── Header Navigation Overrides ── */\n@media (max-width: 1376px) {\n\n    .taglines {\n        column-gap: 0px;\n    }\n\n}\n\n/* ── Header Navigation Overrides ── */\n@media (max-width: 992px) {\n\n\n    .nav-links {\n        display: none !important;\n    }\n\n    .hamburger {\n        display: flex !important;\n    }\n\n    .nav-right .btn-login,\n    .nav-right .btn-signup {\n        display: none !important;\n    }\n}\n\n/* ── Hero Section Layout Overrides ── */\n@media (max-width: 1024px) {\n    #hero {\n        padding: 40px 20px 30px !important;\n        min-height: auto !important;\n    }\n\n    .hero-inner {\n        grid-template-columns: 1fr !important;\n        gap: 50px !important;\n        text-align: center !important;\n        justify-items: center !important;\n        padding: 20px 0 10px !important;\n        min-height: auto !important;\n    }\n\n    .copy {\n        align-items: center !important;\n    }\n\n    .sub {\n        max-width: 580px !important;\n        margin: 0 auto 30px !important;\n    }\n\n    .email-cta {\n        max-width: 480px !important;\n        width: 100% !important;\n        margin: 0 auto 24px !important;\n    }\n\n    .hero-actions-sec {\n        align-self: center !important;\n        align-items: center !important;\n    }\n\n    .action-row {\n        justify-content: center !important;\n    }\n\n    .trust-grid {\n        justify-content: center !important;\n    }\n\n    .phones {\n        width: 100% !important;\n        max-width: 480px !important;\n        height: 450px !important;\n        margin: 0 auto !important;\n    }\n\n    .ph-c {\n        width: 220px !important;\n        height: 397px !important;\n    }\n\n    .ph-l,\n    .ph-r {\n        width: 182px !important;\n        height: 300px !important;\n    }\n\n    .hero-globe {\n        left: 50% !important;\n        bottom: 5% !important;\n        /* Elevated to sit directly behind the mobile mockups on small screens */\n        width: clamp(600px, 75vw, 900px) !important;\n        height: clamp(300px, 37.5vw, 450px) !important;\n        margin-left: calc(-1 * clamp(600px, 75vw, 900px) / 2) !important;\n    }\n\n    .hero-horizon-glow {\n        left: 50% !important;\n    }\n}\n\n@media (max-width:767px) {\n\n    .agcex.copy {\n        width: 100%;\n    }\n\n    .float-shape.s1 {\n        top: 10%;\n        left: 40%;\n        width: 220px;\n        height: 220px;\n    }\n\n    .step-num {\n        color: rgb(201 168 76);\n    }\n\n    .agcex.phones {\n        z-index: 9999 !important;\n    }\n\n}\n\n\n/* ── Market Screener Responsive Overrides ── */\n@media (max-width: 768px) {\n    .mkt-tabs {\n        overflow-x: auto !important;\n        white-space: nowrap !important;\n        padding-bottom: 8px !important;\n        -webkit-overflow-scrolling: touch !important;\n        display: flex !important;\n        flex-wrap: nowrap !important;\n    }\n\n    .mkt-tab {\n        flex: 0 0 auto !important;\n    }\n\n    .mkt-table th:nth-child(5),\n    .mkt-table td:nth-child(5) {\n        display: none !important;\n        /* Hide the sparkline column fully in both headers and data cells */\n    }\n}\n\n/* ── Onboarding Steps Responsive Overrides ── */\n@media (max-width: 992px) {\n    .step-grid {\n        grid-template-columns: 1fr !important;\n        gap: 24px !important;\n    }\n\n    .step-card {\n        padding: 36px 30px !important;\n    }\n}\n\n/* ── Footer Grid Responsive Overrides ── */\n@media (max-width: 576px) {\n    .ft-grid {\n        grid-template-columns: 1fr !important;\n        gap: 32px !important;\n    }\n}\n\n/* ── Complete Institutional Crypto Suite (Orbital Showcase) Overrides ── */\n@media (max-width: 1100px) {\n    .orbit-showcase {\n        min-height: auto !important;\n        gap: 40px !important;\n        padding: 20px 0% !important;\n        /* lateral padding to prevent screen boundary bleed */\n        box-sizing: border-box !important;\n    }\n\n    .bento-card.feat-large .bc-title {\n        font-size: 26px;\n    }\n\n    .agcex.orbit-control-wheel {\n        display: none;\n    }\n\n    .orbit-rings,\n    .orbit-beams {\n        display: none !important;\n    }\n\n    .orbit-track {\n        position: relative !important;\n        top: auto !important;\n        left: auto !important;\n        transform: none !important;\n        width: 100% !important;\n        height: auto !important;\n        animation: none !important;\n        display: flex !important;\n        flex-direction: column !important;\n        gap: 20px !important;\n        align-items: center !important;\n    }\n\n    .orbit-node {\n        position: relative !important;\n        width: 100% !important;\n        height: auto !important;\n        top: auto !important;\n        left: auto !important;\n        transform: none !important;\n        animation: none !important;\n        display: block !important;\n    }\n\n    .orbit-center-phone {\n        width: 470px;\n        margin: 0 auto 20px !important;\n        margin-top: 0 !important;\n        /* fully override default top margin in stacked layout */\n        order: -1 !important;\n        /* Place center phone at top of stack for beautiful mobile priority flow */\n    }\n\n    .orbit-card {\n        position: relative !important;\n        width: 100% !important;\n        max-width: 100% !important;\n        margin: 0 auto !important;\n        top: auto !important;\n        left: auto !important;\n        right: auto !important;\n        bottom: auto !important;\n        transform: none !important;\n        box-sizing: border-box !important;\n    }\n\n    .orbit-card.premium {\n        width: 100% !important;\n        max-width: 100% !important;\n        box-sizing: border-box !important;\n    }\n}\n\n@media (max-width: 991px) {\n\n    .orbit-card.premium {\n        max-width: 100% !important;\n    }\n\n    .orbit-showcase {\n        margin: 20px auto 30px;\n    }\n\n    .orbit-center-phone {\n        width: 520px;\n        max-width: 100%;\n    }\n\n}\n\n/* ── 100% 1:1 Proof of Reserves Mobile Overrides ── */\n@media (max-width: 768px) {\n\n    .bento-card.feat-large .bc-mockup {\n        min-height: auto !important;\n        height: auto !important;\n        flex-direction: column !important;\n        align-items: stretch !important;\n        padding: 20px 16px !important;\n        gap: 16px !important;\n        box-sizing: border-box !important;\n    }\n\n    .bento-grid {\n        margin: 20px auto;\n    }\n\n    .merkle-svg {\n        height: 180px !important;\n        width: 100% !important;\n    }\n\n    .por-terminal {\n        position: relative !important;\n        bottom: auto !important;\n        left: auto !important;\n        right: auto !important;\n        margin: 0 !important;\n        padding: 12px 14px !important;\n        font-size: 11px !important;\n        width: 100% !important;\n        box-sizing: border-box !important;\n    }\n\n    .por-row-live {\n        font-size: 11px !important;\n        gap: 6px !important;\n        padding-bottom: 6px !important;\n    }\n\n    .por-row-live span {\n        white-space: nowrap !important;\n        overflow: hidden !important;\n        text-overflow: ellipsis !important;\n        max-width: 130px !important;\n        /* prevents long stablecoin label from pushing percentage out of bounds */\n    }\n\n    .por-row-live strong {\n        font-size: 12px !important;\n    }\n}\n\n/* ── Professional Advanced Trading Terminal Overrides ── */\n@media (max-width: 768px) {\n    .browser-mockup {\n        width: 100% !important;\n        margin-top: 16px !important;\n        box-sizing: border-box !important;\n    }\n\n    .hf-web-nav {\n        flex-wrap: wrap !important;\n        gap: 8px 12px !important;\n        padding: 10px 12px !important;\n    }\n\n    .hf-pair {\n        font-size: 14px !important;\n        width: 100% !important;\n        /* Let pair occupy its own line for clean layout */\n        margin-bottom: 4px !important;\n    }\n\n    .hf-stat {\n        flex: 1 1 30% !important;\n        min-width: 80px !important;\n    }\n\n    .hf-web-body {\n        grid-template-columns: 1fr !important;\n        min-height: auto !important;\n    }\n\n    .hf-chart {\n        border-right: none !important;\n        border-bottom: 1px solid rgba(255, 255, 255, 0.06) !important;\n        padding: 16px 12px !important;\n    }\n\n    .hf-candles {\n        max-height: 180px !important;\n    }\n\n    .hf-vol-bars {\n        margin-top: 12px !important;\n        height: 28px !important;\n    }\n\n    .hf-orderbook {\n        padding: 16px 12px !important;\n    }\n}\n\n/* ── Built for Professional Dominance (USP Cards) Mobile/Tablet Overrides ── */\n@media (max-width: 992px) {\n    .usp-grid {\n        grid-template-columns: 1fr !important;\n        gap: 20px !important;\n    }\n\n    .usp-card {\n        padding: 30px 20px !important;\n        width: 100% !important;\n        box-sizing: border-box !important;\n    }\n}\n\n/* =======================================================================\n       GLOBAL RESPONSIVE BULLETPROOFING OVERRIDES\n       ======================================================================= */\n#hero {\n    overflow-x: hidden !important;\n    width: 100%;\n    max-width: 100vw;\n    position: relative;\n}\n\n\n\n.trust-bento-grid {\n    display: grid;\n    grid-template-columns: repeat(4, 1fr);\n    gap: 24px;\n    max-width: 1200px;\n    margin: 40px auto 0;\n    padding: 0 4%;\n}\n\n@media (max-width: 992px) {\n    .trust-bento-grid {\n        grid-template-columns: repeat(2, 1fr);\n    }\n}\n\n@media (max-width: 600px) {\n    .trust-bento-grid {\n        grid-template-columns: 1fr;\n    }\n}\n\n.trust-card {\n    background: linear-gradient(135deg, rgba(255, 255, 255, 0.03) 0%, rgba(255, 255, 255, 0.01) 100%);\n    border: 1px solid rgba(255, 255, 255, 0.06);\n    border-radius: 20px;\n    padding: 32px;\n    position: relative;\n    overflow: hidden;\n    transition: transform 0.4s cubic-bezier(0.25, 1, 0.22, 1), box-shadow 0.4s ease, border-color 0.4s ease;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    min-height: 220px;\n    backdrop-filter: blur(5px);\n    -webkit-backdrop-filter: blur(5px);\n}\n\n.trust-card.tc-large {\n    grid-column: span 2;\n    flex-direction: row;\n    align-items: center;\n    gap: 32px;\n}\n\n@media (max-width: 992px) {\n    .trust-card.tc-large {\n        flex-direction: column;\n        align-items: flex-start;\n        gap: 0;\n    }\n}\n\n@media (max-width: 600px) {\n    .trust-card.tc-large {\n        grid-column: span 1;\n    }\n}\n\n.tc-glow-orb {\n    position: absolute;\n    width: 150px;\n    height: 150px;\n    border-radius: 50%;\n    filter: blur(60px);\n    opacity: 0.3;\n    z-index: 0;\n    animation: orbFloat 8s infinite alternate ease-in-out;\n    pointer-events: none;\n    top: -30px;\n    left: -30px;\n}\n\n.tc-large .tc-glow-orb {\n    width: 300px;\n    height: 300px;\n    right: -100px;\n    bottom: -100px;\n    top: auto;\n    left: auto;\n    animation-direction: alternate-reverse;\n    animation-duration: 12s;\n}\n\n@keyframes orbFloat {\n    0% {\n        transform: translate(0, 0) scale(1);\n        opacity: 0.15;\n    }\n\n    100% {\n        transform: translate(-30px, -20px) scale(1.3);\n        opacity: 0.4;\n    }\n}\n\n.trust-card:hover {\n    transform: translateY(-8px);\n    box-shadow: 0 25px 50px rgba(0, 0, 0, 0.3), inset 0 1px 0 rgba(255, 255, 255, 0.1);\n}\n\nbody.light_theme .trust-card {\n    background: linear-gradient(135deg, rgba(255, 255, 255, 1) 0%, rgba(245, 245, 245, 1) 100%);\n    border-color: rgba(0, 0, 0, 0.06);\n    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.04);\n}\n\nbody.light_theme .trust-card:hover {\n    box-shadow: 0 25px 50px rgba(0, 0, 0, 0.08), inset 0 1px 0 rgba(255, 255, 255, 0.6);\n}\n\nbody.light_theme .tc-glow-orb {\n    opacity: 0.1;\n}\n\n.tc-content,\n.tc-icon {\n    position: relative;\n    z-index: 2;\n}\n\n.tc-icon {\n    width: 56px;\n    height: 56px;\n    border-radius: 16px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-bottom: 24px;\n    color: #FFF;\n    transition: transform 0.5s cubic-bezier(0.25, 1, 0.22, 1);\n    flex-shrink: 0;\n}\n\n.trust-card.tc-large .tc-icon {\n    margin-bottom: 0;\n    width: 80px;\n    height: 80px;\n    border-radius: 24px;\n}\n\n@media (max-width: 992px) {\n    .trust-card.tc-large .tc-icon {\n        margin-bottom: 24px;\n        width: 56px;\n        height: 56px;\n        border-radius: 16px;\n    }\n}\n\n.trust-card:hover .tc-icon {\n    transform: scale(1.15) rotate(5deg);\n}\n\n.tc-spot {\n    background: rgba(247, 147, 26, 0.15);\n    color: #F7931A;\n    border: 1px solid rgba(247, 147, 26, 0.2);\n}\n\n.tc-margin {\n    background: rgba(98, 126, 234, 0.15);\n    color: #627EEA;\n    border: 1px solid rgba(98, 126, 234, 0.2);\n}\n\n.tc-futures {\n    background: rgba(74, 222, 128, 0.15);\n    color: #4ADE80;\n    border: 1px solid rgba(74, 222, 128, 0.2);\n}\n\n.tc-risk {\n    background: rgba(248, 113, 113, 0.15);\n    color: #F87171;\n    border: 1px solid rgba(248, 113, 113, 0.2);\n}\n\n.tc-port {\n    background: rgba(168, 85, 247, 0.15);\n    color: #A855F7;\n    border: 1px solid rgba(168, 85, 247, 0.2);\n}\n\n.tc-inst {\n    background: rgba(201, 168, 76, 0.15);\n    color: #C9A84C;\n    border: 1px solid rgba(201, 168, 76, 0.2);\n}\n\n.tc-title {\n    font-size: 20px;\n    font-weight: 700;\n    margin-bottom: 10px;\n    color: var(--text-color);\n}\n\n.trust-card.tc-large .tc-title {\n    font-size: 26px;\n}\n\n@media (max-width: 992px) {\n    .trust-card.tc-large .tc-title {\n        font-size: 20px;\n    }\n}\n\n.tc-desc {\n    font-size: 14px;\n    color: var(--text-muted);\n    line-height: 1.6;\n}\n\n/* Extracted from <style> */\n\n.sec-vault-mockup {\n    background: rgba(0, 0, 0, 0.4);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    position: relative;\n    overflow: hidden;\n}\n\n.vault-core {\n    position: relative;\n    width: 64px;\n    height: 64px;\n    color: #FFF;\n    z-index: 5;\n}\n\n.vault-core svg {\n    width: 100%;\n    height: 100%;\n    filter: drop-shadow(0 0 8px rgba(255, 255, 255, 0.4));\n}\n\n.scan-laser {\n    position: absolute;\n    top: 0;\n    left: 10%;\n    width: 80%;\n    height: 2px;\n    background: #4ADE80;\n    box-shadow: 0 0 10px #4ADE80, 0 0 20px #4ADE80;\n    animation: laserScan 2s infinite ease-in-out;\n}\n\n.scan-ring {\n    position: absolute;\n    border: 1px solid rgba(255, 255, 255, 0.1);\n    border-radius: 50%;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    animation: ringPulse 4s infinite cubic-bezier(0.215, 0.61, 0.355, 1);\n}\n\n.scan-ring.r1 {\n    width: 100px;\n    height: 100px;\n    animation-delay: 0s;\n}\n\n.scan-ring.r2 {\n    width: 160px;\n    height: 160px;\n    animation-delay: 1.3s;\n}\n\n.scan-ring.r3 {\n    width: 220px;\n    height: 220px;\n    animation-delay: 2.6s;\n}\n\n@keyframes laserScan {\n    0% {\n        top: 10%;\n        opacity: 0;\n    }\n\n    10% {\n        opacity: 1;\n    }\n\n    90% {\n        opacity: 1;\n    }\n\n    100% {\n        top: 90%;\n        opacity: 0;\n    }\n}\n\n@keyframes ringPulse {\n    0% {\n        width: 40px;\n        height: 40px;\n        opacity: 1;\n    }\n\n    100% {\n        width: 250px;\n        height: 250px;\n        opacity: 0;\n    }\n}\n\n\n/* Extracted from <style> */\n\n.kyc-mockup {\n    background: rgba(0, 0, 0, 0.4);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.kyc-flow {\n    display: flex;\n    align-items: center;\n    gap: 15px;\n    flex-wrap: nowrap;\n}\n\n.kyc-step {\n    width: 50px;\n    height: 50px;\n    flex-shrink: 0;\n    border-radius: 50%;\n    background: rgba(255, 255, 255, 0.05);\n    border: 1px solid rgba(255, 255, 255, 0.1);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: rgba(255, 255, 255, 0.3);\n    transition: all 0.3s;\n    position: relative;\n    z-index: 2;\n}\n\n.kyc-icon svg {\n    width: 24px;\n    height: 24px;\n}\n\n.kyc-line {\n    width: 40px;\n    height: 2px;\n    flex-shrink: 1;\n    background: rgba(255, 255, 255, 0.1);\n    position: relative;\n    z-index: 1;\n    overflow: hidden;\n}\n\n.kyc-line::after {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    height: 100%;\n    width: 100%;\n    background: #4ADE80;\n    transform: translateX(-100%);\n}\n\n@media (max-width: 480px) {\n    .kyc-flow {\n        gap: 8px;\n    }\n\n    .kyc-step {\n        width: 40px;\n        height: 40px;\n    }\n\n    .kyc-icon svg {\n        width: 20px;\n        height: 20px;\n    }\n\n    .kyc-line {\n        width: 20px;\n    }\n}\n\n/* Animation Sequence */\n.kyc-step.s1 {\n    animation: stepActive 4s infinite 0s;\n}\n\n.kyc-line.l1::after {\n    animation: lineFill 4s infinite 0.5s;\n}\n\n.kyc-step.s2 {\n    animation: stepActive 4s infinite 1s;\n}\n\n.kyc-line.l2::after {\n    animation: lineFill 4s infinite 1.5s;\n}\n\n.kyc-step.s3 {\n    animation: stepActive 4s infinite 2s;\n    color: #4ADE80 !important;\n    background: rgba(74, 222, 128, 0.1) !important;\n    border-color: #4ADE80 !important;\n    box-shadow: 0 0 15px rgba(74, 222, 128, 0.4) !important;\n}\n\n@keyframes stepActive {\n\n    0%,\n    90% {\n        color: #4ADE80;\n        background: rgba(74, 222, 128, 0.1);\n        border-color: #4ADE80;\n        box-shadow: 0 0 15px rgba(74, 222, 128, 0.4);\n    }\n\n    95%,\n    100% {\n        color: rgba(255, 255, 255, 0.3);\n        background: rgba(255, 255, 255, 0.05);\n        border-color: rgba(255, 255, 255, 0.1);\n        box-shadow: none;\n    }\n}\n\n@keyframes lineFill {\n\n    0%,\n    90% {\n        transform: translateX(0);\n    }\n\n    95%,\n    100% {\n        transform: translateX(-100%);\n    }\n}\n\nbody.light_theme .kyc-mockup {\n    background: rgba(0, 0, 0, 0.02);\n}\n\nbody.light_theme .kyc-step {\n    background: rgba(0, 0, 0, 0.05);\n    border-color: rgba(0, 0, 0, 0.1);\n    color: rgba(0, 0, 0, 0.3);\n}\n\nbody.light_theme .kyc-line {\n    background: rgba(0, 0, 0, 0.1);\n}\n\n\n/* Extracted from <style> */\n\n.comp-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));\n    gap: 24px;\n    max-width: 1200px;\n    margin: 0 auto;\n    padding: 0;\n    position: relative;\n    z-index: 2;\n}\n\n.comp-card {\n    background: rgba(18, 18, 24, 0.45);\n    border: 1px solid rgba(255, 255, 255, 0.05);\n    border-radius: 20px;\n    padding: 30px 24px;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    transition: all 0.3s ease;\n    box-shadow: 0 15px 35px rgba(0, 0, 0, 0.2);\n    backdrop-filter: blur(5px);\n    -webkit-backdrop-filter: blur(5px);\n}\n\nbody.light_theme .comp-card {\n    background: rgb(255 255 255 / 20%);\n    border-color: rgba(0, 0, 0, 0.06);\n    box-shadow: 0 15px 35px rgba(0, 0, 0, 0.04);\n}\n\n.comp-card:hover {\n    transform: translateY(-5px);\n    border-color: rgba(201, 168, 76, 0.35);\n    box-shadow: 0 20px 45px rgba(201, 168, 76, 0.08);\n}\n\n.comp-ico-wrap {\n    width: 48px;\n    height: 48px;\n    border-radius: 12px;\n    background: rgba(201, 168, 76, 0.08);\n    border: 1px solid rgba(201, 168, 76, 0.2);\n    color: #C9A84C;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-bottom: 20px;\n    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);\n}\n\nbody.light_theme .comp-ico-wrap {\n    background: rgba(201, 168, 76, 0.05);\n    border-color: rgba(201, 168, 76, 0.15);\n}\n\n.comp-partner {\n    font-size: 18px;\n    font-weight: 700;\n    letter-spacing: -0.01em;\n    color: #F2EEE6;\n    margin-bottom: 4px;\n}\n\nbody.light_theme .comp-partner {\n    color: #111;\n}\n\n.comp-role {\n    font-size: 11px;\n    text-transform: uppercase;\n    font-weight: 700;\n    letter-spacing: 0.15em;\n    color: #C9A84C;\n    margin-bottom: 12px;\n}\n\n.comp-desc {\n    font-size: 13.5px;\n    line-height: 1.5;\n    color: #888;\n}\n\nbody.light_theme .comp-desc {\n    color: #555;\n}\n\n\n/* Extracted from <style> */\n\n.otc-wrap {\n    max-width: 1200px;\n    margin: 0 auto;\n    padding: 0 4%;\n    display: grid;\n    grid-template-columns: 1fr;\n    max-width: 800px;\n    gap: 60px;\n    align-items: center;\n}\n\n.otc-content {\n    position: relative;\n    z-index: 2;\n}\n\n.otc-title {\n    font-size: clamp(32px, 4vw, 42px);\n    font-weight: 700;\n    margin-bottom: 20px;\n    color: #FFF;\n    letter-spacing: -0.02em;\n    line-height: 1.1;\n}\n\nbody.light_theme .otc-title {\n    color: #111;\n}\n\n.otc-desc {\n    color: #AAA;\n    font-size: 18px;\n    line-height: 1.6;\n    margin-bottom: 30px;\n}\n\nbody.light_theme .otc-desc {\n    color: #555;\n}\n\n.otc-features {\n    list-style: none;\n    padding: 0;\n    margin-bottom: 40px;\n}\n\n.otc-features li {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    color: #FFF;\n    margin-bottom: 16px;\n    font-size: 16px;\n    font-weight: 500;\n}\n\nbody.light_theme .otc-features li {\n    color: #333;\n}\n\n.otc-features li svg {\n    color: #C9A84C;\n    flex-shrink: 0;\n}\n\n.otc-black-card-container {\n    position: relative;\n    z-index: 2;\n    perspective: 1200px;\n    width: 100%;\n    max-width: 480px;\n    margin: 0 auto;\n}\n\n.otc-black-card {\n    background: linear-gradient(135deg, #111 0%, #1a1a1a 50%, #0a0a0a 100%);\n    border: 1px solid rgba(201, 168, 76, 0.3);\n    border-radius: 20px;\n    padding: 40px;\n    box-shadow: 0 30px 60px rgba(0, 0, 0, 0.6), inset 0 1px 0 rgba(255, 255, 255, 0.1);\n    position: relative;\n    overflow: hidden;\n    transition: transform 0.4s ease, box-shadow 0.4s ease;\n}\n\nbody.light_theme .otc-black-card {\n    background: linear-gradient(135deg, #FFF 0%, #F5F5F5 50%, #E0E0E0 100%);\n    box-shadow: 0 30px 60px rgba(0, 0, 0, 0.1), inset 0 1px 0 rgba(255, 255, 255, 0.8);\n}\n\n.otc-black-card:hover {\n    box-shadow: 0 40px 80px rgba(201, 168, 76, 0.2), inset 0 1px 0 rgba(255, 255, 255, 0.1);\n}\n\nbody.light_theme .otc-black-card:hover {\n    box-shadow: 0 40px 80px rgba(201, 168, 76, 0.15), inset 0 1px 0 rgba(255, 255, 255, 0.8);\n}\n\n.otc-chip {\n    position: absolute;\n    top: 30px;\n    right: 30px;\n    width: 45px;\n    height: 35px;\n    background: linear-gradient(135deg, #E8C97A, #C9A84C, #A58427);\n    border-radius: 6px;\n    opacity: 0.9;\n    box-shadow: inset 0 0 10px rgba(0, 0, 0, 0.5), 0 2px 4px rgba(0, 0, 0, 0.5);\n}\n\n.otc-chip::before,\n.otc-chip::after {\n    content: '';\n    position: absolute;\n    background: rgba(0, 0, 0, 0.3);\n}\n\n.otc-chip::before {\n    top: 12px;\n    left: 0;\n    right: 0;\n    height: 1px;\n    box-shadow: 0 10px 0 rgba(0, 0, 0, 0.3);\n}\n\n.otc-chip::after {\n    top: 0;\n    bottom: 0;\n    left: 15px;\n    width: 1px;\n    box-shadow: 15px 0 0 rgba(0, 0, 0, 0.3);\n}\n\n.otc-form-group {\n    margin-bottom: 24px;\n    position: relative;\n    text-align: left;\n}\n\n.otc-label {\n    display: block;\n    font-size: 12px;\n    text-transform: uppercase;\n    letter-spacing: 0.1em;\n    color: rgba(255, 255, 255, 0.6);\n    margin-bottom: 8px;\n    font-weight: 600;\n}\n\nbody.light_theme .otc-label {\n    color: rgba(0, 0, 0, 0.6);\n}\n\n.otc-input-vip {\n    width: 100%;\n    background: rgba(255, 255, 255, 0.03);\n    border: 1px solid rgba(255, 255, 255, 0.1);\n    border-radius: 12px;\n    padding: 16px;\n    color: #FFF;\n    font-family: inherit;\n    font-size: 16px;\n    transition: all 0.3s;\n}\n\nbody.light_theme .otc-input-vip {\n    background: rgba(0, 0, 0, 0.02);\n    border: 1px solid rgba(0, 0, 0, 0.1);\n    color: #111;\n}\n\n.otc-input-vip:focus {\n    outline: none;\n    border-color: #C9A84C;\n    background: rgba(201, 168, 76, 0.05);\n    box-shadow: 0 0 0 3px rgba(201, 168, 76, 0.1);\n}\n\n.otc-input-vip::placeholder {\n    color: rgba(255, 255, 255, 0.3);\n}\n\nbody.light_theme .otc-input-vip::placeholder {\n    color: rgba(0, 0, 0, 0.3);\n}\n\n.otc-watermark {\n    position: absolute;\n    top: -50%;\n    left: -50%;\n    width: 200%;\n    height: 200%;\n    background: linear-gradient(45deg, transparent, rgba(201, 168, 76, 0.03), transparent);\n    transform: rotate(45deg);\n    pointer-events: none;\n}\n\n.otc-vip-title {\n    font-size: 10px;\n    text-transform: uppercase;\n    letter-spacing: 0.2em;\n    color: #888;\n    margin-bottom: 40px;\n}\n\n.select-vip {\n    appearance: none;\n    background-image: url('data:image/svg+xml;utf8,<svg fill=\"none\" stroke=\"%23C9A84C\" stroke-width=\"2\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M19 9l-7 7-7-7\"></path></svg>');\n    background-repeat: no-repeat;\n    background-position: right 16px center;\n    background-size: 16px;\n}\n\n.otc-select-placeholder {\n    color: #888;\n}\n\n.otc-select-option {\n    color: #111;\n}\n\n.otc-submit-btn {\n    width: 100%;\n    padding: 18px;\n    margin-top: 10px;\n    font-size: 15px;\n    font-weight: 700;\n    letter-spacing: 0.1em;\n    text-transform: uppercase;\n    box-shadow: 0 10px 25px rgba(201, 168, 76, 0.25);\n}\n\n@media (max-width: 992px) {\n    .otc-wrap {\n        grid-template-columns: 1fr;\n        gap: 40px;\n    }\n\n    .otc-black-card {\n        transform: none;\n    }\n}\n\n\n/* Extracted from <style> */\n\n.hf-web-real {\n    background: transparent;\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n    font-family: 'Inter', -apple-system, sans-serif;\n    color: #B7BDC6;\n    overflow: hidden;\n}\n\nbody.light_theme .hf-web-real {\n    background: #FAFAFA;\n    color: #555;\n}\n\n.hf-top-nav {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 12px 16px;\n    background: #181a20;\n    border-bottom: 1px solid #2b3139;\n}\n\nbody.light_theme .hf-top-nav {\n    background: #FFF;\n    border-bottom: 1px solid #EAEAEA;\n}\n\n.hf-ticker-info {\n    display: flex;\n    gap: 24px;\n    align-items: center;\n    flex-wrap: wrap;\n}\n\n.hf-pair-name {\n    font-size: 20px;\n    font-weight: 700;\n    color: #EAECEF;\n}\n\nbody.light_theme .hf-pair-name {\n    color: #111;\n}\n\n.hf-price-main {\n    font-size: 20px;\n    font-weight: 600;\n    color: #0ecb81;\n}\n\n.hf-stat-item {\n    display: flex;\n    flex-direction: column;\n    font-size: 10px;\n}\n\n.hf-stat-item span {\n    color: #848E9C;\n    margin-bottom: 2px;\n}\n\n.hf-stat-item strong {\n    color: #EAECEF;\n    font-weight: 500;\n}\n\nbody.light_theme .hf-stat-item strong {\n    color: #333;\n}\n\n.hf-main-grid {\n    display: flex;\n    flex: 1;\n    height: calc(100% - 60px);\n}\n\n.hf-col-chart {\n    width: 221px;\n    flex: 1;\n    border-right: 1px solid #2b3139;\n    display: flex;\n    flex-direction: column;\n}\n\nbody.light_theme .hf-col-chart {\n    border-right: 1px solid #EAEAEA;\n}\n\n.hf-chart-area {\n    flex: 1;\n    background: #161a1e;\n    position: relative;\n    overflow: hidden;\n}\n\nbody.light_theme .hf-chart-area {\n    background: #F5F5F5;\n}\n\n\n\n.hf-order-history {\n    height: 120px;\n    border-top: 1px solid #2b3139;\n    padding: 12px 16px;\n    background: #181a20;\n}\n\nbody.light_theme .hf-order-history {\n    border-top: 1px solid #EAEAEA;\n    background: #FFF;\n}\n\n.hf-col-ob {\n    width: 240px;\n    border-right: 1px solid #2b3139;\n    display: flex;\n    flex-direction: column;\n    font-size: 12px;\n    font-family: 'Roboto Mono', monospace;\n    background: #181a20;\n}\n\nbody.light_theme .hf-col-ob {\n    border-right: 1px solid #EAEAEA;\n    background: #FFF;\n}\n\n.hf-ob-header {\n    display: flex;\n    justify-content: space-between;\n    padding: 10px 16px;\n    color: #848E9C;\n    font-family: 'Inter', sans-serif;\n    font-size: 11px;\n}\n\n.hf-ob-rows {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n    padding: 0 16px;\n}\n\n.hf-ob-row {\n    display: flex;\n    justify-content: space-between;\n    margin-bottom: 5px;\n    position: relative;\n    padding: 2px 0;\n}\n\n.hf-ob-row::after {\n    content: '';\n    position: absolute;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    background: rgba(246, 70, 93, 0.15);\n    width: 40%;\n    z-index: 0;\n}\n\n.hf-ob-row.bid::after {\n    background: rgba(14, 203, 129, 0.15);\n    width: 60%;\n}\n\n.hf-ob-row span {\n    position: relative;\n    z-index: 1;\n}\n\n.hf-ob-price.ask {\n    color: #f6465d;\n    font-weight: 500;\n}\n\n.hf-ob-price.bid {\n    color: #0ecb81;\n    font-weight: 500;\n}\n\n.hf-ob-mid {\n    text-align: center;\n    font-size: 16px;\n    font-weight: 600;\n    color: #0ecb81;\n    padding: 10px 0;\n    border-top: 1px solid #2b3139;\n    border-bottom: 1px solid #2b3139;\n    margin-bottom: 6px;\n}\n\nbody.light_theme .hf-ob-mid {\n    border-color: #EAEAEA;\n}\n\n.hf-col-entry {\n    width: 280px;\n    padding: 16px;\n    display: flex;\n    flex-direction: column;\n    background: #181a20;\n}\n\nbody.light_theme .hf-col-entry {\n    background: #FFF;\n}\n\n.hf-entry-tabs {\n    display: flex;\n    margin-bottom: 20px;\n    gap: 16px;\n    font-size: 14px;\n    font-weight: 600;\n}\n\n.hf-entry-tab {\n    color: #848E9C;\n    cursor: pointer;\n}\n\n.hf-entry-tab.active {\n    color: #FCD535;\n    border-bottom: 2px solid #FCD535;\n    padding-bottom: 4px;\n}\n\n.hf-entry-input {\n    background: #2b3139;\n    border-radius: 4px;\n    display: flex;\n    justify-content: space-between;\n    padding: 10px 12px;\n    margin-bottom: 14px;\n    font-size: 11px;\n    border: 1px solid transparent;\n}\n\nbody.light_theme .hf-entry-input {\n    background: #F0F0F0;\n}\n\n.hf-entry-input:focus-within {\n    border-color: #FCD535;\n}\n\n.hf-entry-input span {\n    color: #848E9C;\n}\n\n.hf-entry-input input {\n    background: transparent;\n    border: none;\n    color: #EAECEF;\n    text-align: right;\n    width: 60%;\n    outline: none;\n    font-family: 'Roboto Mono', monospace;\n}\n\nbody.light_theme .hf-entry-input input {\n    color: #111;\n}\n\n.hf-btn-buy {\n    background: #0ecb81;\n    color: #fff;\n    text-align: center;\n    padding: 12px;\n    border-radius: 4px;\n    font-weight: 600;\n    font-size: 15px;\n    margin-top: auto;\n    cursor: pointer;\n    transition: background 0.2s;\n}\n\n.hf-btn-buy:hover {\n    background: #0b9e65;\n}\n\n@media (max-width:1024px) {\n\n    .trust-card.tc-large .tc-title {\n        font-size: 22px;\n    }\n\n}\n\n@media (max-width: 992px) {\n\n    .hf-col-ob,\n    .hf-col-entry {\n        display: none;\n    }\n\n\n\n    .hf-web-real {\n        height: 350px;\n    }\n}\n\n\n/* Extracted from <style> */\n\n.support-banner {\n    max-width: 1290px;\n    margin: 0 auto;\n    padding: 48px;\n    border-radius: 32px;\n    background: linear-gradient(135deg, rgba(201, 168, 76, 0.08) 0%, rgba(18, 18, 24, 0.6) 100%);\n    border: 1px solid rgba(201, 168, 76, 0.2);\n    box-shadow: 0 30px 60px rgba(0, 0, 0, 0.5), inset 0 1px 0 rgba(255, 255, 255, 0.05);\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 40px;\n    position: relative;\n    overflow: hidden;\n    backdrop-filter: blur(5px);\n    -webkit-backdrop-filter: blur(5px);\n    transition: all 0.4s ease;\n}\n\nbody.light_theme .support-banner {\n    background: linear-gradient(135deg, rgba(201, 168, 76, 0.05) 0%, rgba(255, 255, 255, 0.7) 100%);\n    box-shadow: 0 30px 60px rgba(0, 0, 0, 0.05);\n    border-color: rgba(201, 168, 76, 0.3);\n}\n\n.support-banner:hover {\n    border-color: rgba(201, 168, 76, 0.5);\n    box-shadow: 0 40px 80px rgba(0, 0, 0, 0.6), 0 0 40px rgba(201, 168, 76, 0.1);\n}\n\nbody.light_theme .support-banner:hover {\n    box-shadow: 0 40px 80px rgba(0, 0, 0, 0.1);\n}\n\n.support-bg-glow {\n    position: absolute;\n    width: 600px;\n    height: 600px;\n    background: radial-gradient(circle, rgba(201, 168, 76, 0.15) 0%, transparent 70%);\n    top: 50%;\n    left: -10%;\n    transform: translateY(-50%);\n    pointer-events: none;\n    z-index: 1;\n}\n\n.support-content {\n    position: relative;\n    z-index: 2;\n    flex: 1;\n}\n\n.support-title-wrap {\n    display: flex;\n    align-items: center;\n    gap: 20px;\n    margin-bottom: 24px;\n}\n\n.support-icon-ring {\n    position: relative;\n    width: 64px;\n    min-width: 64px;\n    height: 64px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: rgba(201, 168, 76, 0.1);\n    border-radius: 50%;\n    border: 1px solid rgba(201, 168, 76, 0.3);\n    color: #C9A84C;\n}\n\n.support-icon-ring::before {\n    content: '';\n    position: absolute;\n    top: -4px;\n    right: -4px;\n    bottom: -4px;\n    left: -4px;\n    border-radius: 50%;\n    border: 2px solid #C9A84C;\n    opacity: 0;\n    animation: pulseRing 3s infinite cubic-bezier(0.215, 0.61, 0.355, 1);\n}\n\n@keyframes pulseRing {\n    0% {\n        transform: scale(0.8);\n        opacity: 0.8;\n    }\n\n    100% {\n        transform: scale(1.4);\n        opacity: 0;\n    }\n}\n\n.support-title {\n    font-size: 32px;\n    font-weight: 700;\n    color: #FFF;\n    margin: 0;\n    line-height: 1.1;\n}\n\nbody.light_theme .support-title {\n    color: #111;\n}\n\n.support-desc {\n    color: #AAA;\n    font-size: 16px;\n    line-height: 1.6;\n    max-width: 500px;\n    margin: 0;\n}\n\nbody.light_theme .support-desc {\n    color: #555;\n}\n\n.support-actions {\n    position: relative;\n    z-index: 2;\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n    min-width: 400px;\n}\n\n.contact-pill {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 16px 24px;\n    background: rgba(255, 255, 255, 0.03);\n    border: 1px solid rgba(255, 255, 255, 0.08);\n    border-radius: 16px;\n    text-decoration: none;\n    transition: all 0.3s ease;\n}\n\nbody.light_theme .contact-pill {\n    background: rgba(0, 0, 0, 0.02);\n    border-color: rgba(0, 0, 0, 0.1);\n}\n\n.contact-pill:hover {\n    background: rgba(201, 168, 76, 0.1);\n    border-color: rgba(201, 168, 76, 0.4);\n    transform: translateX(-4px);\n}\n\n.pill-info {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n}\n\n.pill-label {\n    font-size: 11px;\n    text-transform: uppercase;\n    letter-spacing: 0.1em;\n    color: rgba(255, 255, 255, 0.5);\n    font-weight: 700;\n}\n\nbody.light_theme .pill-label {\n    color: rgba(0, 0, 0, 0.5);\n}\n\n.pill-email {\n    font-size: 16px;\n    font-weight: 600;\n    color: #C9A84C;\n}\n\n.pill-arrow {\n    color: #C9A84C;\n    transition: transform 0.3s;\n}\n\n.contact-pill:hover .pill-arrow {\n    transform: translateX(4px);\n}\n\n@media (max-width: 992px) {\n    .support-banner {\n        flex-direction: column;\n        align-items: flex-start;\n        padding: 32px;\n        gap: 32px;\n    }\n\n    .support-actions {\n        min-width: 100%;\n        width: 100%;\n    }\n\n    .support-title {\n        font-size: 26px;\n    }\n}\n\n@media (max-width: 480px) {\n    .contact-pill {\n        flex-direction: column;\n        align-items: flex-start;\n        gap: 12px;\n    }\n\n    .pill-arrow {\n        display: none;\n    }\n}\n\n\n.agcex-inline-1 {\n    stroke: rgba(74, 222, 128, 0.4);\n\n}\n\n.agcex-inline-2 {\n    stroke: rgba(98, 126, 234, 0.4);\n\n}\n\n.agcex-inline-3 {\n    stroke: rgba(153, 69, 255, 0.4);\n\n}\n\n.agcex-inline-4 {\n    stroke: #C9A84C;\n    stroke-width: 3;\n\n}\n\n.agcex-inline-5 {\n    height: 14px;\n    width: auto;\n    object-fit: contain;\n    display: block;\n    filter: brightness(0) invert(1);\n\n}\n\n.agcex-inline-6 {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n\n}\n\n.agcex-inline-7 {\n    background: transparent;\n\n}\n\n.agcex-inline-8 {\n    color: #C9A84C;\n\n}\n\n.agcex-inline-9 {\n    font-size: 12px;\n\n}\n\n.agcex-inline-10 {\n    background: transparent;\n\n}\n\n.agcex-inline-11 {\n    color: #C9A84C;\n\n}\n\n.agcex-inline-12 {\n    font-size: 12px;\n\n}\n\n.agcex-inline-13 {\n    background: transparent;\n\n}\n\n.agcex-inline-14 {\n    color: #C9A84C;\n\n}\n\n.agcex-inline-15 {\n    font-size: 12px;\n\n}\n\n.agcex-inline-16 {\n    background: transparent;\n\n}\n\n.agcex-inline-17 {\n    color: #C9A84C;\n\n}\n\n.agcex-inline-18 {\n    font-size: 12px;\n\n}\n\n.agcex-inline-19 {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n\n}\n\n.agcex-inline-20 {\n    color: #F97316;\n\n}\n\n.agcex-inline-21 {\n    text-align: right;\n\n}\n\n.agcex-inline-22 {\n    color: #4ADE80;\n\n}\n\n.agcex-inline-23 {\n    text-align: right;\n\n}\n\n.agcex-inline-24 {\n    color: #4ADE80;\n\n}\n\n.agcex-inline-25 {\n    text-align: right;\n\n}\n\n.agcex-inline-26 {\n    color: #4ADE80;\n\n}\n\n.agcex-inline-27 {\n    margin-bottom: 4px;\n\n}\n\n.agcex-inline-28 {\n    color: #F2EEE6;\n    font-weight: 700;\n\n}\n\n.agcex-inline-29 {\n    font-size: 10px;\n    color: #888;\n\n}\n\n.agcex-inline-30 {\n    background: rgba(201, 168, 76, 0.2);\n    border-color: #C9A84C;\n    color: #C9A84C;\n    padding: 1px 4px;\n\n}\n\n.agcex-inline-31 {\n    display: flex;\n    justify-content: space-between;\n    align-items: baseline;\n    margin-bottom: 2px;\n\n}\n\n.agcex-inline-32 {\n    font-size: 20px;\n    font-weight: 700;\n    color: #4ADE80;\n\n}\n\n.agcex-inline-33 {\n    font-size: 9px;\n    color: #888;\n\n}\n\n.agcex-inline-34 {\n    position: relative;\n    height: 75px;\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 6px;\n    overflow: hidden;\n    margin-bottom: 4px;\n    border: 1px solid rgba(255, 255, 255, 0.03);\n\n}\n\n.agcex-inline-35 {\n    width: 100%;\n    height: 100%;\n\n}\n\n.agcex-inline-36 {\n    position: absolute;\n    right: 4px;\n    top: 6px;\n    background: #4ADE80;\n    color: #0b0e11;\n    font-size: 7px;\n    font-weight: bold;\n    padding: 1px 3px;\n    border-radius: 2px;\n    box-shadow: 0 2px 4px rgba(74, 222, 128, 0.25);\n\n}\n\n.agcex-inline-37 {\n    display: grid;\n    grid-template-columns: 1fr;\n    max-width: 800px;\n    gap: 6px;\n    margin-bottom: 6px;\n    font-size: 9px;\n    font-family: monospace;\n    background: rgba(0, 0, 0, 0.12);\n    padding: 5px;\n    border-radius: 6px;\n    border: 1px solid rgba(255, 255, 255, 0.03);\n\n}\n\n.agcex-inline-38 {\n    display: flex;\n    flex-direction: column;\n    gap: 2.5px;\n\n}\n\n.agcex-inline-39 {\n    color: var(--text-muted);\n    display: flex;\n    justify-content: space-between;\n    font-size: 7.5px;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.04);\n    padding-bottom: 1px;\n\n}\n\n.agcex-inline-40 {\n    position: relative;\n    display: flex;\n    justify-content: space-between;\n    color: #F87171;\n    padding: 1px 0;\n\n}\n\n.agcex-inline-41 {\n    position: absolute;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    background: rgba(248, 113, 113, 0.08);\n    width: 75%;\n\n}\n\n.agcex-inline-42 {\n    z-index: 1;\n    font-weight: bold;\n\n}\n\n.agcex-inline-43 {\n    color: #888;\n    z-index: 1;\n\n}\n\n.agcex-inline-44 {\n    position: relative;\n    display: flex;\n    justify-content: space-between;\n    color: #F87171;\n    padding: 1px 0;\n\n}\n\n.agcex-inline-45 {\n    position: absolute;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    background: rgba(248, 113, 113, 0.08);\n    width: 45%;\n\n}\n\n.agcex-inline-46 {\n    z-index: 1;\n    font-weight: bold;\n\n}\n\n.agcex-inline-47 {\n    color: #888;\n    z-index: 1;\n\n}\n\n.agcex-inline-48 {\n    position: relative;\n    display: flex;\n    justify-content: space-between;\n    color: #F87171;\n    padding: 1px 0;\n\n}\n\n.agcex-inline-49 {\n    position: absolute;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    background: rgba(248, 113, 113, 0.08);\n    width: 20%;\n\n}\n\n.agcex-inline-50 {\n    z-index: 1;\n    font-weight: bold;\n\n}\n\n.agcex-inline-51 {\n    color: #888;\n    z-index: 1;\n\n}\n\n.agcex-inline-52 {\n    display: flex;\n    flex-direction: column;\n    gap: 2.5px;\n\n}\n\n.agcex-inline-53 {\n    color: var(--text-muted);\n    display: flex;\n    justify-content: space-between;\n    font-size: 7.5px;\n    border-bottom: 1px solid rgba(255, 255, 255, 0.04);\n    padding-bottom: 1px;\n\n}\n\n.agcex-inline-54 {\n    position: relative;\n    display: flex;\n    justify-content: space-between;\n    color: #4ADE80;\n    padding: 1px 0;\n\n}\n\n.agcex-inline-55 {\n    position: absolute;\n    left: 0;\n    top: 0;\n    bottom: 0;\n    background: rgba(74, 222, 128, 0.08);\n    width: 35%;\n\n}\n\n.agcex-inline-56 {\n    z-index: 1;\n    font-weight: bold;\n\n}\n\n.agcex-inline-57 {\n    color: #888;\n    z-index: 1;\n\n}\n\n.agcex-inline-58 {\n    position: relative;\n    display: flex;\n    justify-content: space-between;\n    color: #4ADE80;\n    padding: 1px 0;\n\n}\n\n.agcex-inline-59 {\n    position: absolute;\n    left: 0;\n    top: 0;\n    bottom: 0;\n    background: rgba(74, 222, 128, 0.08);\n    width: 60%;\n\n}\n\n.agcex-inline-60 {\n    z-index: 1;\n    font-weight: bold;\n\n}\n\n.agcex-inline-61 {\n    color: #888;\n    z-index: 1;\n\n}\n\n.agcex-inline-62 {\n    position: relative;\n    display: flex;\n    justify-content: space-between;\n    color: #4ADE80;\n    padding: 1px 0;\n\n}\n\n.agcex-inline-63 {\n    position: absolute;\n    left: 0;\n    top: 0;\n    bottom: 0;\n    background: rgba(74, 222, 128, 0.08);\n    width: 85%;\n\n}\n\n.agcex-inline-64 {\n    z-index: 1;\n    font-weight: bold;\n\n}\n\n.agcex-inline-65 {\n    color: #888;\n    z-index: 1;\n\n}\n\n.agcex-inline-66 {\n    margin-top: 2px;\n\n}\n\n.agcex-inline-67 {\n    padding: 6px 0;\n    font-size: 10px;\n    font-weight: bold;\n\n}\n\n.agcex-inline-68 {\n    padding: 6px 0;\n    font-size: 10px;\n    font-weight: bold;\n\n}\n\n.agcex-inline-69 {\n    margin-bottom: 6px;\n\n}\n\n.agcex-inline-70 {\n    color: #F2EEE6;\n    font-weight: 700;\n\n}\n\n.agcex-inline-71 {\n    background: rgba(98, 126, 234, 0.2);\n    border-color: #627EEA;\n    color: #627EEA;\n    padding: 1px 4px;\n\n}\n\n.agcex-inline-72 {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    margin: 8px 0;\n    background: rgba(0, 0, 0, 0.15);\n    padding: 6px;\n    border-radius: 8px;\n    border: 1px solid rgba(255, 255, 255, 0.03);\n\n}\n\n.agcex-inline-73 {\n    position: relative;\n    width: 64px;\n    height: 64px;\n    flex-shrink: 0;\n\n}\n\n.agcex-inline-74 {\n    width: 100%;\n    height: 100%;\n    transform: rotate(-90deg);\n\n}\n\n.agcex-inline-75 {\n    position: absolute;\n    inset: 0;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    line-height: 1;\n\n}\n\n.agcex-inline-76 {\n    font-size: 7px;\n    color: var(--text-muted);\n    font-weight: 600;\n    text-transform: uppercase;\n\n}\n\n.agcex-inline-77 {\n    font-size: 10px;\n    font-weight: 700;\n    color: #E8C97A;\n    margin-top: 2px;\n\n}\n\n.agcex-inline-78 {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n    font-size: 8.5px;\n    flex-grow: 1;\n    text-align: left;\n\n}\n\n.agcex-inline-79 {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n\n}\n\n.agcex-inline-80 {\n    color: #C9A84C;\n    font-weight: 600;\n    display: inline-flex;\n    align-items: center;\n    gap: 2px;\n\n}\n\n.agcex-inline-81 {\n    color: #fff;\n\n}\n\n.agcex-inline-82 {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n\n}\n\n.agcex-inline-83 {\n    color: #4ADE80;\n    font-weight: 600;\n    display: inline-flex;\n    align-items: center;\n    gap: 2px;\n\n}\n\n.agcex-inline-84 {\n    color: #fff;\n\n}\n\n.agcex-inline-85 {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n\n}\n\n.agcex-inline-86 {\n    color: #3b82f6;\n    font-weight: 600;\n    display: inline-flex;\n    align-items: center;\n    gap: 2px;\n\n}\n\n.agcex-inline-87 {\n    color: #fff;\n\n}\n\n.agcex-inline-88 {\n    margin-top: 6px;\n    font-size: 9.5px;\n    color: #C9A84C;\n    font-weight: bold;\n\n}\n\n.agcex-inline-89 {\n    display: flex;\n    flex-direction: column;\n    gap: 3px;\n\n}\n\n.agcex-inline-90 {\n    padding: 4px 0;\n\n}\n\n.agcex-inline-91 {\n    text-align: right;\n\n}\n\n.agcex-inline-92 {\n    color: #4ADE80;\n    font-size: 8px;\n\n}\n\n.agcex-inline-93 {\n    padding: 4px 0;\n\n}\n\n.agcex-inline-94 {\n    text-align: right;\n\n}\n\n.agcex-inline-95 {\n    color: #4ADE80;\n    font-size: 8px;\n\n}\n\n.agcex-inline-96 {\n    padding: 4px 0;\n\n}\n\n.agcex-inline-97 {\n    text-align: right;\n\n}\n\n.agcex-inline-98 {\n    color: #888;\n    font-size: 8px;\n\n}\n\n.agcex-inline-99 {\n    color: #C9A84C;\n\n}\n\n.agcex-inline-100 {\n    font-size: 6.5px;\n    color: #4ADE80;\n    font-weight: 700;\n    letter-spacing: 0.5px;\n    margin-top: 2px;\n\n}\n\n.agcex-inline-101 {\n    background: rgba(74, 222, 128, 0.15);\n    color: #4ADE80;\n    border-color: rgba(74, 222, 128, 0.3);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n}\n\n.agcex-inline-102 {\n    background: rgba(98, 126, 234, 0.15);\n    color: #627EEA;\n    border-color: rgba(98, 126, 234, 0.3);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n}\n\n.agcex-inline-103 {\n    background: rgba(168, 85, 247, 0.15);\n    color: #A855F7;\n    border-color: rgba(168, 85, 247, 0.3);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n}\n\n.agcex-inline-104 {\n    background: rgba(247, 147, 26, 0.15);\n    color: #F7931A;\n    border-color: rgba(247, 147, 26, 0.3);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n}\n\n.agcex-inline-105 {\n    border-top: 1px solid rgba(255, 255, 255, 0.05);\n    background: rgba(0, 0, 0, 0.1);\n    position: relative;\n    overflow: hidden;\n\n}\n\n.agcex-inline-106 {\n    position: absolute;\n    left: 50%;\n    top: 50%;\n    transform: translate(-50%, -50%);\n    width: 60%;\n    height: 60%;\n    background: radial-gradient(circle, rgba(201, 168, 76, 0.05) 0%, transparent 70%);\n    filter: blur(80px);\n    z-index: 1;\n    pointer-events: none;\n\n}\n\n.agcex-inline-107 {\n    position: relative;\n    z-index: 2;\n    margin-bottom: 40px;\n\n}\n\n.agcex-inline-108 {\n    max-width: 800px;\n    margin: 0 auto 16px;\n\n}\n\n.agcex-inline-109 {\n    max-width: 650px;\n    margin: 0 auto;\n\n}\n\n.agcex-inline-110 {\n    background: rgba(201, 168, 76, 0.05);\n    position: relative;\n    overflow: hidden;\n    border-top: 1px solid rgba(201, 168, 76, 0.1);\n    border-bottom: 1px solid rgba(201, 168, 76, 0.1);\n\n}\n\n.agcex-inline-111 {\n    position: absolute;\n    right: -10%;\n    top: -20%;\n    width: 50%;\n    height: 140%;\n    background: radial-gradient(ellipse at center, rgba(201, 168, 76, 0.15) 0%, transparent 70%);\n    filter: blur(60px);\n    z-index: 1;\n    pointer-events: none;\n\n}\n\n.agcex-inline-112 {\n    position: absolute;\n    top: -50%;\n    left: -50%;\n    width: 200%;\n    height: 200%;\n    background: linear-gradient(45deg, transparent, rgba(201, 168, 76, 0.03), transparent);\n    transform: rotate(45deg);\n    pointer-events: none;\n\n}\n\n.agcex-inline-113 {\n    font-size: 10px;\n    text-transform: uppercase;\n    letter-spacing: 0.2em;\n    color: #888;\n    margin-bottom: 40px;\n\n}\n\n.agcex-inline-114 {\n    color: #888;\n\n}\n\n.agcex-inline-115 {\n    color: #111;\n\n}\n\n.agcex-inline-116 {\n    color: #111;\n\n}\n\n.agcex-inline-117 {\n    color: #111;\n\n}\n\n.agcex-inline-118 {\n    color: #111;\n\n}\n\n.agcex-inline-119 {\n    width: 100%;\n    padding: 18px;\n    margin-top: 10px;\n    font-size: 15px;\n    font-weight: 700;\n    letter-spacing: 0.1em;\n    text-transform: uppercase;\n    box-shadow: 0 10px 25px rgba(201, 168, 76, 0.25);\n\n}\n\n.agcex-inline-120 {\n    width: 100%;\n    aspect-ratio: 16 / 10;\n    position: relative;\n    overflow: hidden;\n    background: #0b0e11;\n    border-radius: 0 0 12px 12px;\n\n}\n\n.agcex-inline-121 {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 1000px;\n    height: 625px;\n    transform-origin: top left;\n\n}\n\n.agcex-inline-122 {\n    margin-left: 8px;\n\n}\n\n.agcex-inline-123 {\n    color: #0ecb81;\n\n}\n\n.agcex-inline-124 {\n    position: absolute;\n    top: 12px;\n    left: 16px;\n    font-size: 12px;\n    color: #848E9C;\n    font-family: 'Roboto Mono', monospace;\n    z-index: 10;\n\n}\n\n.agcex-inline-125 {\n    padding-top: 40px;\n\n}\n\n.agcex-inline-126 {\n    display: flex;\n    gap: 24px;\n    font-size: 14px;\n    margin-bottom: 12px;\n    font-weight: 600;\n\n}\n\n.agcex-inline-127 {\n    color: #EAECEF;\n    border-bottom: 2px solid #FCD535;\n    padding-bottom: 4px;\n\n}\n\n.agcex-inline-128 {\n    color: #848E9C;\n\n}\n\n.agcex-inline-129 {\n    color: #848E9C;\n\n}\n\n.agcex-inline-130 {\n    font-size: 12px;\n    display: flex;\n    justify-content: space-between;\n    color: #848E9C;\n    margin-bottom: 8px;\n\n}\n\n.agcex-inline-131 {\n    width: 15%;\n\n}\n\n.agcex-inline-132 {\n    width: 15%;\n\n}\n\n.agcex-inline-133 {\n    width: 10%;\n\n}\n\n.agcex-inline-134 {\n    width: 10%;\n\n}\n\n.agcex-inline-135 {\n    width: 20%;\n    text-align: right;\n\n}\n\n.agcex-inline-136 {\n    width: 20%;\n    text-align: right;\n\n}\n\n.agcex-inline-137 {\n    width: 10%;\n    text-align: right;\n\n}\n\n.agcex-inline-138 {\n    font-size: 12px;\n    display: flex;\n    justify-content: space-between;\n    color: #EAECEF;\n    font-family: 'Roboto Mono', monospace;\n\n}\n\n.agcex-inline-139 {\n    width: 15%;\n\n}\n\n.agcex-inline-140 {\n    width: 15%;\n    font-weight: 600;\n\n}\n\n.agcex-inline-141 {\n    width: 10%;\n\n}\n\n.agcex-inline-142 {\n    width: 10%;\n    color: #0ecb81;\n    font-weight: 600;\n\n}\n\n.agcex-inline-143 {\n    width: 20%;\n    text-align: right;\n\n}\n\n.agcex-inline-144 {\n    width: 20%;\n    text-align: right;\n\n}\n\n.agcex-inline-145 {\n    width: 10%;\n    text-align: right;\n\n}\n\n.agcex-inline-146 {\n    margin-bottom: 0;\n\n}\n\n.agcex-inline-147 {\n    font-size: 12px;\n    color: #EAECEF;\n    font-weight: 400;\n    margin-left: 8px;\n\n}\n\n.agcex-inline-148 {\n    justify-content: flex-start;\n\n}\n\n.agcex-inline-149 {\n    display: flex;\n    justify-content: space-between;\n    font-size: 12px;\n    margin-bottom: 16px;\n\n}\n\n.agcex-inline-150 {\n    color: #848E9C;\n\n}\n\n.agcex-inline-151 {\n    color: #EAECEF;\n    font-family: 'Roboto Mono', monospace;\n\n}\n\n.agcex-inline-152 {\n    display: flex;\n    justify-content: space-between;\n    margin-bottom: 20px;\n    align-items: center;\n\n}\n\n.agcex-inline-153 {\n    width: 6px;\n    height: 6px;\n    border-radius: 50%;\n    background: #2b3139;\n\n}\n\n.agcex-inline-154 {\n    flex: 1;\n    height: 2px;\n    background: #2b3139;\n\n}\n\n.agcex-inline-155 {\n    width: 6px;\n    height: 6px;\n    border-radius: 50%;\n    background: #2b3139;\n\n}\n\n.agcex-inline-156 {\n    flex: 1;\n    height: 2px;\n    background: #2b3139;\n\n}\n\n.agcex-inline-157 {\n    width: 6px;\n    height: 6px;\n    border-radius: 50%;\n    background: #2b3139;\n\n}\n\n.agcex-inline-158 {\n    flex: 1;\n    height: 2px;\n    background: #2b3139;\n\n}\n\n.agcex-inline-159 {\n    width: 6px;\n    height: 6px;\n    border-radius: 50%;\n    background: #2b3139;\n\n}\n\n.agcex-inline-160 {\n    margin-bottom: 30px;\n\n}\n\n.agcex-inline-161 {\n    background: rgba(74, 222, 128, 0.15);\n    color: #4ADE80;\n    border-color: rgba(74, 222, 128, 0.3);\n\n}\n\n.agcex-inline-162 {\n    display: flex;\n    gap: 14px;\n    color: #848E9C;\n    align-items: center;\n\n}\n\n.agcex-inline-163 {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n\n}\n\n.agcex-inline-164 {\n    display: flex;\n    align-items: center;\n\n}\n\n.agcex-inline-165 {\n    color: #4ADE80;\n\n}\n\n.agcex-inline-166 {\n    background: transparent;\n\n}\n\n.agcex-inline-167 {\n    color: #C9A84C;\n\n}\n\n.agcex-inline-168 {\n    font-size: 12px;\n    font-weight: 600;\n\n}\n\n.agcex-inline-169 {\n    background: transparent;\n\n}\n\n.agcex-inline-170 {\n    color: #C9A84C;\n\n}\n\n.agcex-inline-171 {\n    font-size: 12px;\n    font-weight: 600;\n\n}\n\n.agcex-inline-172 {\n    background: transparent;\n\n}\n\n.agcex-inline-173 {\n    color: #C9A84C;\n\n}\n\n.agcex-inline-174 {\n    font-size: 12px;\n    font-weight: 600;\n\n}\n\n.agcex-inline-175 {\n    background: transparent;\n\n}\n\n.agcex-inline-176 {\n    color: #C9A84C;\n\n}\n\n.agcex-inline-177 {\n    font-size: 12px;\n    font-weight: 600;\n\n}\n\n.agcex-inline-178 {\n    display: flex;\n    gap: 16px;\n\n}\n\n.agcex-inline-179 {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    font-weight: 600;\n    color: #EAECEF;\n\n}\n\n.agcex-inline-180 {\n    color: #F97316;\n\n}\n\n.agcex-inline-181 {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    font-weight: 600;\n    color: #848E9C;\n\n}\n\n.agcex-inline-182 {\n    color: #C9A84C;\n\n}\n\n.agcex-inline-183 {\n    border-top: 1px solid rgba(255, 255, 255, 0.05);\n    position: relative;\n    z-index: 5;\n\n}\n\n.agcex-inline-184 {\n    padding: 0 4%;\n\n}\n\n.agcex-inline-185 {\n    position: relative;\n    width: 100px;\n    margin: 0 auto 24px;\n\n}\n\n.agcex-inline-186 {\n    margin: 0 auto;\n    display: block;\n\n}\n\n.agcex-inline-187 {\n    animation-delay: 0.5s;\n\n}\n\n.agcex-inline-188 {\n    justify-content: center;\n\n}\n\n.agcex-inline-189 {\n    padding: 24px 64px;\n    font-size: 22px;\n    border-radius: 16px;\n    height: auto;\n\n}\n\nbody.home.light_theme {\n    background: #F8F9FA;\n    color: #1A1A1A;\n}\n\n.icon_notificaton_r ul li.themetbs .ri-moon-line:before {\n    color: #fff;\n}\n\n/* ============================================================\n   Footer — New Design Classes\n   ============================================================ */\n\nbody.light_theme footer {\n    background-color: #fff;\n    border-top: 1px solid rgba(0, 0, 0, 0.06);\n    color: #fff;\n}\n\nfooter {\n    border-top: 1px solid rgba(255, 255, 255, 0.06);\n    background: #181a20;\n    padding: 52px 5% 40px;\n    color: #888;\n    font-size: 14px;\n    position: relative;\n    z-index: 10;\n}\n\n/* .ft-brand {\n    grid-column: span 2;\n} */\n\n.ft-brand-company {\n    margin-top: 0px;\n    width: 100%;\n    margin-left: -40px;\n}\n\n.ft-brand-company-name {\n    color: inherit;\n    pointer-events: none;\n}\n\n/* .ft-col-contact {\n    grid-column: span 2;\n} */\n\n.ft-col-links-list {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n}\n\n.ft-col-contact-body {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    color: #AAA;\n    font-size: 15px;\n    line-height: 1.6;\n}\n\n.ft-col-contact-body p {\n    margin: 0;\n}\n\n.ft-link-email {\n    color: #C9A84C !important;\n    font-weight: 600;\n}\n\n.ft-copy {\n    max-width: 100%;\n    line-height: 1.4;\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    text-align: center;\n    gap: 3px;\n}\n\n.ft-col.linkftr {\n    padding-left: 40px;\n}\n\n.ft-copy-sub {\n    max-width: 100%;\n    color: #848E9C;\n    font-size: 12px;\n}\n\n/* \nbody.light_theme.home .hot_trading_s img.coinimg {\n    filter: invert(1);\n} */\n\n@media (max-width:1440px) {\n\n    .tl {\n        font-size: clamp(32px, 4vw, 66px);\n    }\n\n}\n\n@media (max-width:1200px) {\n\n    .support-title {\n        font-size: 26px;\n    }\n\n    .agcex-inline-189 {\n        padding: 15px 48px;\n        font-size: 18px;\n    }\n\n    .trust-card {\n        padding: 20px;\n    }\n\n\n    .usp-grid {\n        grid-template-columns: repeat(2, 1fr);\n    }\n}\n\n@media (max-width:1100px) {\n    .orbit-showcase {\n        min-height: auto;\n        gap: 30px;\n    }\n\n    .orbit-rings,\n    .orbit-beams {\n        display: none;\n    }\n\n    .orbit-center-phone {\n        margin: 0 auto 40px;\n    }\n\n    .orbit-card {\n        position: relative;\n        width: 100%;\n        top: auto !important;\n        left: auto !important;\n        right: auto !important;\n        bottom: auto !important;\n        transform: none !important;\n    }\n\n    .orbit-card.top-center {\n        width: 100%;\n    }\n\n    .eco-grid,\n    .vip-grid {\n        grid-template-columns: 1fr;\n    }\n\n    .ft-grid {\n        grid-template-columns: 1fr 1fr 1fr 1fr;\n    }\n\n    .ft-col.linkftr {\n        padding-left: 20px;\n    }\n\n    .app-ph.left,\n    .app-ph.right {\n        display: none;\n    }\n\n    .app-ph.center {\n        position: relative;\n        transform: none;\n    }\n}\n\n@media (max-width:768px) {\n    .ft-grid {\n        grid-template-columns: 1fr;\n        max-width: 800px;\n    }\n\n    .cta-form {\n        flex-direction: column;\n    }\n\n    .cta-box {\n        padding: 40px 24px;\n    }\n\n    .ft-bottom {\n        flex-direction: column;\n        gap: 20px;\n        text-align: center;\n    }\n}\n\n\n@media (max-width: 768px) {\n\n    .comp-grid {\n        grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n    }\n\n    /* Fix Hero Mobile Overlaps */\n    #hero {\n        overflow: hidden !important;\n        /* Contain the absolute globe */\n        padding-bottom: 10px !important;\n    }\n\n    .hero-globe {\n        transform: scale(0.6) translateX(-50%) !important;\n        transform-origin: bottom left !important;\n        /* Left because translateX(-50%) shifts it */\n        bottom: -5% !important;\n        left: 50% !important;\n        margin-left: 0 !important;\n    }\n\n\n    .hero-inner {\n        position: relative !important;\n    }\n\n    .copy {\n        position: relative !important;\n        z-index: 10 !important;\n    }\n\n    .phones {\n        top: 0% !important;\n        right: 0% !important;\n        transform: scale(0.7) !important;\n        transform-origin: center !important;\n        pointer-events: none !important;\n        z-index: 1 !important;\n        height: 300px !important;\n    }\n\n\n    /* Footer Grid Fix */\n    .ft-grid {\n        grid-template-columns: 1fr 1fr 1fr 1fr !important;\n        gap: 24px !important;\n    }\n\n    .ft-col.linkftr {\n        padding-left: 0px;\n    }\n\n    .ft-brand,\n    .ft-col {\n        grid-column: span 1 !important;\n    }\n\n    /* Trust Bento Grid Mobile Fix */\n    /* .trust-bento-grid {\n        grid-template-columns: 1fr !important;\n    } */\n\n    .t-bento-card {\n        grid-column: span 1 !important;\n        grid-row: span 1 !important;\n        min-height: auto !important;\n    }\n\n    /* Ensure ecosystem phone scales smoothly */\n    .orbit-center-phone {\n        transform: scale(0.8);\n        transform-origin: center center;\n        margin-bottom: 0px !important;\n    }\n\n    .orbit-control-wheel {\n        display: none !important;\n        /* Hide external wheel on small mobile, too cluttered */\n    }\n\n    .ft-brand-company {\n        margin-left: -20px;\n    }\n}\n\n\n@media (max-width: 767px) {\n\n    .eco-title {\n        font-size: clamp(20px, 2.5vw, 36px);\n        margin-bottom: 10px;\n    }\n\n    .eco-desc {\n        font-size: 14px;\n    }\n\n    .support-desc {\n        font-size: 14px;\n    }\n\n    body.home .cta-sec {\n        padding: 10px 20px 40px;\n    }\n\n    .ft-grid {\n        grid-template-columns: 1fr !important;\n        gap: 32px !important;\n    }\n\n    .comp-grid {\n        grid-template-columns: 1fr;\n    }\n\n    .orbit-showcase {\n        flex-direction: column;\n    }\n\n    .trust-bento-grid {\n        margin: 10px auto 0;\n    }\n\n    .crypto_section .hot_spot_outer {\n        min-height: 330px;\n    }\n\n\n    .hero-inner {\n        gap: 15px !important;\n        padding: 10px 0 10px !important;\n    }\n\n    .hero-actions-sec {\n        margin-bottom: 15px;\n    }\n\n    .ft-copy {\n        flex-direction: column;\n    }\n\n    .ft-copy-sub {\n        max-width: 100%;\n    }\n\n    .orbit-showcase {\n        margin: -70px auto 30px;\n        gap: 10px !important;\n    }\n\n    .bento-card {\n        border-radius: 24px;\n        padding: 24px;\n    }\n\n    .bento-card.feat-large .bc-title {\n        font-size: 24px;\n    }\n\n    .bc-title {\n        font-size: 24px;\n        margin: 0px;\n    }\n\n    .agcex-inline-107 {\n        margin-bottom: 20px;\n    }\n\n    .eco-card {\n        border-radius: 24px;\n        padding: 24px;\n\n    }\n\n    .bc-hdr {\n        margin-bottom: 0px;\n    }\n\n    .browser-mockup {\n        margin-top: 0px !important;\n    }\n\n    .eco-header {\n        margin-bottom: 18px;\n    }\n\n\n    .sec-pad {\n        padding: 30px 20px 30px;\n    }\n\n    .support-title {\n        font-size: 22px;\n    }\n\n    .support-banner {\n        padding: 24px;\n        gap: 24px;\n    }\n\n    .step-grid {\n        margin-top: 10px;\n    }\n\n    .step-card {\n        padding: 24px !important;\n    }\n\n    .step-num {\n        font-size: 36px;\n    }\n\n    .cta-sec {\n        padding: 24px 20px 40px;\n    }\n\n    .agcex-inline-184 {\n        padding: 0 0%;\n    }\n\n    .orbit-showcase {\n        padding: 20px 0% !important;\n    }\n\n    .trust-bento-grid {\n        padding: 0 0%;\n    }\n\n    .cta-title {\n        font-size: clamp(24px, 4vw, 54px);\n    }\n\n    .agcex-inline-189 {\n        padding: 12px 36px;\n        font-size: 15px;\n        border-radius: 12px;\n    }\n\n    footer {\n        padding: 30px 5% 20px;\n    }\n\n    .sub {\n        margin: 0 auto 10px !important;\n    }\n\n    .ft-brand-company {\n        margin-top: 0px;\n        margin-left: 0px;\n    }\n\n    .ft-col.linkftr {\n        padding-left: 0px;\n    }\n\n    .ft-grid {\n        margin-bottom: 24px;\n    }\n\n    .ft-bottom {\n        padding-top: 24px;\n    }\n\n    section#ecosystem {\n        padding-bottom: 15px;\n    }\n\n    #ecosystem .eco-grid {\n        margin-top: 10px;\n    }\n\n    .agcex.t-pill {\n        width: 30%;\n    }\n\n}\n\n\n@media (max-width: 576px) {\n\n    .float-shape.s3 {\n        top: 65%;\n    }\n\n    .bento-card.feat-large .bc-title {\n        font-size: 20px;\n    }\n\n    .float-shape.s1 {\n        top: 60%;\n        left: 10%;\n        width: 180px;\n        height: 180px;\n    }\n\n    #hero {\n        padding: 35px 20px 30px !important;\n    }\n\n    .phones {\n        height: 350px !important;\n        transform: scale(0.7);\n        transform-origin: top center;\n        margin-top: 0px !important;\n    }\n\n    .email-cta {\n        max-width: 100% !important;\n        width: 100% !important;\n        gap: 7px !important;\n    }\n\n    .bento-card.feat-large .bc-title {\n        font-size: 20px;\n    }\n\n    .bc-title {\n        font-size: 20px;\n    }\n\n    .email-input {\n        padding: 11px 15px !important;\n        min-height: 42px;\n    }\n\n    .email-btn {\n        padding: 7px 16px !important;\n        min-height: 42px;\n    }\n\n    .trust-grid {\n        align-items: center !important;\n        gap: 6px !important;\n    }\n\n    .bc-desc {\n        font-size: 14px;\n    }\n\n    body .step-text {\n        font-size: 14px;\n    }\n}\n\n@media (max-width: 370px) {\n\n    .email-input {\n        padding: 10px 10px !important;\n    }\n\n    .email-btn {\n        padding: 6px 13px !important;\n    }\n}\n\n\n\n@media (max-width: 480px) {\n\n    .hero-globe {\n        transform: scale(0.45) translateX(-50%) !important;\n    }\n\n    .agcex.t-pill {\n        width: 49%;\n    }\n\n    .support-icon-ring {\n        width: 54px;\n        min-width: 54px;\n        height: 54px;\n    }\n\n\n    .sec-title {\n        font-size: clamp(24px, 3.5vw, 46px);\n    }\n\n    .agcex.orbit-track {\n        margin-top: -40px;\n    }\n\n    .orbit-showcase {\n        margin: -100px auto 0px;\n        padding-bottom: 0px !important;\n    }\n\n    .phones {\n        transform: scale(0.7) !important;\n        height: 300px !important;\n        margin-top: -20px !important;\n    }\n\n    .orbit-center-phone {\n        transform: scale(0.65);\n    }\n\n    .tl {\n        font-size: clamp(24px, 4.5vw, 66px);\n    }\n}\n\n\n@media (max-width: 420px) {\n\n    .store-buttons {\n        flex-direction: column;\n    }\n\n}\n\n\n@media (max-width: 360px) {\n\n    .agcex.t-pill {\n        width: 47%;\n        text-align: left;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
